(function() {
  'use strict';

angular
	.module("ngFlatDatepicker", []).run(["$templateCache", function($templateCache) {$templateCache.put("datepicker.html","<div class=\"ng-flat-datepicker\" ng-show=\"pickerDisplayed\">\n    <div class=\"ng-flat-datepicker-table-header-bckgrnd\"></div>\n    <table>\n        <caption>\n            <div class=\"ng-flat-datepicker-header-wrapper\">\n                <span class=\"ng-flat-datepicker-arrow ng-flat-datepicker-arrow-left\" ng-click=\"prevMonth()\">\n                    <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"50\" y=\"50\" viewBox=\"0 0 100 100\" xml:space=\"preserve\">\n                        <polygon points=\"64.8,36.2 35.2,6.5 22.3,19.4 51.9,49.1 22.3,78.8 35.2,91.7 77.7,49.1\" />\n                    </svg>\n                </span>\n                <div class=\"ng-flat-datepicker-header-year\">\n                    <div class=\"ng-flat-datepicker-custom-select-box\" outside-click=\"showMonthsList = false\">\n                        <span class=\"ng-flat-datepicker-custom-select-title ng-flat-datepicker-month-name\" ng-click=\"showMonthsList = !showMonthsList; showYearsList = false\" ng-class=\"{selected: showMonthsList }\">{{ calendarCursor.isValid() ? calendarCursor.format(\'MMMM\') : \"\" }}</span>\n                        <div class=\"ng-flat-datepicker-custom-select\" ng-show=\"showMonthsList\">\n                            <span ng-repeat=\"monthName in monthsList\" ng-click=\"selectMonth(monthName); showMonthsList = false\">{{ monthName }}</span>\n                        </div>\n                    </div>\n                    <div class=\"ng-flat-datepicker-custom-select-box\" outside-click=\"showYearsList = false\">\n                        <span class=\"ng-flat-datepicker-custom-select-title\" ng-click=\"showYearsList = !showYearsList; showMonthsList = false\" ng-class=\"{selected: showYearsList }\">{{ calendarCursor.isValid() ? calendarCursor.format(\'YYYY\') : \"\" }}</span>\n                        <div class=\"ng-flat-datepicker-custom-select\" ng-show=\"showYearsList\">\n                            <span ng-repeat=\"yearNumber in yearsList\" ng-click=\"selectYear(yearNumber)\">{{ yearNumber }}</span>\n                        </div>\n                    </div>\n                </div>\n                <span class=\"ng-flat-datepicker-arrow ng-flat-datepicker-arrow-right\" ng-click=\"nextMonth()\">\n                    <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"50\" y=\"50\" viewBox=\"0 0 100 100\" xml:space=\"preserve\">\n                        <polygon points=\"64.8,36.2 35.2,6.5 22.3,19.4 51.9,49.1 22.3,78.8 35.2,91.7 77.7,49.1\" />\n                    </svg>\n                </span>\n            </div>\n        </caption>\n        <tbody>\n            <tr class=\"days-head\">\n                <td class=\"day-head\" ng-repeat=\"dayName in daysNameList\">{{ dayName }}</td>\n            </tr>\n            <tr class=\"days\" ng-repeat=\"week in currentWeeks\">\n                <td ng-repeat=\"day in week\" ng-click=\"selectDay(day)\" ng-class=\"[\'day-item\', { \'isToday\': day.isToday, \'isInMonth\': day.isInMonth, \'isDisabled\': !day.isSelectable, \'isSelected\': day.isSelected }]\">{{ day.date | date:\'dd\' }}</td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n");}]);

})();



(function () {

    'use strict';

    /**
     * @desc Datepicker directive
     * @example <ng-datepicker></ng-datepicker>
     */

    angular
        .module('ngFlatDatepicker')
        .directive('ngFlatDatepicker', ngFlatDatepickerDirective);

    function ngFlatDatepickerDirective($templateCache, $compile, $document, datesCalculator) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                config: '=datepickerConfig'
            },
            link: function (scope, element, attrs, ngModel) {

                var template = angular.element($templateCache.get('datepicker.html'));
                var dateSelected = '';
                var today = moment();

                // Default options
                var defaultConfig = {
                    allowFuture: true,
                    dateFormat: null,
                    minDate: null,
                    maxDate: null
                };

                // Apply and init options
                scope.config = angular.extend(defaultConfig, scope.config);
                if (angular.isDefined(scope.config.minDate)) moment(scope.config.minDate).subtract(1, 'day');
                if (angular.isDefined(scope.config.maxDate)) moment(scope.config.maxDate).add(1, 'day');

                // Data
                scope.calendarCursor = today;
                scope.currentWeeks = [];
                scope.daysNameList = datesCalculator.getDaysNames();
                scope.monthsList = moment.months();
                scope.yearsList = datesCalculator.getYearsList();

                // Display
                scope.pickerDisplayed = false;

                scope.$watch(function () { return ngModel.$modelValue; }, function (value) {
                    if (value) {
                        dateSelected = scope.calendarCursor = moment(value, scope.config.dateFormat);
                    }
                });

                scope.$watch('calendarCursor', function (val) {
                    scope.currentWeeks = getWeeks(val);
                });

                function onDocumentClick(e) {
                    if (template !== e.target && !template[0].contains(e.target) && e.target !== element[0] && e.target.parentNode !== element[0]) {
                        hidePicker();
                    }
                }

                /**
                 * ClickOutside, handle all clicks outside the DatePicker when visible
                 */
                element.bind('click', function (e) {
                    if (!scope.pickerDisplayed) {
                        scope.$apply(function () {
                            scope.pickerDisplayed = true;
                            $document.on('click', onDocumentClick);
                        });
                    } else {
                        hidePicker();
                    }
                });

                function hidePicker() {
                    $document.off('click', onDocumentClick);

                    scope.$apply(function () {
                        scope.calendarCursor = dateSelected ? dateSelected : today;
                        scope.pickerDisplayed = scope.showMonthsList = scope.showYearsList = false;
                    });
                }

                init();

                /**
                 * Display the previous month in the datepicker
                 * @return {}
                 */
                scope.prevMonth = function () {
                    scope.calendarCursor = moment(scope.calendarCursor).subtract(1, 'months');
                };

                /**
                 * Display the next month in the datepicker
                 * @return {}
                 */
                scope.nextMonth = function nextMonth() {
                    scope.calendarCursor = moment(scope.calendarCursor).add(1, 'months');
                };

                /**
                 * Select a month and display it in the datepicker
                 * @param  {string} month The month selected in the select element
                 * @return {}
                 */
                scope.selectMonth = function selectMonth(month) {
                    scope.showMonthsList = false;
                    scope.calendarCursor = moment(scope.calendarCursor).month(month);
                };

                /**
                 * Select a year and display it in the datepicker depending on the current month
                 * @param  {string} year The year selected in the select element
                 * @return {}
                 */
                scope.selectYear = function selectYear(year) {
                    scope.showYearsList = false;
                    scope.calendarCursor = moment(scope.calendarCursor).year(year);
                };

                /**
                 * Select a day
                 * @param  {[type]} day [description]
                 * @return {[type]}     [description]
                 */
                scope.selectDay = function (day) {
                    if (!day.isFuture || (scope.config.allowFuture && day.isFuture)) {
                        resetSelectedDays();
                        day.isSelected = true;
                        ngModel.$setViewValue(moment(day.date).format(scope.config.dateFormat));
                        ngModel.$render();
                        scope.pickerDisplayed = false;
                    }
                };

                /**
                 * Init the directive
                 * @return {}
                 */
                function init() {

                    element.wrap('<div class="ng-flat-datepicker-wrapper"></div>');

                    $compile(template)(scope);
                    element.after(template);

                    if (angular.isDefined(ngModel.$modelValue) && moment.isDate(ngModel.$modelValue)) {
                        scope.calendarCursor = ngModel.$modelValue;
                    }
                }

                /**
                 * Get all weeks needed to display a month on the Datepicker
                 * @return {array} list of weeks objects
                 */
                function getWeeks(date) {

                    var weeks = [];
                    var date = moment(date);
                    var firstDayOfMonth = moment(date).date(1);
                    var lastDayOfMonth = moment(date).date(date.daysInMonth());

                    var startDay = moment(firstDayOfMonth);
                    var endDay = moment(lastDayOfMonth);
                    // NB: We use weekday() to get a locale aware weekday
                    startDay = firstDayOfMonth.weekday() === 0 ? startDay : startDay.weekday(0);
                    endDay = lastDayOfMonth.weekday() === 6 ? endDay : endDay.weekday(6);

                    var currentWeek = [];

                    for (var start = moment(startDay); start.isBefore(moment(endDay).add(1, 'days')); start.add(1, 'days')) {

                        var afterMinDate = !scope.config.minDate || start.isAfter(scope.config.minDate, 'day');
                        var beforeMaxDate = !scope.config.maxDate || start.isBefore(scope.config.maxDate, 'day');
                        var isFuture = start.isAfter(today);
                        var beforeFuture = scope.config.allowFuture || !isFuture;

                        var day = {
                            date: moment(start).toDate(),
                            isToday: start.isSame(today, 'day'),
                            isInMonth: start.isSame(firstDayOfMonth, 'month'),
                            isSelected: start.isSame(dateSelected, 'day'),
                            isSelectable: afterMinDate && beforeMaxDate && beforeFuture
                        };

                        currentWeek.push(day);

                        if (start.weekday() === 6 || start === endDay) {
                            weeks.push(currentWeek);
                            currentWeek = [];
                        }
                    }

                    return weeks;
                }

                /**
                 * Reset all selected days
                 */
                function resetSelectedDays() {
                    scope.currentWeeks.forEach(function (week, wIndex) {
                        week.forEach(function (day, dIndex) {
                            scope.currentWeeks[wIndex][dIndex].isSelected = false;
                        });
                    });
                }
            }
        };
    }
    ngFlatDatepickerDirective.$inject = ["$templateCache", "$compile", "$document", "datesCalculator"];

})();

(function () {

    'use strict';

    /**
     * @desc Dates calculator factory
     */

    angular
        .module('ngFlatDatepicker')
        .factory('datesCalculator', datesCalculator);

    function datesCalculator() {

        /**
         * List all years for the select
         * @return {[type]} [description]
         */
        function getYearsList() {
            var yearsList = [];
            for (var i = 2005; i <= moment().year(); i++) {
                yearsList.push(i);
            }
            return yearsList;
        }

        /**
         * List all days name in the current locale
         * @return {[type]} [description]
         */
        function getDaysNames() {
            var daysNameList = [];
            for (var i = 0; i < 7; i++) {
                daysNameList.push(moment().weekday(i).format('ddd'));
            }
            return daysNameList;
        }

        return {
            getYearsList: getYearsList,
            getDaysNames: getDaysNames
        };
    }

})();

(function() {
    'use strict';

    var dependencies = [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'angAccordion',
        'ngFlatDatepicker',
        'credit-cards',
        'ngDialog',
        'angulartics',
        'angulartics.google.tagmanager',
        'rollerFormRenderer',
        'pascalprecht.translate',
        'angularLoad',
        'ngStorage',
        'roller-email-validation'
    ];

    angular.module('consumerSessions', dependencies);

})();

(function () {

    'use strict';

    angular
        .module('consumerSessions')
        .directive('ziggeoVideo', ziggeoVideo);

    /* @ngInject */
    function ziggeoVideo($window, $document, $q, $timeout, $log) {
        var estimatedZiggeoSize = 135000;//in bytes
        var speedKps = null;
        var directive = {
            restrict: 'E',
            scope: {
                ziggeoToken: '=',
                videoIdentifier: '=',
                isProcessingVideo: '=',
                videoImage: '=',
                onSubmitted: '&?',
                onRecording: '&?',
                onFinished: '&?',
                resumable: '@?',
                isViewOnly: '=',
                showCustomError: '=?',
                embedding: '=?',
                isVisible: '=',
                disableDeviceTest: '=?',
                useLegacyRecorder: '=?'
            },
            templateUrl: 'app/ng/directives/ziggeovideo/ziggeovideo.html',
            replace: true,
            link: {
                pre: ziggeoLink
            }
        };

        return directive;

        /* @ngInject */
        function ziggeoLink(scope) {

            var globalDeferred = null;

            loadZiggeoScript();

            function loadZiggeoScript() {
                if ($window.ZiggeoApi) {
                    embedDynamicPlayer();
                } else {
                    lazyLoadApi().then(function () {
                        if ($window.ZiggeoApi) {
                            embedDynamicPlayer();
                            scope.errorLoading = false;
                        } else {
                            scope.errorLoading = true;
                        }
                    }, function () {
                        scope.errorLoading = true;
                    });
                }
            }

            function embedDynamicPlayer() {
                if (scope.isViewOnly === true) {
                    if (!scope.videoIdentifier) {
                        videoIdentifierWatch(function () {
                            if (scope.isVisible === true) {
                                embedPlayer();
                            } else {
                                visibleWatch(embedPlayer);
                            }
                        });
                    } else {
                        if (scope.isVisible === true) {
                            embedPlayer();
                        } else {
                            visibleWatch(embedPlayer);
                        }
                    }
                } else if (scope.isViewOnly === false) {
                    if (scope.isVisible === true) {
                        embedRecorder();
                    } else {
                        visibleWatch(embedRecorder);
                    }
                }
            }

            function videoIdentifierWatch(callback) {
                var videoIdentifierWatch = scope.$watch('videoIdentifier', function (newValue) {
                    if (newValue) {
                        videoIdentifierWatch();
                        callback();
                    }
                });
            }

            function visibleWatch(callback) {
                var visibleWatch = scope.$watch('isVisible', function (newValue) {
                    if (newValue === true) {
                        visibleWatch();
                        callback();
                    }
                });
            }

            function embedPlayer() {
                $timeout(function () {
                    scope.embedding = $window.ZiggeoApi.Embed.embed('#ziggeoDynamicReplace' + scope.$id,
                        {
                            'video': scope.videoIdentifier,
                            'width' : 320,
                            'height': 240,
                            'responsive': true,
                            'id': scope.$id
                        });

                    attachListener();
                });
            }

            function embedRecorder() {
                $timeout(function () {
                    if (speedKps && speedKps <= 200) {
                        scope.embedding = $window.ZiggeoApi.Embed.embed('#ziggeoDynamicReplace' + scope.$id,
                            {
                                'video': scope.videoIdentifier,
                                'limit': 120,
                                'perms': 'allowupload',
                                'modes': scope.videoIdentifier ? 'rerecorder' : 'recorder',
                                'responsive': true,
                                'height': 240,
                                'width': 320,
                                'recording_width': 320,
                                'recording_height': 240,
                                'disable_device_test': !!scope.disableDeviceTest,
                                'id': scope.$id
                            });
                    } else {
                        scope.embedding = $window.ZiggeoApi.Embed.embed('#ziggeoDynamicReplace' + scope.$id,
                            {
                                'video': scope.videoIdentifier,
                                'limit': 120,
                                'perms': 'allowupload',
                                'modes': scope.videoIdentifier ? 'rerecorder' : 'recorder',
                                'responsive': true,
                                 'height': 240,
                                'width': 320,
                                'disable_device_test': !!scope.disableDeviceTest,
                                'id': scope.$id
                            });
                    }

                    attachListener();
                });
            }

            function attachListener() {

                $window.ZiggeoApi.Events.on("recording", function (data) {
                    if (data.id != scope.$id) {
                        return;
                    }

                    scope.isProcessingVideo = false;

                    if (_.isFunction(scope.onRecording)) {
                        scope.onRecording({ videoData: data });
                    }
                });

                $window.ZiggeoApi.Events.on("submitted", function (data) {
                    if (data.id != scope.$id) {
                        return;
                    }
                    
                    scope.videoIdentifier = data.video.token;
                    scope.isProcessingVideo = false;
                    
                    if (scope.videoIdentifier) {
                        scope.videoImage = $window.ZiggeoApi.Videos.image(scope.videoIdentifier);
                    }

                    if (_.isFunction(scope.onSubmitted)) {
                        scope.onSubmitted({ videoData: data });
                    }
                });

                $window.ZiggeoApi.Events.on("finished", function (data) {
                    if (data.id != scope.$id) {
                        return;
                    }

                    scope.isProcessingVideo = true;
                    if (_.isFunction(scope.onFinished)) {
                        scope.onFinished({ videoData: data });
                    }
                });
            }

            function lazyLoadApi() {
                var startTime, endTime;

                globalDeferred = $q.defer();
                // thanks to Emil Stenström: http://friendlybit.com/js/lazy-loading-asyncronous-javascript/
                if ($document[0].readyState === "complete") {
                    loadCssAndScript();
                } else {
                    if ($window.attachEvent) {
                        $window.attachEvent('onload', loadCssAndScript);
                    } else {
                        $window.addEventListener('load', loadCssAndScript, false);
                    }
                }

                function loadCssAndScript() {
                    var append = '';
                    if (scope.isViewOnly === false) {
                        append = '?' + new Date();
                        startTime = (new Date()).getTime();
                    }

                    var link = $document[0].createElement('link');
                    link.rel = "stylesheet";
                    link.href = '//assets-cdn.ziggeo.com/v1-stable/ziggeo.css' + append;
                    $document[0].head.appendChild(link);

                    var script = $document[0].createElement('script'); // use global document since Angular's $document is weak
                    script.src = '//assets-cdn.ziggeo.com/v1-stable/ziggeo.js' + append;
                    script.onload = checkZiggeoLoaded;
                    $document[0].body.appendChild(script);

                    function checkZiggeoLoaded() {
                        if (scope.isViewOnly === false) {
                            endTime = (new Date()).getTime();
                            measureSpeed();
                        }

                        $window.ZiggeoApi.token = scope.ziggeoToken;
                        $window.ZiggeoApi.Config.resumable = scope.resumable ? scope.resumable : true;
                        $window.ZiggeoApi.Config.webrtc = !scope.useLegacyRecorder;

                        returnPromise();
                    }
                }

                function measureSpeed() {
                    var diff = endTime - startTime;
                    var duration = Math.round((diff) / 1000);
                    if (diff > 10) {
                        var bitsLoaded = estimatedZiggeoSize * 8;
                        var speedBps = Math.round(bitsLoaded / duration);
                        speedKps = speedBps / 1024;
                    } else {
                        speedKps = 1000;
                    }

                    $log.log(speedKps);
                }

                return globalDeferred.promise;
            }

            function returnPromise() {
                if (globalDeferred) {
                    globalDeferred.resolve();
                }
            }
        }
    }
}());
(function() {
    "use strict";

    angular
        .module("consumerSessions")
        .directive("compareTo", compareToDirective);

    /** @ngInject */
    function compareToDirective() {
        return {
            require: "ngModel",
            scope: {
                otherValue: "=compareTo"
            },
            link: function(scope, element, attrs, ngModel) {
                ngModel.$validators.compareTo = function(modelValue) {
                    return ngModel.$isEmpty(modelValue) || modelValue === scope.otherValue;
                };

                scope.$watch("otherValue", function() {
                    ngModel.$validate();
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
      .module('consumerSessions')
      .directive('timePicker', timePicker);

    /** @ngInject */
    function timePicker() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/ng/directives/time-picker/timepicker.html',
            require: 'ngModel',
            scope: {
                startTime: '@',
                increment: '@',
                endTime: '@',
                maxCount: '@'
            },
            replace: true,
            link: LinkFunction,
            controller: LinkController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function LinkFunction(scope, element, attrs, ngModel) {
            var increment = scope.increment ? scope.increment : 15;
            var startTime = scope.startTime ? scope.startTime : 700;
            var endTime = scope.endTime ? scope.endTime : 645;    
            scope.timings = populateTimings(startTime, increment);     
            scope.selectedTime = scope.timings[0];
            
            scope.$watch('selectedTime', function(time){
                if(ngModel.$viewValue != time.value) {
                    ngModel.$setViewValue(time.value);
                    ngModel.$render();
                }
            });

            function populateTimings(start, step) {
                var timing = start;
                var minuteStep = step;
                var timings = [];
                var minuteOffset = 100 - (60 - step);
                timings.push(createTimeStringFromInt(timing));
                var count = 0;
                var maxCount = scope.maxCount ? scope.maxCount : 100;
                while (timing !== endTime && count < maxCount) {
                    var modulus = getModulus((timing + step));
                    if (modulus === 0)
                        minuteStep = minuteOffset;
                    else
                        minuteStep = step;
                    timing = timing + minuteStep;

                    if (timing > 2400) {
                        timing = minuteStep;
                    } else if (timing === 2400) {
                        timing = 0;
                    }

                    timings.push(createTimeStringFromInt(timing));
                    count++;
                }

                return timings;
            }

            function getModulus(value) {
                var valueString = value.toString();

                var lastTwoDigits = value > 99 ? valueString.substr(valueString.length - 2, valueString.length - 1) : valueString;

                return parseInt(lastTwoDigits) % 60;
            }
        }

        /** @ngInject */
        function LinkController($scope) {

        }

        function createTimeStringFromInt(timing) {
            var timeDisplay = calculateTimeDisplay(timing);
            return new TimeDisplay(timing.toString(), timeDisplay);
        }

        function calculateTimeDisplay(time) {
            var currentTime = getFourDigitTimeString(time);
            currentTime = currentTime.slice(0, 2) + ':' + currentTime.slice(2);
            currentTime = appendAMPM(time, currentTime);
            return currentTime;
        }

        function getFourDigitTimeString(time) {
            if (time < 10) {
                return '00' + time + "0";
            } else if (time < 100) {
                return '00' + time;
            } else if (time < 1000) {
                return '0' + time;
            }
            return time.toString();
        }

        function appendAMPM(time, currentTime) {
            if (time < 1200) {
                return currentTime + " AM";
            } else {
                return currentTime + " PM";
            }
        }

        function TimeDisplay(value, display) {
            this.value = value;
            this.display = display;
        }
    }

})();
(function () {

    'use strict';

    angular.module('consumerSessions')
        .service('ticketTimerService', ticketTimerService);

    function ticketTimerService($http, $q, rollerBaseUrl, storageService) {

        var service = {};

        var _recaptchaInitialised = false;
        var _recaptchaRequired = false;

        var _uniqueTimerId = null;

        service.isRecaptchaInitialised = function () {
            return _recaptchaInitialised;
        };

        service.isRecaptchaRequired = function () {
            return _recaptchaRequired;
        };

        service.setRecaptchaInitialisation = function (recaptchaInitialised) {
            _recaptchaInitialised = recaptchaInitialised;
        };

        service.setRecaptchaRequirement = function (recaptchaRequired) {
            _recaptchaRequired = recaptchaRequired;
        };

        service.getUniqueTimerId = function () {
            return _uniqueTimerId;
        }

        service.setUniqueTimerId = function (uniqueTimerId) {
            _uniqueTimerId = uniqueTimerId;
        }

        service.confirmProductsNotSoldOut = function (validationDto) {
            var deferred = $q.defer();

            $http({
                url: rollerBaseUrl.api + 'bookings/timer/validateV2',
                method: 'POST',
                data: validationDto
            }).then(function (response) {
                deferred.resolve(response.data);
                _uniqueTimerId = response.data;
            },
            function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        service.delete = function (uniqueTimerId) {
            _uniqueTimerId = null;

            var deferred = $q.defer();

            if (uniqueTimerId) {
                $http({
                    url: rollerBaseUrl.api + 'bookings/timer/' + uniqueTimerId,
                    method: 'DELETE'
                }).then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve('');
            }
            return deferred.promise;
        }

        service.deleteSync = function () {
            if (_uniqueTimerId) {
                var uniqueTimerId = _uniqueTimerId;
                _uniqueTimerId = null;

                // using jQuery because could not get this to work sync with angular, which
                // is the only way sending a request seems to work on the unload event
                $.ajax({
                    url: rollerBaseUrl.api + 'bookings/timer/' + uniqueTimerId,
                    type: 'delete',
                    async: false,
                    headers: {
                        'X-Api-Key': storageService.load('rw-api-key')
                    }
                });
            }
        }

        return service;
    }

}());

(function () {
    "use strict";

    angular.module("consumerSessions")
           .directive("ticketTimer", function () {
               return {
                   restrict: "E",
                   scope: {
                       booking: "=", // after being initialised, an API call will be made to ensure the products are still available
                                     // expected format: { bookingItems: [{ productId: 123, quantity: 1 }, { productId: 321, quantity: 2 }] }
                       seconds: "=", // the number of seconds the timer runs for
                       timeout: "=", // the function to call when the timer times out
                       soldOut: "=", // the function to call if the booking validation fails (defaults to timeout if not defined)
                       allowTimeExtension: "=", // whether a time extension is permitted after a timeout
                       timeExtensionResponseInSeconds: "=" // when time extensions are enabled, the number of seconds before the time extension offer is revoked
                   },
                   controller: "ticketTimerController",
                   controllerAs: "vm",
                   templateUrl: "app/ng/directives/ticket-timer/ticketTimer.html"
               }
           });
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("ticketTimerController", TicketTimerController);

    /** @ngInject */
    function TicketTimerController($scope, $interval, $translate, orderService, settingsService, ticketTimerService) {
        var vm = this;
        var _timer = null;

        vm.allowTimeExtension = angular.isDefined($scope.allowTimeExtension) ? $scope.allowTimeExtension : true;
        vm.timeExtensionResponseInSeconds = $scope.timeExtensionResponseInSeconds ? $scope.timeExtensionResponseInSeconds : 10;
        vm.seconds = $scope.seconds ? $scope.seconds : 60;
        vm.timeRemaining = getFormattedTime(0);
        vm.timedOut = false;

        initialise();

        function initialise() {
            if (!$scope.timeout) {
                throw 'The function callback "timeout" is required';
            }

            setupTimer();

            // allow the app using this directive to extend the timer, e.g. if user is active on the page,
            // makes sense to give them more time since you know they are at least trying to finish the booking
            $scope.$on('ticket-timer-extend', function (event, args) {
                if (args && args.seconds) {

                    vm.seconds = args.seconds;
                    setupTimer();
                }
            });

            // it's possible the user navigates away from the booking, e.g. back to product selection - so
            // if this directive is removed from the DOM we need to stop any background tasks
            $scope.$on("$destroy", function () {
                cancelTimer();

                if (vm.uniqueTimerId && !orderService.isProcessed()) {
                    ticketTimerService.delete(vm.uniqueTimerId);
                }
            });

            window.onunload = function () {
                if (!orderService.isProcessed()) {
                    ticketTimerService.deleteSync();
                }
            };

            window.timerRecaptchaCallback = getTimer;

            if (settingsService.canUseRecaptcha()) {
                setupRecaptcha();
            }
            else {
                getTimer();
            }
        }

        function setupRecaptcha() {
            if (ticketTimerService.isRecaptchaInitialised()) {
                return;
            }

            ticketTimerService.setRecaptchaRequirement(true);

            try {    
                return window.recaptchaLoaded.then(function () {
                    grecaptcha.render('recaptcha', {
                        'sitekey': RollerEnvironment.googleInvisibleRecaptchaPublicKey,
                        'size': 'invisible',
                        'callback': timerRecaptchaCallback
                    });
                    ticketTimerService.setRecaptchaInitialisation(true);
                });
            }
            catch (error) {
                console.error('Recaptcha error: ', error);
            }
        }

        function getTimer(recaptcha) {
            var booking = getBooking();

            var validationDto = {
                booking: booking,
                recaptcha: {
                    response: recaptcha,
                    isInvisible: true
                }
            }

            ticketTimerService.confirmProductsNotSoldOut(validationDto).then(
                function (result) {
                    vm.uniqueTimerId = result;

                    if (_.isFunction(ticketTimerService.callback) && settingsService.canUseRecaptcha()) {
                        ticketTimerService.callback();
                    }
                },
                function (error) {
                    // if there's an error besides BadRequest we let it continue since a
                    // check is made server-side later anyway if a valid uniqueTimerId does not exist
                    if (error && (error.status == 400 || error.status == 409)) {
                        if (error.data && error.data.message === 'MISSING_RECAPTCHA' && !settingsService.canUseRecaptcha() && settingsService.canUseBookingTimer) {
                            settingsService.setCanUseRecaptcha(true);

                            setupRecaptcha().then(function () {
                                if (_.isFunction(ticketTimerService.callback)) {
                                    grecaptcha.execute();
                                }
                            });

                            return;
                        }

                        if ($scope.soldOut) {
                            $scope.soldOut();
                        }
                        else {
                            $scope.timeout(true);
                        }
                    }
                });
        }

        function getBooking() {
            if (angular.isFunction($scope.booking)) {
                return $scope.booking();
            }
            return $scope.booking;
        }

        function getFormattedTime(secondsPassed) {
            var mins = parseInt(vm.seconds / 60).toString();
            var seconds = (vm.seconds % 60).toString();
            var formattedTime = moment(mins + ':' + seconds, 'mm:ss').subtract(secondsPassed, 'seconds').format('m:ss');
            return formattedTime;
        }

        function setupTimer() {
            cancelTimer();
            var secondsPassed = 0;

            _timer = $interval(function () {
                secondsPassed++;
                vm.timeRemaining = getFormattedTime(secondsPassed);

                if (secondsPassed >= vm.seconds) {
                    cancelTimer();

                    if (vm.allowTimeExtension) {
                        var timeBeforeMsg = moment();

                        if (confirm($translate.instant('GENERIC.SESSION_EXPIRING'))) {
                            // CODE: if we were using a nice modal instead of confirm() we be easier, i.e.
                            // confirm() blocks the thread so we can't close it or anything
                            if (moment() - timeBeforeMsg > vm.timeExtensionResponseInSeconds * 1000) {
                                alert($translate.instant('GENERIC.OUT_OF_TIME'));
                                $scope.timeout();
                            }
                            else {
                                setupTimer();
                            }
                        }
                        else {
                            $scope.timeout();
                        }
                    }
                    else {
                        $scope.timeout(true);
                    }
                }

            }, 1000);

            window.onbeforeunload = function (e) {
                if (orderService.isPaymentRedirecting()) {
                    delete e['returnValue'];
                } else {
                    return 'Are you sure you want to reload?';
                }
            }
        }

        function cancelTimer() {
            if (angular.isDefined(_timer)) {
                $interval.cancel(_timer);
                _timer = undefined;
            }
            window.onbeforeunload = undefined;
        }
    }

})();

(function () {
    'use strict';

    angular.module('consumerSessions')
        .directive('stepCounter', function () {
            return {
                restrict: 'E',
                replace: false,
                scope: {},
                controller: 'StepCounterController',
                controllerAs: 'vm',
                templateUrl: 'app/ng/directives/step-counter/step-counter.html'
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .controller('StepCounterController', StepCounterController);

    /** @ngInject */
    function StepCounterController(orderService, wizardNavigationService, $rootScope, productService, $scope, $timeout) {
        var vm = this;

        $rootScope.$on('$stateChangeSuccess', updateCounter);
        $scope.$on('products-loaded', updateCounter);

        function updateCounter() {
            var states = _.pluck(wizardNavigationService.navigableStates(), 'name');
            var activeStepName = wizardNavigationService.activeState().name;

            if (productService.consumerWidgetGroupTwo()) {
                states.splice(1, 0, 'sessions.home2');
            }

            if ((activeStepName === 'sessions.details' || activeStepName === 'sessions.payment') && !orderService.canBuyAddOns()) {
                states = _.difference(states, ['sessions.addons']);
            }
            else if (productService.isDonationOnly()) {
                states = _.difference(states, ['sessions.home', 'sessions.home2']);
            }

            states = _.uniq(states);

            vm.stepIndex = states.indexOf(activeStepName) + 1;
            vm.stepsCount = states.length;
        }

        updateCounter();
    }
})();

(function () {

    'use strict';
    angular
        .module('consumerSessions')
        .directive('soldOut', soldOut);

    function soldOut() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/ng/directives/product-status/soldout.html'
        };
        return directive;
    }

})();
(function () {

    'use strict';
    angular
        .module('consumerSessions')
        .directive('salesClosed', salesClosed);

    function salesClosed() {
        var directive = {
            restrict: 'E',
            replace: true,
            scope: {
                bookingPhoneNumber: '='
            },
            templateUrl: 'app/ng/directives/product-status/sales-closed.html',
            link: function (scope) {
                scope.callToBook = function (phoneNumber) {
                    if (!phoneNumber) {
                        return;
                    }
                    
                    setTimeout(function () {
                        var link = document.createElement('a');
                        link.href = 'tel:' + phoneNumber;
                        var container = document.getElementById('linkHolder');
                        container.appendChild(link);
                        link.click();
                        container.removeChild(link);
                    });
                }
            }
        };
        return directive;
    }

})();
(function () {
    "use strict";

    angular.module('consumerSessions')
        .directive('numberInput', numberInputDirective);

    /** @ngInject */
    function numberInputDirective($rootScope) {
        return {
            replace: true,
            scope: {
                value: '&',
                increase: '&',
                canIncrease: '&',
                decrease: '&',
                canDecrease: '&',
                ticket: '=',
                qtyAdded: '=',
                textFocus: '&'
            },
            templateUrl: 'app/ng/directives/number-input/number-input.directive.html',
            link: function (scope) {
                scope.ifUndefined = function (value, valueIfUndefined) {
                    return _.isUndefined(value) ? valueIfUndefined : value;
                }
                scope.ticketQuantityChanged = function (ticket) {
                    if (ticket.quantity > 1000) {
                        ticket.quantity = 1000;
                    }
                    else if (ticket.quantity < ticket.minQuantity) {
                        ticket.quantity = ticket.minQuantity;
                    }
                    else if (ticket.quantity > 0) {
                        ticket.quantity = parseInt(ticket.quantity);
                    }
                    else {
                        ticket.quantity = 0;
                    }
                    $rootScope.$broadcast("ticket-quantity-changed", { ticket: ticket });
                }

                scope.ticketQuantityFocus = function () {
                    if (scope.textFocus) {
                        scope.textFocus();
                    }
                }
            }
        }
    }
})();

(function () {

    'use strict';

    /**
     * @desc loader directive
     * @example <loader></loader>
     */

    angular
        .module('consumerSessions')
        .directive('loader', loader);

    /** @ngInject */
    function loader($window, $rootScope) {
        
        var currentNodes = 0;
        var directive = {
            restrict: 'E',
            templateUrl: 'app/ng/directives/loader/loader.html',
            scope: {
                loadingText: '@?',
                isLoading: '=',
                isForHpp: '='
            },
            link: loaderLinker
        };

        return directive;

        /** @ngInject */
        function loaderLinker(scope) {
            var windowEl = angular.element($window);
            var handler = function () {
                scope.pageYOffset = windowEl.scrollTop();
            };

            var containerDiv = angular.element(document).find("#loading-additional")[0];
            if (containerDiv) {            
                var handlerMutation = function (mutations) {
                    for (var i = 0; i < mutations.length; i++) {
                        var mutation = mutations[i];
                        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                            currentNodes += mutation.addedNodes.length;
                        }
                        if (mutation.removedNodes && mutation.removedNodes.length > 0) {
                            currentNodes -= mutation.removedNodes.length;
                        }
                    }
                    scope.$apply(function () {
                        if (currentNodes > 0) {
                            scope.isRedirecting = true;
                        } else {
                            scope.isRedirecting = false;
                        }
                    });
                };
                var objConfig = {
                    childList: true,
                    subtree: true,
                    attribute: false,
                    characterData: false
                };
                var observer = new MutationObserver(handlerMutation);
                observer.observe(containerDiv, objConfig);
            }

            $rootScope.$broadcast('loader-available');

            windowEl.on('scroll', scope.$apply.bind(scope, handler));
            handler();
        }

    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
           .directive("costModifiers", function () {
               return {
                   restrict: "E",
                   replace: false,
                   scope: { },
                   controller: "costModifiersController",
                   controllerAs: "vm",
                   templateUrl: "app/ng/directives/cost-modifiers/cost-modifiers.html"
               }
           });
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("costModifiersController", CostModifiersController);

    /** @ngInject */
    function CostModifiersController($scope, orderService, ngDialog) {
        
        var vm = this;
        vm.costModifiers = [];

        var tickets = orderService.tickets();
        _.each(tickets.items, function (ticket) {
            if (_.some(ticket.bookingCostModifiers)) {
                _.each(ticket.bookingCostModifiers, function (bcm) {
                    if (!bcm.isRequired && !_.some(vm.costModifiers, { id: bcm.id })) {
                        vm.costModifiers.push(bcm);
                    }
                });
            }
        });

        if (vm.costModifiers.length) {
            // e.g. user clicks back, need to see if the order already has modifiers selected
            var costModifiersOnOrder = orderService.bookingCostModifiers();
            if (costModifiersOnOrder && costModifiersOnOrder.length) {
                _.each(vm.costModifiers, function (cm) {
                    cm.isSelected = _.some(costModifiersOnOrder, { id: cm.id });
                });
            }
        }

        vm.calculateAmount = orderService.calculateBookingCostModifier;

        vm.modifierChanged = function (costModifier) {
            if (costModifier.isSelected) {
                orderService.addBookingCostModifier(costModifier);
            }
            else {
                orderService.removeBookingCostModifier(costModifier);
            }
        }

        vm.bookingCostModifierPolicy = function (bcm) {
            ngDialog.open({
                template: 'app/views/modals/terms.and.conditions.html',
                controller: 'TermsAndConditionsController',
                controllerAs: 'vm',
                className: 'ngdialog-theme-roller',
                resolve: {
                    product: function () {
                        return {
                            termsAndConditionsText: bcm.termsAndConditions,
                            ignoreVenue: true
                        };
                    }
                }
            });
        }
    }

})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("TermsAndConditionsController", TermsAndConditionsController);

    /** @ngInject */
    function TermsAndConditionsController(venueService, product, orderService, type) {

        var vm = this;
        var ignoreVenue = product && product.ignoreVenue;
        vm.isPayment = type === 'payment_tos';
        vm.isPrivacy = type === 'privacy_policy';

        if (vm.isPayment) {
            venueService.getPaymentTermsAndConditions().then(function(result) {
                vm.termsAndConditions = [result];
            });
        } else if (vm.isPrivacy) {
            venueService.getPrivacyPolicy().then(function(result) {
                vm.termsAndConditions = [result];
            });
        } else if (product) {
            vm.termsAndConditions = [product.termsAndConditionsText];
        }
        else {
            // multi-product scenario, get the first one
            vm.termsAndConditions = orderService.getTermsAndConditions();
        }

        if (!ignoreVenue) {
            venueService.getVenue().then(function (venue) {
                vm.codeOfConduct = venue.codeOfConduct;
            });
        }
    }

})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("RedeemGiftcardController", RedeemGiftcardController);

    /** @ngInject */
    function RedeemGiftcardController(giftcard, settingsService, giftcardService) {
        var vm = this;
        vm.giftcard = giftcard;
        vm.settings = settingsService;
        vm.deduct = deduct;

        function deduct(amount) {
            if (vm.inProgress) {
                return;
            }

            vm.inProgress = true;
            giftcardService.deduct(giftcard.uniqueBookingId, giftcard.giftcardNumber, amount, vm.passcode).then(
                function () {
                    vm.hasDeducted = true;
                },
                function (response) {
                    vm.error = response.data && response.data.message || 'Something went wrong, please try again.';
                })
                .finally(function () {
                    vm.inProgress = false;
                });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("MessageModalController", MessageModalController);

    /** @ngInject */
    function MessageModalController(title, message, okButtonText, cancelButtonText) {
        var vm = this;
        vm.message = message;
        vm.title = title;
        vm.okButtonText = okButtonText;
        vm.cancelButtonText = cancelButtonText;
    }

})();

/*
 * angaccordion
 * Accordion directive for AngularJS
 * Licensed under the MIT license
 */

(function() {
    'use strict';

    angular
      .module('angAccordion', ['collapsibleItem'])
      .controller('angAccordionController', ['$scope', function($scope){
        var collapsibleItems = [];

          this.openCollapsibleItem = function(collapsibleItemToOpen) {
            if( $scope.oneAtATime ) {
              angular.forEach(collapsibleItems, function(collapsibleItem) {
                collapsibleItem.isOpenned = false;
                collapsibleItem.icon = collapsibleItem.closeIcon;
              });
            }
            collapsibleItemToOpen.isOpenned = true;
          };

          this.addCollapsibleItem = function(collapsibleItem) {
            collapsibleItems.push(collapsibleItem);

            if ( $scope.closeIconClass !== undefined || $scope.openIconClass !== undefined ) {
              collapsibleItem.iconsType = 'class';
              collapsibleItem.closeIcon = $scope.closeIconClass;
              collapsibleItem.openIcon = $scope.openIconClass;
            }
            else if ( $scope.closeIconUrl !== undefined || $scope.openIconUrl !== undefined ) {
              collapsibleItem.iconsType = 'url';
              collapsibleItem.closeIcon = $scope.closeIconUrl;
              collapsibleItem.openIcon = $scope.openIconUrl;
            }

            collapsibleItem.iconIsOnLeft = $scope.iconPosition == 'left' ? true: false;
          };

      }])
      .directive('angAccordion', function() {
      return {
        restrict: 'EA',
        transclude: true,
        replace: true,
        scope: {
          oneAtATime: '@',
          closeIconUrl: '@',
          openIconUrl: '@',
          closeIconClass: '@',
          openIconClass: '@',
          iconPosition: '@'
        },
        controller: 'angAccordionController',
        template: '<div class="accordion" ng-transclude></div>'
      };
    });

    angular.module('collapsibleItem', []).directive('collapsibleItem', function() {
      return {
        require: '^angAccordion',
        restrict: 'EA',
        transclude: true,
        replace: true,
        scope: {
          itemTitle: '@',
          itemDisabled: '=',
          initiallyOpen: '='
        },
        link: function(scope, element, attrs, accordionController) {
          scope.isOpenned = (scope.initiallyOpen) ? true : false;
          accordionController.addCollapsibleItem(scope);

          if(scope.isOpenned)
            scope.icon = scope.openIcon;
          else
            scope.icon = scope.closeIcon;

          scope.toggleCollapsibleItem = function () {
            if(scope.itemDisabled)
              return;

            if(!scope.isOpenned) {
              accordionController.openCollapsibleItem(this);
              scope.icon = scope.openIcon;
            }
            else {
              scope.isOpenned = false;
              scope.icon = scope.closeIcon;
            }
          };

          scope.getIconUrl = function ( type ) {
            return type == 'url' ? scope.icon : null;
          };
        },
        template: '<div class="collapsible-item" ng-class="{open: isOpenned}"><div class="title" ng-class="{disabled: itemDisabled}" ng-click="toggleCollapsibleItem()">{{itemTitle}}<i ng-show="iconsType == \'class\'" class="{{icon}} icon" ng-class="{iconleft: iconIsOnLeft}"></i><img ng-show="iconsType == \'url\'" class="icon" ng-class="{iconleft: iconIsOnLeft}" ng-src="{{getIconUrl(iconsType)}}" /></div><div class="body"><div class="content" ng-transclude></div></div></div>'
      };
    });
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("wizardNavigationService", wizardNavigationService);

    /** @ngInject */
    function wizardNavigationService($state, $rootScope, $log, settingsService, orderService, productService, ticketTimerService, postMessage, $q) {

        var service = {};
        var states = _.chain($state.get())
            .filter(function (s) {
                return !s.abstract &&
                    _.isObject(s.data) &&
                    s.data.order;
            })
            .map(function (s) {
                return {
                    name: s.name,
                    displayName: s.data.displayName,
                    translationKey: s.data.translationKey,
                    order: s.data.order,
                    progress: s.data.progress,
                    navigable: !s.data.hidden,
                    nextButtonTextTranslationKey: s.data.nextButtonTextTranslationKey || "INDEX.ROUTE.CONTINUE"
                };
            })
            .sortBy('order')
            .value();

        var statesHash = _.indexBy(states, 'name');
        var navigableStates = _.where(states, { navigable: true });

        service.navigableStates = _.constant(navigableStates);

        service.cartState = true;

        service.isComplete = function (stateName) {
            var completeStates = _.takeWhile(states, function (s) {
                return s.name !== $state.$current.name;
            });
            return _.some(completeStates, 'name', stateName);
        };

        service.isActive = function (stateName) {
            if (stateName === 'sessions.home' && $state.$current.name === 'sessions.home2') {
                return true;
            }
            return $state.is(stateName);
        }

        service.activeState = function () {
            return _.findWhere(states, { name: $state.$current.name });
        };

        service.activeStateTranslationKey = function () {
            if ($state.is('sessions.home') && settingsService.isDateLed && !orderService.hasDateSelected()) {
                return 'INDEX.WIZARD.TITLE.DATE';
            }

            return service.activeState().translationKey;
        }

        service.nextButtonText = function () {
            if ($state.is('sessions.payment')) {
                return orderService.getPaymentText();
            }

            return service.activeState().nextButtonTextTranslationKey;
        }

        service.getCartState = function () {
            return service.cartState;
        }

        service.toggleCart = function () {
            service.cartState = !service.cartState;
        }

        service.showNavigation = function () {
            if ($state.$current.name === 'sessions.home2') {
                return true;
            }
            return statesHash[$state.$current.name].navigable;
        };

        service.next = function () {
            var next = states[stateIndex(1)];
            var name = next ? next.name : null;

            if (name === 'sessions.home2' && !productService.consumerWidgetGroupTwo()) {
                name = 'sessions.addons';
            }

            return name;
        };

        service.previous = function () {
            if ($state.is('sessions.addons') && productService.isDonationOnly()) {
                return false;
            }

            var previous = states[stateIndex(-1)];
            var name = previous && previous.name;

            return name;
        };

        service.canGoTo = orderService.canTransitionTo;

        service.go = function (stateName) {
            if (service.canGoTo(stateName)) {
                postScrollMessageToParent();
                $state.go(stateName);
            }
        }

        service.movePrevious = function () {
            if (orderService.inProgress) {
                return false;
            }

            var previous = service.previous();

            $log.info('service.movePrevious', previous);
            service.go(previous);

            return previous;
        }

        service.moveNext = function () {
            if (orderService.inProgress) {
                return false;
            }

            orderService.setClickedContinue(true);
            var next = service.next();

            $rootScope.$broadcast('sessions.before-going-next');

            if (service.canGoTo(next, true)) {
                var consumerWidgetGroup = productService.consumerWidgetGroup();

                if (next === 'sessions.payment') {
                    ticketTimerService.callback = _.partial(service.processMove, next);

                    if ((consumerWidgetGroup && consumerWidgetGroup.useRecaptcha) || (settingsService.canUseRecaptcha())) {
                        try {
                            var response = grecaptcha.getResponse();

                            if (!response && (!settingsService.canUseRecaptcha() || !ticketTimerService.getUniqueTimerId())) {
                                grecaptcha.execute();
                                return next;
                            }
                        }
                        catch (error) {
                            console.error('Recaptcha error: ', error);
                        }
                    }
                }

                service.processMove(next);
            }

            return next;
        }

        service.processMove = function (next) {
            var goNext = _.isFunction($rootScope.beforeMovingNext) ? $rootScope.beforeMovingNext() : $q.when();

            goNext.then(function () {
                postScrollMessageToParent();
                orderService.setClickedContinue(false);

                if (next === 'sessions.home2') {
                    orderService.countGroupOneTickets();
                }

                $state.go(next);
            });
        }

        service.canMoveNext = function () {
            return service.canGoTo(service.next());
        }

        service.isProductSelectionStep = function () {
            return $state.is('sessions.home') || $state.is('sessions.home2') || $state.is('sessions.addons');
        }

        function stateIndex(increment) {
            return _.findIndex(states, { name: $state.$current.name }) + (increment || 0);
        }

        // in case we're inside an iframe
        function postScrollMessageToParent() {
            postMessage("parent", {
                action: "scroll",
                location: "middle",
                offset: -50
            }, "*");
        }

        service.isCartVisible = _.bind(orderService.isCartVisible, orderService);
        service.hideNextButton = function () {
            return $state.is('sessions.payment') && orderService.payUsingExtenalMethod() ||
                settingsService.isDateLed && !orderService.hasDateSelected() ||
                $state.is('sessions.home') && !productService.productsAreLoaded();
        }

        return service;
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("venueService", venueService);

    /** @ngInject */
    function venueService($http, $q, rollerBaseUrl) {
        
        var service = {};
        var _venue = null;

        service.getVenue = function () {
            var deferred = $q.defer();
            if (_venue) {
                deferred.resolve(_venue);
            }
            else {
                $http({
                    url: rollerBaseUrl.legacyApi + "venues/me",
                    method: 'GET'
                }).then(function (response) {
                    _venue = response.data;
                    deferred.resolve(response.data);
                },
                    function (response) {
                        deferred.reject(response);
                    });
            }
            return deferred.promise;
        };

        service.getPaymentTermsAndConditions = function () {
            return $http.get(rollerBaseUrl.cdn.replace(/\/+$/, '') + '/file/payment-tos.html').then(_.property('data'));
        };

        service.getPrivacyPolicy = function () {
            return $http.get(rollerBaseUrl.cdn.replace(/\/+$/, '') + '/file/privacy-policy.html').then(_.property('data'));
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .factory('customTranslateLoader', customTranslateLoader)
        .config(translateConfig)
        .run(initTranslation)
        .run(initVenueTranslation);

    var _englishUrl = '/app/translations/translate.en.json';
    var _venueOverrideSuffix = '-VENUE';

    /** @ngInject */
    function customTranslateLoader($http, $q, rollerBaseUrl, $rootScope, settingsService) {
        return function (options) {
            var languageCode = options.key.replace(_venueOverrideSuffix, '');
            var isEnglish = languageCode === 'en';
            $rootScope.languageCode = languageCode;

            // CODE: adding translations/... to rollerBaseUrl.cdn was resulting in some crazy behaviour where
            // the translations part was being replaced by a local path - absolutely no idea how this was happening
            // but removing the end slash from rollerBaseUrl.cdn and adding it to the start of translations works...
            var cdnUrl = rollerBaseUrl.cdn.replace(/\/?$/, '');
            var url = isEnglish ? _englishUrl : cdnUrl + '/translations/translate-cx-' + languageCode + '.json';
            var venueTranslationOverrideAvailable = options.key.indexOf(_venueOverrideSuffix) > 0;

            if (venueTranslationOverrideAvailable) {
                // CODE: not ideal downloading the original file twice, but it's better than
                // showing the translation keys - we can change this if we implement a bootstrap/waiting screen
                var venueSlug = settingsService.venueSlug.toLocaleLowerCase();
                var venueOverrideUrl = cdnUrl + '/translations/venue/' + venueSlug + '-cx-' + languageCode + '.json';

                return $q.all([$http.get(url), $http.get(venueOverrideUrl)]).then(function (responses) {
                    var json = getTranslationData(responses[0].data);
                    var venueJson = getTranslationData(responses[1].data);
                    return _.merge(json, venueJson);
                }, function () {
                    return {};
                });
            }

            return $http.get(url).then(function (response) {
                return getTranslationData(response.data);
            },
                function () {
                    return $http.get(_englishUrl).then(function (response) {
                        return getTranslationData(response.data);
                    });
                });
        };
    }

    function getTranslationData(data) {
        return _.isString(data) ? JSON.parse(data) : data;
    }

    /** @ngInject */
    function translateConfig($translateProvider) {
        $translateProvider
            .useLoader('customTranslateLoader')
            .useSanitizeValueStrategy('escapeParameters')
            .addInterpolation('$translateMessageFormatInterpolation')
            .useMissingTranslationHandler('missingTranslationKeyHandlerFactory')
            .fallbackLanguage('en');
    }

    angular.module('consumerSessions').factory('missingTranslationKeyHandlerFactory', function () {
        // has to return a function which gets a tranlation ID
        return function (translationKey) {
            const split = translationKey ? translationKey.split('.') : [''];
            return split[split.length - 1];
        };
    });

    /** @ngInject */
    function initTranslation($translate, settingsService) {
        $translate.use(settingsService.languageCode);
    }

    /** @ngInject */
    function initVenueTranslation($translate, $timeout, settingsService) {
        var languageCode = settingsService.languageCode.split('-')[0];

        if (settingsService.getTranslationOverrideLanguageCodes().indexOf(languageCode) >= 0) {
            // NOTE: if we don't use $timeout the translation keys are more likely to show -
            // the venue overrides show up slightly after the page load.  also, the use(...)
            // was the only to trigger the customer loader twice
            $timeout(function () { $translate.use(settingsService.languageCode + _venueOverrideSuffix); });
        }
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("storageService", storageService);

    /** @ngInject */
    function storageService($log) {
        var _storage = [];
        var service = {};

        service.load = function (key) {
            var keyValue = _.findWhere(_storage, { key: key });
            if (keyValue) {
                return keyValue.value;
            }
            $log.debug("'" + key + "' not found in session storage.");
        }

        service.save = function (key, value) {
            if (_.some(_storage, function (store) { return store.key === key; })) {
                service.delete(key);
            }
            _storage.push({ key: key, value: value });
            $log.debug("'" + key + "' saved to session storage.")
        }

        service.delete = function (key) {
            _storage = _.reject(_storage, function (store) { return store.key === key; });
            $log.debug("'" + key + "' deleted from session storage.");
        }

        return service;
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("settingsService", settingsService);

    /** @ngInject */
    function settingsService($window, insideIframe, storageService, venueService) {

        var _isLoaded = false;
        var _cellId;
        var _groupName = '';
        var _productId = '';
        var RTL_LANGUAGE_CODES = ['ar'];
        var service = {
            widgetAttributes: {}
        };

        applySettings(window.settings);

        function applySettings(settings) {
            Object.assign(service, settings);
            _cellId = service.cell;
            service.currencySymbol = service.currencySymbol || '$';
            service.venueCountryCode = service.venueCountryCode ? service.venueCountryCode.toUpperCase() : undefined;
            service.venueCountryLocale = getQueryStringValue('l') || service.venueCountryLocale || 'en-AU';
            service.languageCode = getQueryStringValue('l') || service.venueLanguage || service.venueCountryLocale;
            service.venueSlug = storageService.load('rw-api-key') || service.widgetAttributes['venue-slug'] || settings.venueSlug;
            service.ziggeoToken = service.ziggeoToken || 'd61b6dc840cdfd969a6701a9e443e061';
            service.correlationId = generateGuid();
            service.insideIframe = insideIframe;
            _groupName = settings.checkoutSlug;
            _productId = settings.productId;

            if (_.isUndefined(service.useLegacyRecorder) || _.isNull(service.useLegacyRecorder)) {
                service.useLegacyRecorder = true;
            }
        }

        service.refreshCorrelationId = function () {
            service.correlationId = generateGuid();
        }

        service.businessWebsite = function () {
            if (insideIframe) {
                return null;
            }
            return service.venueBusinessWebsite;
        }

        service.groupName = function () {
            return _groupName;
        }

        service.productId = function () {
            return _productId;
        }

        var _initialDateIndex = null;
        service.initialDateIndex = function () {
            if (!_initialDateIndex) {
                var params = new URLSearchParams($window.location.search);
                var date = params.has('date') ? params.get('date') : undefined;

                _initialDateIndex = moment(date).locale('en').format('YYYYMMDD');

                if (_initialDateIndex) {
                    var currentDateIndex = moment().locale('en').format('YYYYMMDD');

                    if (_initialDateIndex < currentDateIndex) {
                        _initialDateIndex = currentDateIndex;
                    }
                }
            }

            return _initialDateIndex;
        }

        var _initialToDateIndex = null;
        service.initialToDateIndex = function () {
            if (!_initialToDateIndex) {
                var toDate = $window.location.search['toDate'];
                _initialToDateIndex = toDate ? moment(toDate).locale('en').format('YYYYMMDD') : undefined;

                if (_initialToDateIndex) {
                    var currentDateIndex = moment().locale('en').format('YYYYMMDD');

                    if (_initialToDateIndex < currentDateIndex) {
                        _initialToDateIndex = currentDateIndex;
                    }
                }
            }

            return _initialToDateIndex;
        }

        service.widgetUsedExternally = function () {
            return service.widgetAttributes['widget-used-externally'] == 'true' ? true : false;
        }

        service.momentVenueTime = function () {
            return moment(service.venueDateTime) || moment();
        }

        service.getTranslationOverrideLanguageCodes = function () {
            var languageCodes = service.translationOverrideLanguageCodes;
            return languageCodes ? languageCodes : [];
        }

        service.isRtl = function () {
            var primaryCode = (service.languageCode || '').split('-')[0].toLowerCase();
            return RTL_LANGUAGE_CODES.indexOf(primaryCode) >= 0;
        }

        var _capturePostcode = null;
        service.capturePostcode = function (capturePostcode) {
            if (angular.isDefined(capturePostcode)) {
                _capturePostcode = capturePostcode;
            }
            return _capturePostcode !== null ? _capturePostcode : service.capturePostCode;
        }

        service.showHeader = function () {
            if (insideIframe) {
                return false;
            }
            return service.widgetAttributes['rw-show-header'] == 'true' ? true : false;
        }

        var _bookingMade = false;
        service.hasBookingBeenMade = function () {
            return _bookingMade;
        }

        service.bookingMade = function () {
            _bookingMade = true;
        }

        var _discountCodeOnlyFlow = null;
        service.discountCodeOnlyFlow = function (discountCodeOnlyFlow) {
            if (angular.isDefined(discountCodeOnlyFlow)) {
                _discountCodeOnlyFlow = discountCodeOnlyFlow;
            }
            return _discountCodeOnlyFlow;
        }

        var _hideSessionDuration = false;
        service.hideSessionDuration = function (hideSessionDuration) {
            if (angular.isDefined(hideSessionDuration)) {
                _hideSessionDuration = hideSessionDuration;
            }
            return _hideSessionDuration;
        }

        var _bookingTimer = {
            timerInSeconds: 60 * 10,
            timerExtensionConfirmationInSeconds: 10
        };
        service.bookingTimer = function (bookingTimer) {
            if (angular.isDefined(bookingTimer)) {
                _bookingTimer = bookingTimer;
            }
            return _bookingTimer;
        }

        function showDatePickerForTickets() {
            return pageContainsClass('feature--show-tickets-calendar');
        }

        function hideDatePicker() {
            return pageContainsClass('feature--hide-calendar');
        }

        service.showDatePicker = function (hideCalendar) {
            if (hideCalendar === true || !_isLoaded) {
                return false;
            }
            else if (hideCalendar === false) {
                // even if the widget option HideCalendar is explicitly set to false, we still cannot
                // show the date picker when using date ranges because the feature doesn't support it
                return !service.initialToDateIndex();
            }
            return !hideDatePicker() && (!service.productId() || showDatePickerForTickets()) && !service.initialToDateIndex();
        }

        service.showDateInCart = function () {
            return !hideDatePicker();
        }

        service.setCellId = function (id) {
            _cellId = id;
        }

        service.getCellId = function () {
            return _cellId;
        }

        var _pageClassCache = {};
        function pageContainsClass(className) {
            if (!angular.isDefined(_pageClassCache[className])) {
                _pageClassCache[className] = $('head').html().indexOf(className) >= 0;
            }
            return _pageClassCache[className];
        }

        function getQueryStringValue(key) {
            var queryString = window.location.search;
            if (queryString && key) {
                queryString = queryString.replace('?', '');
                var split = queryString.split('&');
                var match = _.find(split, function (s) { return s.indexOf(key + '=') === 0; });
                if (match) {
                    return match.split('=')[1];
                }
            }
            return null;
        }

        function generateGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                .replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0;
                    var v = c === 'x'
                        ? r
                        : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
        }

        service.isLoaded = function () {
            _isLoaded = true;
        }

        service.canUseRecaptcha = function () {
            // recaptcha is only valid when booking timer is enabled for the venue
            return service.useRecaptcha && service.canUseBookingTimer;
        }

        service.setCanUseRecaptcha = function (value) {
            service.useRecaptcha = !!value;
        }

        return service;
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("productService", productService);

    /** @ngInject */
    function productService($http, $q, rollerBaseUrl, settingsService, contentService, rollerCurrencyFilter, $translate, productPromotionService, $rootScope) {
        var service = {};

        var _products;
        var _originalProducts;
        var _consumerWidgetGroup;
        var _consumerWidgetGroupTwo;
        var _productsAreLoaded = false;
        var _venueTime = settingsService.momentVenueTime();
        var _productsByDate = {};

        service.productsAreLoaded = function () {
            return _productsAreLoaded;
        }

        service.consumerWidgetGroup = function () {
            return _consumerWidgetGroup;
        }

        service.consumerWidgetGroupTwo = function () {
            return _consumerWidgetGroupTwo;
        }

        service.isDonationOnly = function () {
            return _consumerWidgetGroup && _consumerWidgetGroup.donationOnly;
        }

        service.getProductById = function (productId, date) {
            if (date) {
                return _.findWhere(_productsByDate[date], { productId: productId });
            }

            return _.findWhere(_originalProducts, { productId: productId });
        }

        service.getProducts = function (date, useCurrentProducts) {

            var deferred = $q.defer();
            date = moment(date);

            if (useCurrentProducts) {
                deferred.resolve(angular.copy(_products));
            }
            else {
                getProducts(date, deferred);
            }
            return deferred.promise;
        }

        service.loadProduct = function (id, date) {
            var dateIndex = moment(date).formatEn('YYYYMMDD');
            var url = rollerBaseUrl.legacyApi + 'products/availabilities/widget/load-sessions';
            var params = {
                dateIndex: dateIndex,
                productId: id
            };

            return $http.get(url, { params: params }).then(function (response) {
                var products = transformProducts(response.data.products, moment(date));
                service.setSessions(_products, products);

                return _.findWhere(products, { id: id });
            });
        }

        service.setSessions = function (existingProducts, products) {
            _.each(products, function (product) {
                var existingProduct = _.findWhere(existingProducts, { id: product.id });
                if (existingProduct) {
                    existingProduct.sessions = product.sessions;
                    existingProduct.childApiProducts = product.childApiProducts;
                }
            });
        }

        function getProducts(date, deferred) {

            date = moment(date);

            // if there's a date range and the initial date matches the date passed in we'll use that - otherwise
            // just use the date passed in since that implies the date has changed by clicking a calendar for example
            var initialDateIndex = settingsService.initialDateIndex();
            var initialToDateIndex = settingsService.initialToDateIndex();
            var startDateIndex = date.format("YYYYMMDD");
            var endDateIndex = !initialToDateIndex || !initialDateIndex || initialDateIndex != startDateIndex ? startDateIndex : initialToDateIndex;

            var url = rollerBaseUrl.legacyApi + 'products/availabilities/widget';
            var params = {
                startDateIndex: startDateIndex,
                endDateIndex: endDateIndex
            };

            var groupName = settingsService.groupName();
            if (groupName) {
                params.group = groupName;
            }
            if (settingsService.hasBookingBeenMade()) {
                // get the latest location usage availability i.e. don't use cache
                params.c = 'false';
            }
            if (settingsService.productId()) {
                params.productId = settingsService.productId();
            }

            $http.get(url, { params: params }).then(function (response) {
                _consumerWidgetGroup = response.data.group;
                if (_consumerWidgetGroup) {
                    _.extend(_consumerWidgetGroup, _consumerWidgetGroup.configuration);
                    _consumerWidgetGroup.products = _consumerWidgetGroup.consumerWidgetGroupProducts;
                    settingsService.hideSessionDuration(_consumerWidgetGroup.hideSessionDuration);
                }

                _consumerWidgetGroupTwo = response.data.groupTwo;
                if (_consumerWidgetGroupTwo) {
                    _.extend(_consumerWidgetGroupTwo, _consumerWidgetGroupTwo.configuration);
                    _consumerWidgetGroupTwo.products = _consumerWidgetGroupTwo.consumerWidgetGroupProducts;
                }

                var products = transformProducts(response.data.products, date);

                _products = angular.copy(products);
                _originalProducts = angular.copy(response.data.products);

                setupContent(_products, response.data.content, response.data.venueContent);
                settingsService.discountCodeOnlyFlow(response.data.discountCodeOnly);
                settingsService.bookingTimer(response.data.venueBookingTimer);
                productPromotionService.reloadCardPromotionContent();

                _productsAreLoaded = _productsAreLoaded || _.some(products);
                _productsByDate[moment(date).formatEn('YYYY-MM-DD')] = _originalProducts;
                deferred.resolve(products);
                $rootScope.$broadcast('products-loaded');
            });
        }

        function setupContent(products, content, venueContent) {
            var waiverKey = 'waiver';
            var productsWithWaiver = _.filter(products, function (p) { return !!p.waiver; });

            if (!content) {
                content = [];
            }

            if (_.some(productsWithWaiver) && !_.some(content, function (c) { c.type === waiverKey; })) {
                content.push({ type: waiverKey, value: productsWithWaiver[0].waiver.name });
            }

            if (venueContent && venueContent['mailingListDescription']) {
                var acceptMarketing = _.findWhere(content, { type: 'accept_marketing' });
                if (acceptMarketing) {
                    acceptMarketing.value = venueContent['mailingListDescription'];
                } else {
                    content.push({ type: 'accept_marketing', value: venueContent['mailingListDescription'] });
                }
            }

            if (venueContent && venueContent['mailingListExplanation']) {
                var acceptMarketing = _.findWhere(content, { type: 'accept_marketing_explanation' });
                if (acceptMarketing) {
                    acceptMarketing.value = venueContent['mailingListExplanation'];
                } else {
                    content.push({ type: 'accept_marketing_explanation', value: venueContent['mailingListExplanation'] });
                }
            }

            if (venueContent && venueContent['mailingListDescriptionSMS']) {
                var acceptMarketingSMS = _.findWhere(content, { type: 'accept_marketing_sms' });
                if (acceptMarketingSMS) {
                    acceptMarketingSMS.value = venueContent['mailingListDescriptionSMS'];
                } else {
                    content.push({ type: 'accept_marketing_sms', value: venueContent['mailingListDescriptionSMS'] });
                }
            }

            if (venueContent && venueContent['mailingListExplanationSMS']) {
                var acceptMarketingSMS = _.findWhere(content, { type: 'accept_marketing_sms_explanation' });
                if (acceptMarketingSMS) {
                    acceptMarketingSMS.value = venueContent['mailingListExplanationSMS'];
                } else {
                    content.push({ type: 'accept_marketing_sms_explanation', value: venueContent['mailingListExplanationSMS'] });
                }
            }

            if (venueContent && venueContent['policyUrl']) {
                var policyUrl = _.findWhere(content, { type: 'policy_url' });
                if (policyUrl) {
                    policyUrl.value = venueContent['policyUrl'];
                } else {
                    content.push({ type: 'policy_url', value: venueContent['policyUrl'] });
                }
            }

            if (venueContent && venueContent['withdrawUrl']) {
                var withdrawUrl = _.findWhere(content, { type: 'withdraw_url' });
                if (withdrawUrl) {
                    withdrawUrl.value = venueContent['withdrawUrl'];
                } else {
                    content.push({ type: 'withdraw_url', value: venueContent['withdrawUrl'] });
                }
            }

            contentService.setContent(content);
        }

        service.getTickets = function (product, session) {
            if (product.productTypeId === 'package') {
                var tickets = transformTickets(angular.copy(_.findWhere(_products, { productId: product.productId })), session);
                _.each(tickets, function (ticket) {
                    _.each(ticket.packageItems, function (packageItem) {
                        var sessionForPackgeItem = _.some(packageItem.sessions) ? session : null;
                        transformPackageItem(packageItem, sessionForPackgeItem);
                    });
                });
                return tickets;
            }
            else {
                return transformTickets(angular.copy(_.findWhere(_products, { productId: product.productId })), session);
            }
        }

        service.getAddOns = function (productIdsByDate) {
            var addOnsByDate = {};

            _.each(_.keys(productIdsByDate), function (date) {
                var productsForDate = _productsByDate[date];
                var productIds = productIdsByDate[date];

                if (productsForDate) {
                    var products = angular.copy(productsForDate);
                    var includeDonationsForAllProducts = _consumerWidgetGroup && _consumerWidgetGroup.includeDonationsForAllProducts;

                    if (service.isDonationOnly()) {
                        products = _.filter(products, { subTypeId: 'donation' });
                    }
                    else {
                        products = _.filter(products, function (p) {
                            return (p.productTypeId === 'addOn' && (!productIds || _.intersection(p.addOnParentIds, productIds).length > 0))
                                || (includeDonationsForAllProducts && p.subTypeId === 'donation');
                        });
                    }

                    if (_.any(products)) {
                        addOnsByDate[date] = transformAddOns(products);
                    }
                }
            });

            return $q.resolve(addOnsByDate);
        }

        service.getNextAvailableDateIndex = function (groupName, startDateIndex) {
            var deferred = $q.defer();
            var url = rollerBaseUrl.legacyApi + 'products/nextavailable';
            var params = {
                startDateIndex: startDateIndex,
                groupName: groupName
            };

            $http.get(url, { params: params }).then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        service.getMomentTime = getMomentTime;

        return service;

        function getMomentTime(time, startTime) {
            // startTime is only passed when time is the endTime and we want
            // to add a day when endTime > startTime e.g. 11pm - 1am
            var result = moment(getMomentSafeTimeString(time), 'Hmm');
            if (angular.isDefined(startTime) && result < getMomentTime(startTime)) {
                result = result.add(1, 'day');
            }
            return result;
        }

        function getMomentSafeTimeString(time) {
            var time = time.toString();

            // we use 'Hmm' to parse, needs to be at least 3 characters long or :boom:
            if (time.length === 1) {
                return '00' + time;
            }
            else if (time.length === 2) {
                return '0' + time;
            }
            return time;
        }

        function transformProducts(allProducts, date, includeAddOns) {

            var products = [];
            var productIdFromSettings = settingsService.productId();
            if (productIdFromSettings) {
                products = _.filter(allProducts, function (p) { return p.productId == productIdFromSettings; });
            }
            else if (!includeAddOns) {
                products = _.filter(allProducts, function (product) {
                    return _.some(product.childApiProducts) && product.productTypeId != 'addOn';
                });
            }

            var result = _.map(products, function (product) {

                product.id = product.productId;
                product.availabilityOverride = product.availabilityPeriodsFormattedOverride;

                if (product.meta) {
                    var minimumSpendMeta = _.findWhere(product.meta, { key: 'MinimumSpend' });
                    if (minimumSpendMeta) {
                        product.minimumSpend = parseFloat(minimumSpendMeta.value);
                    }
                }

                if (!product.hasSessions) {
                    // the transformTickets is only done for non-session products because its availability
                    // depends on its child products, whereas the session availability can be based on the session info -
                    // but transformTickets will be called later anyway so they'll end up with the same property names etc...
                    product.childApiProducts = transformTickets(product, null, date);

                    product.isClosed = _.every(product.childApiProducts, function (s) { return s.isClosed; });
                    product.isSoldOut = _.every(product.childApiProducts, function (s) { return s.isSoldOut; }) ||
                        _.some(product.childApiProducts, function (s) { return s.forceMinPurchase && s.isSoldOut; });
                }
                else {

                    // sales period information is against the child product but really should be against the parent as per product setup
                    var availability = _.some(product.childApiProducts) ? product.childApiProducts[0].availability[0] : {};
                    var currentTime = parseInt(_venueTime.format('HHmm'));
                    var currentDateIndex = parseInt(_venueTime.format('YYYYMMDD'));
                    var bookingDateIndex = parseInt(moment(date).locale('en').format('YYYYMMDD'));

                    if (_.some(product.childApiProducts, function (child) { return !!child.remainingRecurringSessions; })) {
                        var remainingRecurringSessions = product.childApiProducts[0].remainingRecurringSessions;
                        var recurringSessionDates = product.childApiProducts[0].recurringSessionDates;
                        var minDate = recurringSessionDates[0];
                        var daysInSameWeek = _.filter(recurringSessionDates, function (recurringDate) {
                            return moment(minDate).isSame(moment(recurringDate), 'week');
                        });
                        var daysOfWeek = _.map(daysInSameWeek, function (date) { return moment(date).format('dddd'); }).join(', ');
                        var maxDate = recurringSessionDates[recurringSessionDates.length - 1];
                        var alreadyStarted = moment(minDate).startOf('day') < _venueTime.startOf('day');
                        var translationKey = alreadyStarted ? 'GENERIC.RECURRING_SESSIONS_AFTER_START' : 'GENERIC.RECURRING_SESSIONS';

                        product.recurringSessionsText = $translate.instant(translationKey, { daysOfWeek: daysOfWeek, minDate: moment(minDate).format('D MMMM'), maxDate: moment(maxDate).format('D MMMM YYYY'), numberOfSessions: remainingRecurringSessions })
                        product.recurringDateSummary = moment(date).format('D') + ' ' + moment(date).format('MMM') + ' - ' + moment(maxDate).format('D') + ' ' + moment(maxDate).format('MMM') + ' ' + moment(maxDate).format('YYYY')
                    }

                    product.sessions = _.filter(product.sessions, function (el) {
                        return currentTime <= el.startTime || bookingDateIndex != currentDateIndex || availability.untilSessionModifier === 2;
                    });

                    product.sessions = _.map(product.sessions, function (session) {
                        return transformSession(session, availability, date, product.childApiProducts);
                    });

                    product.sessions = _.sortBy(_.filter(product.sessions, function (session) { return !session.isClosed; }), 'startTime');
                    product.isClosed = !(_consumerWidgetGroup && _consumerWidgetGroup.loadSessionsOnTheFly) && _.every(product.sessions, function (s) { return s.isClosed; });
                    product.isSoldOut = _.some(product.sessions) && _.every(product.sessions, function (s) { return s.isSoldOut; });
                }

                if (product.productTypeId == 'giftCard' && _.some(product.productPostages) && product.pickupAvailable) {
                    product.productPostages.push({
                        productPostageId: 0, // we bind to isPickup, choosing a number that won't ever conflict
                        price: 0,
                        type: $translate.instant('SESSIONS.DETAILS.FREE_PICKUP'),
                        description: product.pickupDescription,
                        isPickup: true
                    });
                }

                return product;
            });

            result = handlePackages(result, allProducts, date);
            return result;
        }

        function transformSession(session, availability, date, tickets) {

            if (!session.name) {
                session.name = moment(getMomentSafeTimeString(session.startTime), "HH:mm:ss").format("h:mma");
            }

            // some versions of IE don't support Number.MAX_SAFE_INTEGER
            var remaining = session.isSessionCapacityFull ? 0 : (Number.MAX_SAFE_INTEGER || 9999999);
            var percentRemaining = session.isSessionCapacityFull ? 0 : 100;
            session.isSoldOut = session.isSessionCapacityFull;
            session.singleBookingLocationsRemaining = 0;

            // if forced purchased tickets are sold-out, the session / parent product should be sold-out
            var forcedPurchaseSoldOut = _.some(tickets, function (ticket) { return ticket.forceMinPurchase && !isTicketAvailableForSession(ticket, session); });
            var allSoldOut = _.every(tickets, function (ticket) { return !isTicketAvailableForSession(ticket, session); });

            if (forcedPurchaseSoldOut || allSoldOut) {
                remaining = 0;
                session.isSoldOut = true;
            }

            if (!session.isSoldOut) {
                if (_.isNumber(session.maxCapacity)) {
                    remaining = session.maxCapacity - session.bookedQuantity;
                    percentRemaining = remaining / session.maxCapacity * 100;
                    session.isSoldOut = remaining <= 0;
                }

                if (session.productLocationCapacity) {
                    var locationBasedRemaining = session.productLocationCapacity - (session.productBookedQuantityConsideringLocation || 0);
                    if (locationBasedRemaining < remaining) {
                        remaining = locationBasedRemaining;
                        percentRemaining = (locationBasedRemaining / session.productLocationCapacity * 100);
                        session.isSoldOut = locationBasedRemaining <= 0;
                    }
                }

                if (session.availableBookings) {
                    session.singleBookingLocationsRemaining = session.availableBookings;
                    percentRemaining = (session.singleBookingLocationsRemaining / session.totalBookings * 100);
                }
            }

            percentRemaining = percentRemaining >= 1 || remaining == 0 ? percentRemaining : 1;
            session.percentRemaining = percentRemaining + "%";
            session.remaining = remaining;
            session.duration = getSessionDuration(session);

            // usually availability would be against the product/ticket, but
            // this sales period info is relative to the session time
            if (availability && availability.untilSessionBeforeType) {

                var startTimeMoment = getMomentTime(session.startTime);
                var momentSessionNow = date.startOf('day').hour(startTimeMoment.hours()).minute(startTimeMoment.minutes())
                var beforeType = availability.untilSessionBeforeType;
                var beforeValue = availability.untilSessionModifier === 2 ? availability.untilSessionBeforeValue : -(availability.untilSessionBeforeValue);
                var beforeMins = beforeType === 'minutes' ? beforeValue : beforeType === 'hours' ? beforeValue * 60 : beforeType === 'days' ? beforeValue * 24 * 60 : 0;
                var totalMins = moment.duration(_venueTime.diff(momentSessionNow)).asMinutes();
                var salesStartDateUtc = moment.utc(availability.saleStart);

                session.isClosed = beforeMins < totalMins || salesStartDateUtc > moment.utc();
            }

            return session;
        }

        function isTicketAvailableForSession(ticket, session) {
            // NOTE: we can add more logic here, currently only handles session locations
            var ticketSession = _.findWhere(ticket.sessions, { startTime: session.startTime });
            if (ticketSession) {
                if (_.isNumber(ticketSession.productLocationCapacity) && _.isNumber(ticketSession.productBookedQuantityConsideringLocation)) {

                    // the minimum booking capacity is going to be the group size of the ticket by default
                    var minimumBookingCapacity = ticket.requiredGroupSize;

                    // if we have a minimum booking limit and its greater than the required size then
                    // we need to work out the minimum number of tickets needed to satisfy that rule
                    // the minimum booking capacity will then be the required group size multilpied by
                    // the calculated number of tickets
                    //
                    // eg. required group size = 3, minimum booking limit = 10
                    // so 10 / 3 = 3.33 -> 4 tickets, since we need whole numbers
                    // 4 tickets multiplied by require group size of 3 gives us 12
                    // minimum booking capacity required is 12 for purchase
                    if (ticket.minBookingLimit > ticket.requiredGroupSize) {
                        minimumBookingCapacity *= Math.ceil(ticket.minBookingLimit / ticket.requiredGroupSize);
                    }

                    return ticketSession.productLocationCapacity - ticketSession.productBookedQuantityConsideringLocation >= minimumBookingCapacity;
                }
            }
            return true;
        }

        function handlePackages(products, allProducts, date) {
            var packageProducts = _.filter(products, function (product) { return product.productTypeId === 'package'; });
            if (!_.some(packageProducts)) {
                return products;
            }

            var allChildProducts = _.flatten(_.pluck(allProducts, 'childApiProducts'));
            var packages = _.flatten(_.pluck(packageProducts, 'childApiProducts'));

            _.each(packages, function (productPackage) {
                var parentPackage = _.findWhere(packageProducts, { id: productPackage.parentId });
                var productPackageItems = [];
                productPackage.sessions = [];
                parentPackage.sessions = _.some(parentPackage.sessions) ? parentPackage.sessions : [];

                _.each(productPackage.packageItems, function (packageItem) {
                    var packageItemProduct = _.findWhere(allChildProducts, { productId: packageItem.productId });
                    var packageItemParent = _.findWhere(allProducts, { productId: packageItem.parentProductId });

                    if (packageItemProduct) {
                        var productCopy = angular.copy(packageItemProduct);
                        productCopy.isPackageItem = true;
                        productCopy.cost = packageItem.cost;
                        productCopy.price = packageItem.cost;
                        productCopy.quantity = packageItem.quantity;
                        productCopy.costPercentageRequired = productPackage.costPercentageRequired;
                        productCopy.depositAmount = productPackage.depositAmount;
                        productCopy.packageProductId = productPackage.productId;
                        productCopy.formIds = packageItemParent.formIds;
                        productPackageItems.push(productCopy);

                        if (productCopy.minBookingLimit && (!productPackage.minBookingLimit || productCopy.minBookingLimit > productPackage.minBookingLimit)) {
                            productPackage.minBookingLimit = productCopy.minBookingLimit;
                            productPackage.forceMinPurchase = productCopy.forceMinPurchase;
                        }

                        if (productCopy.maxBookingLimit && (!productPackage.maxBookingLimit || productCopy.maxBookingLimit < productPackage.maxBookingLimit)) {
                            productPackage.maxBookingLimit = productCopy.maxBookingLimit;
                        }

                        if (packageItemParent.waiver) {
                            parentPackage.waiver = packageItemParent.waiver;
                        }

                        if (_.some(productCopy.sessions)) {
                            var availability = productCopy.availability[0] || {};

                            _.each(productCopy.sessions, function (session) {
                                transformSession(session, availability, date, [productCopy]);

                                if (!session.isClosed) {
                                    productPackage.sessions.push(session);

                                    if (!_.some(parentPackage.sessions, function (parentSession) { return parentSession.startTime === session.startTime; })) {
                                        parentPackage.sessions.push(session);
                                    }
                                }
                            });

                            productPackage.isClosed = _.every(productPackage.sessions, function (s) { return s.isClosed; });
                            productPackage.isSoldOut = _.some(productPackage.sessions) && _.every(productPackage.sessions, function (s) { return s.isSoldOut; });
                        }
                    }
                    else {
                        console.log('Could not find ' + packageItem.productId + ' for package ' + productPackage.name);
                        parentPackage.childApiProducts = _.filter(parentPackage.childApiProducts, function (product) { return product.productId !== productPackage.productId; });
                    }
                });
                productPackage.packageItems = productPackageItems;
            });


            products = _.filter(products, function (product) { return _.some(product.childApiProducts); });
            return products.map(function(product) {
                product.isClosed = product.childApiProducts.every((function(childProduct) { return childProduct.isClosed; }));
                product.isSoldOut = product.childApiProducts.every((function(childProduct) { return childProduct.isSoldOut; }));
                return product;
            });
        }

        function getSessionDuration(session) {
            var startTime = getMomentTime(session.startTime);
            var endTime = getMomentTime(session.endTime, session.startTime);
            return Math.abs(moment.duration(startTime.diff(endTime)).asMinutes());
        }

        function transformTickets(product, session, date) {

            _.each(product.childApiProducts, function (ticket) {

                if (!ticket.name && (product.productTypeId == 'giftCard' || product.productTypeId == 'wallet' || product.productTypeId == 'cashlessCard')) {
                    ticket.name = rollerCurrencyFilter(ticket.cost);
                    ticket.isNameSameAsPrice = true;
                }
            });

            // copy because otherwise we'd have the same ticket objects used in different sessions
            var tickets = angular.copy(product.childApiProducts);

            if (session) {
                // tickets don't need to be assigned to every session, so we need to
                // filter out tickets that aren't valid for the selected session
                tickets = _.filter(tickets, function (ticket) {
                    return _.some(ticket.sessions, { startTime: session.startTime });
                });
            }

            var mappedTickets = _.map(tickets, function (ticket) {
                return transformTicket(ticket, product, session, date);
            });

            return _.filter(mappedTickets, function (ticket) {
                return !ticket.isClosed;
            });
        }

        function transformPackageItem(packageItem, session) {

            if (session) {
                packageItem.sessionName = session.name;
                packageItem.sessionTime = session.startTime;
                packageItem.sessionTimeFormatted = getMomentTime(session.startTime).format("h:mma");
                packageItem.duration = getSessionDuration(session);
                packageItem.selectedDuration = packageItem.duration;
                packageItem.categories = categorizeTicket(packageItem, session.startTime, packageItem.sessions);
                session.duration = packageItem.duration;
            }
            else {
                var availability = packageItem.availability[0] || {};

                packageItem.remaining = angular.isDefined(availability.totalRemaining) ? availability.totalRemaining : null;
                packageItem.totalRemainingConsideringLocation = angular.isDefined(availability.totalRemainingConsideringLocation) ? availability.totalRemainingConsideringLocation : null;
                packageItem.isSoldOut = (_.isNumber(packageItem.remaining) && packageItem.remaining <= 0) || (_.isNumber(packageItem.totalRemainingConsideringLocation) && packageItem.totalRemainingConsideringLocation <= 0);
            }
            return packageItem;
        }

        function transformTicket(ticket, product, session, date) {
            ticket.id = ticket.productId;
            ticket.parentId = product.productId;
            ticket.parentName = product.name;
            ticket.price = ticket.cost;
            ticket.formIds = product.formIds;
            ticket.termsAndConditionsText = product.termsAndConditionsText;
            ticket.bookingCostModifiers = product.bookingCostModifiers;
            ticket.costPercentageRequired = product.costPercentageRequired;
            ticket.depositAmount = product.depositAmount;
            ticket.productTypeId = product.productTypeId;
            ticket.allowPhysicalGiftCard = product.allowPhysicalGiftCard;
            ticket.productPostages = product.productPostages;
            ticket.pickupAvailable = product.pickupAvailable;
            ticket.pickupDescription = product.pickupDescription;
            ticket.physicalGiftcardMessageMaxLength = product.messagingOptionLimit ? product.messagingOptionLimit : 10000;
            ticket.waiver = product.waiver;
            ticket.minimumSpend = product.minimumSpend;
            ticket.quantity = ticket.forceMinPurchase ? (ticket.minBookingLimit > ticket.requiredGroupSize ? Math.ceil(ticket.minBookingLimit / ticket.requiredGroupSize) : 1) : 0;
            ticket.minQuantity = ticket.quantity;
            ticket.guestLabel = product.guestLabel;
            ticket.recurringDateSummary = product.recurringDateSummary;

            if (ticket.maxAdditionalGuests) {
                ticket.additionalGuestOptions = [1];
                ticket.getAdditionalGuestOptions = function () {
                    var numberOfOptions = ticket.quantity * ticket.maxAdditionalGuests;
                    while (ticket.additionalGuestOptions.length < numberOfOptions) {
                        ticket.additionalGuestOptions.push(ticket.additionalGuestOptions[ticket.additionalGuestOptions.length - 1] + 1);
                    }
                    if (ticket.additionalGuestOptions.length > numberOfOptions) {
                        ticket.additionalGuestOptions = ticket.additionalGuestOptions.slice(0, numberOfOptions);
                    }
                    return ticket.additionalGuestOptions;
                };
            }

            if (product.messagingOption) {
                ticket.giftcardAcceptsMessage = (product.messagingOption === 'message' || product.messagingOption === 'both');
                ticket.giftcardAcceptsPhysicalMessage = product.messagingOptionLimit >= 0;
                ticket.giftcardAcceptsVideo = (product.messagingOption === 'video' || product.messagingOption === 'both');
            }

            var availability = ticket.availability[0] || {};

            if (availability.dateIndex) {
                // usually the booking date is set based on the calendar - but in some scenarios
                // there is no calendar, e.g. events on different days in one checkout
                ticket.bookingDate = moment(availability.dateIndex, 'YYYYMMDD').formatEn('YYYY-MM-DD');
            }

            if (session) {
                var sessionsForTicket = _.filter(product.sessions, function (s) { return _.some(ticket.sessions, { startTime: s.startTime }); });
                ticket.sessionName = session.name;
                ticket.sessionTime = session.startTime;
                ticket.sessionTimeFormatted = getMomentTime(session.startTime).format(moment.localeData().longDateFormat('LT'));
                ticket.duration = getSessionDuration(session);
                ticket.selectedDuration = ticket.duration;
                ticket.categories = categorizeTicket(ticket, session.startTime, sessionsForTicket);
                session.duration = ticket.duration;
            }
            else {
                ticket.remaining = angular.isDefined(availability.totalRemaining) ? availability.totalRemaining : null;
                ticket.totalRemainingConsideringLocation = angular.isDefined(availability.totalRemainingConsideringLocation) ? availability.totalRemainingConsideringLocation : null;
                ticket.isSoldOut = (_.isNumber(ticket.remaining) && ticket.remaining <= 0) || (_.isNumber(ticket.totalRemainingConsideringLocation) && ticket.totalRemainingConsideringLocation <= 0);
                ticket.dateIndex = date.formatEn("YYYYMMDD");

                if (!_.isEmpty(availability)) {
                    // availability is per ticket - if all tickets are not available the product is not available
                    var salesStartDate = moment.utc(availability.saleStart);
                    var salesEndDate = moment.utc(availability.saleEnd);
                    var now = moment.utc();
                    var salesPeriodIsValid = salesEndDate.year() > 2000;

                    ticket.isClosed = availability.isClosed || (salesPeriodIsValid && (salesEndDate < now || salesStartDate > now));
                }
            }
            return ticket;
        }

        function categorizeTicket(ticket, startTime, allSessions) {
            // all the below logic only cares about the current session and maybe the ones after it
            // depending if there's any consecutive sessions allowed for the given product
            var sessions = _.sortBy(_.filter(allSessions, function (el) { return el.startTime >= startTime; }), 'startTime');
            var selectedSession = sessions[0];
            var lastSession = _.last(sessions);
            var midnight = 2400;
            var lastSessionEndTime = lastSession.endTime < lastSession.startTime ? midnight : lastSession.endTime;

            var categories = [{
                duration: selectedSession.duration,
                remaining: selectedSession.remaining
            }];
            // if there's any consecutive session discounts setup we need to
            // determine what categories/durations are allowed
            if (ticket.sessionDiscounts) {

                _.each(ticket.sessionDiscounts, function (el) {

                    if (sessions.length > el.numberOfSessions - 1) {

                        var duration = categories[0].duration * el.numberOfSessions;
                        var nextStartTime = parseInt(getMomentTime(startTime).add(categories[0].duration, 'minutes').format('HHmm'));
                        var nextSession = _.find(sessions, function (s) { return s.startTime == nextStartTime; });

                        if (nextSession && nextSession.remaining > 0) {
                            // handle scenario where sessions are setup with a gap at some point, e.g.
                            // hour long sessions available 1pm - 3pm and 5pm - 8pm, so at 3pm you should only
                            // be able to book 1hr because there is no 4pm slot
                            var diffInMinutes = getSessionDuration({ startTime: selectedSession.startTime, endTime: nextSession.startTime });
                            var isValidConsecutiveSession = (duration - categories[0].duration) >= diffInMinutes;

                            // make sure customer can't choose a duration that wiil go outside open hours, e.g. if the last session
                            // is at 4pm and you have hour long sessions, 3:30pm cannot have a 2 hour duration
                            var nextEndTime = parseInt(getMomentTime(startTime).add(duration, 'minutes').format('HHmm'));
                            var durationFallsWithOpenHours = nextEndTime <= lastSessionEndTime;

                            if (isValidConsecutiveSession && durationFallsWithOpenHours) {

                                categories.push({
                                    duration: duration,
                                    remaining: categories[0].remaining < nextSession.remaining ? categories[0].remaining : nextSession.remaining
                                });
                            }
                        }
                    }
                });
            }
            return categories;
        }

        function transformAddOns(addOns) {
            return _.map(addOns, function (addOn) {
                addOn.id = addOn.productId;

                if (addOn.meta) {
                    addOn.forcePurchaseUnlessRemoved = _.some(addOn.meta, { key: 'ForcePurchaseUnlessRemoved' });
                }

                addOn.childApiProducts = _.map(addOn.childApiProducts, function (c) {
                    c.id = c.productId;
                    c.parentId = addOn.productId;
                    c.parentName = addOn.name;
                    c.price = c.cost;
                    c.isSoldOut = isAddOnSoldOut(c);
                    c.quantity = 0;
                    c.productTypeId = addOn.productTypeId;
                    c.costPercentageRequired = addOn.costPercentageRequired;
                    c.bookingCostModifiers = addOn.bookingCostModifiers;

                    var availability = c.availability[0] || {};

                    if (availability.dateIndex && availability.dateIndex != _venueTime.format('YYYYMMDD')) {
                        // usually the booking date is set based on the calendar - but in some scenarios
                        // there is no calendar, e.g. events on different days in one checkout
                        c.bookingDate = moment(availability.dateIndex, 'YYYYMMDD').formatEn('YYYY-MM-DD');
                    }

                    return c;
                });

                addOn.isSoldOut = _.every(addOn.childApiProducts, function (c) { return c.isSoldOut; });

                return addOn;
            });
        }

        function isAddOnSoldOut(addOn) {
            if (_.some(addOn.availability)) {
                if (_.some(addOn.productLocationCapacityLocations)) {

                    var totalRemainingConsideringLocation = addOn.availability[0].totalRemainingConsideringLocation;

                    return totalRemainingConsideringLocation <= 0;
                } else {
                    return addOn.availability[0].totalRemaining <= 0;
                }
            }

            return false;
        }
    }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("productPromotionService", productPromotionService);

    /** @ngInject */
    function productPromotionService(contentService) {
        var service = {};
        var productsToPromote = null;
        var promotionLink = null;
        var isMXPromotion = false;
        var isBankPromotion = false;
        var hasDiscountedProduct = false;
        var promotionSettings = null;

        service.setProductToPromote = function (products) {
            productsToPromote = _.where(products, { isClosed: false });
            updatePromotionInfo();
        }

        service.isOnPromotion = function () {
            return isMXPromotion || isBankPromotion || !_.isEmpty(promotionLink);
        }

        service.isOnBankPromotion = function () {
            return isBankPromotion;
        }

        service.getSettings = function () {
            return promotionSettings;
        }

        service.contentUrl = function () {
            return "app/views/sessions/sessions.promotion.html";
        }

        service.getProductPromotionLink = function () {
            return promotionLink;
        }

        service.hasPromotedProduct = function() {
            return hasDiscountedProduct;
        }

        service.isMXPromotion = function () {
            return isMXPromotion;
        }

        service.reloadCardPromotionContent = function () {
            promotionSettings = {
                sponsorLogoUrl: contentService.content('promotion_banner_sponsor_logo_url'),
                cardLogoUrl: contentService.content('promotion_card_logo_url'),
                linkToPromotedProductText: contentService.content('promotion_banner_link_to_promoted_product_text'),
                promotedText: contentService.content('promotion_banner_promoted_product_text'),
                generallyAvailableText: contentService.content('promotion_banner_generally_available_product_text'),
                cardPrefixes: (contentService.content('promotion_card_prefixes') || '').split(','),
                cardErrorMessage: contentService.content('promotion_card_error_message'),
                sponsorName: contentService.content('promotion_sponsor')
            };

            if (!promotionSettings.promotedText || !promotionSettings.generallyAvailableText) {
                promotionSettings = null;
            }
        }

        service.hasCardNumberRestriction = function () {
            return promotionSettings && !_.isEmpty(promotionSettings.cardPrefixes);
        }

        service.getCardPromotionValidationMessage = function () {
            return promotionSettings && promotionSettings.cardErrorMessage ? promotionSettings.cardErrorMessage : 'Your card is not eligible for current promotion.';
        }

        service.meetsCardRestriction = function (cardNumber) {
            if (!service.hasCardNumberRestriction() || !cardNumber) {
                return true;
            }

            return _.any(promotionSettings.cardPrefixes, function (p) {
                return _.startsWith(_.trim(cardNumber.toString()), _.trim(p));
            });
        }

        function updatePromotionInfo() {
            if (_.isEmpty(productsToPromote)) {
                promotionLink = null;
                isMXPromotion = false;
                isBankPromotion = false;
                hasDiscountedProduct = false;

                return;
            }

            var productMetaValues = _.flatten(_.filter(_.pluck(productsToPromote, 'meta')));
            var promotionUrlMeta = _.find(productMetaValues, function (meta) { return meta.key === 'PromotionUrl' && meta.value });
            var mxPromotionMeta = _.find(productMetaValues, function (meta) { return meta.key === "CanOnlyBuyWithMX" && (meta.value + "").toLowerCase() === 'true'; });
            var isPromotedMeta = _.find(productMetaValues, function (meta) { return meta.key === "IsPromotedProduct" && (meta.value + "").toLowerCase() === 'true'; });

            promotionLink = (promotionUrlMeta || {}).value;
            isMXPromotion = !_.isEmpty(mxPromotionMeta);
            hasDiscountedProduct = !_.isEmpty(isPromotedMeta);
            isBankPromotion = (hasDiscountedProduct || promotionLink) && contentService.content('promotion_sponsor') && contentService.content('promotion_sponsor') !== 'AMEX';
        }

        return service;
    }
})();

(function() {
    "use strict";

    angular
        .module("consumerSessions")
        .service("postMessage", postMessage);

    /** @ngInject */
    function postMessage($window, $rootScope) {
        var canPostMessage = angular.isFunction($window.postMessage);
        if(canPostMessage) {
            if (angular.isFunction($window.addEventListener)) {
                $window.addEventListener("message", receiveMessage);
            }
            else {
                $window.attachEvent("onmessage", receiveMessage);
            }
        }

        return function(frame, data, targetOrigin) {
            var target;
            if(!canPostMessage) {
                return;
            }
            if(angular.isString(frame)) {
                target = $window[frame];
            } else if(typeof target !== "undefined") {
                target = frame;
            }
            if(target) {
                target.postMessage(data, targetOrigin || "*");
                $rootScope.$broadcast("postMessage:sent", { frame: frame, data: data, targetOrigin: targetOrigin || "*" });
            }
        };

        function receiveMessage(event) {
            $rootScope.$broadcast("postMessage:received", { data: event.data, origin:event.origin });
        }
    }
})();
(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("orderService", orderService);

    /** @ngInject */
    function orderService(OrderItemCollection, OrderCustomerDetails, OrderPaymentDetails,
        $state, bookingService, settingsService, $timeout, $log, rollerBaseUrl, $http, formRendererService,
        analyticsService, productService, $rootScope, $translate, $window, OrderDelivery, $q, $sessionStorage, contentService, productTypes, ticketTimerService) {

        var service = {
            inProgress: false
        },
            order = orderTemplate(),
            _clickedContinue = false,
            _dateSelected = false,
            _costSettings = {},
            _showingCart = false,
            _discount = null,
            _bookingCostModifiers = null,
            _groupOneTicketCount = null,
            _forms = [],
            _taxOverride = null,
            _payFullAmountIgnoringDeposit = false,
            _checkoutStartDateTime = null,
            _discounts = [],
            _giftcards = [],
            _paymentSuccessMessage = null,
            _draftBooking = undefined,
            _paymentAttempts = 0,
            _showBriefOrderConfirmation = false,
            _canBuyAddOns = true;

        // this is to help with some basic metrics capturing so we can determine
        // how long people are spending in the checkout flow
        service.startCheckout = function () {
            if (!_checkoutStartDateTime && $window.performance) {
                _checkoutStartDateTime = $window.performance.now();
            }
        }

        service.costSettings = function () {
            return _costSettings;
        }

        service.countGroupOneTickets = function () {
            var groupOne = productService.consumerWidgetGroup();
            var groupOneProductIds = _.pluck(groupOne.products, 'productId');

            var totalCount = 0;
            var orderedProducts = _.filter(order.tickets.items, function (t) { return _.contains(groupOneProductIds, t.productId) });

            _.each(orderedProducts, function (item) {
                totalCount += (item.quantity || 0);
            });

            _groupOneTicketCount = totalCount;
        }

        service.getGroupOneTicketCount = function () {
            return _groupOneTicketCount;
        }

        service.bookingCostModifiers = function () {
            return _bookingCostModifiers;
        }

        service.getPaymentText = function () {
            if (service.noFurtherPaymentRequired()) {
                return 'SESSIONS.PAYMENT.CONFIRM_ORDER';
            }
            else if (settingsService.discountCodeOnlyFlow() && !_.any(_discounts)) {
                return '';
            }
            if (service.total() &&
                !($rootScope.paymentSetting &&
                    $rootScope.paymentSetting.paymentPortalType === 'Adyen' &&
                    $rootScope.paymentSetting.overrideUI)) {
                if (service.onlyDepositRequired()) {
                    return "SESSIONS.PAYMENT.PAY_DEPOSIT_AMOUNT";
                }
                return "SESSIONS.PAYMENT.PAY_TOTAL_AMOUNT";
            }

            return 'SESSIONS.PAYMENT.CONFIRM_PAYMENT';
        }

        service.hasClickedContinue = function () {
            return _clickedContinue;
        }

        service.setClickedContinue = function (clickedContinue) {
            _clickedContinue = clickedContinue;
        }

        service.setDateSelected = function (selected) {
            _dateSelected = selected;
        }

        service.hasDateSelected = function () {
            return _dateSelected;
        }

        service.setCanBuyAddOns = function (value) {
            _canBuyAddOns = value;
        }

        service.canBuyAddOns = function () {
            return _canBuyAddOns;
        }

        service.setBookingDate = function (date) {
            order.bookingDate = date;
        }

        service.getBookingDate = function (format) {
            var date = order.bookingDate ? order.bookingDate : settingsService.momentVenueTime();
            if (format) {
                return moment(date).format(format);
            }
            return date;
        }

        service.forms = function () {
            return _forms;
        }

        service.getForm = function (formId) {

            if (_.some(_forms, { id: formId })) {
                return; // no need to download the form again
            }

            var result = {
                id: formId,
                form: {}
            };

            formRendererService.getForm(formId).then(function (form) {
                if (form) {
                    if (angular.isString(form)) {
                        form = JSON.parse(form);
                    }
                    result.form = form;
                }
            });
            _forms.push(result);
        }

        $rootScope.$on('form-renderer-ready', function (info, data) {
            if (data.formId) {
                var ticketsForThisForm = _.filter(order.tickets.items, function (ticket) {
                    return ticket.formIds && _.indexOf(ticket.formIds, data.formId) >= 0;
                });
                var tickets = _.map(ticketsForThisForm, function (item) {
                    return {
                        parentId: item.productId,
                        productId: item.id,
                        name: item.name,
                        quantity: item.quantity * (item.requiredGroupSize ? item.requiredGroupSize : 1)
                    };
                });
                formRendererService.setMinTicketDetailsIfApplicable(data.formId, tickets);

                var hasPostcodeDatabinding = formRendererService.hasDataBinding(data.formId, 'Member.Postcode');

                if (hasPostcodeDatabinding) {
                    settingsService.capturePostcode(false);
                }
            }
        });

        service.tickets = function () {
            return order.tickets;
        };

        service.addOns = function () {
            return order.addOns;
        };

        service.details = function () {
            return order.details;
        };

        service.delivery = function () {
            return order.delivery;
        };

        service.payment = function () {
            return order.payment;
        }

        service.bankTransferDetails = function () {
            return order.bankTransferDetails;
        }

        service.isPhysicalGiftcardOnly = function () {
            return !(_.reject(order.tickets.items, function (item) {
                return item.type === 'physical';
            }).length > 0);
        }

        var _minimumSpendProductNames = null;
        service.minimumSpendProductNames = function () {
            return _minimumSpendProductNames;
        }

        service.minimumSpend = function () {
            var minimumSpendTickets = _.filter(service.tickets().items, function (item) { return !!item.minimumSpend; })
            if (_.some(minimumSpendTickets)) {
                _minimumSpendProductNames = _.chain(minimumSpendTickets).pluck('parentName').uniq().value().join(', ');
                return _.reduce(minimumSpendTickets, function (memo, item) { return memo + (item.minimumSpend * item.quantity) }, 0);
            }
            return 0;
        }

        service.hasMetMinimumSpend = function () {
            var minimumSpend = service.minimumSpend();
            return minimumSpend == 0 || service.subTotal() >= service.minimumSpend();
        }

        service.canTransitionTo = function (stateName, isSubmitted) {
            if (order.isProcessed) {
                return stateName === 'sessions.success';
            }

            if (service.inProgress) {
                return false;
            }

            var groupOne = productService.consumerWidgetGroup() || {};
            var hasMetMinimumSpend = service.hasMetMinimumSpend();
            var cartIsValid = (service.tickets().isValid() || (service.addOns().isValid() && groupOne.donationOnly)) && hasMetMinimumSpend;

            switch (stateName) {
                case 'sessions.home':
                    return true;

                case 'sessions.home2':
                case 'sessions.addons':
                    return service.tickets().isValid() || groupOne.donationOnly;

                case 'sessions.details':
                    return cartIsValid;

                case 'sessions.payment':
                    var additionalDetailsFormIsValid = true;
                    var forms = service.getApplicableForms();

                    if (_.some(forms) && _clickedContinue) {
                        // call validate on the form here instead of after order.details.isValid() - because
                        // if that's invalid formRendererService.validate() won't get called and the
                        // invalid inputs on the form won't show as invalid
                        _.each(forms, function (form) {
                            var formValidationResult = formRendererService.validate(form.form.id, isSubmitted);
                            var isValid = formValidationResult.isValid;
                            form.isValid = isValid;
                            form.hasWarnings = _.any(formValidationResult.warnings);

                            if (!isValid) {
                                additionalDetailsFormIsValid = false;
                            }
                        });
                    }

                    if (settingsService.discountCodeOnlyFlow() && !_.any(_discounts)) {
                        return false;
                    }

                    return cartIsValid
                        && order.details.isValid(service.tickets().items)
                        && order.delivery.isValid(service.tickets().items)
                        && additionalDetailsFormIsValid;

                case 'sessions.success':
                    return (service.noFurtherPaymentRequired() && order.details.termsAccepted) ||
                        (
                            cartIsValid &&
                            order.details.isValid() &&
                            order.payment.isValid() &&
                            canTransitionToSuccess && 
                            (!($rootScope.paymentSetting && $rootScope.paymentSetting.isPayUArgentina) || order.payment.isValidBillingAddress())
                        ) ||
                        ($rootScope.paymentSetting &&
                            $rootScope.paymentSetting.overrideUI &&
                            !$rootScope.paymentSetting.isDropIn &&
                            order.details.termsAccepted &&
                            order.payment.isValidBillingAddress() &&
                            order.payment.isValidTermsAndConditions()
                        );
                case 'redirector':
                    return true;
                default:
                    $log.debug('Invalid state ' + stateName);
                    return false;
            }
        };

        function isFree() {
            return (_discount && _discount.isFree) || _.any(_giftcards, 'isFree');
        }

        service.isFree = function () {
            return isFree();
        }

        service.getApplicableForms = function () {
            var packageFormIds = _.chain(service.tickets().items)
                .pluck('packageItems')
                .flatten()
                .pluck('formIds')
                .flatten()
                .value();

            var formIds = _.chain(service.tickets().items)
                .pluck('formIds')
                .flatten()
                .union(packageFormIds)
                .value();

            return _.filter(_forms, function (form) { return _.contains(formIds, form.id); });
        }

        service.getDiscountTotal = function () {
            var subTotal = service.subTotal({ ignoreDiscountCodes: true, ignoreDeposit: true });
            return service.calculateDiscount(subTotal);
        }

        service.calculateDiscount = function (subTotal) {
            // NOTE: _.sum has different behaviour in lodash v4+, replace _.sum with _.sumBy when upgrading lodash.
            var discountTotal = _.sum(_discounts, function (discount) {
                return discount.discountOffBooking;
            });
            // When discount total exceeds product cost, only the product cost is discounted
            // e.g product cost: $60. discount: 3x $25 totaling $75. Max $60 is discounted
            var maxDiscountAmount = subTotal - _discount.onlineSubTotal;

            return discountTotal ? (discountTotal > maxDiscountAmount ? maxDiscountAmount : discountTotal) : 0;
        }

        service.giftcardValue = function () {

            if (!_.any(_giftcards)) {
                return 0;
            }

            return _.sum(_giftcards, 'amountDeducted') || 0;
        }

        function getDepositAmount(items) {
            var nonPackageItems = _.filter(items, function (item) { return !item.packageProductId; });
            var packageItems = _.filter(items, function (item) { return !!item.packageProductId; });

            var result = _.chain(nonPackageItems)
                .filter(function (t) { return _.isNumber(t.depositAmount); })
                .groupBy('parentId')
                .map(function (t) { return _.first(t); })
                .sum('depositAmount')
                .value() || 0;

            result += _.chain(packageItems)
                .filter(function (t) { return _.isNumber(t.depositAmount) && !!t.packageProductId; })
                .groupBy('packageProductId')
                .map(function (t) { return _.first(t); })
                .sum('depositAmount')
                .value() || 0;

            return result;
        }

        service.subTotal = function (options) {
            options = options || {};

            if (!options.ignoreDeposit && !options.ignoreDiscountCodes && _discount) {
                return _discount.onlineSubTotal;
            }

            var items = getItemsForCalcs();

            var depositAmount = 0;

            if (!options.ignoreDeposit && service.onlyDepositRequired()) {
                depositAmount = getDepositAmount(items);
                items = _.filter(items, function (t) { return !t.depositAmount; });
            }

            var total = _.sum(items, itemSubtotal) + depositAmount;

            if (!options.ignoreBookingCostModifiers && _bookingCostModifiers) {
                _.each(_bookingCostModifiers, function (bcm) {
                    total += service.calculateBookingCostModifier(bcm);
                });
            }

            total += productPostageCost(items);

            if (!options.ignoreDiscountCodes && _discount) {
                if (service.onlyDepositRequired() && _.any(_discounts) && !options.ignoreDeposit) {
                    _.each(_discounts, function (d) {
                        total -= d.discountOffBookingExcludingDepositItems;
                    });
                }
                else {
                    total -= service.calculateDiscount(total);
                }
            }

            return roundToTwo(total);

            function itemSubtotal(x) {
                return service.calculateTicketPrice(x, options) * x.quantity;
            }
        };

        // Check if supported, as we are not implementing this in giftcard etc...this is a custom check for now
        var paypalLoaded = false;
        var canTransitionToSuccess = true;
        service.initialisePayPal = function (paymentSetting, containerName) {
            if (paymentSetting && paymentSetting.isPaypalEnabled && !paypalLoaded) {
                var apiKey = settingsService.venueSlug;
                rollerpayment.PaypalComponent.render({
                    paymentSetting: paymentSetting,
                    key: apiKey,
                    environment: paymentSetting.environment,
                    language: $translate.use(),
                    amount: service.total().toString(),
                    currency: settingsService.currencyType,
                    onNonceGenerated: function (nonce) {
                        $timeout(function () {
                            order.payment.paypalNonce = nonce;
                            canTransitionToSuccess = true;
                        });
                    }
                }, containerName);
                paypalLoaded = true;
            }
        };

        service.initialisePayment = function (paymentSetting, containerName, onReady, onPaymentMethodSelectExternal, onError, onBeforeSubmittingPayment, onDisplayPaymentQRCode) {
            if (!paymentSetting) {
                return;
            }

            if (paymentSetting.hasPaymentFrame || paymentSetting.isDropIn || paymentSetting.paymentPortalType === 'SagePay') {
                canTransitionToSuccess = false;

                var callbacks = {
                    translateError: service.getPaymentErrorMessage
                };

                if (paymentSetting.isDropIn) {
                    callbacks = {
                        referenceInfo: getReferenceInfo,
                        billingAddress: function () {
                            return order.billingAddress;
                        },
                        isValid: isValidPaymentDetails,
                        onSubmitting: function () {
                            if (_.isFunction(onBeforeSubmittingPayment)) {
                                onBeforeSubmittingPayment();
                            }

                            var deferred = $q.defer();

                            if (!isValidPaymentDetails()) {
                                deferred.resolve({ cancelled: true });
                                service.setClickedContinue(true);
                            } else {
                                service.inProgress = true;

                                if (service.getPaymentAttempts() > 0 && !service.hadErrors) {
                                    service.paymentAlreadyProcessed().then(function (result) {
                                        if (result.isProcessed) {
                                            service.markBookingAsCompleted();
                                            $state.go('sessions.success');
                                        } else {
                                            _paymentAttempts++;
                                            storeSessionBookingData();
                                            deferred.resolve();
                                        }
                                    });
                                } else {
                                    _paymentAttempts++;
                                    storeSessionBookingData();
                                    deferred.resolve();
                                }
                            }

                            return deferred.promise;
                        },
                        onRedirecting: function (redirecting) {
                            service.hadErrors = false;
                            service.paymentRedirecting = !!redirecting;

                            storeDisplaySettings();

                            return $q.resolve();
                        },
                        onPaymentCompleted: function (result) {
                            service.hadErrors = false;
                            onPaymentCompleted(result);
                            service.inProgress = false;
                            $state.go('sessions.success');
                        },
                        onPaymentError: function (err) {
                            service.hadErrors = true;
                            handleError(err, onError);
                            service.inProgress = false;
                        },
                        getRedirectUrl: function () {
                            var l = window.location;
                            return l.protocol + '//' + l.hostname + l.pathname + l.search + $state.href('callback') + '?action=1';
                        },
                        onPaymentMethodSelect: onPaymentMethodSelectExternal,
                        getPaymentMethodNames: function () {
                            return {
                                scheme: $translate.instant('SESSIONS.PAYMENT.DEBIT_CREDIT'),
                                directEbanking: $translate.instant('SESSIONS.PAYMENT.SOFORT')
                            }
                        },
                        onDisplayPaymentQRCode: onDisplayPaymentQRCode
                    };
                }
                rollerpayment.setupPayment(containerName, function () {
                    $timeout(function () {
                        if (!paymentSetting.isDropIn) {
                            canTransitionToSuccess = true; // Is Valid payment
                        }
                    });

                    if (typeof (onReady) === 'function') {
                        onReady();
                    }
                }, function () {
                    $timeout(function () {
                        canTransitionToSuccess = false; // Is Invalid payment
                    });
                }, callbacks);
            }
            else if (paymentSetting.OverrideUI) {
                canTransitionToSuccess = true;
            }
        }

        service.getPaymentErrorMessage = function (err) {
            var errorMessage = $translate.instant('PAYMENT.ERRORS.' + err.errorCode);
            return $translate.instant('PAYMENT.ERRORS.MESSAGE_WITH_CODE', { message: errorMessage, code: err.errorCodeRaw });
        }

        service.resetPaypal = function () {
            paypalLoaded = false;
        }

        function storeDisplaySettings() {

            try {
                var settings = {};

                settings[settingsService.venueSlug] = {
                    headerImage: settingsService.headerImage,
                    backgroundImageUrl: settingsService.backgroundImage,
                    insideIframe: settingsService.insideIframe,
                    showHeader: settingsService.showHeader()
                };

                // Store display settings in session storage to be used by payment redirection page later
                $sessionStorage.displaySettings = settings;
            }
            catch (err) {
                $log.info(err);
            }
        }

        function isValidPaymentDetails() {
            return order.payment.isValidBillingAddress() && order.payment.isValidTermsAndConditions();
        }

        function storeSessionBookingData() {
            $sessionStorage.draftBooking = {
                bookingData: getCreateBookingData(order.payment.requiresBankTransfer()),
                draft: _draftBooking,
                order: order,
                discounts: _discounts,
                discount: _discount,
                giftcards: _giftcards,
                bookingCostModifiers: _bookingCostModifiers,
                taxOverride: _taxOverride,
                payFullAmountIgnoringDeposit: _payFullAmountIgnoringDeposit,
                paymentAttempts: _paymentAttempts,
                timestamp: new Date().toJSON()
            }
        }

        function roundToTwo(num) {
            return +(Math.round(num + "e+2") + "e-2");
        }

        function customerPaysFees() {
            var group = productService.consumerWidgetGroup();
            var customerPaysFees = _costSettings.customerPaysFees;

            if (group && angular.isDefined(group.customerPaysFees) && group.customerPaysFees != null) {
                customerPaysFees = group.customerPaysFees;
            }
            return customerPaysFees;
        }

        service.transactionFee = function () {
            if (isFree() || order.payment.requiresBankTransfer()) {
                return 0;
            }

            if (!customerPaysFees()) {
                return 0;
            }

            // transaction fees are pre-deposit
            // transaction fees are post-discount
            // credit card fees are based on what they are paying right now

            var transactionFeeOptions = {
                ignoreDeposit: true
            };
            var requiredModifierCost = totalRequiredCostModifiers();
            var totalFeeableIgnoreDeposit = service.subTotal(transactionFeeOptions) + service.taxes(null, true) + requiredModifierCost;
            var fees = roundToTwo((totalFeeableIgnoreDeposit * _costSettings.transactionFeePercent / 100));
            var perProductFees = service.perProductFees();

            var creditCardFeeOptions = {
                ignoreDeposit: false
            };

            var totalFeeable = service.subTotal(creditCardFeeOptions) + service.taxes() + requiredModifierCost;

            if (totalFeeable > 0) {
                fees += _costSettings.feePerTransaction;
            }
            var creditCardFees = roundToTwo((fees + totalFeeable + perProductFees - service.giftcardValue()) * _costSettings.creditCardFeePercent / 100);

            return fees + creditCardFees + perProductFees;
        };

        service.total = function () {
            var subTotal = service.subTotal();

            var total = subTotal + service.transactionFee() - service.giftcardValue() + service.taxes(false, !service.onlyDepositRequired(), service.onlyDepositRequired()) + totalRequiredCostModifiers();

            if (_draftBooking) {
                total = _draftBooking.totalBookingAmount;
            } else if (_discount) {
                total = _discount.onlineTotal - service.giftcardValue(); // need to deduct giftcard value as the final total should be the amount to be paid by credit card
            }

            // decimal precision not perfect, have bumped into an exmaple where
            // the total was a negative number veryyyyy close to zero for a simple calculation
            if (total < 0) {
                return 0;
            }

            return total;
        };

        function totalRequiredCostModifiers() {
            var cost = 0;

            _.chain(getItemsForCalcs())
                .pluck("bookingCostModifiers")
                .flatten()
                .compact()
                .where({ appliesToBookingItem: true, isRequired: true })
                .uniq(false, function (e) { return e.id })
                .each(function (cm) {
                    cost += service.calculateTotalTicketModifierCost(cm) || 0;
                })
                .value();

            return cost;
        }

        function productPostageCost(tickets) {
            var postageCost = 0;
            var multiDelivery = false;
            _.each(tickets, function (ticket) {
                if (ticket.details && ticket.type == 'physical' && ticket.details.postage) {
                    if (ticket.details.differentDeliveryDetails) {
                        postageCost += ticket.details.postage.price;
                    } else if (!multiDelivery && order.delivery && order.delivery.selectedPostage) {
                        postageCost += order.delivery.selectedPostage.price;
                        multiDelivery = true;
                    }
                }
            });
            return postageCost;
        }

        service.perProductFees = function () {
            var includePackages = true;
            var items = getItemsForCalcs(includePackages);
            var ticketsWithFees = _.filter(items, function (t) { return t.perProductBookingFee ? true : false; });

            return _.sum(ticketsWithFees, function (t) { return t.perProductBookingFee * (t.quantity * groupSize(t.requiredGroupSize) + additionalGuests(t.additionalGuests)); });
        }

        function groupSize(requiredGroupSize) {
            return requiredGroupSize ? requiredGroupSize : 1;
        }

        function additionalGuests(numberOfAdditionalGuests) {
            return numberOfAdditionalGuests ? numberOfAdditionalGuests : 0;
        }

        service.taxes = function (returnTaxIfProductPriceIncludesTax, ignoreDeposit, ignoreFixedDeposit) {

            if (_.isObject(_taxOverride)) {
                // it's impossible to calculate per-item tax without the per-item discounts, so
                // the server returns the tax amount so we don't need to worry about it here
                return returnTaxIfProductPriceIncludesTax ? _taxOverride.onlineTax : _taxOverride.onlineTaxExclusiveOnly;
            }

            return getTaxCalculatedPerItem(returnTaxIfProductPriceIncludesTax, ignoreDeposit, ignoreFixedDeposit);
        }

        function getItemsForCalcs(includePackages) {
            var items = service.tickets().items;
            var itemsNoPackages = _.filter(items, function (i) { return i.productTypeId !== 'package'; });
            var packages = _.filter(angular.copy(items), function (i) { return _.some(i.packageItems); });

            _.each(packages, function (packageProduct) {
                _.each(packageProduct.packageItems, function (item) {
                    item.quantity *= packageProduct.quantity;
                    itemsNoPackages.push(item);
                });
            });

            return _.union(itemsNoPackages, service.addOns().items, includePackages ? packages : []);
        }

        service.getAllOrderItems = function () {
            var itemsNoPackages = _.filter(service.tickets().items, function (i) { return !i.isPackage; });

            return _.union(itemsNoPackages, service.addOns().items);
        }

        function getTaxCalculatedPerItem(includeInclusiveTax, ignoreDeposit, ignoreFixedDeposit) {
            var tax = 0;
            var modifierPercent = getModifierPercent();
            var items = getItemsForCalcs();

            var fixedDepositTaxAmount = 0;
            var packageFixedDepositTaxAmount = 0;

            if (!ignoreDeposit && service.onlyDepositRequired()) {
                // since fixed deposit amounts are added once for each product we dont need to calculate it per item, so calculate the tax for that here first
                fixedDepositTaxAmount = _.chain(items)
                    .filter(function (item) { return _.isNumber(item.depositAmount) && !item.packageProductId; })
                    .groupBy('parentId')
                    .map(function (items) {
                        // get total of cost product items
                        var productDepositItemsCost = _.chain(items)
                            .map(function (item) { return service.calculateTicketPrice(item, { ignoreDeposit: ignoreDeposit }); })
                            .sum()
                            .value();

                        // calculate how much of the deposit amount needs to be taxed by summing the deposit amount multiplied by the percentage of the item cost of the total cost of the product's items multiplied by item's tax percentage
                        return _.chain(items)
                            .filter(function (item) { return includeInclusiveTax || item.isTaxInclusive === false || (item.isTaxInclusive !== true && !_costSettings.productPricesIncludeTax); })
                            .map(function (item) { return service.calculateTicketPrice(item, { ignoreDeposit: ignoreDeposit }) / productDepositItemsCost * item.depositAmount * item.taxPercent / 100; })
                            .sum()
                            .value();
                    })
                    .sum()
                    .value();

                // NOTE: this logic doesn't take into consideration different tax rates etc, however this is what the server is currently doing
                packageFixedDepositTaxAmount = _.chain(items)
                    .filter(function (item) { return _.isNumber(item.depositAmount) && item.packageProductId; })
                    .groupBy('packageProductId')
                    .map(function (items) {
                        var item = _.first(items);

                        return (includeInclusiveTax || item.isTaxInclusive === false || (item.isTaxInclusive !== true && !_costSettings.productPricesIncludeTax)) ? item.depositAmount * item.taxPercent / 100 : 0;
                    })
                    .sum()
                    .value();


                // get the remaining items that did not have a fixed deposit amount
                items = _.filter(items, function (item) { return !item.depositAmount; });
            }

            _.each(items, function (item) {
                var originalTicketPrice = service.calculateTicketPrice(item, { ignoreDeposit: ignoreDeposit });
                var ticketPrice = originalTicketPrice;
                var requiredCostModifiers = _.where(item.bookingCostModifiers, { appliesToBookingItem: true, isRequired: true });

                _.each(requiredCostModifiers, function (cm) {
                    if (cm.isPercentage) {
                        ticketPrice += (originalTicketPrice * cm.amount / 100);
                    } else {
                        ticketPrice += cm.amount;
                    }
                });

                var itemCost = ticketPrice * item.quantity;

                if (modifierPercent) {
                    itemCost += (itemCost * modifierPercent / 100);
                }

                if (item.isTaxInclusive || (item.isTaxInclusive !== false && _costSettings.productPricesIncludeTax)) {
                    if (includeInclusiveTax) {
                        tax += (itemCost - (itemCost / (1 + (item.taxPercent / 100))));
                    }
                }
                else {
                    tax += (itemCost * item.taxPercent / 100);
                }
            });

            return tax + (ignoreFixedDeposit ? 0 : (fixedDepositTaxAmount + packageFixedDepositTaxAmount));
        }

        function getModifierPercent() {
            var result = 0;

            if (_bookingCostModifiers) {

                var options = {
                    ignoreBookingCostModifiers: true,
                    ignoreDiscountCodes: true
                };
                var subTotal = service.subTotal(options);

                _.each(_bookingCostModifiers, function (bcm) {
                    result += (bcm.isPercentage ? bcm.amount : (bcm.amount / subTotal));
                });
            }
            return result;
        }

        service.processOrder = function () {
            if (!service.inProgress) {
                try {
                    _paymentAttempts++;
                    makePayment();
                }
                catch (err) {
                    $log.error(err);
                    handleError(err);
                }
            }
        };

        service.processDraftOrder = function () {
            if (service.inProgress) {
                return $q.reject();
            }

            return createBookingForUser();
        };

        service.isProcessed = function () {
            return !!order.isProcessed;
        };

        // "items" could be a OrderItemCollection of tickets or addOns
        service.removeItem = function (items, item, checkAddOns, removeAll, quantityToRemove) {

            var removingQuantity = quantityToRemove || 1;

            if (removingQuantity > 1 && item.productTypeId === productTypes.giftCard || item.productTypeId === productTypes.wallet || item.productTypeId === productTypes.cashlessCard) {
                for (var i = 0; i < removingQuantity; i++) {
                    items.remove(item, removeAll);
                }
            } else {
                items.remove(item, removeAll, quantityToRemove);
            }

            if (checkAddOns) {
                var addOnsToRemove = [];

                _.forEach(order.addOns.items, function (addOnItem) {
                    var addOn = productService.getProductById(addOnItem.parentId, item.bookingDate);

                    if (addOn) {
                        var removeAddOn = !_.any(addOn.addOnParentIds, function (addOnParentId) {
                            return _.any(order.tickets.items, function (item) { return item.parentId === addOnParentId && addOnItem.bookingDate === item.bookingDate });
                        });

                        if (removeAddOn) {
                            addOnsToRemove.push(addOnItem);
                        }
                    }
                });

                _.forEach(addOnsToRemove, function (item) {
                    order.addOns.remove(item, true);

                    item.quantity = 0;

                    $rootScope.$broadcast('cart-item-removed', { item: item });
                });
            }

            $rootScope.$broadcast('cart-item-removed', { item: item });

            var remainingQuantity = service.getInCartQuantity(order.tickets, item, item.bookingDate);

            if (item.forceMinPurchase && !remainingQuantity) {
                // user has clicked the X on the cart, but that item has a min set and is required for the given package/product
                $rootScope.$broadcast('reset-products', {});
                service.resetOrder();
            } else if ($state.current.name != 'sessions.home' && !service.tickets().any() && !($state.is('sessions.addons') && productService.isDonationOnly())) {
                service.resetOrder();
            }
        }

        service.itemCount = function () {
            return order.tickets.count() + order.addOns.count();
        };

        service.isCartVisible = function () {
            return _showingCart;
        };

        service.showCart = function () {
            _showingCart = true;
        };

        service.hideCart = function () {
            _showingCart = false;
        };

        service.getPaymentAttempts = function () {
            return _paymentAttempts;
        }

        service.resetOrder = function (retainState) {
            order = orderTemplate();
            service.clearDiscount();
            _draftBooking = null;
            _bookingCostModifiers = null;
            _forms = [];
            _payFullAmountIgnoringDeposit = false;
            _checkoutStartDateTime = null;
            settingsService.refreshCorrelationId();
            _paymentSuccessMessage = null;
            _paymentAttempts = 0;
            _dateSelected = false;
            _canBuyAddOns = true;
            _giftcards = [];
            _dateSelected = false;
            _showBriefOrderConfirmation = false;
            service.setBookingDate(null);

            if (!retainState) {
                $state.go('sessions.home');
            }
        };

        service.calculateTicketPrice = function (ticket, options) {
            options = options || {};

            var hasDeposit = !options.ignoreDeposit && service.onlyDepositRequired();
            var selectedDuration = ticket.selectedDuration ? ticket.selectedDuration : ticket.duration;
            var hasDiscounts = ticket.sessionDiscounts && ticket.sessionDiscounts.length > 0;
            var ticketPrice = ticket.packagePrice || ticket.price;
            var calculatedPrice = ticketPrice;

            if (selectedDuration > ticket.duration && hasDiscounts) {

                var consecutiveSessions = selectedDuration / ticket.duration;
                var price = ticketPrice * consecutiveSessions;
                var index = _.findIndex(ticket.sessionDiscounts, function (el) {
                    return el.numberOfSessions == consecutiveSessions;
                });
                index = index >= 0 ? index : ticket.sessionDiscounts.length - 1;

                var discount = ticket.sessionDiscounts[index];

                if (discount) {

                    if (discount.amountType == 1) {

                        price -= price * (discount.amount / 100);
                    }
                    else {

                        price -= discount.amount;
                    }
                }

                calculatedPrice = price;
            }
            return hasDeposit ? calculatedPrice * (ticket.costPercentageRequired / 100) : calculatedPrice;
        }

        service.calculateTotalTicketModifierCost = function (costModifier) {
            if (!costModifier) {
                return 0;
            }

            var cost = 0;

            _.each(getItemsForCalcs(), function (ticket) {
                var ticketPrice = ticket.packagePrice ? ticket.packagePrice : ticket.price;
                var bcm = _.findWhere(ticket.bookingCostModifiers, { appliesToBookingItem: true, id: costModifier.id });

                if (bcm) {
                    var ticketCost = 0;

                    if (!bcm.isPercentage) {
                        ticketCost += bcm.amount;
                    } else {
                        ticketCost += bcm.amount / 100.0 * ticketPrice;
                    }
                    cost += (ticketCost * ticket.quantity);
                }
            });

            return cost;
        }

        service.loadCostSettings = function () {

            bookingService.getCostSettings().then(function (data) {
                _costSettings = data;
            }, function (error) {
                var showErrorMsg = window.location.search ? window.location.search.indexOf('showerror') >= 0 : false;
                var errorMsg = showErrorMsg && error && error.data && error.data.message ? error.data.message : '';
                $log.error(errorMsg);
                $state.go('error');
            });
        }

        // this method is used for the ticket timer
        service.getBooking = function () {

            var booking = { bookingItems: [] };
            var isDateIndex = service.getBookingDate().toString().length == 8;
            var bookingDate = moment(service.getBookingDate()).formatEn('YYYY-MM-DD');

            if (isDateIndex) {
                bookingDate = moment(service.getBookingDate(), 'YYYYMMDD').formatEn('YYYY-MM-DD');
            }

            var items = order.tickets.items;

            _.each(items, function (ticket) {
                booking.bookingItems.push({
                    productId: ticket.productId,
                    sessionStart: ticket.sessionTime,
                    sessionEnd: getSessionEndTime(ticket),
                    quantity: ticket.quantity,
                    bookingDate: ticket.bookingDate,
                    additionalGuests: ticket.additionalGuests
                });
            });

            _.each(order.addOns.items, function (addOn) {
                booking.bookingItems.push({
                    productId: addOn.productId,
                    quantity: addOn.quantity,
                    bookingDate: bookingDate
                });
            });

            return booking;
        }

        function getCreateBookingData(isBankTransfer) {
            var bookings = angular.copy(order.tickets.items);

            _.each(order.addOns.items, function (el) {
                bookings.push(el);
            });

            var discounts = getDiscountsDto();

            return {
                userDetails: order.details,
                bookings: bookings,
                discounts: discounts,
                giftcards: angular.copy(_giftcards),
                bookingCostModifiers: _bookingCostModifiers,
                payFullAmountIgnoringDeposit: _payFullAmountIgnoringDeposit,
                checkoutStartDateTime: _checkoutStartDateTime,
                isBankTransfer: isBankTransfer
            };
        }

        function createBookingForUser(isBankTransfer) {
            var deferred = $q.defer();

            try {
                service.inProgress = true;

                var createBookingData = getCreateBookingData(isBankTransfer);

                bookingService.createBookingForUser(createBookingData, order.delivery).then(
                    function (response) {
                        order.shrunkenBookingUniqueId = response.bookingId;
                        settingsService.bookingMade();
                        _draftBooking = response;

                        if (_draftBooking && _discount) {
                            _taxOverride = {
                                totalTax: _draftBooking.totalTaxAmount,
                                onlineTax: _draftBooking.taxAmount,
                                taxExclusiveOnly: _draftBooking.totalTaxExclusiveOnly,
                                onlineTaxExclusiveOnly: _draftBooking.taxExclusiveOnly
                            };
                        }

                        if (_draftBooking.bookingTimerId) {
                            ticketTimerService.setUniqueTimerId(_draftBooking.bookingTimerId);
                        }

                        deferred.resolve(response);
                    },
                    function (err) {
                        var errors = [];

                        if (err && err.data && angular.isDefined(err.data.params) && angular.isDefined(err.data.params.length)) {
                            errors = _.pluck(err.data.params, 'message');
                        }
                        else {
                            errors = ['Unable to process your booking at this time.'];
                        }

                        $log.error(errors);
                        deferred.reject(errors);
                    }
                ).finally(function () {
                    service.inProgress = false;
                });
            } catch (err) {
                $log.error(err);
                deferred.reject(err);
                service.inProgress = false;
            }

            return deferred.promise;
        }

        function getSessionEndTime(ticket) {
            if (!angular.isDefined(ticket.sessionTime)) {
                return null;
            }
            return parseInt(productService.getMomentTime(ticket.sessionTime).add(ticket.selectedDuration, 'minutes').formatEn('HHmm'));
        }

        service.getReceiptNumber = function () {
            return order.receiptNumber;
        };

        service.getShrunkenBookingUniqueId = function () {
            return order.shrunkenBookingUniqueId;
        }

        service.getPaymentMethod = function () {
            if (order.payment.requiresBankTransfer()) {
                return service.getPayLaterName();
            }
            return order.paymentMethod;
        }

        service.getShopperStatement = function () {
            return order.shopperStatement;
        }

        service.isPaymentPending = function () {
            return order.isPaymentPending;
        }

        // Ensure we don't duplicate discount code or add invalid discounts
        function processDiscountDto(dtos, discountDto) {
            if (discountDto) {
                if (discountDto.code) {
                    var existing = _.find(dtos, function (dto) {
                        return dto.code == discountDto.code;
                    });

                    if (!existing) {
                        dtos.push(discountDto);
                    }
                }
                else {
                    dtos.push(discountDto);
                }
            }
            return dtos;
        }

        function getDiscountsDto(discountCode) {
            var dtos = [];

            _.each(_discounts, function (discount) {
                var code = discount.codes[0];

                if (code) {
                    dtos.push({ code: code.code });
                }
            });

            if (discountCode) {
                dtos = processDiscountDto(dtos, { code: discountCode });
            }
            return dtos;
        }

        service.applyDiscountCode = function (discountCode) {
            var deferred = $q.defer();
            var discounts = getDiscountsDto(discountCode);

            if (_.any(discounts)) {
                var bookings = angular.copy(order.tickets.items);
                _.each(order.addOns.items, function (el) {
                    bookings.push(el);
                });

                var getBookingData = {
                    userDetails: order.details,
                    bookings: bookings,
                    discounts: discounts,
                    bookingCostModifiers: _bookingCostModifiers
                };

                if (_.any(_giftcards)) {
                    getBookingData.giftCardPaymentValue = service.giftcardValue();
                }

                var booking = bookingService.getBookingObject(getBookingData, order.delivery);

                $http({
                    url: rollerBaseUrl.legacyApi + "bookings/discount/valid",
                    method: "POST",
                    data: booking
                }).then(function (response) {
                    if (response.data.returnValue) {
                        _discount = response.data.returnValue[0];
                        _taxOverride = {
                            totalTax: _discount.tax,
                            onlineTax: _discount.onlineTax,
                            taxExclusiveOnly: _discount.taxExclusiveOnly,
                            onlineTaxExclusiveOnly: _discount.onlineTaxExclusiveOnly
                        };
                        _discounts = response.data.returnValue;
                    }

                    deferred.resolve(response.data);
                });
            }
            else {
                service.clearDiscount();
                deferred.reject();
            }

            return deferred.promise;
        }

        service.getDiscounts = function () {
            return _discounts;
        }

        service.getGiftCards = function () {
            return _giftcards;
        }

        service.getDiscountText = function (discount) {
            if (_.any(discount.codes)) {
                return discount.codes[0].code;
            }
        }

        service.removeAppliedGiftCard = function (index) {
            if (_.isNumber(index) && _.any(_giftcards)) {

                var removed = _giftcards.splice(index, 1);

                service.inProgress = true;

                validateGiftCards(_giftcards).then(function () {
                    $rootScope.$broadcast('gift-card-removed', removed);
                }).finally(function () {
                    service.inProgress = false;
                });
            }
        }

        service.removeAppliedDiscount = function (index) {
            if (_.isNumber(index) && _.any(_discounts)) {
                _discounts.splice(index, 1);
            }

            _discount = _.first(_discounts);

            $rootScope.$broadcast('discount-removed', {});

            return service.applyDiscountCode();
        }

        service.applyGiftCard = function (giftCardNumber, giftCardExpiryMonth, giftCardExpiryYear, giftCardPin) {

            if (_.findWhere(_giftcards, { giftcardNumber: giftCardNumber })) {
                return $q.resolve({ isValid: false, isUsed: true });
            }

            var giftcards = _.union(_giftcards, [{
                giftCardNumber: giftCardNumber,
                giftCardExpiryMonth: giftCardExpiryMonth,
                giftCardExpiryYear: giftCardExpiryYear,
                giftCardPin: giftCardPin
            }]);

            var validCallback = function (validGiftCards) {
                return _.any(validGiftCards, function (gc) { return gc.giftcardNumber === giftCardNumber; })
            };

            return validateGiftCards(giftcards, validCallback);
        }



        service.hasValidDiscountCode = function () {

            return _.any(_discounts);
        }

        service.hasValidGiftCard = function () {

            return _.any(_giftcards);
        }

        service.noFurtherPaymentRequired = function (ignorePayLater) {
            var isBankTransfer = ignorePayLater ? false : !!order.payment.requiresBankTransfer();
            if (_draftBooking) {
                return _draftBooking.totalBookingAmount === 0 || isBankTransfer;
            }
            return isBankTransfer;
        }

        service.clearDiscount = function () {
            _discount = null;
            _taxOverride = null;
            _discounts = [];
            _payFullAmountIgnoringDeposit = false;
            _draftBooking = null;
            _giftcards = [];
        }

        service.removeGiftCard = function () {
            _giftcards = [];
        }

        service.onlyDepositRequired = function () {
            if (_payFullAmountIgnoringDeposit) {
                return false;
            }

            return service.hasDepositItems();
        }

        service.hasDepositItems = function () {
            return _.some(order.tickets.items, function (ticket) { return _.isNumber(ticket.depositAmount) || ticket.costPercentageRequired < 100; });
        }

        service.canAddAddOn = function (addOn, product) {
            if (addOn.isSoldOut) {
                return false;
            }

            if (_.some(addOn.availability)) {
                var addOnAvailability = addOn.availability[0];
                var orderAddOns = service.addOns();
                var quantityForTicket = orderAddOns.quantity(addOn);

                if (_.some(addOn.productLocationCapacityLocations)) {

                    var orderAddOnsNotInCart = product ? _.filter(product.childApiProducts, function (t) { return t.quantity !== t.inCartQuantity; }) : [];
                    var tickets = orderAddOns.getAllTickets(orderAddOnsNotInCart);
                    var quantityOfOtherTicketsUsingSameCapacity = orderAddOns.quantityOfTicketsUsingSameCapacity(addOn, tickets);
                    var totalRemainingConsideringLocation = addOnAvailability.totalRemainingConsideringLocation;

                    if (quantityForTicket >= totalRemainingConsideringLocation ||
                        quantityOfOtherTicketsUsingSameCapacity >= totalRemainingConsideringLocation) {
                        return false;
                    }
                }
                else if (angular.isDefined(addOnAvailability.totalRemaining) && quantityForTicket >= addOnAvailability.totalRemaining) {
                    return false;
                }
            }
            return true;
        }

        service.canModifyOrder = function () {
            return !service.isProcessed() && !$state.is('sessions.details') && !$state.is('sessions.payment');
        }

        service.canModifyDiscount = function () {
            return !service.isProcessed() && !$state.is('sessions.payment');
        }

        service.canModifyGiftCard = function () {
            return !service.isProcessed() && !$state.is('sessions.payment');
        }

        service.getInCartQuantity = function (items, child, bookingDate) {
            if (child.hasUserDefinedCost) {
                return undefined;
            }

            var existingItems = items.existingItems(child, bookingDate);

            if (child.productTypeId === productTypes.giftCard || child.productTypeId === productTypes.wallet || child.productTypeId === productTypes.cashlessCard) {
                return _.sum(existingItems, 'quantity');
            } else {
                var first = _.first(existingItems);

                if (first) {
                    return first.quantity;
                }
            }

            return 0;
        }

        function validateGiftCards(giftcards, localValidCallback) {

            if (!_.any(giftcards)) {
                return $q.resolve({ isValid: false });
            }

            var bookings = angular.copy(order.tickets.items);
            _.each(order.addOns.items, function (el) {
                bookings.push(el);
            });

            var discounts = getDiscountsDto();
            var getBookingData = {
                userDetails: order.details,
                bookings: bookings,
                discounts: discounts,
                giftcards: giftcards,
                bookingCostModifiers: _bookingCostModifiers
            };

            var booking = bookingService.getBookingObject(getBookingData, order.delivery);

            return $http({
                url: rollerBaseUrl.legacyApi + "bookings/giftcard/valid",
                method: "POST",
                data: booking
            }).then(function (response) {

                var isValid = false;

                if (response.data.returnValue) {

                    var giftCardResult = response.data.returnValue;
                    var validGiftCards = _.chain(giftCardResult.giftCards)
                        .filter('isValid')
                        .pluck('returnValue')
                        .value();

                    if (_.isFunction(localValidCallback)) {
                        isValid = localValidCallback(validGiftCards);
                    } else {
                        isValid = _.any(validGiftCards);
                    }

                    _giftcards = validGiftCards;
                }

                if (isValid && _discount) {
                    // TODO: need to decide how we want to handle the discount result now being invalid - may never happen after applying a giftcard?
                    return service.applyDiscountCode().then(function () {
                        return response.data;
                    });
                }

                return {
                    isValid: isValid
                };
            });
        }

        function canAddPackage(ticket, validateCurrentQuantitiesOnly, allProducts) {
            var products = angular.copy(ticket.packageItems);

            var allTickets = [];

            if (!validateCurrentQuantitiesOnly) {
                _.each(allProducts, function (p) {
                    _.each(p.tickets, function (item) {
                        var t = service.getItemWithQuantityDiff(item);

                        if (t.quantity) {
                            if (_.any(t.packageItems)) {
                                _.each(t.packageItems, function (pi) {
                                    var packageItem = angular.copy(pi);
                                    packageItem.quantity = packageItem.quantity * t.quantity;
                                    allTickets.push(packageItem);
                                });
                            }
                            else {
                                allTickets.push(t);
                            }
                        }
                    });
                });
            } else {
                _.each(products, function (product) {
                    product.quantity = product.quantity * ticket.quantity;
                });
            }

            return _.every(products, function (ticketToCheck) {

                if (_.some(ticketToCheck.sessions)) {
                    ticketToCheck.sessionTime = ticket.sessionTime;
                    ticketToCheck.selectedDuration = ticket.selectedDuration;
                }

                if (ticketToCheck.productTypeId === 'addOn') {
                    return service.canAddAddOn(ticketToCheck);
                }
                return service.canAdd(ticketToCheck, [{ tickets: (validateCurrentQuantitiesOnly ? products : allTickets) }], validateCurrentQuantitiesOnly);
            });
        }

        service.canAdd = function (ticket, products, validateCurrentQuantitiesOnly) {

            if (ticket.isSoldOut || ticket.isClosed) {
                return false;
            }
            else if (_.some(ticket.packageItems)) {
                return canAddPackage(ticket, validateCurrentQuantitiesOnly, products);
            }
            else if (!canAddRecurringPaymentTicket(ticket)) {
                return false;
            }

            var orderTickets = service.tickets();
            // we cannot rely on the cart having all the tickets anymore since the UX has changed
            // so that users choose the amount they want, then add to cart - so we need to check product.tickets too
            var orderTicketsNotInCart = products ? _.filter(_.flatten(_.pluck(products, 'tickets')), function (t) {
                return t && t.quantity > 0 && t.quantity !== t.inCartQuantity && (!ticket.sessionTime || t.sessionTime);
            }) : [];
            var includeGroupSize = true;
            var quantityForTicket = orderTickets.quantity(ticket, includeGroupSize);
            var tickets = orderTickets.getAllTickets(orderTicketsNotInCart);

            // requiredGroupSize is added to the current quantities to determine if anymore tickets can be added - however
            // when validateCurrentQuantitiesOnly is true we only want to test that the current quantities are valid
            var requiredGroupSize = validateCurrentQuantitiesOnly ? 0 : (ticket.requiredGroupSize ? ticket.requiredGroupSize : 1);
            if (!ticket.sessionTime) {

                if (shouldCheckExternalLimit()) {
                    var externalLimit = 0; // This limit is calculated by number of ticket in previous step x group limit multiplier
                    var prevTicketCount = service.getGroupOneTicketCount() || 0;
                    var groupOne = productService.consumerWidgetGroup() || {};

                    if (_.isNumber(groupOne.nextGroupMaxQuantityPerProduct) &&
                        groupOne.nextGroupMaxQuantityPerProduct > 0 && prevTicketCount > 0) {

                        externalLimit = prevTicketCount * groupOne.nextGroupMaxQuantityPerProduct;

                        var bookingCountForProduct = 0;

                        _.each(orderTickets.items, function (t) {
                            if (t && t.productId === ticket.productId) {
                                bookingCountForProduct += (t.quantity || 0);
                            }
                        });

                        if (externalLimit > 0 && (bookingCountForProduct >= externalLimit)) {
                            return false;
                        }
                    }
                }

                var quantityOfNonSessionTicketsUsingSameCapacity = orderTickets.quantityOfTicketsUsingSameCapacity(ticket, tickets);
                var remainingConsideringLocation = _.isNumber(ticket.totalRemainingConsideringLocation) ? ticket.totalRemainingConsideringLocation : null;

                if (remainingConsideringLocation == null || remainingConsideringLocation > ticket.productLocationCapacity) {
                    remainingConsideringLocation = ticket.productLocationCapacity;
                }

                if (orderTickets.hasBookingRestriction(ticket, tickets)) {
                    return false;
                }

                return (ticket.remaining == null || quantityForTicket + requiredGroupSize <= ticket.remaining) &&
                    (!ticket.maxBookingLimit || ticket.productTypeId === 'wallet' || (quantityForTicket + requiredGroupSize <= ticket.maxBookingLimit)) &&
                    (!_.isNumber(remainingConsideringLocation) || quantityOfNonSessionTicketsUsingSameCapacity + requiredGroupSize <= remainingConsideringLocation);
            }
            else {
                var productSession = _.findWhere(ticket.sessions, { startTime: ticket.sessionTime });
                var category = _.findWhere(ticket.categories, { duration: ticket.selectedDuration ? ticket.selectedDuration : ticket.duration });
                var productBookedQuantityConsideringLocation = productSession.productBookedQuantityConsideringLocation ? productSession.productBookedQuantityConsideringLocation : 0;
                var remaining = productSession.productLocationCapacity ? productSession.productLocationCapacity - productBookedQuantityConsideringLocation : category.remaining;
                var quantityOfTicketsUsingSameCapacity = orderTickets.quantityOfTicketsUsingSameCapacity(productSession, tickets);
                var quantityOfTicketsForSession = orderTickets.quantityOfTicketsForSession(ticket, orderTicketsNotInCart);

                //console.log('---', ticket.name, ticket, productSession, category, productBookedQuantityConsideringLocation, remaining, quantityOfTicketsUsingSameCapacity, quantityOfTicketsForSession, requiredGroupSize)

                if (orderTickets.hasBookingRestriction(ticket, tickets, productSession)) {
                    return false;
                }

                return _.isObject(category) &&
                    // isSessionCapacityFull is true when all single-booking locations are booked
                    !productSession.isSessionCapacityFull &&
                    // session/duration has enough capacity
                    (!_.isNumber(productSession.capacity) || category.remaining >= quantityOfTicketsForSession + requiredGroupSize) &&
                    // given ticket can only be purchased X times
                    (!ticket.maxBookingLimit || (quantityForTicket + requiredGroupSize <= ticket.maxBookingLimit)) &&
                    // given ticket must be purchased X times, or not at all (depending on forceMinPurchase flag)
                    (!ticket.minBookingLimit || ticket.minBookingLimit <= remaining) &&
                    // ticket within session has its own capacity (optionally)
                    (!productSession.capacity || (quantityForTicket + (productSession.bookedQuantity || 0)) + requiredGroupSize <= productSession.capacity) &&
                    // cross-product capacity validation taking into account all current tickets based on locations
                    (!quantityOfTicketsUsingSameCapacity || productBookedQuantityConsideringLocation + quantityOfTicketsUsingSameCapacity + requiredGroupSize <= productSession.productLocationCapacity);
            }
        }

        service.isSessionSoldOut = function (ticket) {
            var productSession = _.findWhere(ticket.sessions, { startTime: ticket.sessionTime });
            return productSession &&
                productSession.capacity &&
                productSession.bookedQuantity &&
                productSession.capacity <= productSession.bookedQuantity;
        }

        service.canDecrease = function (ticket) {
            return ticket.quantity > 0 && (!ticket.minBookingLimit || !ticket.forceMinPurchase || ((ticket.quantity - 1) * ticket.requiredGroupSize) >= ticket.minBookingLimit);
        }

        service.getTermsAndConditions = function () {
            return service.tickets().termsAndConditions();
        }

        service.calculateBookingCostModifier = function (costModifier) {
            if (!costModifier.isPercentage) {
                return costModifier.amount;
            }
            var options = {
                ignoreBookingCostModifiers: true,
                ignoreDiscountCodes: true
            };
            var subTotal = service.subTotal(options);

            return costModifier.amount / 100.0 * subTotal;
        }

        service.addBookingCostModifier = function (costModifier) {
            if (!_bookingCostModifiers) {
                _bookingCostModifiers = [];
            }
            _bookingCostModifiers.push(costModifier);
        }

        service.removeBookingCostModifier = function (costModifier) {
            _bookingCostModifiers = _.filter(_bookingCostModifiers, function (cm) { return cm.name != costModifier.name; });
        }

        service.getWaiver = function () {
            var waiver;
            order.tickets.items.forEach(function(item) {
                if (waiver) {
                    return;
                }
                waiver = item.waiver;
                if (!waiver) {
                    var index = _.findIndex(item.packageItems, function(packItem) { return packItem.waiver; });
                    if (~index) {
                        waiver = item.packageItems[index].waiver;
                    }
                }
            })
            return waiver || null;
        }

        service.setDepositPayFullOverride = function (payFullAmount) {
            _payFullAmountIgnoringDeposit = payFullAmount;
        }

        service.getDepositPayFullOverride = function () {
            return _payFullAmountIgnoringDeposit;
        }

        service.getTotalTicketsForAddon = function (addOn, bookingDate) {
            var tickets = _.filter(order.tickets.items, function (item) {
                return (!bookingDate || item.bookingDate === bookingDate) && _.contains(addOn.addOnParentIds, item.parentId);
            });
            return _.reduce(tickets, function (memo, ticket) {
                return memo + (ticket.quantity * ticket.requiredGroupSize);
            }, 0);
        }

        service.hasRecurring = function () {
            return order && order.tickets && !_.isEmpty(_.filter(order.tickets.items, function (item) {
                return !!item.recurringPayment;
            }));
        }

        service.getPaymentSuccessMessage = function () {
            return _paymentSuccessMessage;
        }

        service.updateDraftBookingPaymentOptions = function () {
            if (!(_draftBooking && _draftBooking.bookingId)) {
                return $q.reject();
            }

            service.inProgress = true;

            var bookingData = getCreateBookingData(order.payment.requiresBankTransfer());

            return bookingService.updateBookingPaymentOptions(bookingData, order.delivery).then(function (response) {
                order.receiptNumber = response.receiptNumber;
                order.shrunkenBookingUniqueId = response.bookingId;
                settingsService.bookingMade();
                _draftBooking = response;

                if (_draftBooking && _discount) {
                    _taxOverride = {
                        totalTax: _draftBooking.totalTaxAmount,
                        onlineTax: _draftBooking.taxAmount,
                        taxExclusiveOnly: _draftBooking.totalTaxExclusiveOnly,
                        onlineTaxExclusiveOnly: _draftBooking.taxExclusiveOnly
                    };
                }

                if (_draftBooking.bookingTimerId) {
                    ticketTimerService.setUniqueTimerId(_draftBooking.bookingTimerId);
                }

            }).finally(function () {
                service.inProgress = false;
            });
        }

        service.requiresRecaptcha = function () {
            var hasGiftCards = _.some(service.tickets().items, function (i) { return i.productTypeId === productTypes.giftCard; });
            return settingsService.canUseRecaptcha() || (settingsService.forceRecaptchaForGiftCard && hasGiftCards);
        }

        service.validateRecaptcha = function (recaptcha) {
            if (recaptcha) {
                return $http.post(rollerBaseUrl.legacyApi + 'google/recaptcha/', { response: recaptcha, isInvisible: true }).then(function (response) {
                    return response.data;
                });
            } else {
                return $q.when();
            }
        }

        service.paymentAlreadyProcessed = function (shrunkenBookingUniqueId) {
            service.inProgress = true;
            var deferred = $q.defer();

            checkIfPaymentProcess(shrunkenBookingUniqueId || order.shrunkenBookingUniqueId, 3, 1500, function (response) {
                service.inProgress = false;
                deferred.resolve(response.data);
            }, deferred.reject);

            return deferred.promise;
        };

        service.markBookingAsCompleted = function (receiptNumber) {
            commitOrder({
                receiptNumber: receiptNumber || _draftBooking.bookingId
            });
        }

        service.isPaymentRedirecting = function () {
            return service.paymentRedirecting;
        }

        service.abandonedOrder = function () {
            var pendingData = $sessionStorage.draftBooking;

            if (pendingData && pendingData.order && pendingData.timestamp) {
                if (moment.duration(moment().diff(moment(pendingData.timestamp))).asMinutes() <= 10) {
                    return pendingData.order;
                }
            }

            return null;
        }

        service.setOrderResult = function (result) {
            order.isProcessed = result.success;
            service.inProgress = false;

            if (result.success) {
                onPaymentCompleted(result);
            }
        }
        service.clearLocalOrderData = function () {
            $sessionStorage.draftBooking = null;
        }

        service.loadLocalOrderData = function () {
            var data = $sessionStorage.draftBooking;

            if (!data || !data.order) {
                return false;
            }

            var temp = orderTemplate();

            temp.product = data.order.product;
            temp.bookingDate = data.order.bookingDate;
            temp.delivery = new OrderDelivery(data.order.delivery);
            temp.details = new OrderCustomerDetails(data.order.details);
            temp.payment = new OrderPaymentDetails(data.order.payment);
            temp.addOns = new OrderItemCollection(data.order.addOns);
            temp.tickets = new OrderItemCollection(data.order.tickets);
            temp.sessionTime = data.order.sessionTime;
            temp.discount = data.order.discount;
            temp.shrunkenBookingUniqueId = data.order.shrunkenBookingUniqueId;

            order = temp;

            _draftBooking = data.draft;
            _discount = data.discount;
            _discounts = data.discounts;
            _giftcards = data.giftcards;
            _bookingCostModifiers = data.bookingCostModifiers;
            _taxOverride = data.taxOverride;
            _payFullAmountIgnoringDeposit = data.payFullAmountIgnoringDeposit;
            _paymentAttempts = data.paymentAttempts;

            return true;
        }

        service.payUsingExtenalMethod = function () {
            return !service.noFurtherPaymentRequired() && !order.payment.requiresBankTransfer() &&
                $rootScope.paymentSetting && $rootScope.paymentSetting.isDropIn;
        }

        service.getPayLaterName = function () {
            return contentService.content('pay_later_name') || $translate.instant('SESSIONS.PAYMENT.BANK_TRANSFER');
        }

        service.mustCheckIfProcessed = function () {
            return !order.payment.requiresBankTransfer();
        }

        service.getItemWithQuantityDiff = function (item) {

            if (item) {
                var inCartQuantity = item.inCartQuantity || 0;
                var diff = item.quantity - inCartQuantity;
                var ticket = angular.copy(item);

                ticket.quantity = diff;

                return ticket;
            }

            return item;
        }

        service.showBriefOrderConfirmation = function () {
            return _showBriefOrderConfirmation;
        }

        service.setBriefOrderConfirmation = function (isBrief) {
            _showBriefOrderConfirmation = isBrief;
        }

        return service;

        function checkIfPaymentProcess(shrunkenBookingUniqueId, repeatCount, delayMiliseconds, successCallback, failCallback) {
            $http({
                url: rollerBaseUrl.legacyApi + 'payment/processed/' + shrunkenBookingUniqueId,
                method: "GET"
            }).then(function (response) {
                if (response.data.isProcessed) {
                    successCallback(response);
                } else if (repeatCount > 0) {
                    setTimeout(function () {
                        checkIfPaymentProcess(shrunkenBookingUniqueId, --repeatCount, delayMiliseconds * 2, successCallback, failCallback);
                    }, delayMiliseconds);
                } else {
                    successCallback(response);
                }
            }, function (err) {
                if (repeatCount > 0) {
                    setTimeout(function () {
                        checkIfPaymentProcess(shrunkenBookingUniqueId, --repeatCount, delayMiliseconds * 2, successCallback, failCallback);
                    }, delayMiliseconds);
                } else {
                    failCallback(err);
                }
            });
        }

        function orderTemplate() {
            return {
                product: null,
                sessionTime: null,
                tickets: new OrderItemCollection(),
                addOns: new OrderItemCollection(),
                details: new OrderCustomerDetails(),
                payment: new OrderPaymentDetails(),
                discount: null,
                delivery: new OrderDelivery(),
                bookingDate: order && order.bookingDate ? order.bookingDate : null // retain date for another purchase
            };
        }

        function shouldCheckExternalLimit() {
            return $state.is('sessions.home2');
        }

        function getReferenceInfo() {
            var refInfo = {
                referenceId: _draftBooking.bookingId,
                customerId: _draftBooking.customerId,
                receiptNumber: _draftBooking.receiptNumber,
                additionalPaymentMode: order.payment.paymentMethod === 'others' ? order.payment.subPaymentMethod : null,
                totalAmount: _draftBooking.totalBookingAmount,
                totalAmountInMinorUnit: _draftBooking.totalAmountInMinorUnit,
                textOverride: $translate.instant('SESSIONS.PAYMENT.LOADER_TEXT_OVERRIDE'),
                buttonOverride: $translate.instant('SESSIONS.PAYMENT.LOADER_BUTTON_OVERRIDE'),
                customerEmail: order.details.email,
                hasRecurring: service.hasRecurring(),
                correlationId: settingsService.correlationId
            };

            if (order.payment.additionalInfo) {
                refInfo.idDocumentType = order.payment.additionalInfo.idType;
                refInfo.idDocumentNumber = order.payment.additionalInfo.idNumber;
            }

            return refInfo;
        }

        function makePayment() {

            if (!_draftBooking) {
                $state.go('sessions.details');
            }

            service.inProgress = true;

            var isBankTransfer = order.payment.requiresBankTransfer();

            try {
                if (service.noFurtherPaymentRequired() && !service.hasRecurring()) {

                    bookingService.publishDraft(_draftBooking.bookingId, isBankTransfer).then(function (response) {
                        order.receiptNumber = response.receiptNumber;
                        order.shrunkenBookingUniqueId = response.bookingId;
                        order.bankTransferDetails = response.bankTransferDetails;

                        order.isProcessed = true;
                        service.inProgress = false;

                        analyticsService.pageTrack('success', settingsService.venueName);
                        analyticsService.successEvent(_draftBooking.totalBookingAmount, settingsService.venueName);
                        analyticsService.eventTrack("confirmation", "totalTickets", order.tickets.quantity(), settingsService.venueName);
                    }, handleError);
                } else {
                    var referenceInfo = getReferenceInfo();
                    var paymentInfo = {
                        creditCardNumber: order.payment.cardNumber,
                        cardHolderName: order.payment.cardName,
                        expiryMonth: getNumberString(order.payment.cardExpiryMonth),
                        expiryYear: getNumberString(order.payment.cardExpiryYear),
                        ccv: order.payment.cardCVV,
                        paypalNonce: order.payment.paymentMethod === 'paypal' ? order.payment.paypalNonce : null,
                    };

                    var addressInfo = order.payment.billingAddress ? {
                        address: order.payment.billingAddress.address,
                        address2: order.payment.billingAddress.address2,
                        city: order.payment.billingAddress.city,
                        state: order.payment.billingAddress.state,
                        country: order.payment.billingAddress.country,
                        postalCode: order.payment.billingAddress.postalCode
                    } : void (0);

                    rollerpayment.submitPayment(referenceInfo, paymentInfo, addressInfo, '#loading-additional', null, $translate.use(), true)
                        .then(onPaymentCompleted).catch(handleError);
                }
            } catch (ex) {
                handleError(ex);
            }
        }

        function onPaymentCompleted(result) {
            $timeout(function () {
                service.inProgress = false;
            });
            $log.info("SUCCESS", result);
            commitOrder(result);

            if (_showBriefOrderConfirmation) {
                if (result.bookingAmount) {
                    analyticsSuccessEvent(result.bookingAmount, true);
                }
            }
            else {
                analyticsSuccessEvent(_draftBooking.totalBookingAmount);
            }
        }

        function analyticsSuccessEvent(totalBookingAmount, onlySendTotalAmount) {
            try {
                analyticsService.pageTrack('success', settingsService.venueName);
                analyticsService.successEvent(totalBookingAmount, settingsService.venueName);

                if (!onlySendTotalAmount) {
                    analyticsService.eventTrack("confirmation", "totalTickets", order.tickets.quantity(), settingsService.venueName);
                }

                //TODO:find out if we can remove the above events (totalBookingAmount, totalTickets) now we're sending this GAecommerce event>
                //TODO: review following ecommerce data and ensure it is correct - refer Jeron
                var transactionData = {
                    transactionId: service.getReceiptNumber(),
                    transactionAffiliation: settingsService.venueName,
                    transactionTotal: totalBookingAmount,
                    event: 'GAecommerce'
                };

                if (!onlySendTotalAmount) {
                    transactionData.transactionTotal = service.total();
                    transactionData.transactionTax = service.taxes(true);
                    transactionData.transactionProducts = _.map(service.getAllOrderItems(), function (item) {
                        return {
                            sku: item.name,
                            name: item.name,
                            category: item.parentName,
                            price: item.price,
                            quantity: item.quantity
                        };
                    });
                }

                analyticsService.sendTransactionData(transactionData);
            }
            catch (ex) {
                $log.error(ex);
            }
        }

        function getNumberString(number) {
            if (number < 10) {
                return ("0" + number).slice(-2);
            }
            if (number.toString().length === 4) {
                return number.toString().substr(2, 2);
            }
            return number;
        }

        function handleError(error, errorCallback) {
            if (hppWasSuccessful(error)) {
                commitOrder({
                    receiptNumber: _draftBooking.bookingId
                });
            }
            else {
                if (hppWasClosed(error)) {
                    error = $translate.instant('PAYMENT.POPUP_CLOSED', { BOOKING_ID: _draftBooking.bookingId }, 'messageformat');
                }
                else if (error.data && error.data.message) {
                    error = error.data.message;
                } else if (!_.isArray(error) && _.isObject(error) && (error.config || error.headers)) {
                    // Should not display whole API response error to the end user
                    error = $translate.instant('GENERIC.PAYMENT_ERROR');
                }

                if (error === 'CANCELLED') {
                    error = $translate.instant('SESSIONS.PAYMENT.CANCELLED');
                }
                // Normalise errors to an array with null errors removed
                var errors = _.filter(_.isArray(error) ? error : [error]);
                service.inProgress = false;

                if (typeof (errorCallback) === 'function') {
                    errorCallback(errors);
                } else {
                    $state.go('sessions.payment', {
                        paymentErrors: errors,
                        giftcardCode: _.any(_giftcards) ? _giftcards[0].code : null
                    });
                }
            }
        }

        function hppWasClosed(error) {
            return isHpp() && (error === 'Canceled' || error === 'close_detected');
        }

        function hppWasSuccessful(error) {
            try {
                return isHpp() && error && JSON.stringify(error).indexOf('authResult=AUTHORISED') > 0;
            }
            catch (ex) {
                return false;
            }
        }

        function commitOrder(result) {
            if (result && result.message) {
                _paymentSuccessMessage = result.message;
            }

            if (order.payment.paymentMethod === 'creditcard') {
                var cardEnding = $translate.instant('ORDER_SUMMARY.CARD_ENDING');
                var cardNumber = order.payment.cardNumber;

                if (result.cardLast4Digits) {
                    cardNumber = result.cardLast4Digits;
                }

                order.paymentMethod = cardEnding + ' ' + (cardNumber || '').replace(/\s+$/, '').substr(-4);
            }
            else if (order.payment.paymentMethod === 'paypal') {
                order.paymentMethod = $translate.instant('SESSIONS.PAYMENT.PAYPAL');
            }
            else if (order.payment.paymentMethod === 'banktransfer') {
                order.paymentMethod = service.getPayLaterName();
            }

            order.isProcessed = true;
            service.inProgress = false;
            order.receiptNumber = result.receiptNumber;
            order.shopperStatement = result.shopperStatement;
            order.isPaymentPending = result.isPaymentPending === 'true';

            service.clearLocalOrderData();
        }

        function canAddRecurringPaymentTicket(ticket) {
            if (!ticket.recurringPayment) {
                return true;
            }

            var orderTickets = service.tickets();
            var recurringPaymentTickets = _.filter(orderTickets.items, function (t) { return !!t.recurringPayment });
            var result = _.findIndex(recurringPaymentTickets, function (t) {
                return ticket.recurringPayment.numberOfPayments != t.recurringPayment.numberOfPayments ||
                    ticket.recurringPayment.paymentFrequencyId != t.recurringPayment.paymentFrequencyId;
            });
            return result == -1;
        }

        function isHpp() {
            return $rootScope.paymentSetting && ($rootScope.paymentSetting.key === 'HPP' || $rootScope.paymentSetting.paymentPortalType === 'Payfort');
        }
    }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("modalService", modalService);

    /** @ngInject */
    function modalService(ngDialog, $q) {

        var service = {
            showVenueTermsAndConditions: _.bind(showTermsAndConditions, this),
            showPaymentTermsAndConditions: _.bind(showTermsAndConditions, this, 'payment_tos'),
            showPrivacyPolicy: _.bind(showTermsAndConditions, this, 'privacy_policy'),
            redeemGiftcard: redeemGiftcard,
            confirm: confirm
        };

        function showTermsAndConditions(type) {
            ngDialog.open({
                template: 'app/views/modals/terms.and.conditions.html',
                controller: 'TermsAndConditionsController',
                controllerAs: 'vm',
                className: 'ngdialog-theme-roller',
                resolve: {
                    product: function () {
                        return null;
                    },
                    type: function () { return type }
                }
            });
        }

        function redeemGiftcard(giftcard) {
            return ngDialog.open({
                template: 'app/views/modals/redeem-giftcard.html',
                controller: 'RedeemGiftcardController',
                controllerAs: 'vm',
                className: 'ngdialog-theme-roller redeem redeem__admin',
                showClose: false,
                resolve: {
                    giftcard: function () {
                        return giftcard;
                    }
                }
            });
        }

        function confirm(message, title, okButtonText, cancelButtonText) {

            var deferred = $q.defer();

            ngDialog.open({
                template: 'app/views/modals/message.html',
                controller: 'MessageModalController',
                controllerAs: 'vm',
                className: 'ngdialog-theme-roller',
                showClose: false,
                closeByDocument: false,
                closeByEscape: false,
                resolve: {
                    title: function () { return title || 'GENERIC.CONFIRM'; },
                    message: function () { return message; },
                    okButtonText: function () { return okButtonText; },
                    cancelButtonText: function () { return cancelButtonText; }
                }
            }).closePromise.then(function (result) {
                if (result && result.value === true) {
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            }, deferred.reject);

            return deferred.promise;
        }

        return service;
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("giftcardService", giftcardService);

    /** @ngInject */
    function giftcardService($http, rollerBaseUrl) {

        function getGiftcard(uniqueBookingId, giftcardNumber) {
            return $http.get(rollerBaseUrl.legacyApi.replace(/\/+$/, '') + '/bookings/' + uniqueBookingId + '/giftcard/' + giftcardNumber).then(_.property('data'));
        }

        function deduct(uniqueBookingId, giftcardNumber, amount, passcode) {
            var data = {
                amountToDeduct: amount,
                uniqueGiftCardId: giftcardNumber,
                passcode: passcode
            };
            return $http.put(rollerBaseUrl.legacyApi.replace(/\/+$/, '') + '/bookings/' + uniqueBookingId + '/giftcards', data).then(_.property('data'));
        }

        return {
            getGiftcard: getGiftcard,
            deduct: deduct
        };
    }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("countryService", countryService);

    /** @ngInject */
    function countryService($q, $log, $http, rollerBaseUrl) {
        var service = {};
        var _countries = null;
        var _timeZones = null;

        service.getCountries = function () {
            if (_countries === null) {
                return $http({
                    url: rollerBaseUrl.legacyApi + 'countries/',
                    method: 'GET'
                }).then(function (response) {
                    _countries = response.data;
                    return $q.when(response.data);
                }, function (error) {
                    return $log.error(error);
                });
            } else {
                return $q.when(_countries);
            }
        }

        service.getTimeZones = function () {
            var deferred = $q.defer();
            if (_timeZones === null) {
                $http({
                    url: rollerBaseUrl.legacyApi + 'bookings/timeZones/',
                    method: 'GET'
                }).then(function (response) {
                    _timeZones = response.data;

                    deferred.resolve(response.data);
                }, function (response) {
                    deferred.reject(response);
                });
            } else {
                deferred.resolve(_timeZones);
            }
            return deferred.promise;
        }

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .service("contentService", contentService);

    /** @ngInject */
    function contentService($translate) {
        var service = {};

        var _content = null;
        service.setContent = function (content) {
            _content = null;

            if (content) {
                _content = {};

                _.each(content, function (c) {
                    _content[c.type] = c.value;
                });
            }
        }

        service.content = function (type, ignoreDefault) {
            if (_content && (_content[type] || ignoreDefault)) {
                return _content[type];
            }

            var translateKey = _translateKeys[type];
            if (translateKey) {
                return $translate.instant(translateKey);
            }
            else {
                return _defaults[type] || '';
            }
        }

        var _defaults = {};
        _defaults['show_amex_logo'] = 'false';
        _defaults['membership_code'] = 'Your chosen tickets require a Membership ID';
        _defaults['waiver'] = 'Waiver';

        var _translateKeys = {};
        _translateKeys['discount_code'] = 'GENERIC.DISCOUNT_CODE';

        return service;
    }
})();

(function () {

    'use strict';
    
    angular.module('consumerSessions')
            .service('clipboardService', clipboardService);

    function clipboardService($q, $http) {
        var service = {};

        service.copy = function (text) {
            $('body').append('<span id="copyUrlToClipboardTemp">' + text + '</span>');

            selectElementContents($('#copyUrlToClipboardTemp')[0]);
            document.execCommand("Copy");

            $('span').remove('#copyUrlToClipboardTemp');
        }

        function selectElementContents(el) {
            var body = document.body, range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
            } else if (body.createTextRange) {
                range = body.createTextRange();
                range.moveToElementText(el);
                range.select();
            }
        }

        return service;
    };
}());
(function () {

    'use strict';

    angular.module('consumerSessions')
        .service('bookingService', bookingService);

    function bookingService($http, $q, rollerBaseUrl, formRendererService, ticketTimerService, productService) {

        var service = {
            createBookingForUser: createBookingForUser,
            getCostSettings: getCostSettings,
            getBookingObject: makeBookingObject,
            updateBookingPaymentOptions: updateBookingPaymentOptions,
            publishDraft: publishDraft
        };
        return service;

        function makeBookingObject(data, delivery) {
            var booking = { user: {}, orders: [] };

            booking.user.firstName = data.userDetails.firstName;
            booking.user.lastName = data.userDetails.lastName;
            booking.user.phone = data.userDetails.phone;
            booking.user.email = data.userDetails.email;
            booking.user.postCode = data.userDetails.postcode;
            booking.user.acceptMarketing = data.userDetails.acceptMarketing || false;
            booking.user.acceptMarketingSMS = data.userDetails.acceptMarketingSMS || false;

            booking.discounts = data.discounts;
            booking.costModifiers = data.bookingCostModifiers ? _.pluck(data.bookingCostModifiers, 'id') : null;
            booking.bookingTimerId = ticketTimerService.getUniqueTimerId();
            booking.payFullAmountIgnoringDeposit = data.payFullAmountIgnoringDeposit;
            booking.giftcards = data.giftcards;

            if (data.checkoutStartDateTime) {
                booking.timeTakenMilliseconds = performance.now() - data.checkoutStartDateTime;
            }

            var group = productService.consumerWidgetGroup();
            booking.consumerWidgetGroupId = group ? group.id : null;

            var uniqueFormIds = _.chain(data.bookings)
                .pluck('formIds')
                .flatten()
                .compact()
                .uniq()
                .value();

            //check for package form responses
            var packageFormIds = _.chain(data.bookings)
                .flatten()
                .pluck('packageItems')
                .flatten()
                .pluck('formIds')
                .flatten()
                .compact()
                .uniq()
                .value();

            uniqueFormIds = _.merge(uniqueFormIds, packageFormIds);

            if (uniqueFormIds) {
                booking.formResponses = [];

                _.each(uniqueFormIds, function (formId) {
                    booking.formResponses.push({
                        formId: formId,
                        json: JSON.stringify(formRendererService.response(formId))
                    });
                });
            }

            // payment type usually isn't handled at this point, but now that we're
            // supporting manual bank transfers we need to indicate that here
            booking.paymentTypeId = data.isBankTransfer ? 8 : 0;

            _.each(data.bookings, function (item) {
                if (_.isNumber(item.quantity) && item.quantity > 0) {
                    var order = {
                        quantity: item.quantity,
                        productId: item.productId,
                        bookingDate: moment(item.bookingDate, 'YYYY-MM-DD').formatEn('YYYYMMDD'),
                        additionalGuests: item.additionalGuests,
                        costModifiers: _.pluck(_.where(item.bookingCostModifiers, { appliesToBookingItem: true, isRequired: true }), 'id')
                    };

                    if (item.hasUserDefinedCost) {
                        order.product = {
                            cost: item.price
                        };
                    }

                    if (item.productTypeId == 'giftCard') {

                        var address = null;
                        var isBulkDelivery = false;
                        var deliveryName = null;
                        if (item.type == 'physical') {
                            if (item.details.differentDeliveryDetails && item.details.address) {
                                order.productPostageId = item.details.postage.productPostageId;
                                address = {
                                    address: item.details.address.address,
                                    suburb: item.details.address.suburb,
                                    state: item.details.address.state,
                                    postcode: item.details.address.postcode,
                                    country: item.details.address.country,
                                    city: item.details.address.city
                                };
                                deliveryName = item.details.name;
                            } else if (delivery && delivery.selectedPostage) {
                                order.productPostageId = delivery.selectedPostage.productPostageId;
                                address = {
                                    address: delivery.address,
                                    suburb: delivery.suburb,
                                    state: delivery.state,
                                    postcode: delivery.postcode,
                                    country: delivery.country,
                                    city: delivery.city
                                };
                                isBulkDelivery = true;
                                deliveryName = delivery.deliveryName;
                            }
                        }

                        order.ticketUserInfo = [{
                            firstName: item.details.name,
                            email: item.details.email,
                            message: item.details.message,
                            videoId: item.giftcardAcceptsVideo ? item.details.videoIdentifier : null,
                            sendDate: item.sendLater ? moment(item.details.sendDate, 'DD MMM YYYY').formatEn('YYYY-MM-DD') : null,
                            sendTime: item.sendLater ? item.details.sendTime : null,
                            sendTimeZone: item.sendLater ? item.details.timezone : null,
                            ticketUserAddress: address,
                            isBulkDelivery: isBulkDelivery,
                            deliveryName: deliveryName,
                            deliveryMode: address != null ? (item.isPickup() ? 2 /* Issue physical card */ : 3) /* Send physical card */ : 1 /* Send to receiver */
                        }];
                    }

                    if (item.sessionTime) {

                        order.sessionStart = item.sessionTime;
                        order.sessionEnd = productService.getMomentTime(item.sessionTime).add(item.selectedDuration, 'minutes').formatEn('HHmm');
                    }
                    booking.orders.push(order);
                }
            });

            return booking;
        }

        function createBookingForUser(data, delivery) {
            var booking = makeBookingObject(data, delivery);

            var deferred = $q.defer();

            $http({

                url: rollerBaseUrl.legacyApi + 'bookings/draft/create',
                method: 'POST',
                data: booking

            }).then(function (response) {

                deferred.resolve(response.data);

            }, function (response) {

                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getCostSettings() {

            var deferred = $q.defer();

            $http({

                url: rollerBaseUrl.legacyApi + 'costSettings',
                method: 'GET'

            }).then(function (response) {

                deferred.resolve(response.data);

            }, function (response) {

                deferred.reject(response);

            });

            return deferred.promise;
        }

        function updateBookingPaymentOptions(data, delivery) {
            var bookingData = makeBookingObject(data, delivery);

            return $http.post(rollerBaseUrl.legacyApi + 'bookings/payment-options/update', bookingData).then(_.property('data'));
        }

        function publishDraft(uniqueBookingId, isBankTransfer) {
            var data = { uniqueBookingId: uniqueBookingId };
            if (isBankTransfer) {
                data.paymentType = 8;
            }
            return $http.post(rollerBaseUrl.legacyApi + 'bookings/draft/publish', data).then(_.property('data'));
        }
    }
}());

(function() {
    "use strict";

    angular.module("consumerSessions")
        .service("analyticsService", analyticsService);

    function analyticsService($log, $analytics, $location, $window) {
        var service = {};

        service.pageTrack = function (stageLabel, venueName) {
            var absUrl = $location.absUrl();
            var path = $location.path();
            var pageTrackUrl = absUrl.substring(absUrl.indexOf(path));
            $log.debug(pageTrackUrl);
            $analytics.pageTrack(pageTrackUrl);
           
            service.eventTrack("Stage Event", "stage", stageLabel, venueName);
        }

        service.eventTrack = function (eventName, eventCategory, eventValue, venueName) {
            try {

                //override default behaviour to include customer datalayer variables
                //$analytics.eventTrack(eventName,
                //    {
                //        category: eventCategory.toString(),
                //        label: eventValue.toString(),
                //        value: parseInt(eventValue)
                //    });

                var properties = {
                    category: eventCategory.toString(),
                    label: eventValue.toString(),
                    value: parseInt(eventValue)
                };
 
                var dataLayer = window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': properties.event || 'interaction',
                    'target': properties.category,
                    'action': eventName,
                    'target-properties': properties.label,
                    'value': properties.value,
                    'interaction-type': properties.noninteraction,
                    'venueName': venueName,
                    'userId': $analytics.settings.ga.userId
                });

                $log.debug(eventName + ' ' + eventLabel.toString() + ' ' + eventValue.toString() + ' ' + venueName.toString());
            }
            catch (err) { $log.debug('eventTrack fail'); };
        }

        service.sendTransactionData = function (data) {
            try {
                var dataLayer = window.dataLayer = window.dataLayer || [];
                dataLayer.push(data);
                $log.debug('sendTransactionData');
            }
            catch (err) { };
        }

        service.successEvent = function (amount, venueName) {
            try {
                service.eventTrack("confirmation", "totalAmount", amount, venueName);

                //TODO: Find out whether this is now depreciated
                if (rollerWidget && rollerWidget.facebookTrackingEnabled) {

                    fbq('track', 'Purchase', {value: amount.toString(), currency: 'AUD', campaign: 'FFX006'});
                    //TODO: get Campaign
                    $log.debug(rollerWidget.facebookTrackingId);
                }
            }
            catch (err){ };
        }

        return service;
    }

})();

/*
Pass in a string with numeric placeholders and an array of values. String interpolation will 
be used to replace placeholders in the string based on position in the array. For example, 
pass in "the {0} sat on the {1}", with an array of ['cat','chair']. 
*/
(function () {
    "use strict";
    angular.module("consumerSessions")
        .filter("stringFormat", stringFormatFilter);

    function stringFormatFilter() {
            return function (formatString) {
                var parts = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    parts[_i - 1] = arguments[_i];
                }
                return formatString.format.apply(formatString, parts);
            };
    }
})();
(function () {
    "use strict";

    angular.module("consumerSessions")
        .filter("soldOut", soldOutFilter);

    /** @ngInject */
    function soldOutFilter($translate) {
        return function (actualValue) {
            if (actualValue <= 0) {
                return $translate.instant('GENERIC.SOLD_OUT');
            }
            return $translate.instant('GENERIC.LEFT', { value: actualValue });
        }
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .filter("rollerTranslate", rollerTranslateFilter);

    /** @ngInject */
    function rollerTranslateFilter($filter) {
        return function (value, args) {
            /*
                angular-translate renders &nbsp; as the literal string. Convert those back to the unique nbsp; after translation
                https://github.com/angular-translate/angular-translate/issues/506
            */
            var tf = $filter('translate');
            var translated = tf(value, args);
            var cleaned = translated.replace(/&nbsp;/g, '\u00A0');// \00A0 is unicode for nbsp;
            cleaned = cleaned.replace(/&hellip;/g, '\u2026');// \u2026 is unicode for u2026;u2026u2026u2026
            cleaned = cleaned.replace(/&lt;\/b&gt;/g, '</b>')
                .replace(/&lt;b&gt;/g, '<b>');
            return cleaned;
        }
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .filter("rollerCurrency", rollerCurrencyFilter);

    /** @ngInject */
    function rollerCurrencyFilter($filter, settingsService) {
        return function (value, symbol, fractionSize) {
            var currencyFilter = $filter('currency');
            var currencySymbol = settingsService.currencySymbol;
            var currencyFractionSize = settingsService.currencyFractionSize;

            if (angular.isDefined(symbol)) {
                currencySymbol = symbol;
            }

            if (angular.isDefined(fractionSize)) {
                currencyFractionSize = fractionSize;
            }

            return currencyFilter(value, currencySymbol, currencyFractionSize);
        };
    }

})();

(function() {
    "use strict";

    angular.module("consumerSessions")
        .filter("moment", momentFilter);

    /** @ngInject */
    function momentFilter() {
        return function(value, parseFormat, outputFormat) {
            if(_.isNull(value) || _.isUndefined(value)) {
                return value;
            }
            var parsed = moment(value, parseFormat);
            if(_.isString(outputFormat)){
                return parsed.format(outputFormat);
            }
            return parsed;
        }
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .filter("expiry", expiryFilter);

    /** @ngInject */
    function expiryFilter() {
        return function (value, format) {
            if (_.isNull(value) || _.isUndefined(value)) {
                return value;
            }
            var expiry = moment().add(value, 'days');
            if (_.isString(format)) {
                return expiry.format(format);
            }
            return expiry.format('DD MMM YYYY');
        }
    }

})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .filter("duration", durationFilter);

    /** @ngInject */
    function durationFilter($translate) {
        return function (value) {
            if (_.isNumber(value)) {
                return formatDuration(value);
            }
            return value;
        }

        function formatDuration(duration) {
            var hours = Math.floor(duration / 60),
                minutes = duration % 60,
                parts = [];

            if (hours >= 1) {
                parts.push(
                    $translate.instant('GENERIC.TIME.HOUR', { NUMBER: hours }, 'messageformat')
                );
            }
            if (minutes > 0) {
                parts.push(
                    $translate.instant('GENERIC.TIME.MINUTE', { NUMBER: minutes }, 'messageformat')
                );
            }
            return parts.join(", ");
        }
    }
})();
(function () {
    "use strict";

    angular.module('consumerSessions')
        .directive("rollerWidget", rollerWidget);

    /** @ngInject */
    function rollerWidget(storageService, $window, settingsService, insideIframe) {

        var linkFunction = function (scope, element, attributes) {

            for (var attr in attributes) {

                if (attr == 'rwApiKey') {

                    if (attributes[attr]) {
                        storageService.save(formatAttributeName(attr), attributes[attr]);

                        // if an API key is provided, the widget is being used externally
                        storageService.save('widget-used-externally', true);
                        settingsService.widgetAttributes['widget-used-externally'] = true;
                    }
                    else {
                        var slug = settingsService.venueSlug;
                        storageService.save(formatAttributeName(attr), slug);
                        settingsService.widgetAttributes[formatAttributeName(attr)] = slug;
                    }
                }
                else if (attr.indexOf('ng') == 0 || attr.indexOf('rw') == 0) {
                    storageService.save(formatAttributeName(attr), attributes[attr]);
                    settingsService.widgetAttributes[formatAttributeName(attr)] = attributes[attr];
                }
            }
        };

        // e.g. turn rwApiKey into rw-api-key
        function formatAttributeName(attr) {
            return attr.split(/(?=[A-Z])/).join('-').toLowerCase();
        }

        return {
            restrict: "E",
            template: '<div ui-view autoscroll="' + !insideIframe + '"></div>',
            link: linkFunction
        };
    }

})();

(function () {
    "use strict";

    angular.module('consumerSessions')
        .directive('orderSummary', orderSummaryDirective);

    /** @ngInject */
    function orderSummaryDirective(orderService, settingsService, wizardNavigationService, productTypes) {
        return {
            templateUrl: 'app/ng/directives/orderSummaryDirective.html',
            scope: {
                alwaysVisible: '@'
            },
            link: function (scope) {
                scope.order = orderService;
                scope.settings = settingsService;
                scope.hideCart = _.bind(orderService.hideCart, orderService);
                scope.$watch('order.tickets().items', groupTickets, true);
                scope.$watch('order.addOns().items', groupTickets, true);
                scope.$watch('order.bookingCostModifiers()', bookingCostModifiers, true);
                scope.$watch('order.delivery().selectedPostage', bookingCostModifiers, true);
                scope.$watch('order.delivery().selectedPostage', orderService.total, true);
                scope.bookingCostModifiers = [];
                scope.hasItemTax = false;
                scope.hideTaxLabels = scope.settings.hideTaxLabels;

                scope.canMoveNext = _.bind(wizardNavigationService.canMoveNext, wizardNavigationService);
                scope.nextButtonText = _.bind(wizardNavigationService.nextButtonText, wizardNavigationService);
                scope.isProductSelectionStep = _.bind(wizardNavigationService.isProductSelectionStep, wizardNavigationService);

                function groupTickets() {
                    var tickets = _.union(orderService.tickets().items, orderService.addOns().items);

                    _.each(tickets, function (ticket) {
                        if (ticket.recurringDateSummary) {
                            ticket.formattedBookingDate = ticket.recurringDateSummary;
                        } else {
                            ticket.formattedBookingDate = moment(ticket.bookingDate).format(moment.localeData().longDateFormat('ll'));
                        }
                    });

                    scope.groupedDates = _.sortBy(_.map(_.groupBy(tickets, 'formattedBookingDate'), function (items, formattedBookingDate) {
                        return {
                            formattedBookingDate: formattedBookingDate,
                            bookingDate: moment(_.first(items).bookingDate),
                            items: _.sortBy(_.map(_.groupBy(items, 'parentName'), function (items, parentName) {
                                var isAddOn = _.first(items).productTypeId === productTypes.addOn;

                                return {
                                    parentName: parentName,
                                    items: items,
                                    sortType: isAddOn ? 2 : 1
                                };
                            }), 'sortType')
                        };
                    }), 'bookingDate');

                    bookingCostModifiers();
                    requiredCostModifiers();
                    refreshItemTax();
                }

                function checkTaxExclusive(items, hasNoOverride) {
                    return _.some(items, function (item) {
                        return hasNoOverride ? (item.isTaxInclusive !== false && item.isTaxInclusive !== true) : item.isTaxInclusive === false;
                    });
                }

                function refreshItemTax() {
                    var hasExclusiveItems = checkTaxExclusive(orderService.tickets().items) || checkTaxExclusive(orderService.addOns().items);
                    var hasNoOverrideItems = checkTaxExclusive(orderService.tickets().items, true) || checkTaxExclusive(orderService.addOns().items, true);

                    scope.hasItemTax =
                        hasExclusiveItems
                        || (hasNoOverrideItems && !orderService.costSettings().productPricesIncludeTax);
                }

                function bookingCostModifiers() {
                    var result = angular.copy(orderService.bookingCostModifiers());
                    if (!result) {
                        result = [];
                    }

                    var postage = null;
                    _.each(orderService.tickets().items, function (item) {
                        if (item.details && item.type == 'physical' && item.details.differentDeliveryDetails && item.details.postage) {
                            if (postage) {
                                postage.amount += item.details.postage.price;
                            }
                            else {
                                postage = {
                                    name: 'Postage',
                                    isPercentage: false,
                                    amount: item.details.postage.price,
                                    isPostage: true
                                };
                            }
                        }
                    });

                    var giftcardsWithoutDiffDelivery = _.filter(_.where(orderService.tickets().items,
                        { productTypeId: 'giftCard', type: 'physical' }), noDifferentDelivery);

                    if (giftcardsWithoutDiffDelivery && giftcardsWithoutDiffDelivery.length > 0) {
                        var selectedPostage = orderService.delivery().selectedPostage;
                        if (selectedPostage && !selectedPostage.isPickup) {
                            if (postage) {
                                postage.amount += selectedPostage.price;
                            }
                            else {
                                postage = {
                                    name: 'Postage',
                                    isPercentage: false,
                                    amount: selectedPostage.price,
                                    isPostage: true
                                };
                            }
                        }
                    }

                    if (postage) {
                        result.push(postage);
                    }
                    scope.bookingCostModifiers = result;
                }

                function noDifferentDelivery(value) {
                    return !value.details.differentDeliveryDetails;
                }

                function requiredCostModifiers() {
                    var costModifiers = _.chain(orderService.getAllOrderItems())
                        .pluck("bookingCostModifiers")
                        .flatten()
                        .compact()
                        .where({ appliesToBookingItem: true, isRequired: true })
                        .uniq(false, function (e) { return e.id })
                        .cloneDeep()
                        .each(function (cm) { cm.cost = orderService.calculateTotalTicketModifierCost(cm) || 0; })
                        .value();

                    scope.requiredCostModifiers = _.chain(costModifiers)
                        .groupBy('modifierGroupName')
                        .mapValues(function (v, k) {
                            return {
                                name: k,
                                cost: _.sum(v, 'cost')
                            }
                        })
                        .values()
                        .sortByOrder('name')
                        .value();
                }

                scope.getBookingCostModifierName = function (bcm) {
                    if (bcm.isPercentage) {
                        // parseFloat will turn 7.50 into 7.5
                        return bcm.name + ' (' + parseFloat(bcm.amount) + '%)';
                    }
                    return bcm.name;
                }

                scope.hideCartAndMoveNext = function () {
                    scope.hideCart();
                    wizardNavigationService.moveNext();
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('consumerSessions')
           .directive('rollerMessage', message);

    var states = {
        'success': 'check',
        'warning': 'warning',
        'error': 'error_outline',
        'timer': 'access_time'
    };

    /** @ngInject */
    function message($translate) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                undo: '=',
                icon: '@'
            },
            template: '<div class="message" ng-class="messageClass">' +
                '<span class="material-icons" ng-bind-html="icon"></span>' +
                '<ng-transclude />' +
                '<div ng-if="allowClose"><i class="btm bt-times _cursor--pointer" ng-click="close()"></i></div>' +
                '<div ng-if="allowUndo"><a style="text-decoration:underline;color:white;cursor:pointer" ng-click="localUndo()">' + $translate.instant('GENERIC.UNDO') + '</a></div>' +
            '</div>',
            link: function(scope, element, attrs) {
                var type = attrs['type'];                
                if (!states[type]) {
                    type = 'warning';
                }                
                scope.allowClose = angular.isDefined(attrs['allowClose']) ? (attrs['allowClose'] == true) : true;
                scope.allowUndo = angular.isDefined(attrs['undo']) ? true : false
                scope.messageClass = 'message--' + type;
                scope.icon = states[type];

                scope.close = function () {
                    element.remove();
                }

                scope.localUndo = function () {
                    element.remove();
                    scope.undo();
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('consumerSessions')
        .directive('materialIcons', materialIcons);
    
    /* @ngInject */
    function materialIcons() {
        var mappings = {
            access_time: '&#xE192;',
            arrow_back: '&#xE5C4;',
            arrow_drop_down: '&#xE5C5;',
            check: '&#xE5CA;',
            check_circle: '&#xE86C;',
            date_range: '&#xE916;',
            delete: '&#xE872;',
            error: '&#xE000;',
            error_outline: '&#xE001;',
            info_outline: '&#xE88F;',
            keyboard_arrow_down: '&#xE313;',
            keyboard_arrow_left: '&#xE314;',
            keyboard_arrow_right: '&#xE315;',
            local_offer: '&#xE54E;',
            search: '&#xE8B6;',
            shopping_cart: '&#xE8CC;'
        };

        return {
            link: link,
            restrict: 'C',
            transclude: true
        };        

        function link(scope, element, attrs, ctrl, transclude) {
            transclude(scope, function(clone) {
                var name = clone.text();
                element.html(mappings[name] || name);
            });
        }
    }
})();
(function() {
    "use strict";

    angular.module('consumerSessions')
        .directive('filterInput', filterInputDirective);

        /** @ngInject */
        function filterInputDirective($log) {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    pattern: '@filterInput'  
                },
                link: function(scope, element, attrs, ctrl) {
                    var regExp;
                    
                    scope.$watch('pattern', function(value) {
                        if(_.isUndefined(value) || _.isNull(value)) {
                            regExp = void(0);
                            return;
                        }
                        if(_.isObject(value) && _.isFunction(value.test)) {
                            regExp = value;
                        } else if(_.isString(value)) {
                            try {
                                regExp = new RegExp('^' + value + '$');
                            } catch(e) {
                                $log.warn(e);
                            }
                        }
                    });
                    ctrl.$parsers.unshift(function(value) {
                        if(!regExp || ctrl.$isEmpty(value)) { 
                            return value;
                        }
                        var cleanedValue = _.filter(value, _.bind(regExp.test, regExp)).join('');
                        if(cleanedValue !== value) {
                            ctrl.$setViewValue(cleanedValue);
                            ctrl.$render();
                        }
                        return cleanedValue;
                    });
                }
            }
        }
})();

(function () {
    "use strict";

    angular.module('consumerSessions')
        .directive('emptyIfZero', emptyIfZeroDirective);

    function emptyIfZeroDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                ctrl.$formatters.push(function (val) {

                    if (!ctrl.$modelValue && $(element).is(':focus')) {
                        return '';
                    }
                    return val;
                });

                var focusHandler = function () {

                    if (!ctrl.$modelValue) {
                        ctrl.$setViewValue('');
                        ctrl.$render();
                    }
                };

                var blurHandler = function () {

                    if (!ctrl.$modelValue) {
                        ctrl.$setViewValue('0');
                        ctrl.$render();
                    }
                };

                $(element).on('focus', focusHandler);
                $(element).on('blur', blurHandler);

                scope.$on('$destroy', function () {
                    $(element).off('focus', focusHandler);
                    $(element).off('blur', blurHandler);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .directive('elementReady', elementReady);

    /** @ngInject */
    function elementReady($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.ready(function () {
                    var func = $parse(attrs.elementReady);

                    $timeout(function () {
                        func(scope);
                    });
                });
            }
        };
    }
})();

(function() {
    "use strict";

    angular.module('consumerSessions')
        .directive('cartIcon', cartIconDirective);

        /** @ngInject */
        function cartIconDirective($rootScope, orderService) {
            return {
                replace: true,
                scope: {},
                templateUrl: 'app/ng/directives/cartIconDirective.html',
                link: function(scope) {
                    scope.itemCount = _.bind(orderService.itemCount, orderService);
                    scope.showCart = _.bind(orderService.showCart, orderService);
                }
            }
        }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .directive("broadcastHeight", broadcastHeight);

    /** @ngInject */
    function broadcastHeight(postMessage, insideIframe, $log, $timeout, $window) {
        return {
            restrict: "A",
            link: function (scope, element) {

                if (!insideIframe) {
                    return;
                }

                var previousHeight,
                    getHeight = angular.isFunction(element.height) ? getJQueryHeight : getOffsetHeight;

                update();

                function update() {
                    var height = getHeight(),
                        data;

                    if (height !== previousHeight) {
                        previousHeight = height;
                        data = {
                            action: "resize",
                            height: height,
                            originId: $window.originId
                        };
                        postMessage("parent", data, "*");
                    }
                    // Using $timeout instead of scope.$watch
                    // because scope.$watch wasn't reliable
                    $timeout(update, 50);
                }

                function getJQueryHeight() {
                    var height = element.height();
                    return height == 0 ? element.children().first().height() : height;
                }

                function getOffsetHeight() {                    
                    return element[0].offsetHeight || 0;
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .controller('WizardController', WizardController);

    /** @ngInject */
    function WizardController($state, orderService, settingsService, insideIframe, productService, productPromotionService, wizardNavigationService, contentService) {
        // WARNING - Navigation logics has been moved to wizardNavigationService.
        // Consider moving the continue actions into the forms, and do validation properly.
        var vm = this;

        vm.$state = $state;
        vm.widgetUsedExternally = settingsService.widgetUsedExternally();
        vm.showImage = settingsService.showHeader();
        vm.headerImage = settingsService.headerImage ? settingsService.headerImage : '';
        vm.policyUrl = settingsService.policyUrl ? settingsService.policyUrl : '';
        vm.withdrawUrl = settingsService.withdrawUrl ? settingsService.withdrawUrl : '';
        vm.insideIframe = insideIframe;
        vm.settings = settingsService;

        var businessWebsite = settingsService.businessWebsite();
        if (businessWebsite) {
            vm.businessWebsiteUrl = /^https?:\/\//.test(businessWebsite) ? businessWebsite : 'http://' + businessWebsite;
            vm.businessWebsite = vm.businessWebsiteUrl.replace(/^https?:\/\/(www\.)?|\/.*$/g, '');
        }

        if (insideIframe) {
            angular.element('body').css('background-color', 'transparent');
        }
        else if (settingsService.backgroundImage) {
            angular.element('.background').css('background-image', 'url(\'' + settingsService.backgroundImage + '\')');
        }

        vm.navigableStates = _.bind(wizardNavigationService.navigableStates, wizardNavigationService);

        vm.isComplete = _.bind(wizardNavigationService.isComplete, wizardNavigationService);

        vm.isActive = _.bind(wizardNavigationService.isActive, wizardNavigationService);

        vm.activeState = _.bind(wizardNavigationService.activeState, wizardNavigationService);

        vm.getCartState = _.bind(wizardNavigationService.getCartState, wizardNavigationService);

        vm.toggleCart = _.bind(wizardNavigationService.toggleCart, wizardNavigationService);

        vm.showNavigation = _.bind(wizardNavigationService.showNavigation, wizardNavigationService);

        vm.activeStateTranslationKey = _.bind(wizardNavigationService.activeStateTranslationKey, wizardNavigationService);

        vm.next = _.bind(wizardNavigationService.next, wizardNavigationService);

        vm.nextButtonText = _.bind(wizardNavigationService.nextButtonText, wizardNavigationService);

        vm.previous = _.bind(wizardNavigationService.previous, wizardNavigationService);

        vm.canGoTo = _.bind(wizardNavigationService.canGoTo, wizardNavigationService);

        vm.isCartVisible = _.bind(wizardNavigationService.isCartVisible, wizardNavigationService);

        vm.go = _.bind(wizardNavigationService.go, wizardNavigationService);

        vm.moveNext = _.bind(wizardNavigationService.moveNext, wizardNavigationService);

        vm.canMoveNext = _.bind(wizardNavigationService.canMoveNext, wizardNavigationService);

        vm.movePrevious = _.bind(wizardNavigationService.movePrevious, wizardNavigationService);

        vm.hideNextButton = _.bind(wizardNavigationService.hideNextButton, wizardNavigationService);

        vm.content = contentService.content;

        vm.isCartAlwaysVisible = function () {
            return $state.is('sessions.payment') && contentService.content('always_show_cart_for_payment_on_mobile');
        }

        orderService.loadCostSettings();

        vm.timeout = function (forced) {

            if (forced) {
                alert('You just missed out, try again in case another customer cancels their booking.');
            }
            orderService.resetOrder();
        }

        var _bookingTimerDetailsSet = false;
        vm.useTicketTimer = function () {

            if (settingsService.canUseBookingTimer && !orderService.isProcessed() && productService.productsAreLoaded()) {

                if (vm.$state.$current.name == 'sessions.details' || vm.$state.$current.name == 'sessions.payment' || vm.$state.$current.name == 'sessions.success') {

                    if (!_bookingTimerDetailsSet) {
                        // we set the details here because at this point the products are loaded
                        // which means the booking timer settings are loaded too
                        vm.timerSeconds = settingsService.bookingTimer().timerInSeconds;
                        vm.timeExtensionResponseInSeconds = settingsService.bookingTimer().timerExtensionConfirmationInSeconds;
                        vm.allowTimeExtension = vm.timeExtensionResponseInSeconds ? true : false;

                        _bookingTimerDetailsSet = true;
                    }
                    return true;
                }
            }
            return false;
        }

        vm.order = orderService;

        vm.showPromotionBanner = function () {
            return productPromotionService.isOnPromotion();
        }

        vm.promotion = function () {
            return productPromotionService;
        }

        vm.isPaymentInProgress = function () {
            return $state.is('sessions.success');
        }

        window.recaptchaCallback = function (recaptcha) {
            orderService.validateRecaptcha(recaptcha).then(function () {
                wizardNavigationService.processMove(vm.next());
            }, function () {
                vm.timeout(true);
            });
        }

        vm.setProgressPercent = function () {
            document.documentElement.style.setProperty('--progressPercent', $state.$current.data.progress + '%');
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("ViewGiftcardController", ViewGiftcardController);

    /** @ngInject */
    function ViewGiftcardController($stateParams, $window, giftcardService, settingsService, modalService) {
        var vm = this;
        vm.settings = settingsService;
        vm.redeemGiftcard = redeemGiftcard;
        vm.isLoading = true;

        initialise();

        function initialise() {
            if (!$stateParams.uniqueBookingId || !$stateParams.giftcardNumber) {
                return;
            }

            vm.giftcardNumber = $stateParams.giftcardNumber;

            giftcardService.getGiftcard($stateParams.uniqueBookingId, $stateParams.giftcardNumber).then(function (giftcard) {
                vm.giftcard = giftcard;
                vm.giftcard.uniqueBookingId = $stateParams.uniqueBookingId;
                vm.giftcard.giftcardNumber = $stateParams.giftcardNumber;
                vm.giftcard.print = function () {
                    $window.print();
                };
                vm.isLoading = false;
            });
        }

        function redeemGiftcard() {
            modalService.redeemGiftcard(vm.giftcard).closePromise.then(function (result) {
                vm.isLoading = true;
                initialise();
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("SuccessController", SuccessController);

    /** @ngInject */
    function SuccessController(orderService, rollerBaseUrl, storageService, productService, $state, contentService, settingsService, $scope, $rootScope, $translate, analyticsService, modalService, rollerCurrencyFilter, clipboardService, $log) {
        var hotmailReg = new RegExp("@hotmail|@live|@outlook");
        var vm = this;

        if (orderService.isProcessed() || !orderService.itemCount()) {
            $state.go('sessions.home');
        }

        vm.content = contentService.content;

        vm.isHotmail = function () {
            var email = vm.orderService.details().email;
            return hotmailReg.test(email);
        };

        vm.paymentSetting = $rootScope.paymentSetting;
        vm.isHpp = vm.paymentSetting.paymentPortalType === 'Adyen' && vm.paymentSetting.overrideUI &&
            !vm.paymentSetting.isDropIn && !orderService.noFurtherPaymentRequired();

        vm.orderService = orderService;
        vm.waiver = orderService.getWaiver();
        vm.canUseWaivers = settingsService.canUseWaivers;
        vm.paymentAlreadyProcessed = false;
        vm.openDropdown = false;
        vm.copyToClipboard = clipboardService.copy;
        vm.showBriefConfirmation = orderService.showBriefOrderConfirmation();

        $scope.$on('loader-available', function () {
            if (!orderService.isProcessed() && orderService.itemCount() > 0) {
                // there was a consistent flow of bad requests hitting the API with no booking items,
                // so if the user somehow ends up here without items, send them home
                if (orderService.mustCheckIfProcessed() && vm.isHpp && orderService.getPaymentAttempts() > 0) {
                    analyticsService.eventTrack('hosted-payment-page', 'hpp_loaded', orderService.getPaymentAttempts(), settingsService.venueName);

                    orderService.paymentAlreadyProcessed()
                        .then(function (result) {
                            if (result.isProcessed) {
                                vm.paymentAlreadyProcessed = true;
                                orderService.markBookingAsCompleted(result.receiptNumber);
                            }
                        })
                        .finally(function () {
                            if (vm.paymentAlreadyProcessed) {
                                return;
                            }

                            modalService.confirm($translate.instant('PAYMENT.POPUP_LOADED_AGAIN'), null, 'GENERIC.CONTINUE').then(function () {
                                orderService.processOrder();
                            }, function () {
                                $state.go('sessions.payment');
                            });
                        });
                }
                else {
                    orderService.processOrder();
                }
            }
        });

        vm.waiverUrl = function () {
            if (!vm.waiver) {
                return null;
            }
            var ubid = orderService.getShrunkenBookingUniqueId();
            if (ubid) {
                return vm.waiver.url + '?ubid=' + ubid;
            }
            return vm.waiver.url;
        }

        // https://css-tricks.com/how-to-use-the-web-share-api
        vm.shareWaiverUrl = function () {
            var shareData = {
                text: getSharingText('SESSIONS.SUCCESS.WAIVER.SHARE_API_TEXT', true),
                url: vm.waiverUrl()
            }
            if (navigator.share) {
                navigator.share(shareData)
                    .catch($log.error);
            } else {
                vm.openDropdown = !vm.openDropdown;
            }
        }

        vm.getMailtoDetails = function () {
            var emailSubject = getSharingText('SESSIONS.SUCCESS.WAIVER.SHARE_EMAIL_SUBJECT');
            var emailBody = getSharingText('SESSIONS.SUCCESS.WAIVER.SHARE_EMAIL_BODY');
            var mailto = '?subject=' + emailSubject + '&body=' + emailBody;

            return mailto;
        }

        vm.formWidgetUrl = function () {

            var venueSlug = storageService.load('rw-api-key');
            var groupOne = productService.consumerWidgetGroup();

            if (groupOne && groupOne.completeFormLater) {
                var formId = orderService.additionalDetailsFormId();
                var uniqueBookingId = vm.orderService.getShrunkenBookingUniqueId();

                if (formId && uniqueBookingId) {
                    return rollerBaseUrl.forms + '#/' + venueSlug + '/' + formId + '/' + uniqueBookingId;
                }
            }
            return null;
        }

        vm.getPayLaterInstructions = function () {
            if (!orderService.bankTransferDetails().instructions) {
                return '';
            }

            return orderService.bankTransferDetails().instructions
                .replace(/\[PayLaterAmount\]/g, rollerCurrencyFilter(orderService.total()))
                .replace(/\[ReceiptNumber\]/g, vm.orderService.getReceiptNumber());
        }

        function getShareData() {
            var firstBookingDate = _.chain(orderService.tickets().items)
                .sortBy(function (t) { return moment(t.bookingDate); })
                .first()
                .value();
            var data = {
                venueName: settingsService.venueName,
                waiverUrl: vm.waiverUrl(),
                bookingDate: moment(firstBookingDate).format(moment.localeData().longDateFormat('ll')),
                firstName: orderService.details().firstName
            };

            return data;
        }

        function getSharingText(key, isNativeShare) {
            return $translate.instant(key, getShareData()).replace(/\<br\s*\/\>/ig, isNativeShare ? '' : '%0D%0A');
        }

        function getFacebookShare() {
            var linkText = trim(vm.content('success_page_facebook_share_text'));
            var linkUrl = trim(vm.content('success_page_facebook_share_url'));

            if (linkText && linkUrl) {
                return {
                    linkText: linkText,
                    linkUrl: linkUrl
                };
            }

            return null;
        }

        vm.resetOrder = function () {
            try {
                orderService.resetOrder();                
            } catch (error) {
                $log.error(error);
            }
        }

        /**
         * Remove all the whitespace characters (space, tab, no-break space, etc.) from both ends of the input text
         */
        function trim(text) {
            if (_.isString(text)) {
                if (_.isFunction(text.trim)) {
                    return text.trim();
                }

                return text.replace(/^\s+|\s+$/gm, '');
            }

            return text;
        }

        function init() {
            vm.facebookShare = getFacebookShare();
        }

        init();
    }

})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("PaymentController", PaymentController);

    /** @ngInject */
    function PaymentController(orderService, $stateParams, settingsService, $log, $timeout, analyticsService, contentService, productPromotionService, countryService, $rootScope, $scope, $translate, rollerTranslateFilter, modalService, rollerCurrencyFilter) {
        var vm = this,
            year = moment().year();
        vm.payment = orderService.payment();
        vm.months = _.map(_.range(1, 13), function (month) {
            return {
                name: ("0" + month).match(/\d{2}$/)[0],
                value: month
            };
        });
        vm.years = _.range(year, year + 11);
        vm.payFullAmount = orderService.getDepositPayFullOverride();
        vm.content = contentService.content;
        vm.orderService = orderService;
        vm.paypalLoading = false;

        vm.countries = [];
        vm.onlyAcceptMX = productPromotionService.isMXPromotion();
        vm.isMXCardPreferred = productPromotionService.isOnPromotion() && !productPromotionService.isOnBankPromotion();
        vm.promotion = productPromotionService;
        vm.paymentSetting = $rootScope.paymentSetting;
        vm.isCartAlwaysVisible = contentService.content('always_show_cart_for_payment_on_mobile');
        vm.hasRecurringPayment = false;
        vm.recurringPaymentDetails = [];
        vm.paymentNote = rollerTranslateFilter('SESSIONS.PAYMENT.NOTICE', { paymentText: $translate.instant(orderService.getPaymentText()) });
        vm.isPopup = false;
        vm.hasCreditCardOption = hasCreditCardOption;
        vm.termsAndConditions = _.bind(modalService.showPaymentTermsAndConditions, modalService);
        vm.privacyStatement = _.bind(modalService.showPrivacyPolicy, modalService);
        vm.isReady = false;
        vm.payLaterName = orderService.getPayLaterName();
        vm.updatingPaymentMethod = false;
        vm.requiresTermsToBeAccepted = settingsService.requiresTermsToBeAccepted;
        vm.getMinPeriodString = getMinPeriodString;
        vm.isShowingPaymentQRCode = false;
        vm.qrCodeStatusCheckTimer = undefined;
        vm.languageCode = settingsService.languageCode;
        vm.isRtl = settingsService.isRtl();

        orderService.resetPaypal();

        processRecurringPaymentTickets();
        initSubPaymentType();

        if (!vm.paymentSetting) {
            $scope.$on('paymentLoaded', function () {
                vm.paymentSetting = $rootScope.paymentSetting;
                loadPaymentRelatedInfo();
                initSubPaymentType();
            });
        } else {
            loadPaymentRelatedInfo();
        }

        vm.hackClick = function (id) {
            // Adyen is not aware of bank transfer method so if they click i.e. CC payment then Bank transfer
            // and change mind to click on CC again, Adyen drop-in sees the method unchanged hence not fire the external method event
            // We can't use ng-click on the div itself as the ng-touch will cause issues in mobile
            // Guard: paymentSetting may be undefined if payment component failed to load (e.g. 425)
            if (vm.paymentSetting && vm.paymentSetting.isDropIn) {
                var el = document.getElementById(id);

                if (el) {
                    $(el).click(function () {
                        $timeout(function () {
                            vm.setPaymentMethod('creditcard', true);
                        });
                    });
                }
            }
        }

        $scope.$on('cart-item-removed', function () {
            processRecurringPaymentTickets();
        });


        function loadPaymentRelatedInfo() {
            vm.isPopup = !vm.paymentSetting.isDropIn && (vm.paymentSetting.isPopup || (vm.paymentSetting.paymentPortalType === 'Adyen' && vm.paymentSetting.overrideUI));
            vm.isPayUArgentina = vm.paymentSetting.isPayUArgentina;
            vm.documentTypes = vm.paymentSetting.idTypes;
            vm.states = vm.paymentSetting.states;

            if (vm.paymentSetting.paymentPortalType === "Payfort" && _.any(vm.paymentSetting.subPaymentTypes)) {
                vm.sortedSubPaymentTypes = getSortedSubPaymentTypes();
            }

            loadCountries();
            loadPaymentFrame();

            if (!vm.paymentSetting.isDropIn) {
                vm.isReady = true;
            }

            if (settingsService.isPlayground) {

                vm.payment.cardName = 'Playground Test';
                vm.payment.cardNumber = '4111111111111111';

                if (vm.paymentSetting.paymentPortalType === 'Adyen') {
                    vm.payment.cardCVV = '737';
                    vm.payment.cardExpiryMonth = 3;
                    vm.payment.cardExpiryYear = 2030;
                }
                else {
                    vm.payment.cardCVV = '111';
                    vm.payment.cardExpiryMonth = 12;
                    vm.payment.cardExpiryYear = moment().year() + 1;
                }
            }
        }

        function hasCreditCardOption() {
            if (vm.paymentSetting) {
                if (vm.paymentSetting.paymentPortalType === "Payfort" && _.any(vm.paymentSetting.subPaymentTypes) || vm.paymentSetting.isDropIn) {
                    return false;
                }

                return true;
            }

            return false;
        }

        function getSortedSubPaymentTypes() {
            if (!vm.paymentSetting || !vm.paymentSetting.subPaymentTypes || !_.any(vm.paymentSetting.subPaymentTypes)) {
                return [];
            }
            var types = vm.paymentSetting.subPaymentTypes.slice();
            var madaIndex = _.findIndex(types, function (t) { return (t || '').toLowerCase() === 'mada'; });
            if (madaIndex === -1) {
                return types;
            }
            var madaValue = types[madaIndex];
            // Static order: MADA first so it stays in the first row when wrapping. RTL/LTR presentation is handled by CSS (direction: rtl) so MADA appears top-right for Arabic, top-left for LTR.
            types.splice(madaIndex, 1);
            types.unshift(madaValue);
            return types;
        }

        function initSubPaymentType() {
            if (vm.paymentSetting && vm.paymentSetting.paymentPortalType === "Payfort" && _.any(vm.paymentSetting.subPaymentTypes)) {
                vm.sortedSubPaymentTypes = getSortedSubPaymentTypes();
                if (!vm.payment.subPaymentMethod && vm.sortedSubPaymentTypes.length) {
                    vm.payment.paymentMethod = 'others';
                    var madaInList = _.find(vm.sortedSubPaymentTypes, function (t) { return (t || '').toLowerCase() === 'mada'; });
                    vm.payment.subPaymentMethod = madaInList || vm.sortedSubPaymentTypes[0];
                }
            }
        }

        function loadCountries() {
            if (vm.paymentSetting && vm.paymentSetting.isAVSEnabled === true) {
                countryService.getCountries().then(function (response) {
                    $timeout(function () {
                        vm.countries = response;
                    });
                }, function (error) {
                    vm.paymentErrors = [];
                    vm.paymentErrors.push(error);
                    $log.error(error);
                });
            }
        }

        function onPaymentMethodSelectExternal() {
            vm.isShowingPaymentQRCode = false;
            cancelQRPaymentstatusTimer();

            $timeout(function () {
                vm.setPaymentMethod('creditcard', true);
            });
        }

        function loadPaymentFrame() {
            if (vm.paymentSetting.hasPaymentFrame || vm.paymentSetting.isDropIn || vm.paymentSetting.paymentPortalType === 'SagePay') {
                $timeout(function () {
                    orderService.initialisePayment(vm.paymentSetting, '#payment-container', function () {
                        vm.isReady = true;
                    }, onPaymentMethodSelectExternal, onError, onBeforeSubmittingDropInPayment, onDisplayPaymentQRCode);
                });
            }
        }

        function onError(errors) {
            vm.paymentErrors = errors;
        }

        function onBeforeSubmittingDropInPayment() {
            vm.isShowingPaymentQRCode = false;
            vm.paymentErrors = [];
            cancelQRPaymentstatusTimer();
        }

        function cancelQRPaymentstatusTimer(){

            if (vm.qrCodeStatusCheckTimer) {
                clearInterval(vm.qrCodeStatusCheckTimer);
                vm.qrCodeStatusCheckTimer = undefined;
            }
        }

        function onDisplayPaymentQRCode() {
            vm.isShowingPaymentQRCode = true;
            vm.qrCodeStatusCheckTimer = setInterval(checkQRPaymentStatus, moment.duration(2, 'minutes').asMilliseconds());
        }

        // Find the tickets with recurring payments
        function filterRecurringTickets(tickets) {
            return _.filter(tickets, function (item) {
                return !!item.recurringPayment;
            });
        }

        // Group all tickets that match on frequency and number of payments
        function groupRecurringTickets(recurringTickets) {
            return _.reduce(recurringTickets, function (result, value, key) {
                var derivedKey = (!!value.recurringPayment.paymentFrequencyId && !!value.recurringPayment.numberOfPayments)
                    ? value.recurringPayment.paymentFrequencyId + '-' + value.recurringPayment.numberOfPayments
                    : value.recurringPayment.paymentFrequencyId + '-ongoing';

                (result[derivedKey] || (result[derivedKey] = [])).push({
                    price: value.price,
                    quantity: value.quantity,
                    numberOfPayments: value.recurringPayment.numberOfPayments,
                    frequency: value.recurringPayment.paymentFrequencyId,
                    minNumberOfPayments: value.recurringPayment.minNumberOfPayments,
                    productName: value.parentName,
                    ticketName: value.name
                });

                return result;
            }, {});
        }

        // Sum the price of matching grouped tickets
        function sumGroupedTicketPrice(groupedTickets) {
            return _.map(groupedTickets, function (item) {
                if (item.length == 1) {
                    var result = item[0];
                    result.price = (result.price * result.quantity);
                    return result;
                }
                else {
                    return _.reduce(item, function (result, value, key) {
                        result.price += (value.price * value.quantity);
                        result.numberOfPayments = result.numberOfPayments || value.numberOfPayments;
                        result.minNumberOfPayments = result.minNumberOfPayments || value.minNumberOfPayments;
                        result.frequency = result.frequency || value.frequency;
                        return result;
                    }, { price: 0 });
                }
            });
        }

        function processRecurringPaymentTickets() {
            var filteredTickets = filterRecurringTickets(orderService.tickets().items);

            if (!!filteredTickets) {
                var groupedTickets = groupRecurringTickets(filteredTickets);
                vm.recurringPaymentDetails = sumGroupedTicketPrice(groupedTickets);
                vm.hasRecurringPayment = vm.recurringPaymentDetails != null && vm.recurringPaymentDetails.length > 0;
            }
            else {
                vm.hasRecurringPayment = false;
                vm.recurringPaymentDetails = [];
            }
        }

        function loadPaypal() {
            if (vm.paymentSetting) {
                orderService.initialisePayPal(vm.paymentSetting, '#paypal-container');
            }
        }

        vm.setPaymentMethod = function (method, ignoreDraftBookingUpdate) {
            if (method == 'creditcard') {
                vm.payment.paymentMethod = 'creditcard';
            }
            else if (method == 'paypal') {
                vm.payment.paymentMethod = 'paypal';
                loadPaypal();
            }
            else if (method == 'banktransfer') {
                vm.payment.paymentMethod = 'banktransfer';
            }

            vm.payment.subPaymentMethod = void (0);

            if (!ignoreDraftBookingUpdate) {
                vm.updatingPaymentMethod = true;

                orderService.updateDraftBookingPaymentOptions().finally(function () {
                    vm.updatingPaymentMethod = false;
                });
            }
        }

        vm.allowBookingDeposit = function () {
            return orderService.hasDepositItems() && settingsService.depositPayFullAmount && !vm.orderService.isFree();
        }

        vm.showPaymentDetails = function () {
            var ignorePayLater = true;
            return (!orderService.noFurtherPaymentRequired(ignorePayLater) && !settingsService.discountCodeOnlyFlow()) || vm.orderService.hasRecurring();
        }

        vm.paymentErrors = $stateParams.paymentErrors;

        vm.getAcceptedCardType = function () {
            if (vm.onlyAcceptMX) {
                return "American Express";
            }

            return null;
        }

        vm.getCardTypeValidationMsg = function () {
            if (productPromotionService.isMXPromotion()) {
                return "You must have a valid American Express Card to be eligible for the discounted tickets";
            }

            return vm.getAcceptedCardType() ? ("Please enter a valid " + vm.getAcceptedCardType() + " card.") : "";
        }

        vm.depositOptionChanged = function (payFullAmount) {
            var originalPayFullOption = orderService.getDepositPayFullOverride();
            orderService.setDepositPayFullOverride(payFullAmount);

            if (vm.payment.paymentMethod !== 'banktransfer') {
                orderService.updateDraftBookingPaymentOptions().catch(function () {
                    vm.payFullAmount = originalPayFullOption;
                    orderService.setDepositPayFullOverride(originalPayFullOption);
                }).finally(function() {
                    if (vm.paymentSetting.isDropIn) {
                        loadPaymentFrame();
                    }
                });
            }
        }

        vm.venueCountryFirst = function (country) {
            return country.countryCode === settingsService.venueCountryCode ? -1 : 1;
        }

        function getMinPeriodString() {
            var periods = _.flatten(_.map(vm.recurringPaymentMinimumPeriods, function (item) {
                var sentence = [
                    item.minNumberOfPayments,
                    rollerTranslateFilter('SESSIONS.RECURRING_BILLING.FREQUENCY.PLURAL.' + item.frequency.toUpperCase()),
                    'for ' + item.productName + ' - ' + item.ticketName
                ].join(' ');
                return '<b>' + sentence + '</b>';
            })).join(' and ');
            return rollerTranslateFilter('SESSIONS.PAYMENT.RECURRING_MINIMUM_OBLIGATION_MULTIPLE', { minPaymentProduct: periods });
        }
        vm.getTranslatedRecurringPaymentText = function (baseString, args) {
            return rollerTranslateFilter(baseString, {
                paymentMethod: args.paymentMethod,
                amount: rollerCurrencyFilter(args.amount),
                frequency: $translate.instant('SESSIONS.RECURRING_BILLING.FREQUENCY.SINGULAR.' + args.frequency.toUpperCase()),
                numberOfPayments: args.numberOfPayments,
                period: args.showPeriod ? $translate.instant('SESSIONS.RECURRING_BILLING.FREQUENCY.PLURAL.' + args.frequency.toUpperCase()) : undefined
            });
        }

        analyticsService.pageTrack('payment', settingsService.venueName);
    }
})();

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController(productService, orderService, $state, settingsService, $stateParams, analyticsService, productPromotionService, durationFilter, $scope, contentService, $rootScope, countryService, wizardNavigationService, productTypes) {
        var vm = this;
        vm.order = orderService;
        vm.settings = settingsService;
        vm.content = contentService.content;
        vm.useSessionTiles = true;
        vm.showRemainingCapacity = false;
        vm.datePickerConfig = {
            minDate: moment.utc()
        };
        vm.nextButtonText = _.bind(wizardNavigationService.nextButtonText, wizardNavigationService);
        vm.moveNext = _.bind(wizardNavigationService.moveNext, wizardNavigationService);

        $scope.$on('ticket-quantity-changed', ticketQuantityChanged);
        $scope.$on('reset-products', loadProducts);
        $scope.$on('paymentLoaded', loadCountries);
        $scope.$on('cart-item-removed', cartItemRemoved);

        // reset capturePostcode in case a form was downloaded which contains the postcode data binding
        settingsService.capturePostcode(null);

        // currently consumer widget groups can have one linked group
        // i.e. allows for an optional second ticket page showing different products
        var isGroupTwo = $stateParams.isGroupTwo;
        var expandAccordions = false;
        var venueTime = settingsService.momentVenueTime();
        var activeTicket = undefined;
        var focusTicket = undefined;

        orderService.clearDiscount();

        vm.showDateLedCalendar = function () {
            return settingsService.isDateLed && !orderService.hasDateSelected();
        }

        vm.canShowCalendar = function () {
            return window.settings && window.settings.canShowCalendar;
        }

        if (!vm.showDateLedCalendar()) {
            loadProducts();
        }

        vm.showLimitedSpotsKey = function (product) {
            return vm.useSessionTiles && _.some(product.sessions, function (session) { return vm.hasLimitedAvailability(session); });
        }

        vm.findNextAvailable = function () {
            var groupName = null;
            var group = vm.group();
            if (group && group.slug) {
                groupName = group.slug;
            }
            var date = moment(vm.date);
            var startDateIndex = parseInt(date.locale('en').format('YYYYMMDD'));
            vm.loading = true;
            vm.error = '';
            productService.getNextAvailableDateIndex(groupName, startDateIndex).then(function (data) {
                if (data > 0) {
                    loadProducts(moment(data, 'YYYYMMDD'));
                } else {
                    vm.error = 'Unable to find next available products.';
                }
            }, function () {
                vm.error = 'An error has occurred.  Please try again';
            }).finally(function () {
                vm.loading = false;
            });
        }

        vm.getProducts = function (date) {
            loadProducts(date);
        };

        vm.selectSession = function (product, session) {
            session.isSelected = !session.isSelected;
        }

        vm.canIncrease = function (item, products) {
            var ticket = orderService.getItemWithQuantityDiff(item);

            return vm.order.canAdd(ticket, products);
        }

        vm.canDecrease = function (ticket) {
            return vm.order.canDecrease(ticket);
        }

        vm.increase = function (ticket, product) {
            vm.quantityAddedToCart = 0;

            if ((ticket.quantity * ticket.requiredGroupSize) < ticket.minBookingLimit) {
                ticket.quantity = ticket.minBookingLimit > ticket.requiredGroupSize ? Math.ceil(ticket.minBookingLimit / ticket.requiredGroupSize) : 1
            } else {
                ticket.quantity++;
            }

            if (vm.canUpdateCart(ticket)) {
                vm.updateCart(ticket, product);
            }

            updateQuantityFromCart(ticket);
        }

        vm.dateSelected = function (date) {
            orderService.setDateSelected(true);
            vm.getProducts(date);
        }

        vm.decrease = function (ticket, product) {
            if (ticket.minBookingLimit > ticket.requiredGroupSize && ticket.quantity <= Math.ceil(ticket.minBookingLimit / ticket.requiredGroupSize)) {
                ticket.quantity = 0;
            } else {
                ticket.quantity--;
            }

            ticket.showMaxTicketWarning = false;

            if (ticket.inCartQuantity > ticket.quantity) {
                var bookingDate = moment(getTicketBookingDate(ticket)).formatEn('YYYY-MM-DD');
                var existingTickets = vm.order.tickets().existingItems(ticket, bookingDate);
                var existingTicket = _.first(existingTickets);

                orderService.removeItem(vm.order.tickets(), existingTicket, true);
            }

            updateQuantityFromCart(ticket);
        }

        vm.canUpdateCart = function (item) {
            var inCartQuantity = item.inCartQuantity || 0;
            var diff = item.quantity - inCartQuantity;
            var ticket = angular.copy(item);
            ticket.quantity = diff;

            return (ticket.quantity > 0 && (!ticket.maxAdditionalGuests || ticket.additionalGuests)) ||
                (ticket.hasUserDefinedCost && ticket.price >= ticket.minUserDefinedCost && ticket.price <= ticket.maxUserDefinedCost) ||
                diff !== 0;
        }

        vm.updateCart = function (item, product) {
            orderService.startCheckout();

            var inCartQuantity = item.inCartQuantity || 0;
            var diff = item.quantity - inCartQuantity;
            var ticket = angular.copy(item);

            ticket.quantity = diff;

            // orderService.canAdd is typically used to determine if the quantity can
            // be increased but here we're using it to determine if the selected quantity
            // is valid - because the user can enter a number manually now
            var bookingDate = moment(getTicketBookingDate(ticket)).formatEn('YYYY-MM-DD');
            if (diff < 0) {
                ticket.bookingDate = bookingDate;
                orderService.removeItem(vm.order.tickets(), ticket, true, !item.quantity, Math.abs(diff));
                updateQuantityFromCart(item);
            } else if ((ticket.quantity || (ticket.hasUserDefinedCost && ticket.price > 0)) && orderService.canAdd(ticket, vm.products, true)) {

                if (!ticket.bookingDate) {
                    ticket.bookingDate = bookingDate;
                }

                if (ticket.productTypeId === productTypes.giftCard || ticket.productTypeId === productTypes.wallet || ticket.productTypeId === productTypes.cashlessCard) {
                    var quantity = ticket.hasUserDefinedCost ? 1 : ticket.quantity;

                    for (var i = 0; i < quantity; i++) {
                        vm.order.tickets().add(ticket);
                    }

                    if (ticket.hasUserDefinedCost) {
                        ticket.price = null;
                    }
                } else {
                    vm.order.tickets().add(ticket, true);
                }

                if (!ticket.hasUserDefinedCost) {
                    var updatedQuantity = orderService.getInCartQuantity(vm.order.tickets(), ticket, ticket.bookingDate);

                    if (_.isNumber(updatedQuantity)) {
                        item.quantity = updatedQuantity;
                        item.inCartQuantity = updatedQuantity;
                    }
                } else {
                    item.quantity = 0;
                    item.price = 0.0;
                }

                if (_.some(ticket.formIds)) {
                    // instead of downloading forms when we get to the details page, do
                    // it now so it's more likely the form is already ready
                    _.each(ticket.formIds, function (formId) {
                        orderService.getForm(formId);
                    });
                }
                else if (_.some(ticket.packageItems)) {
                    _.each(ticket.packageItems, function (item) {
                        _.each(item.formIds, function (formId) {
                            orderService.getForm(formId);
                        });
                    });
                }
            }

            activeTicket = item;

            if (ticket.productTypeId !== productTypes.package && product) {
                var forcePurchaseTickets = _.filter(product.tickets, function (t) { return t.forceMinPurchase && t.inCartQuantity < t.minBookingLimit; });

                _.each(forcePurchaseTickets, function (t) {
                    if (vm.canIncrease(t)) {
                        vm.increase(t);
                    }
                });

                // On mobile to show continue button at the bottom of last cart item
                activeTicket = _.findLast(product.tickets, function (t) { return !!t.inCartQuantity; });
            }
        }

        vm.showNextButton = function (item) {
            return activeTicket === item && wizardNavigationService.canMoveNext();
        }

        vm.showUpdateCartButton = function (item) {
            return focusTicket === item && vm.canUpdateCart(item);
        }

        vm.userDefinedCostChanged = function (ticket) {
            var price = parseFloat(ticket.price);
            ticket.price = price !== NaN && price >= 0 ? ticket.price : null;
        }

        vm.toggleSession = function (session, product) {
            _.each(product.sessions, function (s) {
                s.isSelected = false;
            });
            session.isSelected = true;

            product.tickets = productService.getTickets(product, session);

            refreshDisplayQuantity();
        }

        vm.hasLimitedAvailability = function (session) {
            // TODO: need some formal rules around what shows has limited availability, probably end up being configurable per venue
            var checkForSingleBookingLocations = !session.totalBookings || session.totalBookings > 5;
            return !session.isSoldOut && checkForSingleBookingLocations && parseFloat(session.percentRemaining) < 20;
        }

        vm.showTickets = function (product) {
            return (!_.some(product.sessions) || vm.useSessionTiles) && !product.isSoldOut;
        }

        vm.formatDuration = function (duration) {
            return durationFilter(duration);
        };

        function loadCountries() {
            if ($rootScope.paymentSetting && $rootScope.paymentSetting.isAVSEnabled) {
                countryService.getCountries()
            }
        }

        function loadProducts(date) {
            date = handleBookingDate(date);
            vm.products = [];
            vm.loading = true;

            productService.getProducts(date, isGroupTwo).then(function (products) {
                settingsService.isLoaded();

                var productsForGroup = [];
                var groupOne = productService.consumerWidgetGroup();
                var groupTwo = productService.consumerWidgetGroupTwo();

                if (groupTwo) {
                    if (isGroupTwo) {
                        var data = getProductsForGroup(groupTwo, products);
                        vm.products = data.products;
                        productsForGroup = data.productsForGroup;

                        if (!_.some(vm.products)) {
                            $state.go('sessions.addons');
                            return;
                        }

                        setGroupConfigurations(groupTwo);
                    }
                    else {
                        var data = getProductsForGroup(groupOne, products);
                        vm.products = data.products;
                        productsForGroup = data.productsForGroup;

                        setGroupConfigurations(groupOne);
                    }
                }
                else if (groupOne) {

                    if (groupOne.donationOnly) {
                        orderService.setBookingDate(new Date(date));
                        $state.go('sessions.addons');
                        return;
                    }

                    setGroupConfigurations(groupOne);

                    var data = getProductsForGroup(groupOne, products);
                    vm.products = data.products;
                    productsForGroup = data.productsForGroup;
                }
                else {
                    vm.products = products;
                }

                if (_.some(productsForGroup, function (p) { return p.groupTitle ? true : false; })) {
                    vm.groupedProducts = [];
                    var groups = _.uniq(_.pluck(productsForGroup, 'groupTitle'));
                    _.each(groups, function (groupTitle) {
                        var productIdsInThisGroup = _.pluck(_.filter(productsForGroup, { groupTitle: groupTitle }), 'productId');
                        var productsInThisGroup = _.filter(vm.products, function (p) { return _.indexOf(productIdsInThisGroup, p.productId) >= 0; });

                        if (_.some(productsInThisGroup)) {
                            var group = { title: groupTitle, products: productsInThisGroup };
                            group.isSoldOut = _.every(group.products, { isSoldOut: true });
                            vm.groupedProducts.push(group);
                        }
                    });
                }
                else {
                    // the majority of the time there won't be grouped products, but the HTML is
                    // is simpler if we make groups always exist - so we put all products in a group
                    vm.groupedProducts = [{ products: vm.products }];
                }

                // groups can define whether they want accordions expanded by default
                var groupOne = productService.consumerWidgetGroup();

                if (vm.products.length === 1) {
                    vm.toggleProduct(vm.products[0]);
                    vm.toggleGroup(vm.groupedProducts[0]);
                }
                else if (groupOne) {
                    if ((!isGroupTwo && groupOne.expandAccordions) || (isGroupTwo && groupTwo && groupTwo.expandAccordions)) {
                        expandAccordions = true;
                        _.each(vm.products, function (product) {
                            vm.toggleProduct(product);
                        });
                        _.each(vm.groupedProducts, function (group) {
                            vm.toggleGroup(group);
                        });
                    }
                }
                else {
                    // consumer widget groups have their own ordering currently done server-side
                    vm.products = _.sortBy(vm.products, 'name');
                }

                if (groupOne && groupOne.callToBookPhoneNumber) {
                    vm.callToBookPhoneNumber = groupOne.callToBookPhoneNumber;
                }

                productPromotionService.setProductToPromote(vm.products);
                refreshDisplayQuantity();

            }, function () {
                vm.error = "Unable to load products.";
            }).finally(function () {
                var abandonedOrder = orderService.abandonedOrder();

                if (abandonedOrder && abandonedOrder.shrunkenBookingUniqueId && !orderService.hasClickedContinue()) {
                    vm.loading = true;

                    orderService.paymentAlreadyProcessed(abandonedOrder.shrunkenBookingUniqueId).then(function (result) {
                        if (result.isProcessed) {
                            orderService.loadLocalOrderData();
                            result.success = true;
                            orderService.setOrderResult(result);

                            $state.go('sessions.success');
                        } else {
                            orderService.resetOrder();
                        }
                    }).finally(function () {
                        vm.loading = false;
                        orderService.clearLocalOrderData();
                    });
                } else {
                    vm.loading = false;
                }
            });
        }

        function refreshDisplayQuantity() {
            _.each(vm.groupedProducts, function (group) {
                _.each(group.products, function (product) {
                    _.each(product.tickets, function (ticket) {
                        updateQuantityFromCart(ticket);
                    });
                });
            });
        }

        function setGroupConfigurations(group) {
            vm.showRemainingCapacity = group.showRemainingCapacity;
            vm.hideCalendar = group.hideCalendar || isGroupTwo;
            vm.useSessionTiles = !group.useSessionBarWithAvailability;
            vm.title = group.title;
        }

        function getProductsForGroup(group, products) {
            var groupProductIds = _.pluck(group.products, 'productId');
            var groupProducts = _.filter(products, function (product) { return _.indexOf(groupProductIds, product.productId) >= 0; });

            groupProducts = _.sortBy(groupProducts, function (product) { return groupProductIds.indexOf(product.id); });

            return {
                products: groupProducts,
                productsForGroup: group.products
            };
        }

        function handleBookingDate(date) {
            var initialDateIndex = settingsService.initialDateIndex();
            var bookingDate = orderService.getBookingDate();

            // ignore the booking date if it's today - because there could be
            // an initial date index (from the URL), and if the user needs today they
            // can select it on the calendar in which case date will have a value
            if (!date && !moment(bookingDate).isSame(venueTime, "day")) {
                date = bookingDate;
            }

            if (date) {
                date = moment(date);

                var dateIndex = parseInt(date.locale('en').format('YYYYMMDD'));
                var currentDateIndex = parseInt(venueTime.format('YYYYMMDD'));

                if (dateIndex < currentDateIndex) {
                    date = moment(venueTime);
                }

                vm.date = date.formatEn('YYYY-MM-DD');
                orderService.setBookingDate(new Date(date));
            } else if (initialDateIndex) {
                date = moment(initialDateIndex, 'YYYYMMDD');
                vm.date = date.formatEn('YYYY-MM-DD');
                orderService.setBookingDate(new Date(date));
            } else {
                orderService.setBookingDate(new Date(venueTime));
            }

            return date;
        }

        function ticketQuantityChanged(event, args) {
            if (args && args.ticket) {
                focusTicket = args.ticket;
                var ticket = args.ticket;
                var clonedTicket = angular.copy(ticket);
                var diff = clonedTicket.quantity - (clonedTicket.inCartQuantity || 0);

                clonedTicket.quantity = diff;

                if (clonedTicket.quantity > 0 && !orderService.canAdd(clonedTicket, vm.products, true)) {
                    var maxAttempts = 100;
                    // it's tricky to determine the max remaining per ticket so we'll try X times
                    // to find the max number they can have otherwise send them back to zero - the reason
                    // for this is the UI disabled the control if they over and can only click decrease which
                    // is painful if you're well over the max allowed
                    for (var i = 0; i < maxAttempts; i++) {
                        clonedTicket.quantity--;
                        ticket.quantity--;

                        if (orderService.canAdd(clonedTicket, vm.products, true)) {
                            ticket.quantity = clonedTicket.inCartQuantity + clonedTicket.quantity;
                            ticket.showMaxTicketWarning = true;
                            break;
                        }
                        else if (i + 1 === maxAttempts) {
                            ticket.quantity = clonedTicket.inCartQuantity || 0;
                        }
                    }
                }
            }
        }

        /** Listens for item removal from external sources */
        function cartItemRemoved(event, args) {
            if (args && args.item) {
                var item = args.item;

                _.each(vm.groupedProducts, function (group) {
                    _.each(group.products, function (product) {
                        _.each(product.tickets, function (ticket) {
                            if (item.id === ticket.id) {
                                updateQuantityFromCart(ticket);
                            }
                        });
                    });
                });
            }
        }

        function updateQuantityFromCart(ticket) {

            if (ticket.hasUserDefinedCost) {
                return;
            }

            var updatedQuantity = orderService.getInCartQuantity(vm.order.tickets(), ticket, getTicketBookingDate(ticket));

            if (_.isNumber(updatedQuantity)) {
                ticket.quantity = updatedQuantity;
                ticket.inCartQuantity = updatedQuantity;
            }
        }

        /** Prefer the ticket's booking date or use the selected date. Used in other methods when matching basket items */
        function getTicketBookingDate(ticket) {
            return ticket && ticket.bookingDate ? ticket.bookingDate : vm.date;
        }

        vm.formattedDate = function () {
            if (!_.isString(vm.date) || !moment(vm.date).isValid()) {
                vm.date = venueTime.formatEn('YYYY-MM-DD');
            }
            var momentDate = moment(vm.date);
            var dateTimeFormat = moment.localeData().longDateFormat('LLLL');
            var timeFormat = moment.localeData().longDateFormat('LT');
            var formatToUse = dateTimeFormat.replace(timeFormat, '').replace('[kl.]', '').trim();

            return momentDate.format(formatToUse);
        };

        vm.productsAvailable = function (product) {

            return vm.products && vm.products.length > 0;
        }

        vm.toggleProduct = function (product, e, alreadyLoadedFromApi) {
            if (e && e.target.nodeName === 'A') {
                return;
            }

            var group = vm.group();
            var loadProductFromApi = group
                && group.loadSessionsOnTheFly
                && product.subTypeId === 'session'
                && !_.some(product.sessions)
                && !alreadyLoadedFromApi;

            if (loadProductFromApi) {
                product.loadingSessions = true;
                productService.loadProduct(product.id, vm.date).then(function (result) {
                    productService.setSessions(vm.products, [result]);
                    vm.toggleProduct(product, e, true);
                }).finally(function () { product.loadingSessions = false; });
                return;
            }

            if (!product.isClosed) {
                if (!expandAccordions) {
                    _.each(vm.products, function (p) {
                        if (p.id != product.id) {
                            p.isSelected = false;
                        }
                    });
                }
                product.isSelected = !product.isSelected;

                if (!product.tickets) {
                    product.tickets = product.childApiProducts;
                }

                if (_.some(product.sessions) && product.isSelected) {
                    var availableSessions = _.filter(product.sessions, { isSoldOut: false });
                    var firstSession = _.first(availableSessions);

                    if (firstSession) {
                        vm.toggleSession(firstSession, product);
                    }
                }
                else if (product.isSelected) {

                    _.each(product.tickets, function (ticket) {
                        updateQuantityFromCart(ticket);
                    });
                }
            }
        }

        var _selectedGroup = null;
        vm.toggleGroupedProduct = function (group) {
            if (_selectedGroup && _selectedGroup.title == group.title) {
                _selectedGroup = null;
            }
            else {
                _selectedGroup = group;
            }
        }

        vm.isActiveGroupedProduct = function (group) {
            return _selectedGroup && _selectedGroup.title == group.title;
        }

        vm.isConsumerWidgetGroup = function () {
            var group = vm.group();
            return group && (group.imageUrl || group.description);
        }

        if (isGroupTwo) {
            vm.group = productService.consumerWidgetGroupTwo;
        }
        else {
            vm.group = productService.consumerWidgetGroup;
        }

        vm.showAvailabilityOverride = function () {
            if (settingsService.productId() && _.some(vm.products) && vm.products[0].availabilityOverride) {
                return true;
            }
            return false;
        }

        vm.toggleGroup = function (group) {
            var isSelected = group.isSelected;
            if (!expandAccordions) {
                _.each(vm.groupedProducts, function (group) {
                    group.isSelected = false;
                });
            }
            group.isSelected = !isSelected;
        }

        vm.selectDuration = function (ticket, duration) {
            ticket.selectedDuration = duration;
            updateQuantityFromCart(ticket);
        }

        vm.onCustomFieldFocus = function (ticket) {
            focusTicket = ticket;
        }

        analyticsService.pageTrack('home', settingsService.venueName);
    }
})();

(function () {
  'use strict';

  angular
    .module('consumerSessions')
    .controller('ErrorController', ErrorController);

  /** @ngInject */
  function ErrorController(settingsService) {
    var vm = this;

    vm.hideBranding = settingsService.hideRollerBranding;
  }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("DetailsController", DetailsController);

    /** @ngInject */
    function DetailsController(orderService, settingsService, analyticsService, contentService, countryService, $scope, rollerCurrencyFilter, $rootScope, $stateParams, productService, modalService, ticketTimerService, $timeout, $log, $q, $state, $translate) {
        var vm = this;

        if (orderService.isProcessed() || !orderService.itemCount()) {
            $state.go('sessions.home');
        }

        ticketTimerService.setRecaptchaInitialisation(false);

        vm.details = orderService.details();
        vm.orderService = orderService;
        vm.settings = settingsService;
        vm.countryCode = vm.settings.venueCountryCode;
        vm.content = contentService.content;
        vm.showDeliveryDetailsForm = false;
        vm.hasMultiGiftcard = false;
        vm.swapNameOrder = settingsService.swapNameOrder;
        vm.combinedDeliveryDetails = orderService.delivery();
        vm.consumerWidgetGroup = productService.consumerWidgetGroup();
        vm.rollerPlacesHandlers = {};
        vm.showGiftCard = false;
        vm.giftCardVerified = false;
        vm.showDiscountCode = true;
        vm.giftExpiryMonth = "";
        vm.giftExpiryYear = "";
        vm.applyGiftCard = applyGiftCard;
        vm.applyDiscountCode = applyDiscountCode;
        vm.hasMoreGiftcardFields = false;
        vm.canAddDiscount = getCanAddDiscount();
        vm.isActivated = isActivated;
        vm.combinedDeliveryDetails = orderService.delivery();
        vm.loadAddressAutocomplete = loadAddressAutocomplete;
        vm.termsAndConditions = _.bind(modalService.showVenueTermsAndConditions, modalService);
        vm.canUseDiscounts = settingsService.canUseDiscounts;
        vm.canUseMemberships = settingsService.canUseMemberships;
        vm.policyUrl = settingsService.policyUrl;
        vm.addDiscountCode = addDiscountCode;
        vm.addGiftCard = addGiftCard;
        vm.removeGiftCard = removeGiftCard;
        vm.canUseDiscountsAndGiftCards = canUseDiscountsAndGiftCards;
        vm.giftcardDeliveryOption = giftcardDeliveryOption;
        vm.toggleForm = toggleForm;
        vm.toggleGiftcard = toggleGiftcard;
        vm.setGiftcardMessagingOption = setGiftcardMessagingOption;
        vm.paymentSetting = $rootScope.paymentSetting;
        vm.hasMoreGiftcardOptions = false;
        vm.redemptionType = undefined;
        vm.setRedemptionType = setRedemptionType;
        vm.isRedeeming = isRedeeming;
        vm.isVerifyingGiftCard = false;
        vm.giftcardPin = undefined;
        vm.errors = [];
        vm.datePickerConfig = {
            minDate: moment.utc(),
            dateFormat: 'DD MMM YYYY'
        };
        vm.extraDetails = undefined;
        vm.canRedeemGiftCards = canRedeemGiftCards;
        vm.isBookingMailboxValid = undefined;
        vm.hasWarnings = hasWarnings;
        vm.rollerPlacesHandlers = {};
        vm.formValidationMessageProvider = {
            getMessages: function () {
                return {
                    'mailbox': $translate.instant('SESSIONS.DETAILS.EMAIL_APPEARS_INCORRECT')
                }
            }
        };

        vm.isWorldpayCard = isWorldpayCard;
        vm.isStoreCard = isStoreCard;
        vm.isValutecCard = isValutecCard;
        vm.isValidStoreCard = isValidStoreCard;

        initialise();

        function initialise() {
            settingsService.capturePostcode(null);
            orderService.clearDiscount();
            prepareForms();
            prepareGiftcards();
            hideAllForms();
            analyticsService.pageTrack('details', settingsService.venueName);

            if (vm.consumerWidgetGroup) {

                vm.extraDetails = vm.consumerWidgetGroup.extraDetailTerms;

                if (ticketTimerService.isRecaptchaRequired() && !ticketTimerService.isRecaptchaInitialised()) {
                    try {
                        window.recaptchaLoaded.then(function () {
                            grecaptcha.render('recaptcha', {
                                'sitekey': RollerEnvironment.googleInvisibleRecaptchaPublicKey,
                                'size': 'invisible',
                                'callback': window.timerRecaptchaCallback
                            });
                            ticketTimerService.setRecaptchaInitialisation(true);
                        });
                    }
                    catch (error) {
                        console.error('Recaptcha error: ', error);
                    }
                }
                else if (vm.consumerWidgetGroup.useRecaptcha && !settingsService.canUseRecaptcha()) {
                    try {
                        window.recaptchaLoaded.then(function () {
                            grecaptcha.render('recaptcha', {
                                'sitekey': RollerEnvironment.googleInvisibleRecaptchaPublicKey,
                                'size': 'invisible',
                                'callback': recaptchaCallback
                            });
                        });
                    }
                    catch (error) {
                        console.error('Recaptcha error: ', error);
                    }
                }
            }
        }

        $rootScope.beforeMovingNext = onBeforeMovingNext;

        $scope.$on('$destroy', function () {
            $rootScope.beforeMovingNext = undefined;

            _.each(Object.keys(vm.rollerPlacesHandlers), function (key) {
                var handler = vm.rollerPlacesHandlers[key];
                if (handler && handler.autocomplete) {
                    handler.autocomplete.destroy();
                }
            });
        });

        $scope.$on('cart-item-removed', function () {
            prepareForms();
            prepareGiftcards();
        });

        $scope.$on('sessions.before-going-next', function () {
            if (settingsService.discountCodeOnlyFlow() && !_.any(orderService.getDiscounts())) {
                vm.errors = [$translate.instant('SESSIONS.DETAILS.DISCOUNT_CODE_REQUIRED')];
            }
        });

        $rootScope.$on('discount-removed', function () {
            vm.discountCodeVerified = false;
            vm.canAddDiscount = getCanAddDiscount();
        });

        $scope.$on('gift-card-removed', function () {
            vm.giftCardVerified = false;
        });

        if (!vm.paymentSetting) {
            $scope.$on('paymentLoaded', function () {
                vm.paymentSetting = $rootScope.paymentSetting;
            });
        }

        if ($stateParams.giftcardCode) {
            applyGiftCard($stateParams.giftcardCode);
        }

        if ($stateParams.discountCode) {
            applyDiscountCode($stateParams.discountCode);
        }

        function onBeforeMovingNext() {
            vm.errors = [];

            var deferred = $q.defer();

            orderService.processDraftOrder().then(deferred.resolve, function (err) {
                vm.errors = err;
                try {
                    $('.message--warning')[0].scrollIntoView(false)
                } catch (error) {
                    console.log('Failed to scroll to .message--warning');
                }
            });

            return deferred.promise;
        }

        function isRedeeming(type) {
            return vm.redemptionType === type;
        }

        function setRedemptionType(type) {
            if (isRedeeming(type)) {
                vm.redemptionType = undefined;
            } else {
                vm.redemptionType = type;
            }

            resetDiscountCode();
            resetGiftCard();
        }

        function resetDiscountCode() {
            vm.invalidDiscountCode = false;
            vm.discountCode = undefined;
        }

        function resetGiftCard() {
            vm.invalidGiftCard = false;
            vm.giftCardNumber = undefined;
            vm.giftcardPin = undefined;
        }

        function addDiscountCode() {
            vm.showDiscountCode = !vm.showDiscountCode;
        }

        function loadAddressAutocomplete(id, detail, index) {
            if (!window.RollerPlaces) {
                console.log('RollerPlaces not found');
                return;
            }

            var concatedId = index >= 0 ? (id + index) : id;

            var handler = vm.rollerPlacesHandlers[concatedId];
            if (handler && handler.autocomplete) {
                handler.autocomplete.destroy();
            }

            var searchOptions = {
                country: vm.countryCode
            };

            vm.rollerPlacesHandlers[concatedId] = RollerPlaces.searchAddress(concatedId, searchOptions)
                .on('autocomplete:selected', function (event, suggestion) {
                    $timeout(function () {
                        if (suggestion) {
                            detail.formattedAddress = suggestion.value;
                            detail.address = suggestion.address;
                            detail.houseNumber = suggestion.houseNumber;
                            detail.street = suggestion.street;
                            detail.suburb = suggestion.suburb;
                            detail.city = suggestion.city;
                            detail.postcode = suggestion.postcode;
                            detail.county = suggestion.county;
                            detail.state = suggestion.state;
                            detail.country = suggestion.country;
                            detail.addressPopulated = true;
                        }
                    });
                });
        }

        function isActivated() {
            var activated = vm.giftcards && !_.all(_.filter(_.where(vm.giftcards, { 'type': 'physical' }), hasNoDifferentDelivery), notEmpty);
            if (!activated) {
                vm.showDeliveryDetailsForm = false;
            }
            return activated;
        };

        function hasWarnings() {
            return vm.isBookingMailboxValid === false ||
                _.any(vm.giftcards, function (gc) { return gc.isMailboxValid === false; }) ||
                _.any(vm.forms, function (f) { return f.hasWarnings; });
        }

        function applyDiscountCode(discountCode) {
            ticketTimerService.callback = _.partial(applyDiscount, discountCode);

            if (orderService.requiresRecaptcha()) {
                try {
                    var response = grecaptcha.getResponse();

                    if (!response && !ticketTimerService.getUniqueTimerId()) {
                        grecaptcha.execute();
                        return;
                    }
                }
                catch (error) {
                    console.error('Recaptcha error: ', error);
                }
            }

            applyDiscount(discountCode);
        }

        function applyDiscount(discountCode) {
            vm.discountCodeApplied = undefined;
            vm.discountCodeVerified = false;

            // Ensure that discount code is set
            if (!vm.discountCode) {
                vm.discountCode = discountCode;
            }

            orderService.applyDiscountCode(discountCode).then(function (result) {
                vm.invalidDiscountCode = !result.isValid;
                vm.discountCodeVerified = result.isValid;
                vm.discountCodeApplied = vm.discountCode;
                vm.discountCode = undefined;
                vm.canAddDiscount = getCanAddDiscount();

                if (result.isValid) {
                    setRedemptionType(undefined);
                }
            }, function (error) {
                vm.invalidDiscountCode = true;
                $log.error(error);
            });
        }

        function addGiftCard() {
            vm.showGiftCard = !vm.showGiftCard;
        }

        function applyGiftCard(giftCardNumber, expiryMonth, expiryYear) {
            ticketTimerService.callback = _.partial(applyGiftCardNumber, giftCardNumber, expiryMonth, expiryYear);

            if (orderService.requiresRecaptcha()) {
                try {
                    var response = grecaptcha.getResponse();

                    if (!response && !ticketTimerService.getUniqueTimerId()) {
                        grecaptcha.execute();
                        return;
                    }
                }
                catch (error) {
                    console.error('Recaptcha error: ', error);
                }
            }

            applyGiftCardNumber(giftCardNumber, expiryMonth, expiryYear);
        }

        function applyGiftCardNumber(giftCardNumber, expiryMonth, expiryYear) {
            if (vm.isVerifyingGiftCard) {
                return;
            }

            vm.isVerifyingGiftCard = true;
            // Ensure that vm.giftCardNumber is set
            if (!vm.giftCardNumber) {
                vm.giftCardNumber = giftCardNumber;
            }

            orderService.applyGiftCard(giftCardNumber, expiryMonth, expiryYear, _.trim(vm.giftcardPin)).then(function (result) {
                vm.showGiftCard = result.isValid;
                vm.invalidGiftCard = !result.isValid;
                vm.giftCardVerified = result.isValid;

                if (result.isValid) {
                    setRedemptionType(undefined);
                }
            }, function (error) {
                vm.invalidGiftCard = true;
                $log.error(error);
            }).finally(function () {
                vm.isVerifyingGiftCard = false;
            });
        }

        function canRedeemGiftCards() {
            return !orderService.isFree();
        }

        function removeGiftCard() {
            vm.giftCardVerified = false;
            orderService.removeGiftCard();

            resetGiftCard();
            vm.showGiftCard = false;
            setRedemptionType(undefined);
        }

        // in case the user applied a discount then went back and changed ticket quantities
        vm.removeGiftCard();

        function canUseDiscountsAndGiftCards() {

            return !vm.orderService.noFurtherPaymentRequired();
        }

        function hasNoDifferentDelivery(value) {
            return !value.details.differentDeliveryDetails;
        }

        function notEmpty(value) {
            return _.isString(value) && /\S+/.test(value);
        }

        function prepareGiftcards() {
            vm.giftcards = _.where(orderService.tickets().items, { productTypeId: 'giftCard' });
            if (vm.giftcards && vm.giftcards.length > 0) {
                vm.hasMultiGiftcard = true;
            }

            if (_.some(vm.giftcards)) {
                countryService.getTimeZones().then(function (timezones) {
                    _.each(vm.giftcards, function (giftcard) {
                        if (!giftcard.details) {
                            giftcard.details = {
                                address: { country: '' },
                                sendDate: moment().add(1, 'days').format(vm.datePickerConfig.dateFormat),
                                sendTime: '700',
                                timezone: settingsService.venueTimezone,
                                postage: _.some(giftcard.productPostages) ? giftcard.productPostages[0] : null,
                                selectedMessagingOption: getGiftcardDefaultMessagingOption(giftcard),
                                videoIdentifier: null,
                                differentDeliveryDetails: false
                            };
                            giftcard.sendLater = false;
                            giftcard.type = giftcard.allowPhysicalGiftCard === true ? 'physical' : 'digital';
                            giftcard.timezones = angular.copy(timezones);

                            giftcard.deliveryOptionDescription = function () {
                                if (giftcard.details.postage) {
                                    return giftcard.details.postage.description;
                                }
                                return null;
                            }

                            giftcard.isPickup = function () {
                                return giftcard.details.postage && giftcard.details.postage.isPickup;
                            }

                            addPostageOptions(giftcard.productPostages);
                        }
                    });
                });

                _.sortBy(vm.combinedDeliveryDetails.postageOptions, function (o) { return o.type; })
            }
        }

        function prepareForms() {
            vm.forms = orderService.getApplicableForms();
        }

        function giftcardDeliveryOption(option) {
            return option.type + (option.price == 0 ? '' : ' - ' + rollerCurrencyFilter(option.price));
        }

        function toggleForm(form) {
            hideAllForms(form.id);
            form.showForm = !form.showForm;
        }

        function setGiftcardMessagingOption(giftcard, mode) {
            giftcard.details.selectedMessagingOption = mode;
        }

        function toggleGiftcard(giftcard) {
            var isSelected = giftcard.isSelected;
            _.each(vm.giftcards, function (g) {
                g.isSelected = false;
            });
            giftcard.isSelected = !isSelected;
        }

        vm.setGiftcardMessagingOption = function (giftcard, mode) {
            giftcard.details.selectedMessagingOption = mode;
        }

        function addPostageOptions(postages) {
            if (!vm.combinedDeliveryDetails.postageOptions) {
                vm.combinedDeliveryDetails.postageOptions = [];
            }

            if (postages) {
                _.each(postages, function (postage) {
                    if (!_.findWhere(vm.combinedDeliveryDetails.postageOptions, { 'price': postage.price, 'type': postage.type })) { // No Duplicates
                        vm.combinedDeliveryDetails.postageOptions.push(postage);
                    }
                });
            }
        }

        function hideAllForms(formIdToIgnore) {
            _.each(vm.forms, function (form) {
                if (!formIdToIgnore || form.id != formIdToIgnore) {
                    form.showForm = false;
                }
            });
        }

        function getGiftcardDefaultMessagingOption(giftcard) {
            if (giftcard.giftcardAcceptsMessage) {
                return 'message';
            }

            if (giftcard.giftcardAcceptsVideo) {
                return 'video';
            }

            return null;
        }

        function getCanAddDiscount() {
            var canUseMultipleDiscountsInCheckout = settingsService.canUseMultipleDiscountsInCheckout;
            var discounts = orderService.getDiscounts() || [];

            // Always allow for one discount to be added
            return canUseMultipleDiscountsInCheckout || discounts.length === 0 || !vm.discountCodeVerified || !vm.orderService.hasValidDiscountCode();
        }

        function isWorldpayCard() {
            return isValutecCard() || isStoreCard();
        }
        function isStoreCard() {
            var storeCardBin = '6050110';
            if (!settingsService.canRedeemWorldpayStoreCard || !vm.giftCardNumber) {
                return false;
            }
            return _.startsWith(vm.giftCardNumber, storeCardBin);
        }

        function isValutecCard() {
            if (!settingsService.canRedeemWorldpayStoreCard || !vm.giftCardNumber) {
                return false;
            }
            return _.startsWith(vm.giftCardNumber, '7') && _.size(vm.giftCardNumber) == 19;
        }

        function isValidStoreCard() {
            var pinLength = _.chain(vm.giftcardPin).trim().size().value();
            if (isStoreCard()) {
                return (pinLength === 3 || pinLength === 8);
            }
            if (isValutecCard()) {
                return pinLength == 8;
            }
            return false;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("CallbackController", CallbackController);

    /** @ngInject */
    function CallbackController($state, settingsService, $scope, $rootScope, insideIframe, $location, orderService) {
        var vm = this;

        vm.loading = true;
        vm.$state = $state;
        vm.showImage = settingsService.showHeader();
        vm.headerImage = settingsService.headerImage ? settingsService.headerImage : '';
        vm.insideIframe = insideIframe;
        vm.settings = settingsService;
        vm.paymentSetting = $rootScope.paymentSetting;

        if (insideIframe) {
            angular.element('body').css('background-color', 'transparent');
        }
        else if (settingsService.backgroundImage) {
            angular.element('.background').css('background-image', 'url(\'' + settingsService.backgroundImage + '\')');
        }

        if (!vm.paymentSetting) {
            $scope.$on('paymentLoaded', function () {
                processPaymentResult();
            });
        } else {
            processPaymentResult();
        }

        function processPaymentResult() {
            var params = $location.search();
            var hasLocalData = orderService.loadLocalOrderData();
            var success = (params.success || '').toLowerCase() === 'true';
            var result = angular.copy(params);
            result.success = success;

            if (success) {
                if (!hasLocalData) {                 
                    orderService.resetOrder(true);
                    orderService.setBriefOrderConfirmation(true);
                    delete params.shopperStatement;
                }

                orderService.setOrderResult(params);

                $state.go('sessions.success');
            } else {
                var errorMessage = params.errorMessage;

                if (params.errorCode) {
                    errorMessage = orderService.getPaymentErrorMessage(params);
                }

                goToPaymentWithError(errorMessage);
            }
        }

        function goToPaymentWithError(errorMessage) {
            $state.go('sessions.payment', {
                paymentErrors: [errorMessage]
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .controller("AddOnsController", AddOnsController);

    /** @ngInject */
    function AddOnsController(productService, orderService, $state, $stateParams, analyticsService, settingsService, $scope, wizardNavigationService, $timeout, productTypes) {
        var vm = this;

        vm.settings = settingsService;
        vm.order = orderService;
        vm.nextButtonText = _.bind(wizardNavigationService.nextButtonText, wizardNavigationService);
        vm.moveNext = _.bind(wizardNavigationService.moveNext, wizardNavigationService);

        $scope.$on('cart-item-removed', cartItemRemoved);
        var parentIdsByDate = orderService.tickets().parentIdsByDate();
        var activeAddOn = undefined;
        var focusAddOn = undefined;
        var debouncedRefreshQuantity = _.debounce(refreshQuantity, 250);

        if (!_.any(_.keys(parentIdsByDate)) && productService.isDonationOnly()) {
            // Donation only checkout
            parentIdsByDate[moment(orderService.getBookingDate()).formatEn('YYYY-MM-DD')] = [];
        }

        productService.getAddOns(parentIdsByDate).then(function (data) {
            var hasAddOn = _.some(_.keys(data));

            if (!hasAddOn) {
                if ($stateParams.fromStateName !== 'sessions.details') {
                    $state.go('sessions.details');
                } else {
                    $state.go('sessions.home');
                }
            }

            orderService.setCanBuyAddOns(hasAddOn);

            vm.addOnGroups = _.chain(_.keys(data))
                .map(function (key) {
                    return {
                        bookingDate: key,
                        sortDate: moment(key),
                        formattedBookingDate: moment(key).format('D MMM YYYY'),
                        addOns: _.filter(data[key], function (addOn) { return _.any(addOn.childApiProducts); })
                    }
                })
                .sortBy('sortDate')
                .value();

            refreshQuantity();
            applyForcedPurchase();
        });

        orderService.clearDiscount();

        vm.canAdd = function (addOn, product) {
            return orderService.canAddAddOn(addOn, product);
        }

        vm.canIncrease = function (item, products) {
            var addOn = orderService.getItemWithQuantityDiff(item);

            return vm.order.canAdd(addOn, products);
        }

        vm.canDecrease = function (addOn) {
            return vm.order.canDecrease(addOn);
        }

        vm.increase = function (addOn, date) {
            activeAddOn = addOn;

            addOn.quantity++;

            if (vm.canUpdateCart(addOn)) {
                vm.updateCart(addOn, date);
            }
        }

        vm.decrease = function (addOn, date) {
            activeAddOn = addOn;
            addOn.quantity--;

            if (addOn.inCartQuantity > addOn.quantity) {
                var existingAddOns = vm.order.addOns().existingItems(addOn, date);
                var existingAddOn = _.first(existingAddOns);

                orderService.removeItem(vm.order.addOns(), existingAddOn);
            }

            updateQuantityFromCart(addOn);
        }

        vm.canUpdateCart = function (item) {
            var inCartQuantity = item.inCartQuantity || 0;
            var diff = item.quantity - inCartQuantity;
            var child = angular.copy(item);

            child.quantity = diff;

            return (child.hasUserDefinedCost && child.price) || (!child.hasUserDefinedCost && diff !== 0);
        }

        vm.updateCart = function (child, date) {
            var inCartQuantity = child.inCartQuantity || 0;
            var diff = child.quantity - inCartQuantity;
            var childToUpdate = angular.copy(child);

            childToUpdate.quantity = diff;

            if (diff < 0) {

                childToUpdate.bookingDate = date;
                orderService.removeItem(vm.order.addOns(), childToUpdate, false, !child.quantity, Math.abs(diff));
            }
            else if ((childToUpdate.hasUserDefinedCost && childToUpdate.price) || childToUpdate.quantity) {

                if (!childToUpdate.bookingDate) {
                    childToUpdate.bookingDate = date;
                }

                orderService.addOns().add(childToUpdate, true);

                if (child.hasUserDefinedCost) {
                    child.price = 0.0;
                    child.quantity = 0;
                }
            }

            updateQuantityFromCart(child);
            focusAddOn = undefined;
            child.forceShowAddToCart = false;
        }

        vm.showNextButton = function (item) {
            return activeAddOn === item && wizardNavigationService.canMoveNext();
        }

        vm.showUpdateCartButton = function (item) {
            return focusAddOn === item && vm.canUpdateCart(item) || item.forceShowAddToCart;
        }

        vm.userDefinedCostChanged = function (addOn) {
            var price = parseFloat(addOn.price);

            addOn.price = price !== NaN && price >= 0 ? addOn.price.replace(',', '') : 0;
        }

        vm.onCustomFieldFocus = function (item) {
            focusAddOn = item;
        }

        function applyForcedPurchase() {
            _.each(vm.addOnGroups, function (group) {

                var addOnWithForcePurchase = _.findWhere(group.addOns, { forcePurchaseUnlessRemoved: true });
                if (addOnWithForcePurchase) {
                    // we choose the first because this feature ony applies to add-ons with one child product
                    var addOn = addOnWithForcePurchase.childApiProducts[0];

                    if (addOn) {
                        var minimumForcedQuantity = orderService.getTotalTicketsForAddon(addOnWithForcePurchase, group.bookingDate);
                        var alreadyInCartQuantity = orderService.getInCartQuantity(vm.order.addOns(), addOn, group.bookingDate);

                        if (alreadyInCartQuantity < minimumForcedQuantity) {
                            addOn.quantity = minimumForcedQuantity;
                            addOn.forcePurchaseQuantity = minimumForcedQuantity;
                            addOn.inCartQuantity = alreadyInCartQuantity;

                            if (settingsService.autoCartUpdate) {
                                vm.updateCart(addOn, group.bookingDate);
                            } else {
                                addOn.forceShowAddToCart = true;
                            }
                        }
                    }
                }
            });
        }

        function refreshQuantity() {
            _.each(vm.addOnGroups, function (group) {
                _.each(group.addOns, function (addOn) {
                    _.each(addOn.childApiProducts, function (child) {
                        updateQuantityFromCart(child, group.bookingDate);
                    });
                });
            });
        }

        function cartItemRemoved(event, args) {
            if (!(args && args.item && args.item.productTypeId === productTypes.addOn)) {
                return;
            }

            debouncedRefreshQuantity();
        }

        function updateQuantityFromCart(addOn, date) {
            if (addOn.hasUserDefinedCost) {
                return;
            }

            var bookingDate = date || moment(orderService.getBookingDate()).formatEn('YYYY-MM-DD');
            var updatedQuantity = orderService.getInCartQuantity(vm.order.addOns(), addOn, bookingDate);

            $timeout(function () {
                if (addOn.forcePurchaseQuantity) {
                    addOn.quantity = addOn.forcePurchaseQuantity;
                    addOn.forcePurchaseQuantity = undefined;
                } else {
                    addOn.quantity = updatedQuantity;
                }
                addOn.inCartQuantity = updatedQuantity;
            });
        }

        analyticsService.pageTrack('addons', settingsService.venueName);
    }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .factory("OrderPaymentDetails", orderPaymentDetailsFactory);

    /** @ngInject */
    function orderPaymentDetailsFactory(settingsService, $translate, productPromotionService, $rootScope) {
        function OrderPaymentDetails(values) {
            var self = this;

            self.paymentMethod = "creditcard";
            self.subPaymentMethod = null;
            self.cardNumber = "";
            self.cardName = "";
            self.cardExpiryMonth = null;
            self.cardExpiryYear = null;
            self.cardCVV = "";
            self.paypalEmail = "";
            self.paypalPassword = "";
            self.isPaypalEnabled = false;
            self.paypalNonce = null;
            self.paypalError = null;
            self.isValidBillingAddress = isValidBillingAddress;
            self.termsAccepted = false;
            self.privacyPolicyAccepted = false;
            self.billingAddress = {
                address: null,
                address2: null,
                city: null,
                state: null,
                country: null,
                postalCode: null
            };
            self.additionalInfo = {
                idType: "",
                idNumber: ""
            };

            _.extend(self, values);

            self.isBankTransferEnabled = settingsService.canBankTransfer;

            self.requiresCreditCard = function () {
                return self.paymentMethod === "creditcard";
            };

            self.requiresPayPal = function () {
                return self.paymentMethod === "paypal";
            };

            self.requiresBankTransfer = function () {
                return self.paymentMethod === "banktransfer";
            };

            self.isValid = function () {
                switch (self.paymentMethod) {
                    case "creditcard":
                        return !!self.cardNumber &&
                            !!self.cardCVV &&
                            !self.cardExpiryError() &&
                            !!self.cardName &&
                            !self.cardPromotionError() &&
                            isValidBillingAddress() &&
                            self.isValidTermsAndConditions() &&
                            isValidAdditionalInfo();
                    case "paypal":
                        return self.paypalNonce && !self.paypalError && self.isValidTermsAndConditions();
                    case "banktransfer":
                    case "others":
                        return self.isValidTermsAndConditions();
                }
                return false;
            };

            self.cardExpiryError = function () {
                var month = self.cardExpiryMonth,
                    year = self.cardExpiryYear;

                if (!self.requiresCreditCard()) {
                    return false;
                }
                if (!_.isNumber(month) || !_.isNumber(year)) {
                    return $translate.instant('ORDER_PAYMENT.EXPIRY_DATE');
                }
                if (moment(new Date(year, month, 1)).isBefore()) {
                    return $translate.instant('ORDER_PAYMENT.NOT_EXPIRED');
                }
                return false;
            };

            self.countryError = function () {
                if (!self.billingAddress || !self.billingAddress.country) {
                    return $translate.instant('ORDER_PAYMENT.BILLING_COUNTRY');
                }
                return false;
            };

            self.cardPromotionError = function () {
                return productPromotionService.hasPromotedProduct() && productPromotionService.hasCardNumberRestriction() &&
                    !productPromotionService.meetsCardRestriction(self.cardNumber);
            };

            self.isValidTermsAndConditions = function () {
                return !settingsService.requiresTermsToBeAccepted || (self.termsAccepted && self.privacyPolicyAccepted);
            };

            function isValidBillingAddress() {
                if ($rootScope.paymentSetting) {
                    if ($rootScope.paymentSetting.isPayUArgentina) {
                        return !!(self.billingAddress && self.billingAddress.state);
                    }

                    if ($rootScope.paymentSetting.isAVSEnabled === true) {
                        return self.billingAddress && self.billingAddress.address && self.billingAddress.postalCode;
                    }
                }

                return true;
            }

            function isValidAdditionalInfo() {
                if ($rootScope.paymentSetting && $rootScope.paymentSetting.isPayUArgentina) {
                    return self.additionalInfo && self.additionalInfo.idType && self.additionalInfo.idNumber;
                }

                return true;
            }
        }
        return OrderPaymentDetails;
    }
})();

(function () {

    angular.module("consumerSessions")
        .factory("OrderItemCollection", orderItemCollectionFactory);

    /** @ngInject */
    function orderItemCollectionFactory() {

        function OrderItemCollection(values) {
            var self = this;
            self.items = [];

            _.extend(self, values);

            self.itemsIncludingPackageItems = function () {
                var items = self.items;
                var packages = angular.copy(_.filter(self.items, function (item) { return _.some(item.packageItems); }));
                items = _.filter(items, function (item) {
                    return !_.some(item.packageItems);
                });

                _.each(packages, function (item) {
                    _.each(item.packageItems, function (p) {
                        p.quantity = p.quantity * item.quantity;
                        p.bookingDate = item.bookingDate;
                    });
                    items = _.union(items, item.packageItems);
                });
                return items;
            }

            self.any = function () {
                return self.items.length > 0;
            };

            /**
             *
             * @param {*} item Ticket object
             * @param {string} date Date string in `YYYY-MM-DD` format
             * @returns
             */
            self.existingItems = function (item, date) {
                return _.filter(self.items, function (ticket) {
                    return ticket.id == item.id && (!item.sessionTime || ticket.sessionTime == item.sessionTime) &&
                        (!item.selectedDuration || item.selectedDuration == ticket.selectedDuration) &&
                        (!date || ticket.bookingDate == date);
                });
            }

            self.add = function (item, useItemQuantity) {
                var existing = _.first(self.existingItems(item, item.bookingDate));

                if (!existing || item.productTypeId == 'giftCard' || item.productTypeId === 'wallet' || item.productTypeId === 'cashlessCard' || item.hasUserDefinedCost) {
                    existing = _.extend({}, item, { quantity: 0 });
                    self.items.push(existing);
                }
                else if (item.additionalGuests) {
                    if (!existing.additionalGuests) {
                        existing.additionalGuests = 0;
                    }
                    existing.additionalGuests += item.additionalGuests;
                }

                var increment = item.minBookingLimit ? item.minBookingLimit : 1;
                var itemQuantity = (item.minBookingLimit && item.quantity + existing.quantity > item.minBookingLimit) ? item.quantity : item.minBookingLimit;
                existing.quantity += (useItemQuantity ? itemQuantity : increment);
            };

            self.remove = function (item, removeAll, quantity) {

                var existingTicket = _.first(self.existingItems(item, item.bookingDate));

                if (item.type) {
                    // TODO: this is for giftcards so we remove the correct giftcard, but really
                    // we want similar logic for everything, just need to make sure it's all good
                    existingTicket = item;
                }

                if (existingTicket) {
                    existingTicket.quantity -= quantity || 1;
                    if (existingTicket.quantity <= 0 || removeAll ||
                        (existingTicket.minBookingLimit && existingTicket.quantity < existingTicket.minBookingLimit)) {
                        _.remove(self.items, existingTicket);
                    }
                    else if (existingTicket.additionalGuests && existingTicket.additionalGuests > item.maxAdditionalGuests) {
                        existingTicket.additionalGuests = item.maxAdditionalGuests;
                    }
                }
            }

            self.clear = function () {
                self.items = [];
            };

            self.count = function () {
                return _.reduce(self.items, function (memo, item) { return memo + item.quantity; }, 0);
            };

            self.quantity = function (item, includeGroupSize, useParentId) {
                var source = self.items;
                if (_.isObject(item)) {
                    if (useParentId) {
                        source = _.where(source, { parentId: item.parentId });
                    }
                    else {
                        source = _.where(source, { id: item.id });
                    }

                    if (item.sessionTime) {
                        source = _.where(source, { bookingDate: item.bookingDate, productId: item.productId, sessionTime: item.sessionTime });
                    }
                }
                var quantity = item ? item.quantity * (includeGroupSize && item.requiredGroupSize ? item.requiredGroupSize : 1) : 0;
                _.each(source, function (ticket) {
                    quantity += (ticket.quantity * (includeGroupSize && ticket.requiredGroupSize ? ticket.requiredGroupSize : 1));
                });
                return quantity;
            };

            self.quantityOfTicketsForSession = function (item, orderTicketsNotInCart) {
                var ticketsNotInCart = angular.copy(orderTicketsNotInCart);
                _.each(ticketsNotInCart, function (item) {
                    if (item.inCartQuantity) {
                        item.quantity = item.quantity - item.inCartQuantity;
                    }
                });

                var source = _.union(_.where(self.itemsIncludingPackageItems(), { bookingDate: item.bookingDate, productId: item.productId, sessionTime: item.sessionTime }), ticketsNotInCart);
                var quantity = 0;
                _.each(source, function (ticket) {
                    quantity += (ticket.quantity * (ticket.requiredGroupSize ? ticket.requiredGroupSize : 1));
                });
                return quantity;
            }

            self.getAllTickets = function (orderTicketsNotInCart) {
                var ticketsNotInCart = angular.copy(orderTicketsNotInCart);
                _.each(ticketsNotInCart, function (item) {
                    if (item.inCartQuantity) {
                        item.quantity = item.quantity - item.inCartQuantity;
                    }
                });

                return _.union(angular.copy(self.itemsIncludingPackageItems()), ticketsNotInCart);
            }

            self.hasBookingRestriction = function (ticket, itemsToCheck, productSession) {
                for (var i = 0; i < itemsToCheck.length; i++) {
                    var itemToCheck = itemsToCheck[i];
                    var itemToCheckDateIndex = moment(itemToCheck.bookingDate).formatEn('YYYYMMDD');
                    var itemDateIndex = productSession ? productSession.dateIndex : ticket.availability[0].dateIndex;
                    var locations = productSession ? productSession.locations : ticket.locations;

                    if (itemToCheck.productId === ticket.productId || itemToCheckDateIndex != itemDateIndex) {
                        continue;
                    }

                    if (itemToCheck.sessionTime && productSession && itemToCheck.sessionTime != productSession.startTime) {
                        continue;
                    }

                    if (itemToCheck.sessionTime) {
                        var session = productSession
                            ? _.findWhere(itemToCheck.sessions, { startTime: productSession.startTime }) || _.findWhere(itemToCheck.sessions, { startTime: productSession.startTime })
                            : _.findWhere(itemToCheck.sessions, { startTime: itemToCheck.sessionTime });

                        if (session && checkBookingRestrictionLocations(session.locations, locations, ticket.parentId == itemToCheck.parentId)) {
                            return true;
                        }
                    } else {
                        if (checkBookingRestrictionLocations(itemToCheck.locations, locations, ticket.parentId == itemToCheck.parentId)) {
                            return true;
                        }
                    }
                }

                return false;
            }

            function checkBookingRestrictionLocations(itemToCheckLocations, itemLocations, sameParent) {
                if (hasBookingRestrictionLocations(itemToCheckLocations, itemLocations, 'singleTicketType')) {
                    return true;
                }

                if (!sameParent && hasBookingRestrictionLocations(itemToCheckLocations, itemLocations, 'singleProduct')) {
                    return true;
                }

                return false;
            }

            function hasBookingRestrictionLocations(ticketLocations, itemLocations, bookingRestriction) {
                var locations = _.where(ticketLocations, { bookingRestriction: bookingRestriction });
                var locationIds = _.pluck(locations, 'id');
                var itemLocationIds = _.pluck(itemLocations, 'id');

                return _.intersection(locationIds, itemLocationIds).length > 0;
            }

            self.quantityOfTicketsUsingSameCapacity = function (productSession, itemsToCheck) {
                if (!productSession.productLocationCapacityLocations) {
                    return null;
                }

                var ticketsUsingSameCapacity = _.filter(itemsToCheck, function (ticket) {

                    var ticketBookingDateIndex = moment(ticket.bookingDate).formatEn('YYYYMMDD');

                    if (productSession.dateIndex != ticketBookingDateIndex ||
                        productSession.startTime != ticket.sessionTime) {
                        return false;
                    }

                    ticket.quantity *= (ticket.requiredGroupSize ? ticket.requiredGroupSize : 1);
                    var ps = ticket;

                    if (ticket.sessionTime && !ps.productLocationCapacityLocations) {
                        ps = _.findWhere(ticket.sessions, { startTime: ticket.sessionTime });
                    }

                    if (!ps.productLocationCapacityLocations) {
                        return false;
                    }

                    if (ps.productLocationCapacity > productSession.productLocationCapacity) {

                        // either this ticket's quantity won't be considered or we need to reduce it
                        // so that the scenario described below is still valid
                        ticket.quantity -= (ps.productLocationCapacity - ticket.quantity);

                        if (productSession.productLocationCapacity < ps.productLocationCapacity - ticket.quantity) {
                            // let's say you have Jumper and Adult tickets - Jumper has party room (20) and jump area (60) locations while
                            // Adult just has some area.  that means capacity of Jumper is 20, so if you choose 20 Adult tickets, that should
                            // not mean Jumper is sold out, because Adult didn't actually use up any of the party room location
                            return false;
                        }
                    }

                    var intersection = _.intersection(productSession.productLocationCapacityLocations, ps.productLocationCapacityLocations);
                    return intersection.length > 0;
                });
                return _.sum(ticketsUsingSameCapacity, 'quantity');
            }

            self.total = function (item) {
                var source = self.items;
                if (_.isArray(item)) {
                    source = item;
                }
                else if (_.isObject(item)) {
                    source = _.where(source, { id: item.id });
                }
                return _.sum(source, function (i) {
                    return i.price * i.quantity;
                });
            }

            self.isValid = function () {
                var invalid = _.some(self.items, function (item) {
                    return item.minBookingLimit && item.minBookingLimit > 1 && item.quantity ? item.minBookingLimit > item.quantity : false;
                });
                return !invalid && self.items.length > 0;
            }

            self.parentIds = function () {
                return _.pluck(self.items, 'parentId');
            }

            self.parentIdsByDate = function () {
                return _.chain(self.items)
                    .groupBy('bookingDate')
                    .mapValues(function (val) { return _.pluck(val, 'parentId') })
                    .value();
            }

            self.termsAndConditions = function () {
                return _.compact(_.pluck(_.uniq(self.items, false, function (t) { return t.parentId }), "termsAndConditionsText"));
            }
        }

        return OrderItemCollection;
    }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .factory("OrderDelivery", orderDeliveryFactory);

        function orderDeliveryFactory() {

            function OrderDelivery(values) {
                var self = this;
                self.postageOptions = [];
                self.showDeliveryDetails = false;
                self.selectedPostage = null;
                self.deliveryName = null;
                self.addressPopulated = null;
                self.countryRestriction = null;
                self.address = null;
                self.suburb = null;
                self.postcode = null;
                self.country = null;
                self.state = null;
                self.city = null;

                _.extend(self, values);

                self.isValid = function (tickets) {
                    var giftcards = _.filter(_.where(tickets, { productTypeId: 'giftCard', type:'physical' }), noDifferentDelivery);
                    if (giftcards && giftcards.length > 0) {
                        // If there are physical giftcards without different delivery
                        var postage = self.selectedPostage ? self.selectedPostage.productPostageId : null;
                        var isNonPickup = self.selectedPostage ? !self.selectedPostage.isPickup : true;
                        var result = !!(postage != null && notEmpty(self.deliveryName));
                        if (result && isNonPickup) {
                            result = notEmpty(self.address);
                        }
                        return result;
                    }
                    return true;
                };

                function notEmpty(value) {
                    return _.isString(value) &&
                        /\S+/.test(value);
                }

                function noDifferentDelivery(value) {
                    return !value.details.differentDeliveryDetails;
                }
            }
            return OrderDelivery;
        }
})();

(function () {
    "use strict";

    angular.module("consumerSessions")
        .factory("OrderCustomerDetails", orderCustomerDetailsFactory);

    /** @ngInject */
    function orderCustomerDetailsFactory(settingsService, validation) {

        function OrderCustomerDetails(values) {
            var self = this;

            self.firstName = "";
            self.lastName = "";
            self.email = "";
            self.phone = "";
            self.postcode = "";
            self.acceptMarketing = !!settingsService.acceptMarketingEmailByDefault;
            self.acceptMarketingSMS = !!settingsService.acceptMarketingSMSByDefault;
            self.termsAccepted = false;

            _.extend(self, values);

            if (settingsService.isPlayground) {
                self.termsAccepted = true;
            }

            self.isValid = function (tickets) {
                var required = [
                    self.firstName,
                    self.lastName,
                    self.email,
                    self.phone
                ];

                if (settingsService.capturePostcode()) {
                    required.push(self.postcode);
                }

                var result = _.all(required, notEmpty) &&
                    validEmail(self.email) &&
                    validPhone(self.phone) &&
                    self.termsAccepted;

                if (tickets && result) {
                    var giftcards = _.where(tickets, { productTypeId: 'giftCard' });
                    if (_.some(giftcards)) {
                        result = _.all(_.pluck(giftcards, 'details.name'), notEmpty) &&
                            _.all(_.pluck(_.where(giftcards, { type: 'digital' }), 'details.email'), validEmail) &&
                            _.all(_.pluck(_.filter(_.where(giftcards, { type: 'physical' }), notPickupAndDiffDelivery), 'details.address.address'), notEmpty);
                    }
                }

                return result;
            };

            self.phoneRegex = function () {
                return phoneRegex;
            };

            function notPickupAndDiffDelivery(value) {
                return !value.details.postage.isPickup && value.details.differentDeliveryDetails;
            }

            function notEmpty(value) {
                return (_.isString(value) && /\S+/.test(value));
            }

            function validEmail(value) {
                return _.isString(value) &&
                    validation.emailRegex.test(value);
            }
            function validPhone() {
                //return _.isString(value) &&
                //    phoneRegex.test(value);
                return true;
            }
        }
        return OrderCustomerDetails;
    }
})();

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["angularLoad"] = factory();
	else
		root["angularLoad"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* angular-load.js / v0.4.2 / (c) 2014, 2015, 2016 Uri Shaked / MIT Licence */

angular.module('angularLoad', []).service('angularLoad', ['$document', '$q', '$timeout', function ($document, $q, $timeout) {
	var document = $document[0];
	var promises = {};

	function loader(createElement) {
		return function (url) {
			if (typeof promises[url] === 'undefined') {
				var deferred = $q.defer();
				var element = createElement(url);

				element.onload = element.onreadystatechange = function (e) {
					if (element.readyState && element.readyState !== 'complete' && element.readyState !== 'loaded') {
						return;
					}

					$timeout(function () {
						deferred.resolve(e);
					});
				};
				element.onerror = function (e) {
					$timeout(function () {
						deferred.reject(e);
					});
				};

				promises[url] = deferred.promise;
			}

			return promises[url];
		};
	}

	/**
  * Dynamically loads the given script
  * @param src The url of the script to load dynamically
  * @returns {*} Promise that will be resolved once the script has been loaded.
  */
	this.loadScript = loader(function (src) {
		var script = document.createElement('script');

		script.src = src;

		document.body.appendChild(script);
		return script;
	});

	/**
  * Dynamically loads the given CSS file
  * @param href The url of the CSS to load dynamically
  * @returns {*} Promise that will be resolved once the CSS file has been loaded.
  */
	this.loadCSS = loader(function (href) {
		var style = document.createElement('link');

		style.rel = 'stylesheet';
		style.type = 'text/css';
		style.href = href;

		document.head.appendChild(style);
		return style;
	});

	/**
  * Dynamically unloads the given CSS file
  * @param href The url of the CSS to unload dynamically
  * @returns boolean that will be true once the CSS file has been unloaded successfully or otherwise false.
  */
	this.unloadCSS = function (href) {
		delete promises[href];
		var docHead = document.head;
		if (docHead) {
			var targetCss = docHead.querySelector('[href="' + href + '"]');
			if (targetCss) {
				targetCss.remove();
				return true;
			}
		}
		return false;
	};
}]);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(0);

exports.default = 'angularLoad';

/***/ })
/******/ ]);
});
String.prototype.format = function () {
    var pattern = /\{\d+\}/g;
    var args = arguments;
    return this.replace(pattern, function (capture) { return args[capture.match(/\d+/)]; });
};

if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, ''); 
    }
}

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .run(runBlock);

    var dataLayer = window.dataLayer = window.dataLayer || [];

    /** @ngInject */
    function runBlock($rootScope, $state, orderService, $q, $log, validation, $anchorScroll, angularLoad, rollerBaseUrl, settingsService) {

        extendMoment();

        var apiKey = settingsService.venueSlug;

        $q.all([
            angularLoad.loadCSS(rollerBaseUrl.cdn + 'apps/payment/v2/adyen.css?v=' + moment().formatEn('YYYYMMDDHHmm')),
            angularLoad.loadScript(rollerBaseUrl.cdn + 'apps/payment/v2/rollerpayment-component.popup.min.js?v=' + moment().formatEn('YYYYMMDDHHmm'))
        ]).then(function () {
            var cellId = settingsService.getCellId();
            var customHeaders = {
                'X-CorrelationId': settingsService.correlationId
            };

            if (cellId) {
                customHeaders['X-Cell-Id'] = cellId;
            }

            if (window.originId) {
                customHeaders['X-Origin-Id'] = window.originId;
            }

            rollerpayment.bootstrapPayment(apiKey, extractEnvironment(), null, customHeaders)
                .then(function (paymentSetting) {
                    $rootScope.paymentSetting = paymentSetting;
                    $rootScope.$broadcast('paymentLoaded');
                });
        });

        /*eslint angular/on-watch:0 */
        $rootScope.$on("$stateChangeStart",
            function (event, toState, toParams, fromState) {
                var isHandlingPaymentResponse = toState.name === 'callback' || (toState.name === 'payment' && fromState.name === 'callback');

                if (toState.name === 'error' || toState.name === 'view-giftcard' || isHandlingPaymentResponse) {
                    return;
                }
                if (!orderService.canTransitionTo(toState.name)) {
                    $log.debug("Invalid order state for state", toState.name);
                    event.preventDefault();
                    var stateNames = _.pluck($state.get(), 'name');
                    var firstValidStateName = _.find(stateNames, orderService.canTransitionTo);
                    if (firstValidStateName) {
                        $state.go(firstValidStateName);
                        return;
                    }
                    // Not sure what we do here?
                }
                toParams.fromStateName = fromState.name;
            });

        handleRecaptchaInitialisationCallback($q);

        $rootScope.$on("$stateChangeSuccess", function () { $anchorScroll(); });

        $rootScope.validation = validation;
        $log.debug('runBlock end');


    }

    function handleRecaptchaInitialisationCallback($q) {
        var deferred = $q.defer();

        // this promise is used as a guard before calling the recaptcha render function
        window.recaptchaLoaded = deferred.promise;

        // resolve the above promise once the recaptcha script has triggered the load callback
        window.recaptchaLoadCallback = function () {
            deferred.resolve();
        };

        var recaptchaScriptLoader = document.createElement('script');
        recaptchaScriptLoader.src = '//www.google.com/recaptcha/api.js?onload=recaptchaLoadCallback&render=explicit';
        recaptchaScriptLoader.type = 'text/javascript';
        recaptchaScriptLoader.async = 'async';
        recaptchaScriptLoader.defer = 'defer';
        document.body.appendChild(recaptchaScriptLoader);
    }

    function extendMoment() {
        if (_.isUndefined(moment.prototype.formatEn)) {
            moment.prototype.formatEn = function (format) {
                return this.locale('en').format(format);
            }
        }
    }

    function extractEnvironment() {
        var host = window.location.host.toLowerCase();
        var isRoller = /\.roller\.app/ig.test(host);

        if (host.indexOf('.roller.local') > 0 || host.indexOf('localhost') === 0) {
            return 'local';
        }
        else if (isRoller) {
            return host.split('.')[1];
        }
        else if (env.baseUrls.api) {
            var apiEnv = /api\.((zeus|ares|hera|odin|thor|loki|iris|nyx|dev|rel|stag|play|haveablast)\.)?roller\.app/ig.exec(env.baseUrls.api)[2];

            return apiEnv ? apiEnv : 'prod';
        }

        return 'unknown';
    }

})();

(function () {
    'use strict';

    angular
        .module('consumerSessions')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('error', {
                url: '/error',
                templateUrl: 'app/views/error.html',
                controller: 'ErrorController',
                controllerAs: 'vm'
            })
            .state('callback', {
                url: '/callback',
                templateUrl: 'app/views/callback.html',
                controller: 'CallbackController',
                controllerAs: 'vm',
                data: {
                    hidden: true
                }
            })
            .state('view-giftcard', {
                url: '/redemptions/:uniqueBookingId/:giftcardNumber',
                templateUrl: 'app/views/view-giftcard.html',
                controller: 'ViewGiftcardController',
                controllerAs: 'vm',
                data: {
                    hidden: true
                }
            })
            .state('sessions', {
                abstract: true,
                url: '/sessions',
                templateUrl: 'app/views/sessions.html',
                controller: 'WizardController',
                controllerAs: 'vm'
            })
            .state('sessions.home', {
                url: '',
                templateUrl: 'app/views/sessions/sessions.home.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    order: 1,
                    displayName: 'Products',
                    translationKey: 'INDEX.WIZARD.TITLE.PRODUCTS',
                    progress: 25
                },
                params: {
                    isGroupTwo: false
                }
            })
            .state('sessions.home2', {
                url: '',
                templateUrl: 'app/views/sessions/sessions.home.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                data: {
                    order: 1,
                    displayName: 'Products',
                    translationKey: 'INDEX.WIZARD.TITLE.PRODUCTS',
                    progress: 25,
                    hidden: true
                },
                params: {
                    isGroupTwo: true
                }
            })
            .state('sessions.addons', {
                url: '/addons',
                templateUrl: 'app/views/sessions/sessions.addons.html',
                controller: 'AddOnsController',
                controllerAs: 'vm',
                data: {
                    order: 2,
                    displayName: 'Add-Ons',
                    translationKey: 'INDEX.WIZARD.TITLE.ADDONS',
                    progress: 25
                }
            })
            .state('sessions.details', {
                url: '/details',
                templateUrl: 'app/views/sessions/sessions.details.html',
                controller: 'DetailsController',
                controllerAs: 'vm',
                data: {
                    order: 3,
                    displayName: 'Details',
                    translationKey: 'INDEX.WIZARD.TITLE.DETAILS',
                    progress: 50,
                    nextButtonTextTranslationKey: 'SESSIONS.DETAILS.CONTINUE_TO_PAYMENT'                    
                }
            })
            .state('sessions.payment', {
                url: '/payment',
                templateUrl: 'app/views/sessions/sessions.payment.html',
                controller: 'PaymentController',
                controllerAs: 'vm',
                data: {
                    order: 4,
                    displayName: 'Pay',
                    nextButtonText: 'Confirm Payment',
                    nextButtonTextTranslationKey: 'INDEX.ROUTE.CONFIRM_PAYMENT',
                    translationKey: 'INDEX.WIZARD.TITLE.PAY',
                    progress: 75
                },
                params: {
                    paymentErrors: null,
                    giftcardCode: null,
                    discountCode: null
                }
            })
            .state('sessions.success', {
                url: '/success',
                templateUrl: 'app/views/sessions/sessions.success.html',
                controller: 'SuccessController',
                controllerAs: 'vm',
                data: {
                    order: 5,
                    displayName: 'Success!',
                    hidden: true,
                    progress: 101
                }
            });

        $urlRouterProvider.otherwise('/sessions');
    }
})();

(function () {
    "use strict";

    angular
        .module("consumerSessions")
        .constant("braintreeMerchantId", "qmvfnhk8dzwvmvh6")
        .constant('env', window.env)
        .constant("rollerBaseUrl", {
            legacyApi: window.env.baseUrls.api.replace(/\/?$/, "/"),
            api: window.env.baseUrls.api.substring(0, window.env.baseUrls.api.length - 4).replace(/\/?$/, "/"), // when we update env.js, this will need to change
            forms: window.env.baseUrls.forms ? window.env.baseUrls.forms.replace(/\/?$/, "/") : 'https://forms.rollerdigital.com/',
            cdn: window.env.baseUrls.cdn ? window.env.baseUrls.cdn.replace(/\/?$/, "/") : 'https://s3-ap-southeast-2.amazonaws.com/staging-rollerdigital-cdn/'
        })
        .constant("clientTokenPath", window.env.baseUrls.api.replace(/\/?$/, "") + "/payment/clienttoken")
        .constant('insideIframe', window.self !== window.top)
        .constant('validation', {
            emailRegex: RollerConstants.emailRegex,
            phoneRegex: /^\s*(\+\d{1,2}\s?\d{2,3}|\(?0\d{2,3}\)?)\s?(\d[-\s]?){6,20}\s*/
        })
        .constant('productTypes', {
            giftCard: 'giftCard',
            wallet: 'wallet',
            cashlessCard: 'cashlessCard',
            package: 'package',
            addOn: 'addOn'
        });
})();

(function () {
    'use strict';

    angular.module('consumerSessions')
        .config(config)
        .factory("HttpRequestInterceptor", httpInterceptor);

    /** @ngInject */
    function config($compileProvider, $logProvider, $httpProvider, $analyticsProvider) {
        var isDebugMode = !!(function (unminified) { }).toString().match(/unminified/);
        $logProvider.debugEnabled(isDebugMode);
        $compileProvider.debugInfoEnabled(isDebugMode);

        $httpProvider.interceptors.push("HttpRequestInterceptor");
        //turn off auto page view tracking
        $analyticsProvider.virtualPageviews(false);
    }

    /** @ngInject */
    function httpInterceptor($q, $log, $injector) {
        return {
            request: function (config) {
                if (!config.headers["Content-Type"] || config.headers["Content-Type"].indexOf('multipart/form-data') < 0) {
                    var settingsService = $injector.get('settingsService');
                    var apiKey = settingsService.venueSlug;

                    config.headers["X-Api-Key"] = apiKey;
                    config.headers["X-CorrelationId"] = settingsService.correlationId;

                    var cellId = settingsService.getCellId();

                    if (cellId) {
                        config.headers["X-Cell-Id"] = cellId;
                    }

                    if (window.originId) {
                        config.headers["x-origin-id"] = window.originId;
                    }
                }

                return config;
            },
            requestError: function (rejection) {
                $log.error(rejection);
                return $q.reject(rejection);
            },
            responseError: function (rejection) {
                if (rejection.config && rejection.config.url === 'https://sec.paymentexpress.com/pxmi3/pxfusionauth') {
                    $q.when('Payment Success');
                } else {
                    $log.error(rejection);
                    return $q.reject(rejection);
                }
            }
        };
    }
})();

(function () {
    "use strict";

    var injector = angular.injector(["ng"]);
    var $window = injector.get("$window");
    var _settings;

    getVenueSettings()
        .then(injectCssOverrides)
        .then(injectFontOverrides)
        .then(bootstrap);

    function bootstrap() {
        angular.element(document).ready(function () {
            angular.bootstrap(document, ['consumerSessions']);
        });
    }

    function loadScript(url, onLoad, onError) {
        if (url) {
            var script = document.createElement("script");
            script.src = url;
            script.onload = onLoad;
            script.onerror = onError;

            document.body.appendChild(script);
        }
    }

    function getVenueSettings() {
        var env = window.env;
        var $http = injector.get("$http");
        var deferred = injector.get("$q").defer();
        var venueSlug = getVenueSlug();
        var checkout = getCheckoutFromUrl();
        var productId = getProductIdFromUrl();
        var originId = getCookie('Origin-Id');
        var cell = getCookie('Cell') || window.cell;
        
        var headers = {
            'X-Api-Key': venueSlug
        };

        if (originId) {
            window.originId = originId;
            headers['x-origin-id'] = originId;
        }

        if (cell) {
            headers['x-cell-id'] = cell;
        }

        if (_settings) {
            deferred.resolve(_settings);
        }
        else {
            $http({
                url: env.baseUrls.api + "/venues/configurations" + (checkout ? '?group=' + checkout : ''),
                method: 'GET',
                headers: headers
            }).then(function (response) {
                _settings = response.data;
                _settings.venueSlug = venueSlug;
                _settings.checkoutSlug = checkout;
                _settings.productId = productId;

                if (_settings.momentLocale) {

                    moment.locale(_settings.momentLocale);

                    var momentLocaleUrl = env.baseUrls.cdn + '/scripts/moment/2.22.1/locale/' + _settings.momentLocale.toLowerCase() + '.js';
                    var onLoad = function() {
                        _settings.canShowCalendar = true;
                    }

                    loadScript(momentLocaleUrl, onLoad, onLoad);
                }
                else {
                    _settings.canShowCalendar = true;
                }

                if (_settings.venueCountryLocale) {

                    var ngLocaleUrl = env.baseUrls.cdn + '/scripts/angular-i18n/1.3.15/angular-locale_' + _settings.venueCountryLocale.toLowerCase() + '.js';

                    loadScript(ngLocaleUrl);
                }

                window.settings = _settings;
                deferred.resolve(response.data);

                if(response.data.isMaintenanceMode) {
                    showMaintenanceMode($http);
                }

                if (response.data.analyticsScripts) {
                    $(response.data.analyticsScripts).appendTo(document.body);
                }
            },
            function(err) {
                console.error(err);
                switch(err.status) {
                    case 503: {
                        showMaintenanceMode($http);
                        break;
                    }
                    default: {
                        showGenericError($http);
                    }
                }
                deferred.reject
            });
        }

        return deferred.promise;
    }

    function showMaintenanceMode($http) {
        $http({ url: '/app/views/maintenance.html' }).then(
            function (req) {
                document.querySelector('html').innerHTML = req.data;
            }
        );
    }

    function showGenericError($http) {
        $http({ url: '/app/views/generic-error.html' }).then(
            function (req) {
                document.querySelector('html').innerHTML = req.data;
            }
        );
    }

    function isUsingSubDomain() {
        var host = $window.location.host;
        return (host.indexOf('.ecom.') > 0 || host.indexOf('.checkout.') > 0);
    }

    function isUsingCustomDomain() {
        var host = $window.location.host;
        return (host.indexOf('roller.app') < 0 && host.indexOf('roller.local') < 0 && host.indexOf('localhost') < 0)
    }

    function getCheckoutFromUrl() {

        if (/\/product\/\d+/ig.test($window.location.pathname)) {
            return undefined;
        }

        return (isUsingSubDomain() || isUsingCustomDomain()) ? $window.location.pathname.split('/')[2] : $window.location.pathname.split('/')[3];
    }

    function getVenueSlug() {

        if (isUsingCustomDomain()) {
            return getCookie('Current-Venue');
        }

        return isUsingSubDomain() ? $window.location.host.split('.')[0] : $window.location.pathname.split('/')[1];
    }

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }

    function getProductIdFromUrl() {
        var pathTokens = window.location.pathname.split('/');

        if (pathTokens.length && ((pathTokens[pathTokens.length - 2] || '').toLowerCase() === 'product') && /^\d+$/.test(_.last(pathTokens))) {
            return _.last(pathTokens);
        }

        return undefined;
    }

    function injectCssOverrides() {
        var StyleMap = {
            "button_Primary": ".btn--green",
            "button_Secondary": ".btn--grey",
            "font_Body": "body",
            "heading_H1": "h1",
            "heading_H2": "h2",
            "heading_H3": "h3",
            "heading_H4": "h4",
            "link": "a",
            "remaining_Bar": ".session__inner",
            "duration_Single_Option": ".feature--duration-single-option",
            "display_Remaining_Capacity": ".feature--display-remaining-capacity",
            "hide_Calendar": ".feature--hide-calendar",
            "show_Tickets_Calendar": ".feature--show-tickets-calendar",
            "accordion_Hover_And_Open": ".accordion__header.is-open, .accordion__header:hover, .accordion__body",
            "promotion_Banner": ".banner--amex .banner__copy",
            "promotion_Banner_Outer": ".banner--amex",
        }
        var style = document.createElement('style');
        style.type = "text/css";

        var cssOverrides = _settings.cssOverrides;

        var styles = [];
        _.forEach(cssOverrides, function (value) {
            var element = value.styleTypeId;

            _.mapKeys(StyleMap, function (value, key) {
                if (key == element) {
                    element = value;
                }
            });

            var result = element + '{' + value.cssProperty + ':' + value.cssValue + '}';
            styles.push(result)

        });
        style.innerHTML = styles.join('');
        document.head.appendChild(style);
    }

    function injectFontOverrides() {
        var fontImports = _settings.fontImports;

        _.forEach(fontImports, function (value) {
            var link = document.createElement('link');
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = value;

            document.head.appendChild(link);
        });
    }
})();

angular.module("consumerSessions").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/callback.html","<div class=\"flexbox flexbox--fixed flexbox--body panel panel--soft-ends flush--portable\" ng-class=\"{\'is-embedded\' : vm.insideIframe, \'push--ends\' : !vm.businessWebsite}\"><div class=\"flexbox__item one-whole border\"><div class=\"panel--main panel--white panel--empty _radius _radius-flush--portable\" ng-class=\"{\'_border--left _border--right _border--ends\' : !vm.settings.backgroundImage || vm.insideIframe}\"><div><loader class=\"spinner--dark\" loading-text=\"{{\'SESSIONS.LOADING\' | translate }}\" is-loading=\"vm.loading\"></loader></div></div></div></div>");
$templateCache.put("app/views/error.html","<div class=\"flexbox flexbox--fixed flexbox--body panel panel--soft-ends flush--portable _border--top push--ends\"><div class=\"flexbox__item one-whole border text--center _border--top panel--main panel--white panel--empty _radius _radius-flush--portable\"><p class=\"push--top push-half--bottom\">The page failed to load correctly. Please refresh to try again.</p><a ng-hide=\"vm.hideBranding\" class=\"brand--roller\" href=\"https://www.roller.software?utm_campaign=Powered by ROLLER Referral&utm_source=checkout\" target=\"_blank\"><span class=\"brand__text\" translate=\"SESSIONS.POWERED_BY\"></span> <img src=\"/app/img/logo@2x.png\" class=\"logo--roller\" height=\"22\" alt=\"ROLLER\"></a></div></div>");
$templateCache.put("app/views/generic-error.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Roller - Maintenance</title><link href=\"//fonts.googleapis.com/css?family=Lato:300,400,700\" rel=\"stylesheet\" type=\"text/css\"><style type=\"text/css\">\n        /*------------------------------------*\\\n            RESET\n        \\*------------------------------------*/\n        /* http://meyerweb.com/eric/tools/css/reset/\n            v2.0b1 | 201101\n            NOTE:WORK IN PROGRESS\n            USE WITH CAUTION AND TEST WITH ABANDON */\n\n        html, body, div, span, applet, object, iframe,\n        h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n        a, abbr, acronym, address, big, cite, code,\n        del, dfn, em, img, ins, kbd, q, s, samp,\n        small, strike, strong, sub, sup, tt, var,\n        b, u, i, center,\n        dl, dt, dd, ol, ul, li,\n        fieldset, form, label, legend,\n        table, caption, tbody, tfoot, thead, tr, th, td,\n        article, aside, canvas, details, figcaption, figure,\n        footer, header, hgroup, menu, nav, section, summary,\n        time, mark, audio, video {\n            margin: 0;\n            padding: 0;\n            border: 0;\n            outline: 0;\n            font-size: 100%;\n            font: inherit;\n            vertical-align: baseline;\n        }\n        /* HTML5 display-role reset for older browsers */\n        article, aside, details, figcaption, figure,\n        footer, header, hgroup, menu, nav, section {\n            display: block;\n        }\n\n        body {\n            line-height: 1;\n        }\n\n        ol, ul {\n            list-style: none;\n        }\n\n        blockquote, q {\n            quotes: none;\n        }\n\n            blockquote:before, blockquote:after,\n            q:before, q:after {\n                content: ’’;\n                content: none;\n            }\n        /* remember to define visible focus styles!\n        :focus{\n            outline:?????;\n        } */\n\n        /* remember to highlight inserts somehow! */\n        ins {\n            text-decoration: none;\n        }\n\n        del {\n            text-decoration: line-through;\n        }\n\n        table {\n            border-collapse: collapse;\n            border-spacing: 0;\n        }\n\n        /*------------------------------------*\\\n            $MAIN\n        \\*------------------------------------*/\n        /* GO! */\n\n        html, body {\n            width: 100%;\n            height: 100%;\n        }\n\n        body {\n            display: table;\n        }\n\n        .cell {\n            display: table-cell;\n            vertical-align: middle;\n            text-align: center;\n        }\n\n        body {\n            font-family: \'Lato\';\n            color: #333;\n        }\n\n        h1 {\n            font-size: 24px;\n            font-weight: normal;\n            margin: 1rem 0;\n        }\n\n        p {\n            font-weight: lighter;\n        }\n    </style></head><body><div class=\"cell\"><img src=\"//cdn.rollerdigital.com/assets/logos/roller-full-color-374x66.png\"><h1>Sorry, looks like something went wrong.</h1><p>Please check back shortly.</p></div></body></html>");
$templateCache.put("app/views/maintenance.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Roller - Maintenance</title><link href=\"//fonts.googleapis.com/css?family=Lato:300,400,700\" rel=\"stylesheet\" type=\"text/css\"><style type=\"text/css\">\n        /*------------------------------------*\\\n            RESET\n        \\*------------------------------------*/\n        /* http://meyerweb.com/eric/tools/css/reset/\n            v2.0b1 | 201101\n            NOTE:WORK IN PROGRESS\n            USE WITH CAUTION AND TEST WITH ABANDON */\n\n        html, body, div, span, applet, object, iframe,\n        h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n        a, abbr, acronym, address, big, cite, code,\n        del, dfn, em, img, ins, kbd, q, s, samp,\n        small, strike, strong, sub, sup, tt, var,\n        b, u, i, center,\n        dl, dt, dd, ol, ul, li,\n        fieldset, form, label, legend,\n        table, caption, tbody, tfoot, thead, tr, th, td,\n        article, aside, canvas, details, figcaption, figure,\n        footer, header, hgroup, menu, nav, section, summary,\n        time, mark, audio, video {\n            margin: 0;\n            padding: 0;\n            border: 0;\n            outline: 0;\n            font-size: 100%;\n            font: inherit;\n            vertical-align: baseline;\n        }\n        /* HTML5 display-role reset for older browsers */\n        article, aside, details, figcaption, figure,\n        footer, header, hgroup, menu, nav, section {\n            display: block;\n        }\n\n        body {\n            line-height: 1;\n        }\n\n        ol, ul {\n            list-style: none;\n        }\n\n        blockquote, q {\n            quotes: none;\n        }\n\n            blockquote:before, blockquote:after,\n            q:before, q:after {\n                content: ’’;\n                content: none;\n            }\n        /* remember to define visible focus styles!\n        :focus{\n            outline:?????;\n        } */\n\n        /* remember to highlight inserts somehow! */\n        ins {\n            text-decoration: none;\n        }\n\n        del {\n            text-decoration: line-through;\n        }\n\n        table {\n            border-collapse: collapse;\n            border-spacing: 0;\n        }\n\n        /*------------------------------------*\\\n            $MAIN\n        \\*------------------------------------*/\n        /* GO! */\n\n        html, body {\n            width: 100%;\n            height: 100%;\n        }\n\n        body {\n            display: table;\n        }\n\n        .cell {\n            display: table-cell;\n            vertical-align: middle;\n            text-align: center;\n        }\n\n        body {\n            font-family: \'Lato\';\n            color: #333;\n        }\n\n        h1 {\n            font-size: 24px;\n            font-weight: normal;\n            margin: 1rem 0;\n        }\n\n        p {\n            font-weight: lighter;\n        }\n    </style></head><body><div class=\"cell\"><img src=\"//cdn.rollerdigital.com/assets/logos/roller-full-color-374x66.png\"><h1>We\'re currently doing some maintenance</h1><p>Please check back shortly.</p></div></body></html>");
$templateCache.put("app/views/sessions.html","<div class=\"flexbox flexbox--fixed flexbox--body panel panel--soft-ends flush--portable\" ng-class=\"{\'is-embedded\' : vm.insideIframe, \'push--ends\' : !vm.businessWebsite, \'flexbox--body--640\' : vm.isActive(\'sessions.success\')}\"><div class=\"flexbox__item one-whole border\" ng-class=\"{\'cart-is-visible\': vm.isCartVisible(), \'panel--success\': vm.order.isProcessed()}\"><div class=\"panel--main panel--white panel--empty _radius _radius-flush--portable\" ng-class=\"{\'_border--left _border--right _border--ends\' : !vm.settings.backgroundImage || vm.insideIframe}\"><div ng-if=\"vm.businessWebsite\"><a class=\"cf one-whole link--back epsilon\" href=\"{{vm.businessWebsiteUrl}}\"><span class=\"float--left link__text\"><span translate=\"SESSIONS.BACK_TO\"></span> {{vm.businessWebsite}}</span></a></div><div class=\"header\" ng-show=\"vm.showImage && vm.headerImage\"><img ng-src=\"{{ vm.headerImage }}\" class=\"one-whole _display--block\" alt=\"\"></div><div ng-if=\"vm.showPromotionBanner()\" ng-include=\"vm.promotion().contentUrl()\"></div><div class=\"progress-bar\" ng-style=\"vm.setProgressPercent()\"></div><div class=\"wizard\" ng-show=\"vm.showNavigation()\"><div class=\"wizard__section--top\"><p class=\"wizard__label\"><span class=\"material-icons _cursor--pointer\" ng-if=\"vm.showNavigation() && vm.previous()\" ng-click=\"vm.movePrevious()\">arrow_back</span><step-counter></step-counter></p><cart-icon class=\"visuallyhidden--desk\" ng-if=\"vm.showNavigation()\"></cart-icon></div><div class=\"wizard__section--bottom\"><h2 class=\"wizard__title\" translate=\"{{ vm.activeStateTranslationKey() }}\"></h2><ticket-timer ng-if=\"vm.useTicketTimer()\" seconds=\"vm.timerSeconds\" allow-time-extension=\"vm.allowTimeExtension\" time-extension-response-in-seconds=\"vm.timeExtensionResponseInSeconds\" timeout=\"vm.timeout\" booking=\"vm.order.getBooking\"></ticket-timer></div></div><div ui-view=\"\"></div><div class=\"btn--group soft-mid cf\" ng-show=\"vm.showNavigation()\"><button qa-id=\"buttonBack\" type=\"button\" class=\"btn btn--soft btn--grey btn--responsive push-mid--bottom--portable text--center btn--navigation\" ng-click=\"vm.movePrevious()\" ng-show=\"vm.previous()\" translate=\"SESSIONS.BACK\"></button> <button qa-id=\"buttonContinue\" type=\"button\" ng-show=\"!vm.hideNextButton()\" class=\"btn btn--soft btn--green btn--responsive push-mid--bottom--portable text--center float--right btn--navigation\" ng-class=\"{\'one-whole\': !vm.previous(), \'muted\': !vm.canMoveNext()}\" ng-click=\"vm.moveNext()\"><span ng-hide=\"vm.order.inProgress\" translate=\"{{ vm.nextButtonText() }}\" translate-values=\"{ amount: \'{{vm.order.total() | rollerCurrency}}\' }\"></span> <span class=\"flex--center\" ng-show=\"vm.order.inProgress\"><img src=\"https://cdn.rollerdigital.com/assets/icons/loaders/spinner.png\" class=\"spinner\" alt=\"loading spinner\"></span></button></div><div class=\"banner--cart panel--dark cf\" ng-show=\"vm.itemCount() > 0\"><a href=\"#\" ng-click=\"showCart()\" class=\"banner--cart__link\"><span class=\"material-icons md-16 banner--cart__link__icon\">shopping_cart</span> <span class=\"banner--cart__link__text\">{{itemCount()}} <span translate=\"SESSIONS.ITEMS\"></span> - {{ order.subTotal() | rollerCurrency }}</span></a> <button type=\"button\" class=\"btn radius btn--green btn--tiny btn--radius banner--cart__button\" ng-click=\"vm.moveNext()\" translate=\"{{ vm.nextButtonText() }}\" translate-values=\"{ amount: \'{{vm.order.total() | rollerCurrency}}\' }\"></button></div><div class=\"flex flex--between soft _border--top\" ng-hide=\"vm.settings.hideRollerBranding && !vm.content(\'policy_url\') && !vm.withdrawUrl\"><div class=\"one-whole\" ng-if=\"vm.policyUrl\"><a class=\"link text--small\" href=\"{{ vm.policyUrl }}\" translate=\"TERMS_AND_CONDITIONS.PRIVACY_POLICY\" target=\"_blank\"></a></div><div class=\"one-whole\" ng-if=\"vm.withdrawUrl\"><a class=\"link text--small\" href=\"{{ vm.withdrawUrl }}\" translate=\"TERMS_AND_CONDITIONS.WITHDRAW_CONTRACT\" target=\"_blank\" rel=\"noopener noreferrer\"></a></div><a class=\"brand--roller\" href=\"https://www.roller.software?utm_campaign=Powered by ROLLER Referral&utm_source=checkout\" target=\"_blank\" ng-hide=\"vm.settings.hideRollerBranding\"><span class=\"brand__text\" translate=\"SESSIONS.POWERED_BY\"></span> <img src=\"/app/img/logo@2x.png\" class=\"logo--roller\" height=\"14\" alt=\"ROLLER\"></a></div></div></div><div class=\"flexbox__item flexbox__item--top layout__sidebar\" ng-hide=\"vm.order.isProcessed() || vm.isPaymentInProgress()\" ng-class=\"{\'visuallyhidden--portable\': !vm.isCartVisible()}\"><div class=\"panel flush-sides--portable push--left\" ng-class=\"{\'panel--fixed\': !vm.widgetUsedExternally, \'visuallyhidden--portable\': !vm.isCartVisible()}\"><order-summary ng-if=\"!vm.order.isProcessed()\"></order-summary></div></div></div>");
$templateCache.put("app/views/view-giftcard.html","<div class=\"redeem__wrapper\" ng-if=\"!vm.isLoading\"><div class=\"redeem\"><header class=\"redeem__header\"><div class=\"logo__wrapper\" ng-show=\"vm.settings.venueLogoUrl\"><img ng-src=\"{{vm.settings.venueLogoUrl}}\"></div><h2 ng-hide=\"vm.settings.venueLogoUrl\">{{vm.settings.venueName}}</h2></header><div class=\"redeem__inner\"><div class=\"redeem__greeting\" ng-if=\"!vm.giftcard.redemptionText\"><h1>{{\'VIEW_GIFTCARD.HI\' | translate : { customerName: vm.giftcard.customerName} }}</h1><h1>{{\'VIEW_GIFTCARD.PRESENT_THIS\' | translate}}</h1></div><div class=\"redeem__greeting\" ng-if=\"vm.giftcard.redemptionText\"><h1>{{vm.giftcard.redemptionText}}</h1></div><div class=\"giftcard\"><div class=\"giftcard__image\" ng-if=\"vm.giftcard.imageUrl\"><img ng-src=\"{{vm.giftcard.imageUrl}}\" alt=\"gift card image\"></div><div class=\"giftcard__details\"><div><img class=\"giftcard__barcode\" ng-src=\"{{vm.giftcard.qrCodeUrl}}\" alt=\"Barcode\"><p class=\"giftcard__number flush\">#{{vm.giftcardNumber}}</p></div><div><p class=\"giftcard__balance\">{{vm.giftcard.balance | rollerCurrency}}</p><p class=\"giftcard__expiry\" ng-if=\"vm.giftcard.expiryDate\">{{\'VIEW_GIFTCARD.EXPIRES\' | translate: { expiryDate: (vm.giftcard.expiryDate | date) } }}</p><p class=\"giftcard__expiry\" ng-if=\"!vm.giftcard.expiryDate\">{{\'VIEW_GIFTCARD.NO_EXPIRY\' | translate}}</p><div class=\"giftcard__buttons hide--print\"><button type=\"button\" class=\"btn btn--primary btn--print\" ng-click=\"vm.giftcard.print()\">{{\'VIEW_GIFTCARD.PRINT_CARD\' | translate}}</button> <button type=\"button\" class=\"btn btn--secondary\" ng-if=\"vm.giftcard.canUsePassCodeRedemption\" ng-click=\"vm.redeemGiftcard()\">{{\'VIEW_GIFTCARD.ADMIN\' | translate}}</button></div></div></div></div><div class=\"giftcard__message\" ng-if=\"vm.giftcard.message\"><h3>{{\'VIEW_GIFTCARD.SAYS\' | translate : { purchaserName: vm.giftcard.purchaserName} }}</h3><p>&ldquo;<span ng-bind-html=\"vm.giftcard.message\"></span>&rdquo;</p></div><div class=\"giftcard__video hide--print\" ng-if=\"vm.giftcard.videoId\"><h3 ng-if=\"vm.giftcard.purchaserName\" class=\"push-half--bottom\">{{\'VIEW_GIFTCARD.MESSAGE_FROM\' | translate : { purchaserName: vm.giftcard.purchaserName} }}</h3><ziggeo-video ziggeo-token=\"vm.settings.ziggeoToken\" is-view-only=\"true\" video-identifier=\"vm.giftcard.videoId\" is-visible=\"vm.giftcard.videoId !== null\"></ziggeo-video></div></div><footer class=\"redeem__footer\"><div class=\"giftcard__terms\" ng-if=\"vm.giftcard.termsAndConditions\"><h3>{{\'VIEW_GIFTCARD.TERMS_AND_CONDITIONS\' | translate}}</h3><p ng-bind-html=\"vm.giftcard.termsAndConditions\"></p></div><div class=\"text--right _border--top hide--print\" ng-if=\"!vm.settings.hideRollerBranding\"><a class=\"brand--roller\" href=\"https://www.roller.software?utm_campaign=Powered by ROLLER Referral&utm_source=checkout\" target=\"_blank\"><span class=\"brand__text\" translate=\"SESSIONS.POWERED_BY\"></span> <img src=\"/app/img/logo@2x.png\" class=\"logo--roller\" height=\"14\" alt=\"ROLLER\"></a></div></footer></div></div><loader is-loading=\"vm.isLoading\" loading-text=\"Loading Giftcard...\"></loader>");
$templateCache.put("app/ng/directives/cartIconDirective.html","<button class=\"btn--plain flex-align--center\" ng-show=\"itemCount() > 0\" ng-click=\"showCart()\"><span class=\"_font--strong\">{{itemCount()}}</span> <span class=\"material-icons md-20 _push-quarter--left\">shopping_cart</span></button>");
$templateCache.put("app/ng/directives/orderSummaryDirective.html","<div id=\"order-summary\" class=\"panel panel--white u--border one-whole\" ng-class=\"{\'panel--order\': !order.isProcessed() && !alwaysVisible, \' _border--ends\' : !vm.settings.backgroundImage && !alwaysVisible, \'_border--bottom\': alwaysVisible}\"><div><header class=\"header _border--bottom cf flexbox flexbox--responsive visuallyhidden--portable\" ng-class=\"{\'soft-half--ends\': order.isProcessed() || order.inProgress}\"><div class=\"flexbox__item one-whole\"><h2 class=\"epsilon flush push-mid--sides\" ng-if=\"order.isProcessed()\" translate=\"ORDER_SUMMARY.YOUR_ITEMS\"></h2><h2 class=\"epsilon flush push-mid--sides\" ng-if=\"!order.isProcessed()\" translate=\"ORDER_SUMMARY.YOUR_CART\"></h2></div><div class=\"flexbox__item visuallyhidden--desk text--right _size--small visuallyhidden-desk\" ng-if=\"!alwaysVisible\"><i ng-click=\"hideCart()\" class=\"_cursor--pointer material-icons md-32 _vertical-align--middle\" role=\"button\" tabindex=\"0\">keyboard_arrow_left</i></div></header><header class=\"flexbox flexbox--responsive flexbox--fixed soft-half--ends _border--bottom soft--sides visuallyhidden--desk\"><div class=\"flexbox__item delta _size--small\" ng-if=\"!alwaysVisible && !order.isProcessed()\"><i ng-click=\"hideCart()\" class=\"_cursor--pointer material-icons md-32 _vertical-align--middle\" role=\"button\" tabindex=\"0\">keyboard_arrow_left</i></div><div class=\"flexbox__item text--center one-whole _vertical-align--top\"><h3 class=\"_display--inline-block text--center flush\" translate=\"ORDER_SUMMARY.YOUR_ITEMS\"></h3></div></header></div><div ng-if=\"order.itemCount()\"><div class=\"flexbox order soft-half--ends soft-mid--sides\"><div class=\"flexbox__item\"><div class=\"order__group\"><div class=\"order__item _push-quarter--top\" ng-repeat=\"group in groupedDates\" qa-id=\"cart-date-{{group.bookingDate}}\"><h4 ng-if=\"settings.showDateInCart()\" class=\"pill flush\">{{ group.formattedBookingDate }}</h4><div class=\"order__item push-half--ends\" ng-repeat=\"item in group.items\" qa-id=\"cart-product-{{item.parentName}}\"><h4 class=\"epsilon _push-quarter--bottom\">{{ item.parentName }}</h4><div class=\"cf\" ng-repeat=\"ticket in item.items track by $index\" ng-if=\"ticket.quantity > 0\" qa-id=\"cart-ticket-{{ticket.name}}\"><p class=\"order__item__ticket\">{{ ticket.quantity }} x {{ ticket.name }} <small ng-show=\"ticket.selectedDuration\" class=\"order__item__duration\">({{ ticket.sessionTimeFormatted }}<span ng-if=\"!settings.hideSessionDuration()\">, <span ng-if=\"ticket.remainingRecurringSessions\">{{ticket.remainingRecurringSessions}} x</span>{{ ticket.selectedDuration || ticket.duration | duration }}</span>)</small> <small ng-if=\"ticket.additionalGuests\">- {{ticket.additionalGuests}} {{ticket.guestLabel || \"guests\"}}</small></p><p class=\"order__item__ticket__price\"><span ng-if=\"!ticket.recurringPayment\" class=\"order__item__ticket__amount\" qa-id=\"cart-ticket-cost\">{{ ticket.quantity * order.calculateTicketPrice(ticket, { ignoreDeposit: true }) | rollerCurrency }}</span> <span ng-if=\"!!ticket.recurringPayment\" class=\"order__item__ticket__amount\">{{ticket.price | rollerCurrency}}/ {{ \'SESSIONS.RECURRING_BILLING.CART_INFO\' | translate: { frequency: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.SINGULAR.\' + ticket.recurringPayment.paymentFrequencyId.toUpperCase()) | translate)} }}</span> <span ng-if=\"ticket.productTypeId !== \'addOn\'\" class=\"order__item__delete material-icons state--error\" ng-click=\"order.removeItem(order.tickets(), ticket, true)\" role=\"button\" tabindex=\"0\" ng-hide=\"!order.canModifyOrder()\" qa-id=\"remove-cart-item\">delete</span> <span ng-if=\"ticket.productTypeId === \'addOn\'\" class=\"order__item__delete material-icons state--error\" ng-click=\"order.removeItem(order.addOns(), ticket)\" role=\"button\" tabindex=\"0\" ng-hide=\"!order.canModifyOrder()\">delete</span></p></div></div></div><div class=\"order__item push--top\" ng-if=\"bookingCostModifiers.length\"><div class=\"cf\" ng-repeat=\"bcm in bookingCostModifiers\" qa-id=\"bcm-{{bcm.name}}\"><p class=\"order__item__ticket\" qa-id=\"bcm-name\">{{ bcm.name }}</p><p class=\"order__item__ticket__price\"><span class=\"order__item__ticket__amount\" qa-id=\"bcm-cost\">{{ order.calculateBookingCostModifier(bcm) | rollerCurrency }}</span> <span class=\"order__item__delete material-icons state--error\" ng-style=\"{\'opacity\': bcm.isPostage ? 0 : 1 }\" ng-click=\"order.removeBookingCostModifier(bcm)\" role=\"button\" tabindex=\"0\" ng-hide=\"order.isProcessed()\">delete</span></p></div></div></div></div></div><div class=\"soft-half--ends soft-mid--sides _border--top\" ng-if=\"order.hasValidDiscountCode()\"><h2 class=\"epsilon _push-quarter--bottom\" translate=\"ORDER_SUMMARY.DISCOUNTS\">Discounts</h2><ul class=\"flush\"><li ng-repeat=\"discount in order.getDiscounts() track by $index\" class=\"pill--primary\"><span class=\"pill__text\">{{ order.getDiscountText(discount) }}</span> <button class=\"pill__icon material-icons\" role=\"button\" tabindex=\"0\" ng-if=\"order.canModifyDiscount()\" ng-click=\"order.removeAppliedDiscount($index)\" aria-hidden=\"false\">delete</button></li></ul></div><div class=\"soft-half--ends soft-mid--sides _border--top\" ng-if=\"order.hasValidGiftCard()\"><h2 class=\"epsilon _push-quarter--bottom\" translate=\"ORDER_SUMMARY.GIFT_CARDS\">Gift cards</h2><ul class=\"flush\"><li ng-repeat=\"$giftcard in order.getGiftCards() track by $index\" class=\"pill--primary\"><span class=\"pill__text\">{{ $giftcard.amountDeducted | rollerCurrency }} (#{{$giftcard.giftcardNumber}})</span> <button class=\"pill__icon material-icons\" role=\"button\" tabindex=\"0\" ng-if=\"order.canModifyGiftCard()\" ng-click=\"order.removeAppliedGiftCard($index)\" aria-hidden=\"false\">delete</button></li></ul></div><div class=\"order-total soft-half--ends soft-mid--sides _border--top cf\"><h2 class=\"epsilon push-half--bottom ng-binding\" translate=\"ORDER_SUMMARY.TOTAL_PAYMENT\"></h2><dl class=\"split flush hard\"><dt class=\"split__title\" translate=\"ORDER_SUMMARY.SUBTOTAL\"></dt><dd id=\"order-summary-sub-total\">{{ order.subTotal({ ignoreDiscountCodes: true, ignoreDeposit: true }) | rollerCurrency }}</dd><dt ng-if=\"order.hasValidDiscountCode()\" class=\"split__title\" translate=\"ORDER_SUMMARY.DISCOUNT\"></dt><dd ng-if=\"order.hasValidDiscountCode()\" id=\"order-summary-discount\">-{{ order.getDiscountTotal() | rollerCurrency }}</dd><dt ng-if=\"order.onlyDepositRequired()\" class=\"split__title weight--normal\" translate=\"ORDER_SUMMARY.DEPOSIT_REQUIRED\"></dt><dd ng-if=\"order.onlyDepositRequired()\" qa-id=\"order-summary-deposit\">{{ order.subTotal() | rollerCurrency }}</dd><dt class=\"split__title\" translate=\"ORDER_SUMMARY.TRANSACTION_FEE\"></dt><dd id=\"order-summary-fee\">{{ order.transactionFee() | rollerCurrency }}</dd><dt ng-if=\"order.giftcardValue()\" class=\"split__title\" translate=\"ORDER_SUMMARY.GIFTCARD\"></dt><dd ng-if=\"order.giftcardValue()\" id=\"order-summary-giftcard\">-{{ order.giftcardValue() | rollerCurrency }}</dd><dt class=\"split__title\" ng-if=\"order.isProcessed()\" translate=\"ORDER_SUMMARY.PAYMENT_METHOD\"></dt><dd ng-if=\"order.isProcessed()\" qa-id=\"order-summary-payment-method\">{{order.getPaymentMethod() || \"&nbsp;\"}}</dd><dt class=\"split__title\" ng-if=\"order.isProcessed()\" translate=\"ORDER_SUMMARY.RECEIPT_NUMBER\"></dt><dd ng-if=\"order.isProcessed()\" qa-id=\"order-summary-receipt-number\">{{order.getReceiptNumber() || \"&nbsp;\"}}</dd><dt class=\"split__title\" ng-if=\"bcm.cost\" ng-repeat=\"bcm in requiredCostModifiers\">{{ bcm.name }}</dt><dd ng-if=\"bcm.cost\" ng-repeat=\"bcm in requiredCostModifiers\" qa-id=\"order-summary-bcm-{{bcm.name}}\">{{ bcm.cost | rollerCurrency }}</dd><dt class=\"split__title\" ng-if=\"hasItemTax && !hideTaxLabels\" translate=\"ORDER_SUMMARY.TAX\"></dt><dd id=\"order-summary-tax\" ng-if=\"hasItemTax && !hideTaxLabels\">{{ order.taxes(true, !order.onlyDepositRequired()) | rollerCurrency }}</dd><dt class=\"split__title epsilon\"><span translate=\"ORDER_SUMMARY.TOTAL\" total=\"\"></span> <span ng-if=\"order.isProcessed() && !order.payment().requiresBankTransfer()\" translate=\"ORDER_SUMMARY.PAID\"></span> <span ng-if=\"order.isProcessed() && order.payment().requiresBankTransfer()\" translate=\"ORDER_SUMMARY.OWING\"></span> <span ng-if=\"!hideTaxLabels\" translate=\"ORDER_SUMMARY.INC_TAX\"></span></dt><dd><strong class=\"epsilon\" id=\"order-summary-total\">{{ order.total() | rollerCurrency }}</strong></dd></dl></div><div class=\"soft-mid--sides soft-mid--bottom\" ng-class=\"{\'visuallyhidden--desk\': !isProductSelectionStep()}\" ng-if=\"!order.isProcessed() && !alwaysVisible\"><button type=\"button\" class=\"btn btn--soft btn--green one-whole\" ng-class=\"{\'muted\': !canMoveNext()}\" ng-click=\"hideCartAndMoveNext()\" translate=\"{{ nextButtonText() }}\" translate-values=\"{ amount: (order.total() | rollerCurrency) }\"></button></div></div><p class=\"order soft-mid--sides push--ends order--empty\" ng-if=\"order.itemCount() === 0\" translate=\"ORDER_SUMMARY.NOTHING\"></p></div>");
$templateCache.put("app/views/modals/message.html","<div><header class=\"soft _border--bottom\"><h3 class=\"flush\"><span>{{ vm.title | rollerTranslate }}</span></h3></header><div class=\"soft\"><div><p>{{ vm.message | rollerTranslate }}</p></div><div class=\"cf push--top\"><button class=\"btn btn--green text--center float--right btn--soft\" ng-click=\"closeThisDialog(true)\"><span>{{ (vm.okButtonText || \'GENERIC.OK\') | translate }}</span></button> <button class=\"btn text--center float--right btn--soft push--right\" ng-click=\"closeThisDialog(false)\"><span>{{ (vm.cancelButtonText || \'GENERIC.CANCEL\') | translate }}</span></button></div></div></div>");
$templateCache.put("app/views/modals/redeem-giftcard.html","<header class=\"admin__header\"><span class=\"material-icons\">warning</span><h3>{{\'VIEW_GIFTCARD.ADMIN_REDEEM.ADMIN_USE_ONLY\' | translate}}</h3></header><div class=\"admin__inner\" ng-if=\"!vm.hasDeducted\"><div class=\"push--bottom\"><h3>{{\'VIEW_GIFTCARD.ADMIN_REDEEM.BALANCE\' | translate : { amount: (vm.giftcard.balance | rollerCurrency)} }}</h3></div><div class=\"admin__deduction\"><label>{{\'VIEW_GIFTCARD.ADMIN_REDEEM.ADMIN_CODE\' | translate}}</label> <input type=\"password\" maxlength=\"4\" ng-model=\"vm.passcode\" autofocus=\"\"></div><div class=\"admin__deduction\"><label>{{\'VIEW_GIFTCARD.ADMIN_REDEEM.AMOUNT_TO_REDEEM\' | translate : { currencySymbol: vm.settings.currencySymbol} }}</label> <input type=\"number\" pattern=\"\\d+(\\.\\d*)?\" ng-model=\"vm.amountToDeduct\"></div><p class=\"error\" ng-show=\"vm.error\">{{vm.error}}</p></div><div class=\"admin__inner\" ng-if=\"vm.hasDeducted\"><div class=\"admin__success\"><h3><span class=\"material-icons\">check_circle</span>{{\'VIEW_GIFTCARD.ADMIN_REDEEM.AMOUNT_REDEEMED\' | translate : { amount: (vm.amountToDeduct | rollerCurrency)} }}</h3><h4>{{\'VIEW_GIFTCARD.ADMIN_REDEEM.BALANCE\' | translate : { amount: (vm.giftcard.balance - vm.amountToDeduct | rollerCurrency)} }}</h4></div></div><footer class=\"admin__footer\"><button class=\"btn\" ng-click=\"closeThisDialog()\">{{\'VIEW_GIFTCARD.ADMIN_REDEEM.CLOSE\' | translate}}</button> <button class=\"btn btn--primary\" ng-disabled=\"!vm.passcode || !vm.amountToDeduct || vm.inProgress\" ng-click=\"vm.deduct(vm.amountToDeduct)\" ng-if=\"!vm.hasDeducted\">{{\'VIEW_GIFTCARD.ADMIN_REDEEM.REDEEM\' | translate}}</button></footer>");
$templateCache.put("app/views/modals/terms.and.conditions.html","<div><header class=\"soft _border--bottom\"><h1 class=\"flush\"><span ng-if=\"!vm.isPrivacy\" translate=\"TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS\"></span> <span ng-if=\"vm.isPrivacy\" translate=\"TERMS_AND_CONDITIONS.PRIVACY_POLICY\"></span></h1></header><div class=\"soft\"><div ng-if=\"vm.termsAndConditions\" class=\"modal__content\"><p ng-repeat=\"tnc in vm.termsAndConditions track by $index\" ng-bind-html=\"tnc\"></p></div><div ng-if=\"vm.codeOfConduct\" ng-bind-html=\"vm.codeOfConduct\" class=\"modal__content\"></div><div class=\"push--bottom\" ng-if=\"!vm.isPayment && !vm.isPrivacy\"><a href=\"https://www.roller.software/terms-of-use/\" target=\"_blank\"><span translate=\"TERMS_AND_CONDITIONS.CLICK_HERE\"></span></a> <span translate=\"TERMS_AND_CONDITIONS.VIEW_ROLLER_TERMS\"></span></div><div class=\"cf push--top\"><button class=\"btn btn--green text--center float--right btn--soft\" ng-click=\"closeThisDialog()\"><span translate=\"TERMS_AND_CONDITIONS.DONE\"></span></button></div></div></div>");
$templateCache.put("app/views/sessions/sessions.addons.html","<div class=\"layout__inner _border--bottom\"><div class=\"epsilon soft-half--ends soft--sides _border--top _shadow--bottom\" ng-if=\"vm.order.minimumSpend() > 0\"><div class=\"flexbox--responsive\" ng-class=\"vm.order.hasMetMinimumSpend() ? \'state--success\' : \'state--warning\'\"><span ng-if=\"!vm.order.hasMetMinimumSpend()\" class=\"flexbox__item material-icons md-18 _vertical-align--middle cell--auto\">local_offer</span> <span ng-if=\"vm.order.hasMetMinimumSpend()\" class=\"flexbox__item material-icons md-18 _vertical-align--middle cell--auto\">check</span> <span class=\"flexbox__item _vertical-align--middle _soft-quarter--left\">{{\'SESSIONS.ADD_ONS.MIN_SPEND\'| translate | stringFormat: vm.order.minimumSpend(): vm.order.minimumSpendProductNames() }}</span></div></div><div ng-repeat=\"group in vm.addOnGroups\"><div class=\"banner--thin _border--ends\" ng-if=\"vm.addOnGroups.length > 1\"><p class=\"text--small flush\">{{\'SESSIONS.ADD_ONS.SELECT_ADDONS_FOR\'| translate }}<span class=\"pill\">{{ group.formattedBookingDate }}</span></p></div><div qa-id=\"add-on-{{addOn.name}}\" ng-repeat=\"addOn in group.addOns\" class=\"_border--top\"><div class=\"flexbox flexbox--responsive one-whole push-half--top soft-half--ends soft-mid--sides\"><div class=\"flexbox__item cell--image flexbox__item--top\" ng-if=\"addOn.imageUrl\"><img ng-src=\"{{addOn.imageUrl}}\" class=\"session__image flexbox__item flexbox__item--top push-half--right\"></div><div class=\"flexbox__item flexbox__item--top\"><div class=\"flex flex--between\"><h2 class=\"flush epsilon\">{{addOn.name}}</h2><sold-out class=\"sold-out\" ng-if=\"addOn.soldOut\"></sold-out></div><p class=\"flexbox__item flexbox__item--top flush _text--small\" ng-if=\"addOn.description\"><span ng-bind-html=\"addOn.description\" qa-id=\"addon-description\"></span></p></div></div><div qa-id=\"add-on-item-{{item.name}}\" class=\"one-whole soft-mid--sides soft--bottom cf\" ng-repeat=\"item in addOn.childApiProducts\" ng-if=\"addOn.childApiProducts.length > 1\" ng-class=\"{\'is-sold-out\' : item.isSoldOut}\"><div class=\"cf\"><div class=\"float--left two-thirds four-tenths--portable soft-half--right\" ng-class=\"{\'is-sold-out\' : item.isSoldOut}\"><p class=\"product__name flush _line-height--medium\">{{ item.name }}</p><p class=\"flush product__price epsilon\" ng-if=\"!item.hasUserDefinedCost\">{{ item.price | rollerCurrency }}</p></div><div class=\"float--right\" ng-if=\"!item.hasUserDefinedCost\"><number-input can-decrease=\"item.quantity > 0\" decrease=\"vm.decrease(item, group.bookingDate)\" can-increase=\"vm.canAdd(item, addOn)\" increase=\"vm.increase(item, group.bookingDate)\" ticket=\"item\" text-focus=\"vm.onCustomFieldFocus(item)\" qty-added=\"item.inCartQuantity\"></number-input><p ng-if=\"item.isSoldOut\" class=\"flush--bottom text--center _push-quarter--top\" translate=\"SESSIONS.SOLD_OUT\"></p></div><input type=\"text\" ng-if=\"item.hasUserDefinedCost\" class=\"float--right text-input input--large text--right\" ng-model=\"item.price\" ng-change=\"vm.userDefinedCostChanged(item)\" ng-focus=\"vm.onCustomFieldFocus(item)\" qa-id=\"udc-input\" empty-if-zero=\"\"> <span ng-if=\"item.hasUserDefinedCost\" class=\"float--right push-half--top push-half--right\">{{CurrencySymbol}}</span></div><div class=\"flex-end push-half--top\"><div ng-if=\"vm.showUpdateCartButton(item)\"><button qa-id=\"addToCart\" type=\"button\" class=\"btn btn--green btn--radius\" ng-click=\"vm.updateCart(item, group.bookingDate)\"><span>{{ (item.inCartQuantity ? \'SESSIONS.UPDATE_CART\' : \'SESSIONS.ADD_TO_CART\') | translate }}</span></button></div><button ng-if=\"vm.showNextButton(item)\" type=\"button\" class=\"btn btn--soft btn--green btn--responsive push-mid--bottom--portable text--center btn--navigation one-whole push-half--ends visuallyhidden--desk\" ng-click=\"vm.moveNext()\" translate=\"{{ vm.nextButtonText() }}\" translate-values=\"{ amount: \'{{vm.order.total() | rollerCurrency}}\' }\"></button></div></div><div class=\"one-whole soft--sides soft--bottom cf\" ng-repeat=\"item in addOn.childApiProducts\" ng-if=\"addOn.childApiProducts.length == 1\" ng-class=\"{\'is-sold-out\' : item.isSoldOut}\"><div class=\"cf\"><div class=\"float--left two-thirds four-tenths--portable soft-half--right\"><p class=\"flush product__price weight--normal delta\">{{ item.price | rollerCurrency }}</p></div><div class=\"float--right\" ng-if=\"!item.hasUserDefinedCost\"><number-input can-decrease=\"item.quantity > 0\" decrease=\"vm.decrease(item, group.bookingDate)\" can-increase=\"vm.canAdd(item, addOn)\" increase=\"vm.increase(item, group.bookingDate)\" ticket=\"item\" text-focus=\"vm.onCustomFieldFocus(item)\" qty-added=\"item.inCartQuantity\"></number-input><p ng-if=\"item.isSoldOut\" class=\"flush--bottom text--center _push-quarter--top\" translate=\"SESSIONS.SOLD_OUT\"></p></div><input type=\"text\" ng-if=\"item.hasUserDefinedCost\" class=\"float--right text-input input--large text--right\" ng-model=\"item.price\" ng-change=\"vm.userDefinedCostChanged(item)\" ng-focus=\"vm.onCustomFieldFocus(item)\" empty-if-zero=\"\"> <span ng-if=\"item.hasUserDefinedCost\" class=\"float--right push-half--top push-half--right\">{{CurrencySymbol}}</span></div><div class=\"flex-end push-half--top\"><div ng-if=\"vm.showUpdateCartButton(item)\"><button qa-id=\"addToCart\" type=\"button\" class=\"btn btn--green btn--radius\" ng-click=\"vm.updateCart(item, group.bookingDate)\"><span>{{ (item.inCartQuantity ? \'SESSIONS.UPDATE_CART\' : \'SESSIONS.ADD_TO_CART\') | translate }}</span></button></div><button ng-if=\"vm.showNextButton(item)\" type=\"button\" class=\"btn btn--soft btn--green btn--responsive push-mid--bottom--portable text--center btn--navigation one-whole push-half--ends visuallyhidden--desk\" ng-click=\"vm.moveNext()\" translate=\"{{ vm.nextButtonText() }}\" translate-values=\"{ amount: \'{{vm.order.total() | rollerCurrency}}\' }\"></button></div></div></div></div><div class=\"soft--sides\"><cost-modifiers></cost-modifiers></div></div>");
$templateCache.put("app/views/sessions/sessions.details.html","<div class=\"layout__inner\"><div class=\"soft--top soft-mid--sides show-validation\" ng-if=\"vm.errors && vm.errors.length\"><div class=\"message--warning\"><ul class=\"flush\"><span>{{\'SESSIONS.DETAILS.ERRORS\' | translate: { NUMBER: vm.errors.length } : \'messageformat\' }}</span><li class=\"push--left\" ng-repeat=\"$error in vm.errors\">{{ $error }}</li></ul></div></div><div><form name=\"detailsForm\" novalidate=\"\"><div class=\"soft-half--bottom soft-mid--sides\"><div class=\"callout--note push--bottom\" ng-if=\"vm.extraDetails\" ng-show=\"!vm.loading\"><p class=\"flush\" ng-bind-html=\"vm.extraDetails\"></p></div><ul class=\"form-fields\"><li><div class=\"flexbox\" ng-if=\"!vm.swapNameOrder\"><div class=\"flexbox__item _vertical-align--top one-half soft-half--right hard--portable\"><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.FIRST_NAME\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': detailsForm.firstName.$invalid && vm.orderService.hasClickedContinue() }\" class=\"text-input one-whole\" id=\"first-name\" name=\"firstName\" ng-model=\"vm.details.firstName\" required=\"\" type=\"text\" maxlength=\"32\"><div ng-messages=\"detailsForm.firstName.$error\" class=\"message--warning\" ng-if=\"detailsForm.firstName.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_FIRST_NAME\"></span></span></div></div><div class=\"flexbox__item _vertical-align--top one-half hard--portable soft-top--portable soft-half--left\"><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.LAST_NAME\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': detailsForm.lastName.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" id=\"last-name\" name=\"lastName\" ng-model=\"vm.details.lastName\" required=\"\" type=\"text\" maxlength=\"32\"><div ng-messages=\"detailsForm.lastName.$error\" class=\"message--warning\" ng-if=\"detailsForm.lastName.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_LAST_NAME\"></span></span></div></div></div><div class=\"flexbox\" ng-if=\"vm.swapNameOrder\"><div class=\"flexbox__item _vertical-align--top one-half soft-half--right hard--portable\"><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.LAST_NAME\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': detailsForm.lastName.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" id=\"last-name\" name=\"lastName\" ng-model=\"vm.details.lastName\" required=\"\" type=\"text\" maxlength=\"32\"><div ng-messages=\"detailsForm.lastName.$error\" class=\"message--warning\" ng-if=\"detailsForm.lastName.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_LAST_NAME\"></span></span></div></div><div class=\"flexbox__item _vertical-align--top one-half hard--portable soft-top--portable soft-half--left\"><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.FIRST_NAME\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': detailsForm.firstName.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" id=\"first-name\" name=\"firstName\" ng-model=\"vm.details.firstName\" required=\"\" type=\"text\" maxlength=\"32\"><div ng-messages=\"detailsForm.firstName.$error\" class=\"message--warning\" ng-if=\"detailsForm.firstName.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_FIRST_NAME\"></span></span></div></div></div></li><li><label for=\"email\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.EMAIL\"></label> <span class=\"required\">*</span> <input qa-id=\"email\" ng-class=\"{\'input--error\': detailsForm.email.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" required=\"\" name=\"email\" ng-model=\"vm.details.email\" type=\"email\" ng-pattern=\"validation.emailRegex\" maxlength=\"256\" validate-mailbox=\"\" is-valid-mailbox=\"vm.isBookingMailboxValid\"><div ng-messages=\"detailsForm.email.$error\" class=\"message--warning\" ng-if=\"detailsForm.email.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_EMAIL\"></span></span> <span ng-message=\"email, pattern\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_VALID_EMAIL\"></span></span></div><div class=\"message--warning\" ng-if=\"detailsForm.email.$valid && vm.isBookingMailboxValid === false\"><span><span translate=\"SESSIONS.DETAILS.EMAIL_APPEARS_INCORRECT\"></span></span></div></li><li><div class=\"flexbox\"><div class=\"flexbox__item _vertical-align--top hard--portable\" ng-class=\"{ \'one-half soft-half--right\' : vm.settings.capturePostcode(), \'one-whole\': !vm.settings.capturePostcode() }\"><label for=\"phone\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.MOBILE_NUMBER\"></label> <span class=\"required\">*</span> <input type=\"tel\" class=\"_display--block text-input one-whole one-whole--portable\" id=\"phone\" name=\"phone\" ng-model=\"vm.details.phone\" required=\"\" pattern=\"\\+?[ 0-9]+\" filter-input=\"[+ 0-9]\" minlength=\"8\" maxlength=\"20\" ng-class=\"{\'input--error\': detailsForm.phone.$invalid && vm.orderService.hasClickedContinue()}\"><div ng-messages=\"detailsForm.phone.$error\" class=\"message--warning\" ng-if=\"detailsForm.phone.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_MOBILE\"></span></span> <span ng-message=\"pattern\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_VALID_PHONE\"></span></span> <span ng-message=\"minlength\"><span translate=\"SESSIONS.DETAILS.MIN_PHONE_LENGTH\"></span></span></div></div><div class=\"flexbox__item _vertical-align--top one-half hard--portable soft-top--portable soft-half--left\" ng-if=\"vm.settings.capturePostcode()\"><label for=\"postcode\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.POSTCODE\">Postcode</label> <span class=\"required\">*</span> <input type=\"text\" class=\"_display--block text-input two-thirds one-whole--portable\" id=\"postcode\" name=\"postcode\" ng-model=\"vm.details.postcode\" required=\"\" maxlength=\"12\" pattern=\"\\+?[ 0-9a-zA-Z\\-]+\" filter-input=\"[+ 0-9a-zA-Z\\-]\" ng-class=\"{\'input--error\': detailsForm.postcode.$invalid && vm.orderService.hasClickedContinue()}\"><div ng-messages=\"detailsForm.postcode.$error\" class=\"message--warning\" ng-if=\"detailsForm.postcode.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.ENTER_YOUR_POST_CODE\"></span></span></div></div></div></li></ul><div ng-repeat=\"form in vm.forms\" class=\"push--top\"><div ng-if=\"form.form.id\"><form-renderer ng-if=\"vm.countryCode\" form=\"form.form\" options=\"{ countryRestriction: vm.countryCode }\" validation-message-provider=\"vm.formValidationMessageProvider\"></form-renderer></div></div></div></form></div><div class=\"_border--bottom\"><div ng-repeat=\"giftcard in vm.giftcards track by $index\"><ng-form name=\"giftcardForm\" novalidate=\"\"><div qa-id=\"giftCardDetails\" class=\"accordion__header flex-end--center\" ng-click=\"vm.toggleGiftcard(giftcard)\" ng-class=\"{ \'is-open\': giftcard.isSelected }\"><div class=\"one-whole\"><h2 class=\"flush delta accordion__title\"><span class=\"material-icons _push-quarter--right state--error\" ng-if=\"vm.orderService.hasClickedContinue() && giftcardForm.$invalid\">error_outline</span> <span class=\"accordion__title__text\" translate=\"SESSIONS.DETAILS.GIFT_CARD_DETAILS\"></span><span>- {{ giftcard.name }} - {{ giftcard.price | rollerCurrency }}</span></h2></div><div class=\"one-quarter text--right\"><span class=\"badge\">{{$index + 1}}<span class=\"_soft-quarter--sides\" translate=\"GENERIC.OF\"></span>{{vm.giftcards.length}}</span></div><div class=\"text--right _size--small accordion__arrow\"><span class=\"accordion__arrow material-icons\" ng-class=\"{\'is-open\': giftcard.isSelected}\">keyboard_arrow_down</span></div></div><div class=\"accordion__body soft-half--ends soft-mid--sides\" ng-show=\"giftcard.isSelected\"><ul class=\"form-fields\"><li><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.RECIPIENTS_NAME\"></label> <span class=\"required\">*</span> <input qa-id=\"recipientName\" ng-class=\"{\'input--error\': giftcardForm.name.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" name=\"name\" ng-model=\"giftcard.details.name\" maxlength=\"64\" required=\"\" type=\"text\"><div ng-messages=\"giftcardForm.name.$error\" class=\"message--warning\" ng-if=\"giftcardForm.name.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.PLEASE_ENTER_RECIPIENT_NAME\"></span></span></div></li><li><div><h2 class=\"epsilon _push-quarter--bottom\" translate=\"SESSIONS.DETAILS.GIFT_CARD_TYPE\"></h2><button ng-hide=\"giftcard.allowPhysicalGiftCard === true\" id=\"giftcard-type-digital-{{$index}}\" qa-id=\"giftcard-type-digital-{{$index}}\" class=\"btn btn--slim btn--border btn--white btn--radius _push-quarter--right btn-text--large\" ng-click=\"giftcard.type = \'digital\'\" ng-class=\"{ \'btn--active\' : giftcard.type === \'digital\' }\" translate=\"SESSIONS.DETAILS.DIGITAL\"></button> <button ng-hide=\"giftcard.allowPhysicalGiftCard === false\" id=\"giftcard-type-physical-{{$index}}\" qa-id=\"giftcard-type-physical-{{$index}}\" class=\"btn btn--slim btn--border btn--white btn--radius _push-quarter--right btn-text--large\" ng-click=\"giftcard.type = \'physical\'\" ng-class=\"{ \'btn--active\' : giftcard.type === \'physical\' }\" translate=\"SESSIONS.DETAILS.PHYSICAL\"></button></div></li><li ng-if=\"giftcard.type == \'digital\'\"><div><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.RECIPIENTS_EMAIL\"></label> <span class=\"required\">*</span> <input qa-id=\"recipientEmail\" ng-class=\"{\'input--error\': giftcardForm.email.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" name=\"email\" ng-model=\"giftcard.details.email\" maxlength=\"128\" required=\"\" type=\"email\" ng-pattern=\"validation.emailRegex\" validate-mailbox=\"\" is-valid-mailbox=\"giftcard.isMailboxValid\"><div ng-messages=\"giftcardForm.email.$error\" class=\"message--warning\" ng-if=\"giftcardForm.email.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.PLEASE_ENTER_RECIPIENT_EMAIL\"></span></span> <span ng-message=\"email, pattern\"><span translate=\"GENERIC.ENTER_YOUR_VALID_EMAIL\"></span></span></div><div class=\"message--warning\" ng-if=\"giftcardForm.email.$valid && giftcard.isMailboxValid === false\"><span><span translate=\"SESSIONS.DETAILS.EMAIL_APPEARS_INCORRECT\"></span></span></div></div><div class=\"push-half--top\"><div ng-show=\"giftcard.giftcardAcceptsMessage && giftcard.giftcardAcceptsVideo\"><div class=\"this-or-this soft\"><div class=\"one-third this-or-this__that one-whole--portable\"><button qa-id=\"giftcard-write-message-{{$index}}\" ng-class=\"{\'btn--tabs--selected\': giftcard.details.selectedMessagingOption === \'message\'}\" class=\"btn btn--soft btn--white btn--tabs this-or-this__that\" ng-click=\"vm.setGiftcardMessagingOption(giftcard, \'message\')\" translate=\"SESSIONS.DETAILS.WRITE_MESSAGE\"></button></div><div class=\"one-third this-or-this__or\"><p class=\"vstrike flush\"><strong translate=\"GENERIC.OR\"></strong></p></div><div class=\"one-third this-or-this__this\"><button qa-id=\"giftcard-record-video-{{$index}}\" ng-class=\"{\'btn--tabs--selected\': giftcard.details.selectedMessagingOption === \'video\' }\" class=\"btn btn--soft btn--white btn--tabs this-or-this__this\" ng-click=\"vm.setGiftcardMessagingOption(giftcard, \'video\')\" translate=\"SESSIONS.DETAILS.RECORD_VIDEO\"></button></div></div></div><div class=\"push-half--top\" ng-show=\"giftcard.giftcardAcceptsMessage && giftcard.details.selectedMessagingOption === \'message\'\"><label for=\"full-name\" class=\"label\" translate=\"SESSIONS.DETAILS.MESSAGE\"></label> <textarea qa-id=\"recipientMessage\" class=\"text-input input--textarea one-whole\" ng-model=\"giftcard.details.message\"></textarea></div><div class=\"push-half--top\" ng-show=\"giftcard.giftcardAcceptsVideo && giftcard.details.selectedMessagingOption === \'video\'\"><label for=\"full-name\" class=\"label\" translate=\"SESSIONS.DETAILS.VIDEO\"></label><ziggeo-video ziggeo-token=\"vm.settings.ziggeoToken\" is-view-only=\"false\" video-identifier=\"giftcard.details.videoIdentifier\" is-visible=\"giftcard.details.selectedMessagingOption === \'video\'\" embedding=\"true\" disable-device-test=\"vm.settings.disableRecordingDeviceTest\" use-legacy-recorder=\"vm.settings.useLegacyRecorder\"></ziggeo-video></div></div><div class=\"push-half--top\"><label class=\"label\" translate=\"SESSIONS.DETAILS.SEND_CARD\"></label> <label class=\"_display--inline-block label--radio\" ng-class=\"{\'is-checked\': !giftcard.sendLater}\"><input class=\"push-half--right\" type=\"radio\" ng-checked=\"!giftcard.sendLater\" ng-model=\"giftcard.sendLater\" ng-value=\"false\"> <span translate=\"SESSIONS.DETAILS.NOW\"></span></label> <label class=\"push-half--left _display--inline-block label--radio\" ng-class=\"{\'is-checked\': giftcard.sendLater}\"><input class=\"push-half--right\" type=\"radio\" ng-checked=\"gift.sendLater\" ng-model=\"giftcard.sendLater\" ng-value=\"true\"> <span translate=\"SESSIONS.DETAILS.LATER\"></span></label></div><div ng-if=\"giftcard.sendLater\" class=\"push--top\"><div><label class=\"label\"><span translate=\"SESSIONS.DETAILS.SEND_DATE\"></span><div ng-messages=\"giftcardForm.sendDate.$error\" class=\"message--warning\" ng-if=\"giftcardForm.sendDate.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.SEND_DATE_REQUIRED\"></span></span></div></label><div id=\"roller-datepicker\" class=\"datepicker__wrapper hard--left\"><button type=\"button\" class=\"datepicker__btn\" ng-model=\"giftcard.details.sendDate\" datepicker-config=\"vm.datePickerConfig\" ng-flat-datepicker=\"\"><i class=\"material-icons\">date_range</i><p class=\"flush--bottom\">{{ giftcard.details.sendDate }}</p><i class=\"material-icons datepicker__arrow\">keyboard_arrow_down</i></button></div></div><div class=\"push-half--top\"><label class=\"label\"><span translate=\"SESSIONS.DETAILS.SEND_TIME\"></span><div ng-messages=\"giftcardForm.sendTime.$error\" class=\"message--warning\" ng-if=\"giftcardForm.sendTime.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.SEND_TIME_REQUIRED\"></span></span></div></label><time-picker ng-class=\"{\'input--error\' : giftcardForm.sendTime.$invalid }\" name=\"sendTime\" ng-model=\"giftcard.details.sendTime\"></time-picker></div><div class=\"push-half--top\"><label class=\"label\"><span translate=\"SESSIONS.DETAILS.TIMEZONE\"></span><div ng-messages=\"giftcardForm.timezone.$error\" class=\"message--warning\" ng-if=\"giftcardForm.timezone.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.TIMEZONE_REQUIRED\"></span></span></div></label><div class=\"custom-select\"><select class=\"one-whole\" ng-class=\"{\'input--error\' : giftcardForm.timezone.$invalid }\" ng-model=\"giftcard.details.timezone\" name=\"timeZone\" ng-options=\"timezone as timezone for timezone in giftcard.timezones\"></select></div></div></div></li><li ng-if=\"giftcard.type == \'physical\'\"><div ng-if=\"giftcard.giftcardAcceptsPhysicalMessage\"><label for=\"full-name\" class=\"label\" translate=\"SESSIONS.DETAILS.MESSAGE\"></label> <textarea class=\"text-input input--textarea one-whole\" maxlength=\"{{giftcard.physicalGiftcardMessageMaxLength}}\" ng-model=\"giftcard.details.message\"></textarea></div><label class=\"push-half--top label--checkbox\" for=\"different-delivery-details{{$index}}\" ng-class=\"{\'is-checked\' : giftcard.details.differentDeliveryDetails}\"><input id=\"different-delivery-details{{$index}}\" name=\"differentDeliveryDetails{{$index}}\" ng-model=\"giftcard.details.differentDeliveryDetails\" type=\"checkbox\"> <span translate=\"SESSIONS.DETAILS.DIFFERENT_DELIVERY_DETAILS\"></span></label><div ng-if=\"giftcard.details.differentDeliveryDetails\"><div><div class=\"push-half--top\"><label class=\"label\" translate=\"SESSIONS.DETAILS.DELIVERY_OPTIONS\"></label><div class=\"custom-select\"><select class=\"one-whole\" ng-model=\"giftcard.details.postage\" ng-options=\"pp as vm.giftcardDeliveryOption(pp) for pp in giftcard.productPostages\"></select></div></div><div class=\"push-half--top\" ng-if=\"giftcard.deliveryOptionDescription()\"><button type=\"button\" class=\"btn--plain link\" ng-click=\"giftcard.showDeliveryDetails = !giftcard.showDeliveryDetails\"><span class=\"material-icons _vertical-align--middle push-half--right md-18\">info_outline</span> <span ng-show=\"!giftcard.showDeliveryDetails\"><span ng-show=\"giftcard.isPickup()\" translate=\"SESSIONS.DETAILS.PICK_UP\"></span> <span ng-show=\"!giftcard.isPickup()\" translate=\"SESSIONS.DETAILS.POSTAGE\"></span></span> <span ng-show=\"giftcard.showDeliveryDetails\" translate=\"SESSIONS.DETAILS.HIDE_DETAILS\"></span></button><div ng-show=\"giftcard.showDeliveryDetails\" class=\"push-half--top\">{{giftcard.deliveryOptionDescription()}}</div></div><div class=\"push-half--ends push--bottom push-half--top\" ng-if=\"giftcard.details.postage && !giftcard.details.postage.isPickup\"><label class=\"label _display--inline-block\" for=\"giftcardDeliveryAddress-{{$index}}\" translate=\"SESSIONS.DETAILS.DELIVERY_ADDRESS\"></label> <span class=\"required\">*</span> <input id=\"giftcardDeliveryAddress-{{$index}}\" name=\"giftcardDeliveryAddress-{{$index}}\" type=\"text\" class=\"text-input one-whole\" placeholder=\"{{ \'GENERIC.ADDRESS_SEARCH_PLACEHOLDER\' | translate }}\" element-ready=\"vm.loadAddressAutocomplete(\'giftcardDeliveryAddress-\', giftcard.details.address, $index)\" ng-class=\"{\'input--error\' : giftcardForm.$invalid && !giftcard.addressPopulated }\" required=\"\"></div><div class=\"push-half--top\" ng-if=\"giftcard.details.postage && !giftcard.details.postage.isPickup && vm.countryCode\"><button type=\"button\" class=\"btn--plain link\" ng-click=\"giftcard.showAddressFields = !giftcard.showAddressFields\"><span class=\"material-icons _vertical-align--middle push-half--right md-18\">info_outline</span> <span translate=\"SESSIONS.DETAILS.ENTER_ADDRESS_MANUALLY\"></span></button></div><div class=\"push-half--top\" ng-show=\"(giftcard.addressPopulated && giftcard.details.postage && !giftcard.details.postage.isPickup) || giftcard.showAddressFields || !vm.countryCode\"><div><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.STREET_ADDRESS\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\' : giftcardForm.address.$invalid }\" type=\"text\" class=\"text-input one-whole\" name=\"address\" ng-model=\"giftcard.details.address.address\" required=\"\"><div ng-messages=\"giftcardForm.address.$error\" class=\"message--warning\" ng-if=\"giftcardForm.address.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.SUBURB\"></label> <input type=\"text\" class=\"text-input one-whole\" ng-class=\"{\'input--error\': giftcardForm.suburb.$invalid && vm.orderService.hasClickedContinue() }\" name=\"suburb\" ng-model=\"giftcard.details.address.suburb\" required=\"\"><div ng-messages=\"giftcardForm.suburb.$error\" class=\"message--warning\" ng-if=\"giftcardForm.suburb.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.CITY\"></label> <input type=\"text\" class=\"text-input one-whole\" ng-class=\"{\'input--error\': giftcardForm.city.$invalid && vm.orderService.hasClickedContinue()}\" name=\"city\" ng-model=\"giftcard.details.address.city\" required=\"\"><div ng-messages=\"giftcardForm.city.$error\" class=\"message--warning\" ng-if=\"giftcardForm.city.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.STATE_PROVINCE\"></label> <input ng-class=\"{\'input--error\' : giftcardForm.state.$invalid }\" type=\"text\" name=\"state\" class=\"text-input one-whole\" ng-model=\"giftcard.details.address.state\" required=\"\"><div ng-messages=\"giftcardForm.state.$error\" class=\"message--warning\" ng-if=\"giftcardForm.state.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.POSTCODE\"></label> <input ng-class=\"{\'input--error\' : giftcardForm.postcode.$invalid }\" type=\"text\" name=\"postcode\" class=\"text-input one-whole\" ng-model=\"giftcard.details.address.postcode\" required=\"\"><div ng-messages=\"giftcardForm.postcode.$error\" class=\"message--warning\" ng-if=\"giftcardForm.postcode.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.COUNTRY\"></label> <input ng-class=\"{\'input--error\' : giftcardForm.country.$invalid }\" type=\"text\" name=\"country\" class=\"text-input one-whole\" ng-model=\"giftcard.details.address.country\" required=\"\"><div ng-messages=\"giftcardForm.country.$error\" class=\"message--warning\" ng-if=\"giftcardForm.country.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div></div></div></div></li></ul></div></ng-form></div><form name=\"giftcardDeliveryForm\" novalidate=\"\" ng-if=\"vm.hasMultiGiftcard\"><div class=\"flexbox flexbox--responsive flexbox--fixed soft-half--ends soft-mid--sides accordion__header\" ng-if=\"vm.isActivated()\" ng-click=\"vm.showDeliveryDetailsForm = vm.isActivated() ? !vm.showDeliveryDetailsForm : false;\" ng-class=\"{\'is-open\': vm.showDeliveryDetailsForm}\" qa-id=\"gift-card-delivery\"><div class=\"flexbox__item one-whole\"><h2 class=\"flush delta accordion__title\"><span class=\"material-icons _push-quarter--right state--error\" ng-if=\"vm.orderService.hasClickedContinue()&& giftcardDeliveryForm.$invalid\">error_outline</span> <span class=\"accordion__title__text\" translate=\"SESSIONS.DETAILS.GIFT_CARD_DELIVERY\"></span></h2></div><div class=\"flexbox__item text--right _size--small accordion__arrow\"><span class=\"accordion__arrow material-icons\" ng-class=\"{\'is-open\': vm.showDeliveryDetailsForm}\">keyboard_arrow_down</span></div></div><div class=\"form-fields accordion__body soft-half--ends soft-mid--sides\" ng-show=\"vm.showDeliveryDetailsForm\"><div><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.DELIVERY_NAME\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': giftcardDeliveryForm.name.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" name=\"name\" ng-model=\"vm.combinedDeliveryDetails.deliveryName\" maxlength=\"64\" ng-required=\"vm.isActivated()\" type=\"text\" qa-id=\"delivery-name\"><div ng-messages=\"giftcardDeliveryForm.deliveryName.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.name.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.PLEASE_ENTER_DELIVERY_NAME\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.DELIVERY_OPTIONS\"></label> <span class=\"required\">*</span><div class=\"custom-select\"><select name=\"deliveryOption\" class=\"one-whole\" ng-class=\"{\'input--error\': giftcardDeliveryForm.deliveryOption.$invalid && vm.orderService.hasClickedContinue()}\" ng-model=\"vm.combinedDeliveryDetails.selectedPostage\" ng-options=\"pp as vm.giftcardDeliveryOption(pp) for pp in vm.combinedDeliveryDetails.postageOptions\" ng-required=\"vm.isActivated()\" qa-id=\"delivery-option\"></select></div></div><div class=\"push-half--top\" ng-if=\"vm.combinedDeliveryDetails.selectedPostage && vm.combinedDeliveryDetails.selectedPostage.description\"><button type=\"button\" class=\"btn--plain link\" ng-click=\"vm.combinedDeliveryDetails.showDeliveryDetails = !vm.combinedDeliveryDetails.showDeliveryDetails\"><span class=\"material-icons _vertical-align--middle push-half--right md-18\">info_outline</span> <span ng-show=\"!vm.combinedDeliveryDetails.showDeliveryDetails\"><span ng-show=\"vm.combinedDeliveryDetails.selectedPostage.isPickup\" translate=\"SESSIONS.DETAILS.PICK_UP\"></span> <span ng-show=\"!vm.combinedDeliveryDetails.selectedPostage.isPickup\" translate=\"SESSIONS.DETAILS.POSTAGE\"></span></span> <span ng-show=\"vm.combinedDeliveryDetails.showDeliveryDetails\" translate=\"SESSIONS.DETAILS.HIDE_DETAILS\"></span></button><div ng-show=\"vm.combinedDeliveryDetails.showDeliveryDetails\" class=\"push-half--top\">{{vm.combinedDeliveryDetails.selectedPostage.description}}</div></div><div class=\"push-half--ends push--bottom push-half--top\" ng-if=\"vm.combinedDeliveryDetails.selectedPostage && !vm.combinedDeliveryDetails.selectedPostage.isPickup\"><label class=\"label _display--inline-block\" for=\"combinedDeliveryAddress\" translate=\"SESSIONS.DETAILS.DELIVERY_ADDRESS\"></label> <span class=\"required\">*</span> <input id=\"combinedDeliveryAddress\" name=\"combinedDeliveryAddress\" type=\"text\" class=\"text-input one-whole\" placeholder=\"{{ \'GENERIC.ADDRESS_SEARCH_PLACEHOLDER\' | translate }}\" element-ready=\"vm.loadAddressAutocomplete(\'combinedDeliveryAddress\', vm.combinedDeliveryDetails)\" ng-class=\"{\'input--error\' : giftcardDeliveryForm.$invalid && !vm.combinedDeliveryDetails.addressPopulated }\" required=\"\"></div><div class=\"push-half--top\" ng-if=\"vm.combinedDeliveryDetails.selectedPostage && !vm.combinedDeliveryDetails.selectedPostage.isPickup && vm.countryCode\"><button type=\"button\" class=\"btn--plain link\" ng-click=\"vm.combinedDeliveryDetails.showAddressFields = !vm.combinedDeliveryDetails.showAddressFields\"><span class=\"material-icons _vertical-align--middle push-half--right md-18\">info_outline</span> <span translate=\"SESSIONS.DETAILS.ENTER_ADDRESS_MANUALLY\" qa-id=\"enter-address-manually\"></span></button></div><div class=\"push-half--top\" ng-show=\"vm.combinedDeliveryDetails.addressPopulated || vm.combinedDeliveryDetails.showAddressFields || !vm.countryCode\"><div><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.STREET_ADDRESS\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\' : giftcardDeliveryForm.address.$invalid }\" type=\"text\" class=\"text-input one-whole\" name=\"address\" ng-model=\"vm.combinedDeliveryDetails.address\" required=\"\"><div ng-messages=\"giftcardDeliveryForm.address.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.address.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.SUBURB\"></label> <span class=\"required\">*</span> <input type=\"text\" class=\"text-input one-whole\" ng-class=\"{\'input--error\': giftcardDeliveryForm.suburb.$invalid && vm.orderService.hasClickedContinue()}\" name=\"suburb\" ng-model=\"vm.combinedDeliveryDetails.suburb\" required=\"\"><div ng-messages=\"giftcardDeliveryForm.suburb.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.suburb.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.CITY\"></label> <span class=\"required\">*</span> <input type=\"text\" class=\"text-input one-whole\" ng-class=\"{\'input--error\': giftcardDeliveryForm.city.$invalid && vm.orderService.hasClickedContinue() }\" name=\"city\" ng-model=\"vm.combinedDeliveryDetails.city\" required=\"\"><div ng-messages=\"giftcardDeliveryForm.city.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.city.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.STATE_PROVINCE\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\' : giftcardDeliveryForm.state.$invalid }\" type=\"text\" name=\"state\" class=\"text-input one-whole\" ng-model=\"vm.combinedDeliveryDetails.state\" required=\"\"><div ng-messages=\"giftcardDeliveryForm.state.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.state.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.POSTCODE\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\' : giftcardDeliveryForm.postcode.$invalid }\" type=\"text\" name=\"postcode\" class=\"text-input one-whole\" ng-model=\"vm.combinedDeliveryDetails.postcode\" required=\"\"><div ng-messages=\"giftcardDeliveryForm.postcode.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.postcode.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div><div class=\"push-half--top\"><label class=\"label _display--inline-block\" translate=\"SESSIONS.DETAILS.COUNTRY\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\' : giftcardDeliveryForm.country.$invalid }\" type=\"text\" name=\"country\" class=\"text-input one-whole\" ng-model=\"vm.combinedDeliveryDetails.country\" required=\"\"><div ng-messages=\"giftcardDeliveryForm.country.$error\" class=\"message--warning\" ng-if=\"giftcardDeliveryForm.country.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.DETAILS.REQUIRED\"></span></span></div></div></div></div></form></div><div><div class=\"push-half--top\" ng-if=\"vm.canUseDiscountsAndGiftCards()\"><div class=\"tab__wrapper show-validation form-fields\"><button qa-id=\"addDiscountCode\" class=\"tab__button btn btn--soft btn--grey btn--responsive\" ng-class=\"{\'is-selected\' : vm.isRedeeming(\'discount\')}\" ng-click=\"vm.setRedemptionType(\'discount\')\" ng-if=\"vm.canUseDiscounts && vm.canAddDiscount && vm.showDiscountCode\"><span ng-if=\"!vm.content(\'discount_code\', true)\" translate=\"SESSIONS.DETAILS.APPLY_DISCOUNT_CODE\"></span> <span ng-if=\"vm.content(\'discount_code\', true)\">{{ vm.content(\'discount_code\') }}</span> <span class=\"tab__arrow\"></span></button><div class=\"tab__content flex\" ng-if=\"vm.canUseDiscounts && vm.canAddDiscount && vm.showDiscountCode && vm.isRedeeming(\'discount\')\"><input type=\"text\" class=\"text-input one-whole push-half--right\" id=\"discount-code\" placeholder=\"{{ \'SESSIONS.DETAILS.APPLY_DISCOUNT_CODE_PLACEHOLDER\' | translate }}\" ng-model=\"vm.discountCode\" ng-class=\"{\'input--error\': vm.invalidDiscountCode && vm.orderService.hasClickedContinue()}\"> <button qa-id=\"applyDiscountCode\" type=\"button\" class=\"btn btn--green one-third btn--radius btn--slim\" ng-click=\"vm.applyDiscountCode(vm.discountCode)\">{{\'SESSIONS.PAYMENT.APPLY\' | translate}}</button></div><button qa-id=\"addMembershipCode\" class=\"tab__button btn btn--soft btn--grey btn--responsive\" ng-class=\"{\'is-selected\' : vm.isRedeeming(\'membership\')}\" ng-click=\"vm.setRedemptionType(\'membership\')\" ng-if=\"vm.canUseMemberships && vm.showDiscountCode && vm.canAddDiscount\">{{ \'SESSIONS.DETAILS.USE_MEMBERSHIP\' | translate }} <span class=\"tab__arrow\"></span></button><div class=\"tab__content flex\" ng-if=\"vm.canUseMemberships && vm.isRedeeming(\'membership\') && vm.canAddDiscount\"><input type=\"text\" class=\"text-input one-whole push-half--right\" placeholder=\"{{ \'SESSIONS.DETAILS.USE_MEMBERSHIP_PLACEHOLDER\' | translate }}\" ng-model=\"vm.discountCode\" ng-class=\"{\'input--error\': vm.invalidDiscountCode && vm.orderService.hasClickedContinue()}\"> <button type=\"button\" class=\"btn btn--green one-third btn--radius btn--slim\" ng-click=\"vm.applyDiscountCode(vm.discountCode)\">{{\'SESSIONS.PAYMENT.APPLY\' | translate}}</button></div><button qa-id=\"redeemGiftCard\" class=\"tab__button btn btn--soft btn--grey btn--responsive\" ng-class=\"{\'is-selected\' : vm.isRedeeming(\'giftCard\')}\" ng-click=\"vm.setRedemptionType(\'giftCard\')\" ng-if=\"vm.canRedeemGiftCards()\">{{ \'SESSIONS.PAYMENT.REDEEM_GIFT_CARD\' | translate }} <span class=\"tab__arrow\"></span></button><div class=\"tab__content\" ng-class=\"vm.isWorldpayCard() ? \'flex--column\' : \'flex\'\" ng-if=\"vm.canRedeemGiftCards() && vm.isRedeeming(\'giftCard\')\"><input qa-id=\"giftCardNo\" type=\"text\" class=\"text-input one-whole push-half--right\" placeholder=\"{{ \'SESSIONS.PAYMENT.REDEEM_GIFT_CARD_PLACEHOLDER\' | translate }}\" ng-model=\"vm.giftCardNumber\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 300, \'blur\': 0} }\" ng-class=\"{\'input--error\': vm.invalidGiftCard && vm.orderService.hasClickedContinue()}\"> <button type=\"button\" class=\"btn btn--green one-third btn--radius btn--slim\" ng-if=\"!vm.isWorldpayCard()\" qa-id=\"applyGiftCard\" ng-click=\"vm.applyGiftCard(vm.giftCardNumber)\" ng-class=\"{\'muted\': !vm.giftCardNumber}\">{{\'SESSIONS.PAYMENT.APPLY\' | translate}}</button><div ng-if=\"vm.isWorldpayCard()\" class=\"push-mid--top\"><label class=\"label push-half--bottom\" for=\"\">{{ \'SESSIONS.DETAILS.ENTER_EITHER_PIN\' | translate }}</label><div class=\"flex--center\"><input ng-if=\"vm.isStoreCard()\" type=\"text\" maxlength=\"8\" class=\"text-input one-whole push-half--right\" placeholder=\"{{ \'SESSIONS.DETAILS.ENTER_GIFT_CARD_PIN_CCV\' | translate }}\" qa-id=\"store-card-cvv\" ng-model=\"vm.giftcardPin\"> <input ng-if=\"vm.isValutecCard()\" type=\"text\" maxlength=\"8\" class=\"text-input one-whole push-half--right\" placeholder=\"{{ \'SESSIONS.DETAILS.ENTER_VALUTEC_CARD_PIN\' | translate }}\" qa-id=\"store-card-cvv\" ng-model=\"vm.giftcardPin\"> <button type=\"button\" class=\"btn btn--green one-third btn--radius btn--slim\" ng-class=\"{\'muted\': !vm.isValidStoreCard()}\" qa-id=\"apply-store-card\" ng-click=\"vm.applyGiftCard(vm.giftCardNumber)\" ng-disabled=\"!vm.isValidStoreCard()\">{{\'SESSIONS.PAYMENT.APPLY\' | translate}}</button></div></div></div></div></div><div class=\"push-mid--sides\" ng-if=\"vm.invalidDiscountCode || vm.invalidGiftCard\"><span class=\"message--warning\" qa-id=\"invalid-discount-code-message\" ng-if=\"vm.isRedeeming(\'discount\')\">{{ vm.content(\'discount_code\') }} {{ \'SESSIONS.PAYMENT.INVALID\' | translate }}</span> <span class=\"message--warning\" qa-id=\"invalid-giftcard-message\" ng-if=\"vm.invalidGiftCard\" translate=\"SESSIONS.PAYMENT.GIFT_CARD_INVALID\"></span> <span class=\"message--warning\" qa-id=\"invalid-membership-message\" ng-if=\"vm.isRedeeming(\'membership\')\" translate=\"SESSIONS.DETAILS.MEMBERSHIP_CODE_INVALID\"></span></div><div class=\"push-half--top push-mid--sides\"><roller-message class=\"push--bottom\" type=\"success\" ng-if=\"vm.giftCardVerified && !vm.isRedeeming(\'giftCard\')\" allow-close=\"false\" allow-undo=\"false\" qa-id=\"giftcard-success-message\"><span translate=\"SESSIONS.PAYMENT.GIFT_CARD\"></span> {{ vm.giftCardNumber }} <span translate=\"SESSIONS.PAYMENT.SUCCESSFULLY_APPLIED\"></span></roller-message><roller-message class=\"push--bottom\" type=\"success\" ng-if=\"vm.discountCodeVerified\" allow-close=\"false\" allow-undo=\"false\" qa-id=\"discount-success-message\"><span translate=\"SESSIONS.PAYMENT.DISCOUNT_APPLIED\" qa-id=\"discount-success-message\"></span>: <span qa-id=\"discount-success-info\">{{ vm.discountCodeApplied }}</span></roller-message></div><form name=\"consentForm\" class=\"push--bottom\"><div class=\"soft-mid--sides\"><div ng-if=\"vm.settings.captureAcceptMarketingEmail\" class=\"push--top flush--bottom\"><label class=\"label label--checkbox\" for=\"accept-marketing\" ng-class=\"{\'is-checked\' : vm.details.acceptMarketing}\"><input id=\"accept-marketing\" name=\"marketingAccepted\" ng-model=\"vm.details.acceptMarketing\" type=\"checkbox\"> <span ng-if=\"vm.content(\'accept_marketing\')\">{{vm.content(\'accept_marketing\')}}</span> <span ng-if=\"!vm.content(\'accept_marketing\')\">{{ (vm.settings.captureSeparateMarketingConsents ? \'SESSIONS.DETAILS.I_ACCEPT_MARKETING_EMAIL\' : \'SESSIONS.DETAILS.I_ACCEPT_MARKETING\') | translate: { VENUENAME: vm.settings.venueName } : \'messageformat\'}}</span><p ng-if=\"vm.content(\'accept_marketing_explanation\')\" class=\"text--small text--secondary push-half--top push--bottom\">{{vm.content(\'accept_marketing_explanation\')}}</p></label></div><div ng-if=\"vm.settings.captureSeparateMarketingConsents && vm.settings.captureAcceptMarketingSMS\" class=\"push-half--top flush--bottom\"><label class=\"label label--checkbox\" for=\"accept-marketing-sms\" ng-class=\"{\'is-checked\' : vm.details.acceptMarketingSMS}\"><input id=\"accept-marketing-sms\" name=\"marketingAcceptedSMS\" ng-model=\"vm.details.acceptMarketingSMS\" type=\"checkbox\"> <span ng-if=\"vm.content(\'accept_marketing_sms\')\">{{vm.content(\'accept_marketing_sms\')}}</span> <span ng-if=\"!vm.content(\'accept_marketing_sms\')\">{{\'SESSIONS.DETAILS.I_ACCEPT_MARKETING_SMS\' | translate: { VENUENAME: vm.settings.venueName } : \'messageformat\'}}</span><p ng-if=\"vm.content(\'accept_marketing_sms_explanation\')\" class=\"text--small text--secondary push-half--top push--bottom\">{{vm.content(\'accept_marketing_sms_explanation\')}}</p></label></div><div class=\"push-half--ends\"><label class=\"label label--checkbox\" for=\"terms-and-conditions\" ng-class=\"{ \'is-checked\' : vm.details.termsAccepted }\"><input id=\"terms-and-conditions\" name=\"termsAccepted\" ng-model=\"vm.details.termsAccepted\" required=\"\" type=\"checkbox\" class=\"_push-quarter--right\"> <span><a ng-click=\"vm.termsAndConditions(); $event.preventDefault();\" class=\"link\"><span ng-if=\"vm.policyUrl\">{{\'SESSIONS.DETAILS.I_HAVE_READ_AND_POLICY\' | translate: { venueName: vm.settings.venueName } }}</span> <span ng-if=\"!vm.policyUrl\">{{\'SESSIONS.DETAILS.I_HAVE_READ\' | translate: { venueName: vm.settings.venueName } }}</span></a>&nbsp;<span class=\"required\">*</span></span><div ng-messages=\"consentForm.termsAccepted.$error\" class=\"message--warning\" ng-if=\"consentForm.termsAccepted.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.MUST_ACCEPT\"></span></span></div></label></div></div></form><div class=\"soft-mid--sides hide-for-desktop\" ng-if=\"vm.hasWarnings()\"><span class=\"message--warning\"><span translate=\"SESSIONS.DETAILS.PLEASE_REVIEW_YOUR_DETAILS_ABOVE\"></span></span></div></div></div><loader class=\"loading--ghost\" ng-show=\"vm.orderService.inProgress && !vm.isVerifyingGiftCard\" is-loading=\"vm.orderService.inProgress\"></loader><div class=\"hide-for-portable\" id=\"recaptcha\"></div>");
$templateCache.put("app/views/sessions/sessions.home.html","<div><div id=\"roller-calendar\" class=\"datepicker__wrapper is-embedded\" ng-if=\"vm.showDateLedCalendar() && vm.canShowCalendar()\"><button qa-id=\"datePicker\" type=\"button\" class=\"datepicker__btn\" ng-model=\"vm.date\" ng-change=\"vm.dateSelected(vm.date)\" datepicker-config=\"vm.datePickerConfig\" ng-flat-datepicker=\"\"><i class=\"material-icons md-14 _push-quarter--right\">date_range</i><p class=\"flush--bottom\">{{ vm.formattedDate() }}</p><i class=\"material-icons datepicker__arrow\">keyboard_arrow_down</i></button></div><div class=\"accordion\" ng-if=\"!vm.showDateLedCalendar() && vm.canShowCalendar()\"><div id=\"roller-datepicker\" class=\"datepicker__wrapper\" ng-if=\"vm.settings.showDatePicker(vm.hideCalendar)\" ng-show=\"!vm.loading\"><button qa-id=\"datePicker\" type=\"button\" class=\"datepicker__btn\" ng-model=\"vm.date\" ng-change=\"vm.getProducts(vm.date)\" datepicker-config=\"vm.datePickerConfig\" ng-flat-datepicker=\"\"><i class=\"material-icons md-14 _push-quarter--right\">date_range</i><p class=\"flush--bottom\">{{ vm.formattedDate() }}</p><i class=\"material-icons datepicker__arrow\">keyboard_arrow_down</i></button></div><span class=\"loading\" ng-if=\"vm.loading\"><img src=\"https://cdn.rollerdigital.com/assets/icons/loaders/spinner.svg\" height=\"70\" alt=\"loading spinner\"></span><div class=\"callout--note push-mid--sides push--bottom\" ng-if=\"vm.isConsumerWidgetGroup() && vm.productsAvailable()\" ng-show=\"!vm.loading\"><div class=\"flex-align--center push-half--bottom\" ng-if=\"vm.title\"><img ng-if=\"vm.group().imageUrl\" ng-src=\"{{vm.group().imageUrl}}\" class=\"session__image push-half--right\"><h3 class=\"delta flush\">{{vm.title}}</h3></div><p class=\"flush\" ng-bind-html=\"vm.group().description\"></p></div><div ng-repeat=\"group in vm.groupedProducts\" ng-show=\"!vm.loading\"><div ng-if=\"group.title\" class=\"flex--between one-whole soft-half--ends soft-mid--sides accordion__header\" ng-class=\"{\'is-open\': group.isSelected}\" ng-click=\"vm.toggleGroup(group)\"><div class=\"flex-align--center flex--between one-whole\"><h2 class=\"flush epsilon\">{{ group.title }}</h2><sold-out class=\"sold-out _push-quarter--top\" ng-if=\"group.isSoldOut\"></sold-out></div><span class=\"accordion__arrow material-icons\" ng-class=\"{\'is-open\': group.isSelected}\">keyboard_arrow_down</span></div><div ng-repeat=\"product in group.products\" ng-if=\"!group.title || group.isSelected\"><div qa-id=\"product-{{product.name}}\" class=\"accordion__header\" ng-class=\"{\'is-open\': product.isSelected && vm.products.length > 1}\" ng-click=\"vm.toggleProduct(product, $event)\"><img ng-src=\"{{product.imageUrl}}\" class=\"cell--image float--left\" ng-if=\"product.imageUrl\"><div class=\"one-whole\"><div class=\"accordion__heading\"><div class=\"one-whole flex flex--between flex--wrap\"><h2 class=\"epsilon\" ng-class=\"{\'_line-height--medium\' : (product.isSoldOut && !group.isSoldOut) || (product.isClosed && !product.isSoldOut)}\">{{ product.name }}</h2><sold-out ng-if=\"product.isSoldOut && !group.isSoldOut\"></sold-out><sales-closed ng-if=\"product.isClosed && !product.isSoldOut\" booking-phone-number=\"vm.callToBookPhoneNumber\"></sales-closed></div><span class=\"accordion__arrow material-icons\" ng-class=\"{\'is-open\': product.isSelected}\" ng-if=\"!product.isClosed && !product.isSoldOut\">keyboard_arrow_down</span></div><p class=\"_text--small _push-quarter--bottom _push-quarter--top\" ng-if=\"vm.showAvailabilityOverride()\">{{ vm.products[0].availabilityOverride }}</p><p class=\"_text--small _push-quarter--top\" style=\"margin-bottom:0;font-weight:700\" ng-if=\"product.recurringSessionsText\">{{ product.recurringSessionsText }}</p><p class=\"flush _text--small _overflow-wrap\"><span ng-if=\"!product.isSelected\" ng-bind-html=\"product.shortDescription\" qa-id=\"product-short-description\"></span> <span ng-if=\"product.isSelected\" ng-bind-html=\"product.description\" qa-id=\"product-description\"></span></p><div ng-if=\"product.productTypeId == \'giftCard\'\" class=\"push-half--top\"><p class=\"flush _text--small _font--strong\" ng-if=\"product.validDays\">{{\'SESSIONS.VALID_UNTIL\' | translate : { expiry: (product.validDays | expiry)} : \'messageformat\' }}</p></div></div></div><span class=\"loading\" ng-if=\"product.loadingSessions\"><img src=\"https://cdn.rollerdigital.com/assets/icons/loaders/spinner.svg\" height=\"70\" alt=\"loading spinner\"></span><div ng-if=\"product.isSelected\" ng-class=\"{\'accordion__body\': vm.products.length > 1}\"><div class=\"soft-half--ends soft-mid--sides\" ng-if=\"product.sessions && product.sessions.length\"><h3 class=\"epsilon _push-quarter--bottom\"><span ng-if=\"vm.content(\'session_time\')\">{{vm.content(\'session_time\')}}</span> <span ng-if=\"!vm.content(\'session_time\')\" translate=\"SESSIONS.SESSION_TIME\"></span></h3><div class=\"btn-grid cf\" ng-if=\"vm.useSessionTiles\"><button type=\"button\" class=\"btn btn--timeslot btn--radius btn--slim text--center\" qa-id=\"sessions\" ng-repeat=\"session in product.sessions\" ng-class=\"{\'btn--active btn--green\': session.isSelected, \'btn--disabled\': session.isSoldOut, \'btn--limited\': vm.hasLimitedAvailability(session)}\" ng-click=\"vm.toggleSession(session, product)\" ng-disabled=\"session.isSoldOut\"><span class=\"btn__text\">{{ session.name }}</span> <span class=\"btn__availability\" ng-if=\"vm.showRemainingCapacity && vm.hasLimitedAvailability(session)\"><span class=\"material-icons md-13\">error</span> <span class=\"btn__availability__text\" translate=\"SESSIONS.SELLING_FAST\"></span></span> <span class=\"btn__availability\" ng-if=\"vm.showRemainingCapacity && !vm.hasLimitedAvailability(session)\">{{ (session.availableBookings ? session.singleBookingLocationsRemaining : session.remaining) | soldOut}}</span></button></div><div class=\"btn-grid cf\" ng-if=\"!vm.useSessionTiles\"><div ng-repeat=\"session in product.sessions\"><button type=\"button\" class=\"btn btn--timeslot btn--radius btn--bar\" ng-class=\"{\'btn--active btn--green\': session.isSelected, \'btn--disabled\': session.isSoldOut}\" ng-click=\"vm.toggleSession(session, product)\" ng-disabled=\"session.isSoldOut\"><span class=\"btn__text\">{{ session.name }}</span> <span class=\"btn__availability\" ng-class=\"{\'btn--limited\': vm.hasLimitedAvailability(session)}\" ng-if=\"vm.showRemainingCapacity\"><span class=\"material-icons md-13\" ng-if=\"vm.hasLimitedAvailability(session)\">error</span> <span ng-if=\"!(session.availableBookings ? session.singleBookingLocationsRemaining : session.remaining)\">{{ soldOut }}</span> <span ng-if=\"!!(session.availableBookings ? session.singleBookingLocationsRemaining : session.remaining)\">{{ session.availableBookings ? session.singleBookingLocationsRemaining : session.remaining }} <span translate=\"SESSIONS.REMAINING\"></span></span></span></button><div class=\"soft-half--ends\" ng-if=\"session.isSelected\" ng-include=\"\'ticket-template\'\"></div></div></div></div><div class=\"soft-half--bottom soft-mid--sides\" ng-if=\"vm.showTickets(product)\" ng-include=\"\'ticket-template\'\"></div></div></div></div><div class=\"panel soft-mid--sides\" ng-if=\"!vm.loading && !vm.productsAvailable()\" ng-show=\"!vm.loading\"><div class=\"not-available text--center\"><div class=\"circle circle--large circle--search _display--inline-block\"><span class=\"material-icons md-28\">search</span></div><p class=\"push-half--bottom\" translate=\"SESSIONS.NOTHING_ON_DATE\"></p><p class=\"_text--small _text--secondary\"><span translate=\"SESSIONS.SHOW_NEXT\"></span> <a href=\"\" ng-click=\"vm.findNextAvailable()\" class=\"_text--secondary\" translate=\"SESSIONS.AVAILABLE_DATE\"></a></p></div></div></div></div><script type=\"text/ng-template\" id=\"ticket-template\"><div> <div class=\"product\" ng-repeat=\"ticket in product.tickets\" ng-class=\"{\'push-half--bottom\' : !ticket.description}\" qa-id=\"ticket-{{ticket.name}}\"> <div class=\"product__options\" ng-class=\"{\'is-sold-out\' : (ticket.isSoldOut || ticket.isClosed || !vm.canIncrease(ticket, vm.products))}\"> <div class=\"one-whole _push-quarter--top\"> <div class=\"product__description\"> <h3 class=\"epsilon _line-height--tiny flush\" ng-if=\"!ticket.isNameSameAsPrice\"> {{ ticket.name }} </h3> <a ng-show=\"!vm.content(\'always_show_ticket_details\') && ticket.description && !ticket.seeMoreClicked\" ng-click=\"ticket.seeMoreClicked = true\" class=\"_text--small _line-height--base link--grey\" aria-hidden=\"false\" translate=\"GENERIC.DETAILS\" qa-id=\"open-ticket-details-button\"></a> <a ng-show=\"!vm.content(\'always_show_ticket_details\') && ticket.description && !!ticket.seeMoreClicked\" ng-click=\"ticket.seeMoreClicked = false\" class=\"_text--small _line-height--base link--grey\" aria-hidden=\"true\" translate=\"GENERIC.COLLAPSE\" qa-id=\"collapse-ticket-details-button\"></a> </div> <div class=\"product__price--duration\"> <div class=\"_display--inline-block product__duration\" ng-if=\"ticket.categories && !vm.settings.hideSessionDuration()\" ng-click=\"ticket.selectDuration = !ticket.selectDuration\" ng-class=\"{\'is-active\': ticket.selectDuration, \'dropdown\': ticket.categories.length > 1}\"> <span qa-id=\"consecutiveSessions\" ng-class=\"{\'dropdown__trigger\': ticket.categories.length > 1}\"><span ng-if=\"ticket.remainingRecurringSessions\">{{ticket.remainingRecurringSessions}} x </span>{{ vm.formatDuration(ticket.selectedDuration) }}</span> <span class=\"material-icons md-18 dropdown__arrow\" ng-if=\"ticket.categories.length > 1\">arrow_drop_down</span> <ul class=\"dropdown-menu\" ng-if=\"ticket.categories.length > 1\" ng-class=\"{\'dropdown-menu--small\' : !vm.showRemainingCapacity}\"> <li class=\"dropdown-menu__item\" ng-repeat=\"category in ticket.categories\"> <a qa-id=\"sessionDurations-{{$index}}\" href=\"\" ng-click=\"vm.selectDuration(ticket, category.duration)\">{{ vm.formatDuration(category.duration) }}<span ng-if=\"vm.showRemainingCapacity\"> - {{ category.remaining }} <span translate=\"SESSIONS.REMAINING\"></span></span></a> </li> </ul> </div> <p ng-if=\"ticket.minimumSpend\" class=\"_display--inline-block flush epsilon\">{{ ticket.minimumSpend | rollerCurrency }} <span translate=\"SESSIONS.MIN_SPEND\"></span></p> <p ng-if=\"!ticket.minimumSpend && !ticket.hasUserDefinedCost\" class=\"_display--inline-block flush epsilon\"> <span ng-if=\"!ticket.recurringPayment\" qa-id=\"ticket-cost\">{{ vm.order.calculateTicketPrice(ticket, { ignoreDeposit: true }) | rollerCurrency }}</span> <span ng-if=\"!!ticket.recurringPayment\"> <span ng-if=\"!ticket.recurringPayment.numberOfPayments\"> {{ticket.price | rollerCurrency}}/ {{ \'SESSIONS.RECURRING_BILLING.INFO_ONGOING\' | translate: { frequency: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.SINGULAR.\' + ticket.recurringPayment.paymentFrequencyId.toUpperCase()) | translate) } }} </span> <span ng-if=\"!!ticket.recurringPayment.numberOfPayments\"> {{ticket.price | rollerCurrency}}/ {{ \'SESSIONS.RECURRING_BILLING.INFO\' | translate: { numberOfPayments: (ticket.recurringPayment.numberOfPayments), frequency: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.SINGULAR.\' + ticket.recurringPayment.paymentFrequencyId.toUpperCase()) | translate), period: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.PLURAL.\' + ticket.recurringPayment.paymentFrequencyId.toUpperCase()) | translate) } }} </span> </span> </p> <p ng-if=\"ticket.hasUserDefinedCost\" class=\"_display--inline-block flush epsilon\" qa-id=\"user-defined-cost-range\">{{ ticket.minUserDefinedCost | rollerCurrency }} - {{ ticket.maxUserDefinedCost | rollerCurrency }}</p> <p class=\"product__min-term__wrapper\" ng-if=\"!!ticket.recurringPayment.minNumberOfPayments\"> <span class=\"product__min-term\">{{ \'SESSIONS.RECURRING_BILLING.MINIMUM_TERM\' | translate: { term: ticket.recurringPayment.minNumberOfPayments + \' \' + ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.PLURAL.\' + ticket.recurringPayment.paymentFrequencyId.toUpperCase()) | translate)} }}</span> </p> </div> </div> <div> <number-input ng-if=\"!ticket.hasUserDefinedCost\" can-decrease=\"vm.canDecrease(ticket)\" can-increase=\"vm.canIncrease(ticket, vm.products)\" decrease=\"vm.decrease(ticket, product)\" increase=\"vm.increase(ticket, product)\" text-focus=\"vm.onCustomFieldFocus(ticket)\" ticket=\"ticket\" qty-added=\"ticket.inCartQuantity\"> </number-input> <p class=\"flush--bottom text--center _push-quarter--top\" ng-if=\"ticket.isSoldOut\" translate=\"SESSIONS.SOLD_OUT\"></p> <div ng-if=\"ticket.hasUserDefinedCost\"> <input type=\"number\" class=\"text-input input--large text--right\" ng-model=\"ticket.price\" min=\"{{ticket.minUserDefinedCost}}\" max=\"{{ticket.maxUserDefinedCost}}\" qa-id=\"user-defined-cost-input\" ng-focus=\"vm.onCustomFieldFocus(ticket)\" empty-if-zero /> </div> <div class=\"push-half--top\" ng-if=\"ticket.maxAdditionalGuests && ticket.quantity\"> <span>No. of {{ticket.guestLabel || \"guests\"}}</span> <div class=\"custom-select push-half--top\" style=\"background-color:#fff\"> <select class=\"one-whole\" ng-model=\"ticket.additionalGuests\" ng-options=\"p as p for p in ticket.getAdditionalGuestOptions()\"></select> </div> </div> </div> </div> <div ng-if=\"vm.showUpdateCartButton(ticket)\" class=\"flex-end push-half--top\"> <button qa-id=\"addToCart\" type=\"button\" class=\"btn btn--green btn--radius\" ng-click=\"vm.updateCart(ticket, product)\"> <span>{{ (ticket.inCartQuantity ? \'SESSIONS.UPDATE_CART\' : \'SESSIONS.ADD_TO_CART\') | translate }}</span> </button> </div> <p class=\"flex--end push-half--ends\" ng-if=\"ticket.showMaxTicketWarning\"> <span class=\"md-20 material-icons state--warning-solid push-half--right\">warning</span> <span>{{ \'SESSIONS.TICKET_LIMIT\' | translate | stringFormat: ticket.quantity }}</span> </p> <p ng-show=\"ticket.seeMoreClicked || vm.content(\'always_show_ticket_details\')\" class=\"product__description__text\" ng-bind-html=\"ticket.description\" qa-id=\"ticket-description\"></p> <button ng-if=\"vm.showNextButton(ticket)\" type=\"button\" class=\"btn btn--soft btn--green btn--responsive push-mid--bottom--portable text--center btn--navigation one-whole push-half--ends visuallyhidden--desk\" ng-click=\"vm.moveNext()\" translate=\"{{ vm.nextButtonText() }}\" translate-values=\"{ amount: \'{{vm.order.total() | rollerCurrency}}\' }\"></button> </div> </div></script>");
$templateCache.put("app/views/sessions/sessions.payment.html","<div class=\"layout__inner soft-half--bottom soft-mid--sides\"><div ng-if=\"vm.isCartAlwaysVisible\" class=\"visuallyhidden--desk\"><order-summary ng-if=\"!vm.orderService.isProcessed()\" always-visible=\"vm.isCartAlwaysVisible\"></order-summary></div><div ng-if=\"vm.paymentErrors && vm.paymentErrors.length\"><span class=\"message--warning\" ng-repeat=\"paymentError in vm.paymentErrors\">{{ paymentError }}</span></div><div class=\"push--bottom\" ng-if=\"vm.showPaymentDetails() && !vm.onlyAcceptMX && !vm.promotion.hasPromotedProduct() && !vm.paymentSetting.isDropIn\"><div class=\"btn--group-pay-type\" ng-class=\"{ \'btn--group-pay-type--rtl\': vm.isRtl }\"><button class=\"btn btn--slim btn--border btn--white btn--radius btn-text--large push-mid--bottom--portable\" ng-disabled=\"vm.orderService.inProgress\" ng-click=\"vm.setPaymentMethod(\'creditcard\')\" ng-class=\"{ \'btn--active\' : vm.payment.paymentMethod === \'creditcard\' }\" name=\"credit\" id=\"credit\" ng-if=\"vm.hasCreditCardOption()\" translate=\"SESSIONS.PAYMENT.DEBIT_CREDIT\"></button> <button class=\"btn btn--slim btn--border btn--white btn--radius btn-text--large push-mid--bottom--portable\" ng-disabled=\"vm.orderService.inProgress\" ng-click=\"vm.setPaymentMethod(\'paypal\')\" ng-class=\"{ \'btn--active\' : vm.payment.paymentMethod === \'paypal\', \'btn--tabs--last\': !vm.payment.isBankTransferEnabled }\" ng-if=\"vm.paymentSetting.isPaypalEnabled && !vm.orderService.hasRecurring()\" name=\"paypal\" id=\"paypal\" translate=\"SESSIONS.PAYMENT.PAYPAL\"></button> <button ng-repeat=\"subPaymentType in vm.sortedSubPaymentTypes || vm.paymentSetting.subPaymentTypes\" ng-if=\"!vm.orderService.hasRecurring()\" class=\"btn btn--slim btn--border btn--white btn--radius btn-text--large push-mid--bottom--portable\" ng-click=\"vm.payment.paymentMethod = \'others\';vm.payment.subPaymentMethod = subPaymentType\" ng-class=\"{ \'btn--active\' : vm.payment.subPaymentMethod === subPaymentType, \'btn--img--sofort\' : subPaymentType === \'directEbanking\', \'btn--img--sofort--fr\' : vm.languageCode === \'fr\', \'btn--img--sofort--es\' : (vm.languageCode === \'es\' || vm.languageCode === \'it\'), \'btn--img--mada\' : (subPaymentType || \'\').toLowerCase() === \'mada\', \'btn--img--visa\' : (subPaymentType || \'\').toLowerCase() === \'visa\', \'btn--img--mastercard\' : (subPaymentType || \'\').toLowerCase() === \'mastercard\'}\" name=\"{{subPaymentType}}\" id=\"{{subPaymentType}}\" ng-disabled=\"vm.orderService.inProgress\"><span class=\"btn__logo\"></span> <span class=\"btn__text\">{{(subPaymentType === \'directEbanking\' ? \'SESSIONS.PAYMENT.SOFORT\' : (subPaymentType === \'paypal\' ? \'SESSIONS.PAYMENT.PAYPAL\' : subPaymentType)) | translate}}</span></button> <button class=\"btn btn--slim btn--border btn--white btn--radius btn-text--large push-mid--bottom--portable\" ng-if=\"vm.payment.isBankTransferEnabled && !vm.orderService.hasRecurring()\" ng-click=\"vm.setPaymentMethod(\'banktransfer\', true)\" ng-class=\"{ \'btn--active\' : vm.payment.paymentMethod === \'banktransfer\' }\" name=\"bank-transfer\" id=\"bank-transfer\" ng-disabled=\"vm.orderService.inProgress\"><span ng-if=\"!vm.payLaterName\" translate=\"SESSIONS.PAYMENT.BANK_TRANSFER\"></span> <span ng-if=\"vm.payLaterName\">{{ vm.payLaterName }}</span></button></div></div><div ng-if=\"vm.hasRecurringPayment\" class=\"push--bottom\"><div class=\"callout--info flex\"><span class=\"material-icons\">info</span><div ng-repeat=\"item in vm.recurringPaymentDetails\"><div><span ng-if=\"!item.numberOfPayments\">{{ \'SESSIONS.PAYMENT.RECURRING_BILLING_SUMMARY_ONGOING\' | rollerTranslate: { paymentMethod: \'card\', amount: (item.price | rollerCurrency), frequency: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.SINGULAR.\' + item.frequency.toUpperCase()) | translate) } }}</span> <span ng-if=\"!!item.numberOfPayments\">{{ \'SESSIONS.PAYMENT.RECURRING_BILLING_SUMMARY\' | rollerTranslate: { paymentMethod: \'card\', amount: (item.price | rollerCurrency), numberOfPayments: (item.numberOfPayments), frequency: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.SINGULAR.\' + item.frequency.toUpperCase()) | translate), period: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.PLURAL.\' + item.frequency.toUpperCase()) | translate) } }}</span> <span ng-if=\"vm.recurringPaymentMinimumPeriods && vm.recurringPaymentMinimumPeriods.length === 1\">{{ \'SESSIONS.PAYMENT.RECURRING_MINIMUM_OBLIGATION_SINGLE\' | rollerTranslate: { numberOfPayments: (vm.recurringPaymentMinimumPeriods[0].minNumberOfPayments), frequency: ((\'SESSIONS.RECURRING_BILLING.FREQUENCY.PLURAL.\' + vm.recurringPaymentMinimumPeriods[0].frequency.toUpperCase()) | translate) } }}</span> <span ng-if=\"vm.recurringPaymentMinimumPeriods && vm.recurringPaymentMinimumPeriods.length > 1\" ng-bind-html=\"vm.getMinPeriodString()\"></span></div></div></div></div><div><form class=\"form-fields\" name=\"paymentForm\" novalidate=\"\"><div class=\"push--bottom\" ng-if=\"vm.showPaymentDetails()\"><div ng-if=\"vm.allowBookingDeposit()\" class=\"push--bottom\"><label for=\"expiry\" class=\"label\" translate=\"SESSIONS.PAYMENT.PAYMENT_OPTION\"></label><div class=\"push-half--top\"><label class=\"push-half--bottom label--radio\" ng-class=\"{\'is-checked\': !vm.payFullAmount}\" style=\"display: inline\" qa-id=\"pay-deposit-checkbox\"><input type=\"radio\" ng-model=\"vm.payFullAmount\" ng-value=\"false\" ng-change=\"vm.depositOptionChanged(vm.payFullAmount)\" ng-disabled=\"vm.orderService.inProgress\"> <span translate=\"SESSIONS.PAYMENT.PAY_DEPOSIT\"></span></label> <label class=\"push--left label--radio\" ng-class=\"{\'is-checked\': vm.payFullAmount}\" style=\"display: inline\" qa-id=\"pay-full-checkbox\"><input type=\"radio\" ng-model=\"vm.payFullAmount\" ng-value=\"true\" ng-change=\"vm.depositOptionChanged(vm.payFullAmount)\" ng-disabled=\"vm.orderService.inProgress\"> <span translate=\"SESSIONS.PAYMENT.PAY_FULL_AMOUNT\"></span></label></div></div><div ng-show=\"vm.paymentSetting.isPaypalEnabled && vm.payment.requiresPayPal()\"><div id=\"paypal-container\" class=\"_border--dashed text--center soft\"></div></div><div class=\"soft-mid--sides\" ng-if=\"vm.requiresTermsToBeAccepted && !vm.orderService.noFurtherPaymentRequired()\"><div class=\"push-half--ends\"><label class=\"push-half--bottom\"><span>{{ \'SESSIONS.PAYMENT.YOUR_PAYMENT_PROCESSED_BY_ROLLER\' | translate }} (<a href=\"https://rllr.co\">rllr.co</a>)</span></label> <label class=\"push-half--bottom label--checkbox\" for=\"terms-and-conditions\" ng-class=\"{ \'is-checked\' : vm.payment.termsAccepted }\"><input id=\"terms-and-conditions\" name=\"termsAccepted\" ng-model=\"vm.payment.termsAccepted\" required=\"\" type=\"checkbox\" class=\"_push-quarter--right\"> <span><a ng-click=\"vm.termsAndConditions(); $event.preventDefault();\" class=\"link\" translate=\"SESSIONS.PAYMENT.I_HAVE_READ_PAYMENT_TERMS\"></a>&nbsp;<span class=\"required\">*</span></span><div ng-messages=\"paymentForm.termsAccepted.$error\" class=\"message--warning\" ng-if=\"paymentForm.termsAccepted.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.YOUR_MUST_ACCEPT_PAYMENT_TERMS\"></span></span></div></label> <label class=\"label--checkbox\" for=\"privacy-policy\" ng-class=\"{ \'is-checked\' : vm.payment.privacyPolicyAccepted }\"><input id=\"privacy-policy\" name=\"privacyPolicyAccepted\" ng-model=\"vm.payment.privacyPolicyAccepted\" required=\"\" type=\"checkbox\" class=\"_push-quarter--right\"> <span><a ng-click=\"vm.privacyStatement(); $event.preventDefault();\" class=\"link\" translate=\"SESSIONS.PAYMENT.I_HAVE_READ_PRIVACY_STATEMENTS\"></a>&nbsp;<span class=\"required\">*</span></span><div ng-messages=\"paymentForm.privacyPolicyAccepted.$error\" class=\"message--warning\" ng-if=\"paymentForm.privacyPolicyAccepted.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.YOUR_MUST_ACCEPT_PRIVACY_POLICY\"></span></span></div></label></div></div><loader ng-if=\"vm.paymentSetting.isDropIn && (!vm.isReady || vm.orderService.inProgress) && !vm.isShowingPaymentQRCode\" class=\"spinner--dark\" loading-text=\"{{ !vm.isReady ? (\'SESSIONS.LOADING\' | translate) : (vm.updatingPaymentMethod ? \' \' : null) }}\" is-loading=\"vm.paymentSetting.isDropIn && (!vm.isReady || vm.orderService.inProgress)\"></loader><div ng-show=\"(vm.paymentSetting.hasPaymentFrame && vm.payment.paymentMethod !== \'banktransfer\') || vm.paymentSetting.isDropIn && vm.isReady && (!vm.orderService.inProgress || vm.isShowingPaymentQRCode)\" ng-class=\"{ \'drop-in-credit-card\': vm.paymentSetting.isDropIn && vm.payment.paymentMethod === \'creditcard\', \'drop-in-bank-transfer\': vm.paymentSetting.isDropIn && vm.payment.paymentMethod === \'banktransfer\'}\"><div id=\"payment-container\" element-ready=\"vm.hackClick(\'payment-container\')\"></div><div class=\"push-half--top\" ng-if=\"vm.payment.isBankTransferEnabled && !vm.orderService.hasRecurring() && vm.paymentSetting.isDropIn\" ng-hide=\"vm.isShowingPaymentQRCode\"><ul class=\"pay-method__list\"><li class=\"pay-method__list-item\" ng-class=\"{\'selected\': vm.payment.paymentMethod == \'banktransfer\' }\" ng-click=\"vm.setPaymentMethod(\'banktransfer\', true)\"><label class=\"label--radio\" ng-class=\"{\'is-checked\': vm.payment.paymentMethod == \'banktransfer\' }\" qa-id=\"bank-transfer\"><input type=\"radio\" ng-model=\"isBankTransfer\" ng-value=\"true\" ng-disabled=\"vm.orderService.inProgress\"> <span class=\"pay-method__image\"><img src=\"//cdn.rollerdigital.com/assets/icons/payment/bank-transfer.svg\" height=\"24\"></span> <span ng-if=\"!vm.payLaterName\" class=\"pay-method__name\" translate=\"SESSIONS.PAYMENT.BANK_TRANSFER\"></span> <span ng-if=\"vm.payLaterName\" class=\"pay-method__name\">{{ vm.payLaterName }}</span></label><div class=\"push-half--top\" ng-if=\"vm.payment.paymentMethod == \'banktransfer\'\"><p class=\"text--center text--small\" translate=\"SESSIONS.PAYMENT.BANK_TRANSFER_NOTICE\"></p></div></li></ul></div></div><div class=\"cf push--bottom\" ng-show=\"vm.payment.requiresCreditCard() && !vm.paymentSetting.hasPaymentFrame && !vm.paymentSetting.overrideUI\" ng-if=\"!vm.onlyAcceptMX\"><img class=\"push-half--ends _push-quarter--right float--left\" style=\"border-radius: 3px; height: 49px\" alt=\"{{vm.promotion.getSettings().sponsorName}}\" ng-if=\"vm.promotion.hasPromotedProduct() && vm.promotion.getSettings() && vm.promotion.getSettings().cardLogoUrl\" ng-src=\"{{vm.promotion.getSettings().cardLogoUrl}}\" height=\"49\"><div class=\"logo _display--inline-block\" ng-class=\"vm.content(\'show_amex_logo\') === \'true\' ? (vm.isMXCardPreferred ? \'logo--credit-card-amex-preferred-with-others\' : \'logo--credit-card-amex\'): \'logo--credit-card\'\"></div></div><div class=\"cf push--bottom\" ng-show=\"vm.payment.requiresCreditCard() && !vm.paymentSetting.hasPaymentFrame && !vm.paymentSetting.overrideUI\" ng-if=\"vm.onlyAcceptMX\"><div class=\"logo--credit-card-amex-preferred\"></div></div><ul class=\"form-fields\" ng-show=\"vm.payment.requiresCreditCard() && !vm.paymentSetting.hasPaymentFrame && !vm.paymentSetting.overrideUI\"><li ng-if=\"vm.payment.requiresCreditCard()\"><label for=\"card-number\" class=\"label _display--inline-block\" translate=\"SESSIONS.PAYMENT.CARD_NUMBER\"></label> <span class=\"required\">*</span> <input type=\"creditcard\" id=\"card-number\" name=\"cardNumber\" ng-model=\"vm.payment.cardNumber\" class=\"text-input one-whole\" ng-class=\"{\'input--error\': paymentForm.cardNumber.$invalid && vm.orderService.hasClickedContinue()}\" required=\"\" cc-number=\"\" cc-format=\"\" cc-eager-type=\"\" cc-type=\"vm.getAcceptedCardType()\"><div ng-messages=\"paymentForm.cardNumber.$error\" class=\"message--warning\" ng-if=\"paymentForm.cardNumber.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ENTER_CC\"></span></span> <span ng-message=\"ccNumber\"><span translate=\"SESSIONS.PAYMENT.ENTER_VALID_CC\"></span></span> <span ng-message=\"ccNumberType\">{{vm.getCardTypeValidationMsg()}}</span></div><div ng-if=\"vm.payment.cardPromotionError()\" class=\"message--warning\"><span>{{vm.promotion.getCardPromotionValidationMessage()}}</span></div></li><li ng-if=\"vm.payment.requiresCreditCard()\"><label for=\"card-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.PAYMENT.CARD_NAME\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': paymentForm.cardName.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole _transform--upper\" id=\"card-name\" name=\"cardName\" required=\"\" ng-model=\"vm.payment.cardName\" type=\"text\"><div ng-messages=\"paymentForm.cardName.$error\" class=\"message--warning\" ng-if=\"paymentForm.cardName.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ENTER_CARD_NAME\"></span></span></div></li></ul><div class=\"flexbox push-half--top\" ng-if=\"vm.payment.requiresCreditCard() && !vm.paymentSetting.hasPaymentFrame && !vm.paymentSetting.overrideUI\"><div class=\"flexbox__item flexbox__item--top _vertical-align--top one-half\"><ul class=\"form-fields push--right\"><li class=\"soft-half--bottom\"><label for=\"expiry\" class=\"label _display--inline-block\" translate=\"SESSIONS.PAYMENT.EXPIRY\"></label> <span class=\"required\">*</span><div class=\"flex\"><div class=\"custom-select input--medium push-half--right _display--inline-block\" ng-class=\"{\'custom-select--error\' : vm.payment.cardExpiryError() && vm.orderService.hasClickedContinue()}\"><select id=\"expiry\" qa-id=\"expiryMonth\" name=\"expiryMonth\" ng-model=\"vm.payment.cardExpiryMonth\" ng-options=\"month.value as month.name for month in vm.months\"><option value=\"?\"><span translate=\"SESSIONS.PAYMENT.SHORT_MONTH\"></span></option></select></div><div class=\"custom-select input--medium _display--inline-block\" ng-class=\"{\'custom-select--error\' : vm.payment.cardExpiryError() && vm.orderService.hasClickedContinue()}\"><select name=\"expiryYear\" qa-id=\"expiryYear\" ng-model=\"vm.payment.cardExpiryYear\" ng-options=\"year for year in vm.years\"><option value=\"?\"><span translate=\"SESSIONS.PAYMENT.SHORT_YEAR\"></span></option></select></div></div><div class=\"message--warning push-half--top\" ng-show=\"vm.payment.cardExpiryError() && vm.orderService.hasClickedContinue()\">{{vm.payment.cardExpiryError()}}</div></li></ul></div><div class=\"flexbox__item flexbox__item--top _vertical-align--top one-half\"><ul class=\"form-fields\"><li><label for=\"ccv\" class=\"label _display--inline-block\" translate=\"SESSIONS.PAYMENT.CVV\"></label> <span class=\"required\">*</span><div class=\"cf\"><input type=\"text\" class=\"text-input two-fifths\" id=\"cvv\" qa-id=\"ccv\" name=\"cardCCV\" ng-model=\"vm.payment.cardCVV\" required=\"\" cc-cvc=\"\" filter-input=\"\\d\" cc-type=\"paymentForm.cardNumber.$ccType\" ng-class=\"{\'input--error\' : paymentForm.cardCCV.$invalid && vm.orderService.hasClickedContinue()}\"><div ng-messages=\"paymentForm.cardCCV.$error\" class=\"message--warning\" ng-if=\"paymentForm.cardCCV.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"ccCvc\"><span translate=\"SESSIONS.PAYMENT.ENTER_CVV\"></span></span> <span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ENTER_CVV\"></span></span></div></div></li></ul></div></div></div><div class=\"push--bottom\" ng-if=\"vm.isPayUArgentina && vm.showPaymentDetails()\"><h3 class=\"_font--strong push-mid--bottom\" translate=\"SESSIONS.PAYMENT.PAYER_INFO\"></h3><ul class=\"form-fields\"><li><label for=\"stateSelect\" class=\"label label _display--inline-block\" translate=\"SESSIONS.PAYMENT.STATE_AR\"></label> <span class=\"required\">*</span><div class=\"flexbox\"><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top\"><div class=\"custom-select input--xlarge _display--inline-block\" ng-class=\"{\'custom-select--error\' : paymentForm.stateSelect.$invalid && vm.orderService.hasClickedContinue()}\"><select id=\"stateSelect\" name=\"stateSelect\" ng-if=\"vm.documentTypes\" ng-model=\"vm.payment.billingAddress.state\" required=\"\"><option value=\"\"></option><option ng-repeat=\"state in vm.states\" ng-value=\"state.code\">{{state.name}}</option></select></div><div ng-messages=\"paymentForm.stateSelect.$error\" class=\"message--warning\" ng-if=\"paymentForm.stateSelect.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ENTER_YOUR_BILLING_STATE\"></span></span></div></div></div></li><li><div class=\"flexbox\"><div class=\"flexbox__item hard--portable soft-top--portable _vertical-align--top\"><label for=\"idType\" class=\"label\"><span translate=\"SESSIONS.PAYMENT.ID_TYPE\"></span>&nbsp;<span class=\"required\">*</span></label><div class=\"custom-select input--medium _display--inline-block push-half--right\" ng-class=\"{\'custom-select--error\' : paymentForm.idType.$invalid && vm.orderService.hasClickedContinue()}\"><select id=\"idType\" name=\"idType\" ng-if=\"vm.documentTypes\" ng-model=\"vm.payment.additionalInfo.idType\" required=\"\"><option value=\"\"></option><option ng-repeat=\"docType in vm.documentTypes\" ng-value=\"docType.code\">{{ docType.name || docType.code }}</option></select></div></div><div class=\"flexbox__item one-whole hard--portable soft-top--portable _vertical-align--top\"><label for=\"full-name\" class=\"label _display--inline-block\"><span translate=\"SESSIONS.PAYMENT.ID_NUMBER\"></span>&nbsp;<span class=\"required\">*</span></label><div class=\"cf\"><input ng-class=\"{\'input--error\': paymentForm.idNumber.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" id=\"idNumber\" name=\"idNumber\" ng-model=\"vm.payment.additionalInfo.idNumber\" required=\"\" type=\"text\" maxlength=\"20\"></div></div></div><div ng-messages=\"paymentForm.idNumber.$error\" class=\"message--warning\" ng-if=\"paymentForm.idNumber.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ID_IS_REQUIRED\"></span></span></div><div ng-messages=\"paymentForm.idType.$error\" class=\"message--warning\" ng-if=\"paymentForm.idType.$invalid && paymentForm.idNumber.$valid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ID_IS_REQUIRED\"></span></span></div></li></ul></div><div class=\"push--bottom\" ng-if=\"vm.paymentSetting.isAVSEnabled && !vm.isPayUArgentina && vm.showPaymentDetails()\"><h3 class=\"_font--strong push-mid--bottom\" translate=\"SESSIONS.PAYMENT.BILLING_ADDRESS\"></h3><ul class=\"form-fields\"><li><div class=\"flexbox\"><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top\"><label for=\"address\" class=\"label _display--inline-block\" translate=\"SESSIONS.PAYMENT.ADDRESS\"></label> <span class=\"required\">*</span> <input ng-class=\"{\'input--error\': paymentForm.address.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input one-whole\" id=\"address\" name=\"address\" ng-model=\"vm.payment.billingAddress.address\" required=\"\" type=\"text\"><div ng-messages=\"paymentForm.address.$error\" class=\"message--warning\" ng-if=\"paymentForm.address.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ENTER_YOUR_BILLING_ADDRESS\"></span></span></div></div><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top soft-half--left\"><label for=\"address2\" class=\"label\" translate=\"SESSIONS.PAYMENT.ADDRESS2\"></label> <input class=\"text-input one-whole\" id=\"address2\" name=\"address2\" ng-model=\"vm.payment.billingAddress.address2\" type=\"text\"></div></div></li><li><div class=\"flexbox\"><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top\"><label for=\"city\" class=\"label\" translate=\"SESSIONS.PAYMENT.CITY\"></label> <input class=\"text-input one-whole\" id=\"city\" name=\"city\" ng-model=\"vm.payment.billingAddress.city\" type=\"text\"></div><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top soft-half--left\"><label class=\"label\" for=\"countrySelect\" translate=\"GENERIC.COUNTRY\"></label><div class=\"cf\"><div class=\"custom-select input--xlarge _display--inline-block\"><select id=\"countrySelect\" name=\"countrySelect\" ng-model=\"vm.payment.billingAddress.country\" ng-disabled=\"!vm.countries.length\"><option ng-model=\"country\" value=\"\">{{ \'SESSIONS.PAYMENT.SELECT_COUNTRY\' | translate }}</option><option ng-repeat=\"country in vm.countries | orderBy: vm.venueCountryFirst\" ng-model=\"country\" ng-value=\"country.countryCode\">{{country.name}}</option></select></div></div></div></div></li><li><div class=\"flexbox\"><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top\" ng-show=\"vm.payment.billingAddress.country === \'US\'\"><label for=\"full-name\" class=\"label\" translate=\"SESSIONS.PAYMENT.STATE_US\"></label> <input class=\"text-input one-whole\" id=\"state\" name=\"state\" ng-model=\"vm.payment.billingAddress.state\" type=\"text\"></div><div class=\"flexbox__item one-half hard--portable soft-top--portable _vertical-align--top\"><label for=\"full-name\" class=\"label _display--inline-block\" translate=\"SESSIONS.PAYMENT.POSTCODE\"></label> <span class=\"required\">*</span><div class=\"cf\"><input ng-class=\"{\'input--error\': paymentForm.postalCode.$invalid && vm.orderService.hasClickedContinue()}\" class=\"text-input two-fifths\" id=\"postalCode\" name=\"postalCode\" ng-model=\"vm.payment.billingAddress.postalCode\" required=\"\" type=\"text\"><div ng-messages=\"paymentForm.postalCode.$error\" class=\"message--warning\" ng-if=\"paymentForm.postalCode.$invalid && vm.orderService.hasClickedContinue()\"><span ng-message=\"required\"><span translate=\"SESSIONS.PAYMENT.ENTER_YOUR_BILLING_POSTCODE\"></span></span></div></div></div></div></li></ul></div><div class=\"callout--info flex\" qa-id=\"noFurtherPayment\" ng-if=\"vm.orderService.noFurtherPaymentRequired() && !vm.orderService.hasRecurring() && !(vm.paymentSetting.isDropIn && vm.payment.paymentMethod === \'banktransfer\')\"><span class=\"material-icons md-18 callout__icon push-half--right\">info</span> <span translate=\"SESSIONS.DETAILS.NO_PAYMENT_REQUIRED\"></span></div><div class=\"push--bottom soft--ends text--center\" ng-if=\"vm.isPopup && !vm.orderService.noFurtherPaymentRequired()\"><img src=\"https://cdn.rollerdigital.com/assets/images/cx/make-payment-hosted.svg\" alt=\"make payment\" class=\"push--ends soft--left\"><p class=\"text--small _line-height--medium two-thirds _centered-margins one-whole--portable\" ng-bind-html=\"vm.paymentNote\"></p></div></form></div></div>");
$templateCache.put("app/views/sessions/sessions.promotion.html","<div class=\"banner banner--amex\"><div class=\"flexbox banner__content\" ng-if=\"!vm.promotion().getSettings()\"><div class=\"banner__img\"><img src=\"/app/img/amex@2x.png\" alt=\"American Express\" width=\"63\" height=\"56\"></div><p ng-if=\"!vm.promotion().getProductPromotionLink()\" class=\"banner__copy\">AMEX Card Members save 15% on selected tickets and receive complimentary blanket hire.</p><p ng-if=\"vm.promotion().getProductPromotionLink()\" class=\"banner__copy\">American Express Card Members save 15% on selected tickets. <a ng-if=\"vm.promotion().getProductPromotionLink()\" ng-href=\"{{vm.promotion().getProductPromotionLink()}}\">Access AMEX tickets here</a></p></div><div class=\"flexbox banner__content\" ng-if=\"vm.promotion().getSettings()\"><div class=\"banner__img\"><img ng-if=\"vm.promotion().getSettings().sponsorLogoUrl\" ng-src=\"{{vm.promotion().getSettings().sponsorLogoUrl}}\" alt=\"{{vm.promotion().getSettings().sponsorName}}\" height=\"49\"></div><p ng-if=\"!vm.promotion().getProductPromotionLink()\" class=\"banner__copy\">{{vm.promotion().getSettings().promotedText}}</p><p ng-if=\"vm.promotion().getProductPromotionLink()\" class=\"banner__copy\">{{vm.promotion().getSettings().generallyAvailableText}} <a ng-if=\"vm.promotion().getProductPromotionLink()\" ng-href=\"{{vm.promotion().getProductPromotionLink()}}\"><span ng-bind-html=\"vm.promotion().getSettings().linkToPromotedProductText\"></span></a></p></div></div>");
$templateCache.put("app/views/sessions/sessions.success.html","<div class=\"layout__inner\" ng-if=\"!vm.orderService.inProgress\"><div class=\"soft\"><header class=\"soft-half--bottom\"><span class=\"flex-align--center text--tiny _font--strong\" ng-if=\"!vm.orderService.bankTransferDetails() && !(vm.orderService.isPaymentPending() || vm.showBriefConfirmation)\"><span class=\"material-icons md-16 _push-quarter--right state--success\">check_circle</span> <span translate=\"SESSIONS.SUCCESS.BOOKING_COMPLETE\"></span></span><h2 class=\"flush text--title\"><span ng-show=\"!vm.orderService.bankTransferDetails()\" translate=\"SESSIONS.SUCCESS.SEE_YOU_SOON\"></span> <span ng-show=\"vm.orderService.bankTransferDetails()\" translate=\"SESSIONS.SUCCESS.PAYMENT_PENDING\"></span></h2></header><div ng-if=\"!vm.orderService.bankTransferDetails()\"><p class=\"push-half--bottom\" ng-if=\"vm.paymentAlreadyProcessed\">{{ \'SESSIONS.SUCCESS.PAYMENT_ALREADY_PROCESSED\' | translate }}</p><div class=\"push--bottom\" ng-if=\"vm.orderService.getShopperStatement()\"><div class=\"callout--info flex\"><span class=\"material-icons\">receipt</span> <span ng-bind-html=\"\'SESSIONS.SUCCESS.STATEMENT_MESSAGE\' | rollerTranslate: { amount: (vm.orderService.total() | rollerCurrency), statementText: vm.orderService.getShopperStatement() }\"></span></div></div><div class=\"push--bottom\" ng-if=\"vm.orderService.isPaymentPending() || vm.showBriefConfirmation\"><div class=\"callout--alert flex\"><span ng-bind-html=\"\'SESSIONS.SUCCESS.PAYMENT_IS_PENDING\' | rollerTranslate\"></span></div></div><p class=\"push-half--bottom\" ng-show=\"!vm.orderService.isPhysicalGiftcardOnly()\">{{ \'SESSIONS.SUCCESS.DELIVERY_MESSAGE\' | translate | stringFormat: vm.orderService.details().email }}</p><p qa-id=\"receipt-number\" class=\"delta push-half--bottom\" id=\"receipt-number\">{{ vm.orderService.getReceiptNumber() }}</p><p class=\"push-half--bottom\" translate=\"SESSIONS.SUCCESS.NOTIFICATION_OF_EMAIL\"></p></div><div class=\"soft--bottom _break-word\" ng-if=\"vm.orderService.bankTransferDetails()\"><p ng-if=\"vm.orderService.bankTransferDetails().instructions\" ng-bind-html=\"vm.getPayLaterInstructions()\"></p><p class=\"flush\" ng-if=\"!vm.orderService.bankTransferDetails().instructions\"><span>{{\'SESSIONS.SUCCESS.NOT_CONFIRMED\' | translate | stringFormat: (vm.orderService.total() | rollerCurrency) }}</span><br><br><span class=\"weight--semibold\">{{ vm.orderService.bankTransferDetails().accountName }}</span><br><span translate=\"SESSIONS.SUCCESS.BSB\"></span>: <span class=\"weight--bold\">{{ vm.orderService.bankTransferDetails().bsbNumber }}</span><br><span translate=\"SESSIONS.SUCCESS.ACCOUNT_NUMBER\"></span>: <span class=\"weight--bold\">{{ vm.orderService.bankTransferDetails().accountNumber }}</span><br><span ng-if=\"vm.orderService.bankTransferDetails().internationalSwitftCode\"><span translate=\"SESSIONS.SUCCESS.SWIFT\"></span>: <span class=\"weight--bold\">{{ vm.orderService.bankTransferDetails().internationalSwitftCode }}</span> <span translate=\"SESSIONS.SUCCESS.FEE\"></span></span> <span translate=\"SESSIONS.SUCCESS.REF_CODE\"></span>: <span class=\"weight--bold\" qa-id=\"reference-code\">{{ vm.orderService.getReceiptNumber() }}</span></p></div><div class=\"push--top\" ng-if=\"vm.isHotmail()\"><p translate=\"SESSIONS.SUCCESS.SPAM\"></p></div><div class=\"callout--alert\" ng-if=\"vm.waiver && vm.canUseWaivers\"><h3 class=\"delta _push-quarter--bottom\">{{\'SESSIONS.SUCCESS.WAIVER.SKIP_THE_QUEUE\' | translate }}</h3><p class=\"push-half--bottom\">{{\'SESSIONS.SUCCESS.WAIVER.SAVE_TIME\' | translate | stringFormat: vm.content(\'waiver\')}}</p><a qa-id=\"signWaiverButton\" href=\"{{ vm.waiverUrl() }}\" class=\"btn btn--green btn--radius one-whole\" target=\"_blank\">{{\'SESSIONS.SUCCESS.SIGN_WAIVER\' | translate | stringFormat: vm.content(\'waiver\')}}</a><div class=\"dropdown\" ng-class=\"{\'is-active\' : vm.openDropdown}\"><button class=\"btn--plain text--small state--info push-mid--top flex-align--center\" ng-click=\"vm.shareWaiverUrl()\"><span class=\"material-icons md-18 _push-quarter--right\">reply</span> <span class=\"text\">{{\'SESSIONS.SUCCESS.WAIVER.SHARE_WAIVER\' | translate }}</span></button><ul class=\"dropdown-menu dropdown-menu--small _push-quarter--top\"><li class=\"dropdown-menu__item\"><a ng-href=\"mailto:{{ vm.getMailtoDetails() }}\" ng-click=\"vm.openDropdown = false;\"><span class=\"material-icons state--info\">email</span> <span translate=\"SESSIONS.SUCCESS.WAIVER.SHARE_VIA_EMAIL\">Email</span></a></li><li class=\"dropdown-menu__item\"><a href=\"javascript:void(0)\" ng-click=\"vm.copyToClipboard(vm.waiverUrl()); vm.openDropdown = false;\"><span class=\"material-icons state--info\">content_copy</span> <span translate=\"SESSIONS.SUCCESS.WAIVER.COPY_LINK\">Copy link</span></a></li></ul></div></div><p class=\"push-half--bottom logo--facebook-share__wrap\" ng-if=\"vm.facebookShare\"><a ng-href=\"{{vm.facebookShare.linkUrl}}\" target=\"_blank\" class=\"_vertical-align--middle\"><span class=\"logo--facebook-share\"></span>{{ vm.facebookShare.linkText }}</a></p><div class=\"callout--note\" ng-if=\"vm.formWidgetUrl()\"><p class=\"flush\"><span class=\"_font--strong\" translate=\"SESSIONS.SUCCESS.ONE_MORE_STEP\"></span><br><span translate=\"SESSIONS.SUCCESS.MORE_INFO\"></span><br><a class=\"push-half--top\" ng-href=\"{{ vm.formWidgetUrl() }}\" target=\"_blank\">{{ vm.formWidgetUrl() }}</a></p></div></div><div ng-if=\"!vm.showBriefConfirmation\" order-summary=\"\"></div><div ng-if=\"vm.orderService.getPaymentSuccessMessage()\" class=\"push--top _border--bottom\"><p>{{ vm.orderService.getPaymentSuccessMessage() }}</p></div><div class=\"soft _border--top\"><a qa-id=\"new-booking-button\" class=\"btn btn--green one-whole text--center\" ng-click=\"vm.resetOrder()\" href=\"\">&laquo; <span translate=\"SESSIONS.SUCCESS.ANOTHER_ORDER\"></span></a></div></div><div class=\"layout__inner\" ng-if=\"vm.orderService.inProgress && !vm.showBriefConfirmation\"><div order-summary=\"\" always-visible=\"true\"></div></div><loader class=\"loading--full\" ng-show=\"vm.orderService.inProgress\" is-loading=\"vm.orderService.inProgress\" is-for-hpp=\"vm.isHpp\"></loader>");
$templateCache.put("app/vendor/directives/datepicker/datepicker.html","<div class=\"ng-flat-datepicker\" ng-show=\"pickerDisplayed\"><div class=\"ng-flat-datepicker-table-header-bckgrnd\"></div><table><caption><div class=\"ng-flat-datepicker-header-wrapper\"><span class=\"ng-flat-datepicker-arrow ng-flat-datepicker-arrow-left\" ng-click=\"prevMonth()\"><svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"50\" y=\"50\" viewbox=\"0 0 100 100\" xml:space=\"preserve\"><polygon points=\"64.8,36.2 35.2,6.5 22.3,19.4 51.9,49.1 22.3,78.8 35.2,91.7 77.7,49.1\"></polygon></svg></span><div class=\"ng-flat-datepicker-header-year\"><div class=\"ng-flat-datepicker-custom-select-box\" outside-click=\"showMonthsList = false\"><span class=\"ng-flat-datepicker-custom-select-title ng-flat-datepicker-month-name\" ng-click=\"showMonthsList = !showMonthsList; showYearsList = false\" ng-class=\"{selected: showMonthsList }\">{{ calendarCursor.isValid() ? calendarCursor.format(\'MMMM\') : \"\" }}</span><div class=\"ng-flat-datepicker-custom-select\" ng-show=\"showMonthsList\"><span ng-repeat=\"monthName in monthsList\" ng-click=\"selectMonth(monthName); showMonthsList = false\">{{ monthName }}</span></div></div><div class=\"ng-flat-datepicker-custom-select-box\" outside-click=\"showYearsList = false\"><span class=\"ng-flat-datepicker-custom-select-title\" ng-click=\"showYearsList = !showYearsList; showMonthsList = false\" ng-class=\"{selected: showYearsList }\">{{ calendarCursor.isValid() ? calendarCursor.format(\'YYYY\') : \"\" }}</span><div class=\"ng-flat-datepicker-custom-select\" ng-show=\"showYearsList\"><span ng-repeat=\"yearNumber in yearsList\" ng-click=\"selectYear(yearNumber)\">{{ yearNumber }}</span></div></div></div><span class=\"ng-flat-datepicker-arrow ng-flat-datepicker-arrow-right\" ng-click=\"nextMonth()\"><svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"50\" y=\"50\" viewbox=\"0 0 100 100\" xml:space=\"preserve\"><polygon points=\"64.8,36.2 35.2,6.5 22.3,19.4 51.9,49.1 22.3,78.8 35.2,91.7 77.7,49.1\"></polygon></svg></span></div></caption><tbody><tr class=\"days-head\"><td class=\"day-head\" ng-repeat=\"dayName in daysNameList\">{{ dayName }}</td></tr><tr class=\"days\" ng-repeat=\"week in currentWeeks\"><td ng-repeat=\"day in week\" ng-click=\"selectDay(day)\" ng-class=\"[\'day-item\', { \'isToday\': day.isToday, \'isInMonth\': day.isInMonth, \'isDisabled\': !day.isSelectable, \'isSelected\': day.isSelected }]\">{{ day.date | date:\'dd\' }}</td></tr></tbody></table></div>");
$templateCache.put("app/ng/directives/cost-modifiers/cost-modifiers.html","<div><div ng-repeat=\"cm in vm.costModifiers\" class=\"push--top\"><div class=\"delta\"><span style=\"float:left\">{{cm.name}}</span> <span style=\"float:right\">{{vm.calculateAmount(cm) | rollerCurrency}}</span></div><div style=\"clear:both\" class=\"soft-half--top\"><img ng-src=\"{{cm.imageUrl}}\" ng-if=\"cm.imageUrl\" style=\"width:75px\"> <input type=\"checkbox\" ng-model=\"cm.isSelected\" ng-change=\"vm.modifierChanged(cm)\" style=\"vertical-align: top;\"><div class=\"push-half--left\" style=\"vertical-align: top;display:inline-block;width:75%\">{{cm.description}} <a ng-if=\"cm.termsAndConditions\" ng-click=\"vm.bookingCostModifierPolicy(cm)\" style=\"cursor:pointer\" href=\"\">Read policy</a></div></div></div></div>");
$templateCache.put("app/ng/directives/loader/loader.html","<div id=\"loading\" class=\"loading one-whole\" ng-show=\"isLoading\"><div class=\"loading__inner soft-half\" ng-if=\"!isForHpp\"><span class=\"flex--center\" ng-if=\"!isRedirecting\"><img src=\"https://cdn.rollerdigital.com/assets/icons/loaders/spinner.png\" class=\"spinner\" alt=\"loading spinner\"></span> <span ng-if=\"!!loadingText && !isRedirecting\" class=\"loading__text\">{{loadingText}}</span> <span ng-if=\"!loadingText && !isRedirecting\" class=\"loading__text\" translate=\"PAYMENT.LOADER.PROCESSING_PAYMENT\"></span></div><div class=\"loading__hpp soft-half\" ng-if=\"isForHpp\"><h4 class=\"_font--strong\" translate=\"PAYMENT.LOADER.PAYMENT_IN_PROGRESS\"></h4><p translate=\"PAYMENT.LOADER.COMPLETE_OR_CANCEL\"></p><img src=\"https://cdn.rollerdigital.com/assets/images/cx/make-payment-hosted.svg\" alt=\"make payment\" class=\"push--ends soft--left push--left\" height=\"100\"><p translate=\"PAYMENT.LOADER.CHECK_POPUP_NOT_BLOCKED\"></p></div><div class=\"loading__external\" id=\"loading-additional\"></div></div>");
$templateCache.put("app/ng/directives/number-input/number-input.directive.html","<div class=\"number-input__wrapper\"><div class=\"number-input\" ng-class=\"{\'push--bottom\' : qtyAdded > 0}\"><button ng-class=\"{muted: !ifUndefined(canDecrease(), true) }\" qa-id=\"qtyDecrease\" ng-disabled=\"!ifUndefined(canDecrease(), true)\" ng-click=\"decrease()\" class=\"number-input__btn\"><span class=\"material-icons\">remove</span></button> <input qa-id=\"qtyInput\" ng-if=\"ticket\" type=\"number\" ng-model=\"ticket.quantity\" ng-class=\"{\'highlighted\' : ticket.quantity > 0 }\" ng-change=\"ticketQuantityChanged(ticket)\" ng-disabled=\"!ifUndefined(canIncrease(), true)\" ng-focus=\"ticketQuantityFocus(ticket)\" empty-if-zero=\"\"> <input ng-if=\"!ticket\" type=\"number\" value=\"{{value()}}\"> <button ng-class=\"{muted: !canIncrease()}\" qa-id=\"qtyIncrease\" ng-disabled=\"!ifUndefined(canIncrease(), true)\" ng-click=\"increase()\" class=\"number-input__btn\"><div class=\"material-icons\">add</div></button></div><div class=\"number-input__message\" ng-show=\"qtyAdded > 0\"><span class=\"material-icons\">check</span> {{\'SESSIONS.ITEMS_ADDED\' | translate: { NUMBER: qtyAdded } : \'messageformat\' }}</div></div>");
$templateCache.put("app/ng/directives/product-status/sales-closed.html","<div><p ng-if=\"!bookingPhoneNumber\" class=\"sales-closed\"><span translate=\"SALES_CLOSED.SALES_CLOSED\"></span></p><a ng-if=\"bookingPhoneNumber\" class=\"sales-closed\" ng-click=\"callToBook(bookingPhoneNumber)\"><span class=\"material-icons\">phone</span> <span translate=\"SALES_CLOSED.CALL_TO_BOOK\"></span></a><div id=\"linkHolder\" ng-show=\"false\"></div></div>");
$templateCache.put("app/ng/directives/product-status/soldout.html","<p class=\"sold-out\" translate=\"SOLD_OUT.SOLD_OUT\"></p>");
$templateCache.put("app/ng/directives/time-picker/timepicker.html","<div class=\"custom-select\"><select class=\"one-whole\" ng-options=\"time.display for time in timings track by time.value\" ng-model=\"selectedTime\"></select></div>");
$templateCache.put("app/ng/directives/ticket-timer/ticketTimer.html","<div class=\"flex-align--center _push-quarter--top _font--strong\" ng-class=\"vm.timedOut ? \'state--error\' : \'state--success\'\"><span class=\"material-icons md-18 _push-quarter--right\">access_time</span> <span class=\"text--small\" ng-show=\"!vm.timedOut\">{{\'TICKET_TIMER.TIME_TO_COMPLETE\' | translate | stringFormat: vm.timeRemaining}}</span> <span class=\"text--small\" ng-show=\"vm.timedOut\" translate=\"TICKET_TIMER.OUT_OF_TIME\"></span></div>");
$templateCache.put("app/ng/directives/step-counter/step-counter.html","<span ng-if=\"vm.stepIndex > 0\" translate=\"{{ \'INDEX.WIZARD.STEP_NUMBER\' }}\" translate-values=\"{ index: vm.stepIndex, total: vm.stepsCount }\"></span>");
$templateCache.put("app/ng/directives/ziggeovideo/ziggeovideo.html","<div class=\"ziggeo-wrap\"><div class=\"ziggeo-container\"><div id=\"ziggeoDynamicReplace{{$id}}\"></div></div></div>");}]);